var  china_area = [
  {
    id: 1,
    pid: 0,
    name: '北京市',
    code: '110000',
    lng: '116.405285',
    lat: '39.904989',
    children: [
      {
        id: 2,
        pid: 1,
        name: '市辖区',
        code: '110100',
        lng: '116.405285',
        lat: '39.904989',
        children: [
          { id: 3, pid: 2, name: '东城区', code: '110101', lng: '116.41005', lat: '39.93157' },
          { id: 4, pid: 2, name: '西城区', code: '110102', lng: '116.36003', lat: '39.9305' },
          { id: 5, pid: 2, name: '朝阳区', code: '110105', lng: '116.48548', lat: '39.9484' },
          { id: 6, pid: 2, name: '丰台区', code: '110106', lng: '116.28625', lat: '39.8585' },
          { id: 7, pid: 2, name: '石景山区', code: '110107', lng: '116.2229', lat: '39.90564' },
          { id: 8, pid: 2, name: '海淀区', code: '110108', lng: '116.29812', lat: '39.95931' },
          { id: 9, pid: 2, name: '门头沟区', code: '110109', lng: '116.10137', lat: '39.94043' },
          { id: 10, pid: 2, name: '房山区', code: '110111', lng: '116.14257', lat: '39.74786' },
          { id: 11, pid: 2, name: '通州区', code: '110112', lng: '116.65716', lat: '39.90966' },
          { id: 12, pid: 2, name: '顺义区', code: '110113', lng: '116.65417', lat: '40.1302' },
          { id: 13, pid: 2, name: '昌平区', code: '110114', lng: '116.2312', lat: '40.22072' },
          { id: 14, pid: 2, name: '大兴区', code: '110115', lng: '116.34149', lat: '39.72668' },
          { id: 15, pid: 2, name: '怀柔区', code: '110116', lng: '116.63168', lat: '40.31602' },
          { id: 16, pid: 2, name: '平谷区', code: '110117', lng: '117.12133', lat: '40.14056' },
          { id: 17, pid: 2, name: '密云县', code: '110228', lng: '116.84295', lat: '40.37618' },
          { id: 18, pid: 2, name: '延庆县', code: '110229', lng: '115.97494', lat: '40.45672' },
        ],
      },
    ],
  },
  {
    id: 19,
    pid: 0,
    name: '天津市',
    code: '120000',
    lng: '117.190182',
    lat: '39.125596',
    children: [
      {
        id: 20,
        pid: 19,
        name: '天津市',
        code: '120100',
        lng: '117.190182',
        lat: '39.125596',
        children: [
          { id: 21, pid: 20, name: '和平区', code: '120101', lng: '117.21456', lat: '39.11718' },
          { id: 22, pid: 20, name: '河东区', code: '120102', lng: '117.22562', lat: '39.12318' },
          { id: 23, pid: 20, name: '河西区', code: '120103', lng: '117.22327', lat: '39.10959' },
          { id: 24, pid: 20, name: '南开区', code: '120104', lng: '117.15074', lat: '39.13821' },
          { id: 25, pid: 20, name: '河北区', code: '120105', lng: '117.19697', lat: '39.14816' },
          { id: 26, pid: 20, name: '红桥区', code: '120106', lng: '117.15145', lat: '39.16715' },
          { id: 27, pid: 20, name: '东丽区', code: '120110', lng: '117.31436', lat: '39.0863' },
          { id: 28, pid: 20, name: '西青区', code: '120111', lng: '117.00927', lat: '39.14123' },
          { id: 29, pid: 20, name: '津南区', code: '120112', lng: '117.38537', lat: '38.99139' },
          { id: 30, pid: 20, name: '北辰区', code: '120113', lng: '117.13217', lat: '39.22131' },
          { id: 31, pid: 20, name: '武清区', code: '120114', lng: '117.04443', lat: '39.38415' },
          { id: 32, pid: 20, name: '宝坻区', code: '120115', lng: '117.3103', lat: '39.71761' },
          { id: 33, pid: 20, name: '滨海新区', code: '120116', lng: '117.70162', lat: '39.02668' },
          { id: 34, pid: 20, name: '宁河县', code: '120221', lng: '117.8255', lat: '39.33048' },
          { id: 35, pid: 20, name: '静海县', code: '120223', lng: '116.97436', lat: '38.94582' },
          { id: 36, pid: 20, name: '蓟县', code: '120225', lng: '117.40799', lat: '40.04567' },
        ],
      },
    ],
  },
  {
    id: 37,
    pid: 0,
    name: '河北省',
    code: '130000',
    lng: '114.502461',
    lat: '38.045474',
    children: [
      {
        id: 38,
        pid: 37,
        name: '石家庄市',
        code: '130100',
        lng: '114.502461',
        lat: '38.045474',
        children: [
          { id: 39, pid: 38, name: '长安区', code: '130102', lng: '114.53906', lat: '38.03665' },
          { id: 40, pid: 38, name: '桥西区', code: '130104', lng: '114.46977', lat: '38.03221' },
          { id: 41, pid: 38, name: '新华区', code: '130105', lng: '114.46326', lat: '38.05088' },
          { id: 42, pid: 38, name: '井陉矿区', code: '130107', lng: '114.06518', lat: '38.06705' },
          { id: 43, pid: 38, name: '裕华区', code: '130108', lng: '114.53115', lat: '38.00604' },
          { id: 44, pid: 38, name: '藁城区', code: '130109', lng: '114.84671', lat: '38.02162' },
          { id: 45, pid: 38, name: '鹿泉区', code: '130110', lng: '114.31347', lat: '38.08782' },
          { id: 46, pid: 38, name: '栾城区', code: '130111', lng: '114.64834', lat: '37.90022' },
          { id: 47, pid: 38, name: '井陉县', code: '130121', lng: '114.14257', lat: '38.03688' },
          { id: 48, pid: 38, name: '正定县', code: '130123', lng: '114.57296', lat: '38.14445' },
          { id: 49, pid: 38, name: '行唐县', code: '130125', lng: '114.55316', lat: '38.43654' },
          { id: 50, pid: 38, name: '灵寿县', code: '130126', lng: '114.38259', lat: '38.30845' },
          { id: 51, pid: 38, name: '高邑县', code: '130127', lng: '114.61142', lat: '37.61556' },
          { id: 52, pid: 38, name: '深泽县', code: '130128', lng: '115.20358', lat: '38.18353' },
          { id: 53, pid: 38, name: '赞皇县', code: '130129', lng: '114.38775', lat: '37.66135' },
          { id: 54, pid: 38, name: '无极县', code: '130130', lng: '114.97509', lat: '38.17653' },
          { id: 55, pid: 38, name: '平山县', code: '130131', lng: '114.186', lat: '38.25994' },
          { id: 56, pid: 38, name: '元氏县', code: '130132', lng: '114.52539', lat: '37.76668' },
          { id: 57, pid: 38, name: '赵县', code: '130133', lng: '114.77612', lat: '37.75628' },
          { id: 58, pid: 38, name: '辛集市', code: '130181', lng: '115.20626', lat: '37.94079' },
          { id: 59, pid: 38, name: '晋州市', code: '130183', lng: '115.04348', lat: '38.03135' },
          { id: 60, pid: 38, name: '新乐市', code: '130184', lng: '114.68985', lat: '38.34417' },
        ],
      },
      {
        id: 61,
        pid: 37,
        name: '唐山市',
        code: '130200',
        lng: '118.175393',
        lat: '39.635113',
        children: [
          { id: 62, pid: 61, name: '路南区', code: '130202', lng: '118.15431', lat: '39.62505' },
          { id: 63, pid: 61, name: '路北区', code: '130203', lng: '118.20079', lat: '39.62436' },
          { id: 64, pid: 61, name: '古冶区', code: '130204', lng: '118.45803', lat: '39.71993' },
          { id: 65, pid: 61, name: '开平区', code: '130205', lng: '118.26171', lat: '39.67128' },
          { id: 66, pid: 61, name: '丰南区', code: '130207', lng: '118.11282', lat: '39.56483' },
          { id: 67, pid: 61, name: '丰润区', code: '130208', lng: '118.12976', lat: '39.8244' },
          { id: 68, pid: 61, name: '曹妃甸区', code: '130209', lng: '118.460379', lat: '39.273070' },
          { id: 69, pid: 61, name: '滦县', code: '130223', lng: '118.70346', lat: '39.74056' },
          { id: 70, pid: 61, name: '滦南县', code: '130224', lng: '118.6741', lat: '39.5039' },
          { id: 71, pid: 61, name: '乐亭县', code: '130225', lng: '118.9125', lat: '39.42561' },
          { id: 72, pid: 61, name: '迁西县', code: '130227', lng: '118.31616', lat: '40.14587' },
          { id: 73, pid: 61, name: '玉田县', code: '130229', lng: '117.7388', lat: '39.90049' },
          { id: 74, pid: 61, name: '遵化市', code: '130281', lng: '117.96444', lat: '40.18741' },
          { id: 75, pid: 61, name: '迁安市', code: '130283', lng: '118.70068', lat: '39.99833' },
        ],
      },
      {
        id: 76,
        pid: 37,
        name: '秦皇岛市',
        code: '130300',
        lng: '119.586579',
        lat: '39.942531',
        children: [
          { id: 77, pid: 76, name: '海港区', code: '130302', lng: '119.61046', lat: '39.9345' },
          { id: 78, pid: 76, name: '山海关区', code: '130303', lng: '119.77563', lat: '39.97869' },
          { id: 79, pid: 76, name: '北戴河区', code: '130304', lng: '119.48388', lat: '39.83408' },
          { id: 80, pid: 76, name: '青龙满族自治县', code: '130321', lng: '118.95242', lat: '40.40743' },
          { id: 81, pid: 76, name: '昌黎县', code: '130322', lng: '119.16595', lat: '39.70884' },
          { id: 82, pid: 76, name: '抚宁县', code: '130323', lng: '119.24487', lat: '39.87538' },
          { id: 83, pid: 76, name: '卢龙县', code: '130324', lng: '118.89288', lat: '39.89176' },
        ],
      },
      {
        id: 84,
        pid: 37,
        name: '邯郸市',
        code: '130400',
        lng: '114.490686',
        lat: '36.612273',
        children: [
          { id: 85, pid: 84, name: '邯山区', code: '130402', lng: '114.48375', lat: '36.60006' },
          { id: 86, pid: 84, name: '丛台区', code: '130403', lng: '114.49343', lat: '36.61847' },
          { id: 87, pid: 84, name: '复兴区', code: '130404', lng: '114.45928', lat: '36.61134' },
          { id: 88, pid: 84, name: '峰峰矿区', code: '130406', lng: '114.21148', lat: '36.41937' },
          { id: 89, pid: 84, name: '邯郸县', code: '130421', lng: '114.53103', lat: '36.59385' },
          { id: 90, pid: 84, name: '临漳县', code: '130423', lng: '114.6195', lat: '36.33461' },
          { id: 91, pid: 84, name: '成安县', code: '130424', lng: '114.66995', lat: '36.44411' },
          { id: 92, pid: 84, name: '大名县', code: '130425', lng: '115.15362', lat: '36.27994' },
          { id: 93, pid: 84, name: '涉县', code: '130426', lng: '113.69183', lat: '36.58072' },
          { id: 94, pid: 84, name: '磁县', code: '130427', lng: '114.37387', lat: '36.37392' },
          { id: 95, pid: 84, name: '肥乡县', code: '130428', lng: '114.79998', lat: '36.54807' },
          { id: 96, pid: 84, name: '永年县', code: '130429', lng: '114.48925', lat: '36.78356' },
          { id: 97, pid: 84, name: '邱县', code: '130430', lng: '115.17407', lat: '36.82082' },
          { id: 98, pid: 84, name: '鸡泽县', code: '130431', lng: '114.8742', lat: '36.92374' },
          { id: 99, pid: 84, name: '广平县', code: '130432', lng: '114.94653', lat: '36.48046' },
          { id: 100, pid: 84, name: '馆陶县', code: '130433', lng: '115.29913', lat: '36.53719' },
          { id: 101, pid: 84, name: '魏县', code: '130434', lng: '114.93518', lat: '36.36171' },
          { id: 102, pid: 84, name: '曲周县', code: '130435', lng: '114.95196', lat: '36.77671' },
          { id: 103, pid: 84, name: '武安市', code: '130481', lng: '114.20153', lat: '36.69281' },
        ],
      },
      {
        id: 104,
        pid: 37,
        name: '邢台市',
        code: '130500',
        lng: '114.508851',
        lat: '37.0682',
        children: [
          { id: 105, pid: 104, name: '桥东区', code: '130502', lng: '114.50725', lat: '37.06801' },
          { id: 106, pid: 104, name: '桥西区', code: '130503', lng: '114.46803', lat: '37.05984' },
          { id: 107, pid: 104, name: '邢台县', code: '130521', lng: '114.56575', lat: '37.0456' },
          { id: 108, pid: 104, name: '临城县', code: '130522', lng: '114.50387', lat: '37.43977' },
          { id: 109, pid: 104, name: '内丘县', code: '130523', lng: '114.51212', lat: '37.28671' },
          { id: 110, pid: 104, name: '柏乡县', code: '130524', lng: '114.69332', lat: '37.48242' },
          { id: 111, pid: 104, name: '隆尧县', code: '130525', lng: '114.77615', lat: '37.35351' },
          { id: 112, pid: 104, name: '任县', code: '130526', lng: '114.6842', lat: '37.12575' },
          { id: 113, pid: 104, name: '南和县', code: '130527', lng: '114.68371', lat: '37.00488' },
          { id: 114, pid: 104, name: '宁晋县', code: '130528', lng: '114.92117', lat: '37.61696' },
          { id: 115, pid: 104, name: '巨鹿县', code: '130529', lng: '115.03524', lat: '37.21801' },
          { id: 116, pid: 104, name: '新河县', code: '130530', lng: '115.24987', lat: '37.52718' },
          { id: 117, pid: 104, name: '广宗县', code: '130531', lng: '115.14254', lat: '37.0746' },
          { id: 118, pid: 104, name: '平乡县', code: '130532', lng: '115.03002', lat: '37.06317' },
          { id: 119, pid: 104, name: '威县', code: '130533', lng: '115.2637', lat: '36.9768' },
          { id: 120, pid: 104, name: '清河县', code: '130534', lng: '115.66479', lat: '37.07122' },
          { id: 121, pid: 104, name: '临西县', code: '130535', lng: '115.50097', lat: '36.87078' },
          { id: 122, pid: 104, name: '南宫市', code: '130581', lng: '115.39068', lat: '37.35799' },
          { id: 123, pid: 104, name: '沙河市', code: '130582', lng: '114.4981', lat: '36.8577' },
        ],
      },
      {
        id: 124,
        pid: 37,
        name: '保定市',
        code: '130600',
        lng: '115.482331',
        lat: '38.867657',
        children: [
          { id: 125, pid: 124, name: '新市区', code: '130602', lng: '115.4587', lat: '38.87751' },
          { id: 126, pid: 124, name: '北市区', code: '130603', lng: '115.49715', lat: '38.88322' },
          { id: 127, pid: 124, name: '南市区', code: '130604', lng: '115.52859', lat: '38.85455' },
          { id: 128, pid: 124, name: '满城县', code: '130621', lng: '115.32296', lat: '38.94972' },
          { id: 129, pid: 124, name: '清苑县', code: '130622', lng: '115.49267', lat: '38.76709' },
          { id: 130, pid: 124, name: '涞水县', code: '130623', lng: '115.71517', lat: '39.39404' },
          { id: 131, pid: 124, name: '阜平县', code: '130624', lng: '114.19683', lat: '38.84763' },
          { id: 132, pid: 124, name: '徐水县', code: '130625', lng: '115.65829', lat: '39.02099' },
          { id: 133, pid: 124, name: '定兴县', code: '130626', lng: '115.80786', lat: '39.26312' },
          { id: 134, pid: 124, name: '唐县', code: '130627', lng: '114.98516', lat: '38.74513' },
          { id: 135, pid: 124, name: '高阳县', code: '130628', lng: '115.7788', lat: '38.70003' },
          { id: 136, pid: 124, name: '容城县', code: '130629', lng: '115.87158', lat: '39.0535' },
          { id: 137, pid: 124, name: '涞源县', code: '130630', lng: '114.69128', lat: '39.35388' },
          { id: 138, pid: 124, name: '望都县', code: '130631', lng: '115.1567', lat: '38.70996' },
          { id: 139, pid: 124, name: '安新县', code: '130632', lng: '115.93557', lat: '38.93532' },
          { id: 140, pid: 124, name: '易县', code: '130633', lng: '115.4981', lat: '39.34885' },
          { id: 141, pid: 124, name: '曲阳县', code: '130634', lng: '114.70123', lat: '38.62154' },
          { id: 142, pid: 124, name: '蠡县', code: '130635', lng: '115.57717', lat: '38.48974' },
          { id: 143, pid: 124, name: '顺平县', code: '130636', lng: '115.1347', lat: '38.83854' },
          { id: 144, pid: 124, name: '博野县', code: '130637', lng: '115.47033', lat: '38.4564' },
          { id: 145, pid: 124, name: '雄县', code: '130638', lng: '116.10873', lat: '38.99442' },
          { id: 146, pid: 124, name: '涿州市', code: '130681', lng: '115.98062', lat: '39.48622' },
          { id: 147, pid: 124, name: '定州市', code: '130682', lng: '114.9902', lat: '38.51623' },
          { id: 148, pid: 124, name: '安国市', code: '130683', lng: '115.32321', lat: '38.41391' },
          { id: 149, pid: 124, name: '高碑店市', code: '130684', lng: '115.87368', lat: '39.32655' },
        ],
      },
      {
        id: 150,
        pid: 37,
        name: '张家口市',
        code: '130700',
        lng: '114.884091',
        lat: '40.811901',
        children: [
          { id: 151, pid: 150, name: '桥东区', code: '130702', lng: '114.8943', lat: '40.78844' },
          { id: 152, pid: 150, name: '桥西区', code: '130703', lng: '114.86962', lat: '40.81945' },
          { id: 153, pid: 150, name: '宣化区', code: '130705', lng: '115.06543', lat: '40.60957' },
          { id: 154, pid: 150, name: '下花园区', code: '130706', lng: '115.28744', lat: '40.50236' },
          { id: 155, pid: 150, name: '宣化县', code: '130721', lng: '115.15497', lat: '40.56618' },
          { id: 156, pid: 150, name: '张北县', code: '130722', lng: '114.71432', lat: '41.15977' },
          { id: 157, pid: 150, name: '康保县', code: '130723', lng: '114.60031', lat: '41.85225' },
          { id: 158, pid: 150, name: '沽源县', code: '130724', lng: '115.68859', lat: '41.66959' },
          { id: 159, pid: 150, name: '尚义县', code: '130725', lng: '113.97134', lat: '41.07782' },
          { id: 160, pid: 150, name: '蔚县', code: '130726', lng: '114.58892', lat: '39.84067' },
          { id: 161, pid: 150, name: '阳原县', code: '130727', lng: '114.15051', lat: '40.10361' },
          { id: 162, pid: 150, name: '怀安县', code: '130728', lng: '114.38559', lat: '40.67425' },
          { id: 163, pid: 150, name: '万全县', code: '130729', lng: '114.7405', lat: '40.76694' },
          { id: 164, pid: 150, name: '怀来县', code: '130730', lng: '115.51773', lat: '40.41536' },
          { id: 165, pid: 150, name: '涿鹿县', code: '130731', lng: '115.22403', lat: '40.37636' },
          { id: 166, pid: 150, name: '赤城县', code: '130732', lng: '115.83187', lat: '40.91438' },
          { id: 167, pid: 150, name: '崇礼县', code: '130733', lng: '115.27993', lat: '40.97519' },
        ],
      },
      {
        id: 168,
        pid: 37,
        name: '承德市',
        code: '130800',
        lng: '117.939152',
        lat: '40.976204',
        children: [
          { id: 169, pid: 168, name: '双桥区', code: '130802', lng: '117.9432', lat: '40.97466' },
          { id: 170, pid: 168, name: '双滦区', code: '130803', lng: '117.74487', lat: '40.95375' },
          { id: 171, pid: 168, name: '鹰手营子矿区', code: '130804', lng: '117.65985', lat: '40.54744' },
          { id: 172, pid: 168, name: '承德县', code: '130821', lng: '118.17639', lat: '40.76985' },
          { id: 173, pid: 168, name: '兴隆县', code: '130822', lng: '117.50073', lat: '40.41709' },
          { id: 174, pid: 168, name: '平泉县', code: '130823', lng: '118.70196', lat: '41.01839' },
          { id: 175, pid: 168, name: '滦平县', code: '130824', lng: '117.33276', lat: '40.94148' },
          { id: 176, pid: 168, name: '隆化县', code: '130825', lng: '117.7297', lat: '41.31412' },
          { id: 177, pid: 168, name: '丰宁满族自治县', code: '130826', lng: '116.6492', lat: '41.20481' },
          { id: 178, pid: 168, name: '宽城满族自治县', code: '130827', lng: '118.49176', lat: '40.60829' },
          { id: 179, pid: 168, name: '围场满族蒙古族自治县', code: '130828', lng: '117.7601', lat: '41.94368' },
        ],
      },
      {
        id: 180,
        pid: 37,
        name: '沧州市',
        code: '130900',
        lng: '116.857461',
        lat: '38.310582',
        children: [
          { id: 181, pid: 180, name: '新华区', code: '130902', lng: '116.86643', lat: '38.31438' },
          { id: 182, pid: 180, name: '运河区', code: '130903', lng: '116.85706', lat: '38.31352' },
          { id: 183, pid: 180, name: '沧县', code: '130921', lng: '116.87817', lat: '38.29361' },
          { id: 184, pid: 180, name: '青县', code: '130922', lng: '116.80316', lat: '38.58345' },
          { id: 185, pid: 180, name: '东光县', code: '130923', lng: '116.53668', lat: '37.8857' },
          { id: 186, pid: 180, name: '海兴县', code: '130924', lng: '117.49758', lat: '38.13958' },
          { id: 187, pid: 180, name: '盐山县', code: '130925', lng: '117.23092', lat: '38.05647' },
          { id: 188, pid: 180, name: '肃宁县', code: '130926', lng: '115.82971', lat: '38.42272' },
          { id: 189, pid: 180, name: '南皮县', code: '130927', lng: '116.70224', lat: '38.04109' },
          { id: 190, pid: 180, name: '吴桥县', code: '130928', lng: '116.3847', lat: '37.62546' },
          { id: 191, pid: 180, name: '献县', code: '130929', lng: '116.12695', lat: '38.19228' },
          { id: 192, pid: 180, name: '孟村回族自治县', code: '130930', lng: '117.10412', lat: '38.05338' },
          { id: 193, pid: 180, name: '泊头市', code: '130981', lng: '116.57824', lat: '38.08359' },
          { id: 194, pid: 180, name: '任丘市', code: '130982', lng: '116.1033', lat: '38.71124' },
          { id: 195, pid: 180, name: '黄骅市', code: '130983', lng: '117.33883', lat: '38.3706' },
          { id: 196, pid: 180, name: '河间市', code: '130984', lng: '116.0993', lat: '38.44549' },
        ],
      },
      {
        id: 197,
        pid: 37,
        name: '廊坊市',
        code: '131000',
        lng: '116.713873',
        lat: '39.529244',
        children: [
          { id: 198, pid: 197, name: '安次区', code: '131002', lng: '116.70308', lat: '39.52057' },
          { id: 199, pid: 197, name: '广阳区', code: '131003', lng: '116.71069', lat: '39.52278' },
          { id: 200, pid: 197, name: '固安县', code: '131022', lng: '116.29916', lat: '39.43833' },
          { id: 201, pid: 197, name: '永清县', code: '131023', lng: '116.50091', lat: '39.32069' },
          { id: 202, pid: 197, name: '香河县', code: '131024', lng: '117.00634', lat: '39.76133' },
          { id: 203, pid: 197, name: '大城县', code: '131025', lng: '116.65353', lat: '38.70534' },
          { id: 204, pid: 197, name: '文安县', code: '131026', lng: '116.45846', lat: '38.87325' },
          { id: 205, pid: 197, name: '大厂回族自治县', code: '131028', lng: '116.98916', lat: '39.88649' },
          { id: 206, pid: 197, name: '霸州市', code: '131081', lng: '116.39154', lat: '39.12569' },
          { id: 207, pid: 197, name: '三河市', code: '131082', lng: '117.07229', lat: '39.98358' },
        ],
      },
      {
        id: 208,
        pid: 37,
        name: '衡水市',
        code: '131100',
        lng: '115.665993',
        lat: '37.735097',
        children: [
          { id: 209, pid: 208, name: '桃城区', code: '131102', lng: '115.67529', lat: '37.73499' },
          { id: 210, pid: 208, name: '枣强县', code: '131121', lng: '115.72576', lat: '37.51027' },
          { id: 211, pid: 208, name: '武邑县', code: '131122', lng: '115.88748', lat: '37.80181' },
          { id: 212, pid: 208, name: '武强县', code: '131123', lng: '115.98226', lat: '38.04138' },
          { id: 213, pid: 208, name: '饶阳县', code: '131124', lng: '115.72558', lat: '38.23529' },
          { id: 214, pid: 208, name: '安平县', code: '131125', lng: '115.51876', lat: '38.23388' },
          { id: 215, pid: 208, name: '故城县', code: '131126', lng: '115.97076', lat: '37.34773' },
          { id: 216, pid: 208, name: '景县', code: '131127', lng: '116.26904', lat: '37.6926' },
          { id: 217, pid: 208, name: '阜城县', code: '131128', lng: '116.14431', lat: '37.86881' },
          { id: 218, pid: 208, name: '冀州市', code: '131181', lng: '115.57934', lat: '37.55082' },
          { id: 219, pid: 208, name: '深州市', code: '131182', lng: '115.55993', lat: '38.00109' },
        ],
      },
    ],
  },
  {
    id: 220,
    pid: 0,
    name: '山西省',
    code: '140000',
    lng: '112.549248',
    lat: '37.857014',
    children: [
      {
        id: 221,
        pid: 220,
        name: '太原市',
        code: '140100',
        lng: '112.549248',
        lat: '37.857014',
        children: [
          { id: 222, pid: 221, name: '小店区', code: '140105', lng: '112.56878', lat: '37.73565' },
          { id: 223, pid: 221, name: '迎泽区', code: '140106', lng: '112.56338', lat: '37.86326' },
          { id: 224, pid: 221, name: '杏花岭区', code: '140107', lng: '112.56237', lat: '37.88429' },
          { id: 225, pid: 221, name: '尖草坪区', code: '140108', lng: '112.48709', lat: '37.94193' },
          { id: 226, pid: 221, name: '万柏林区', code: '140109', lng: '112.51553', lat: '37.85923' },
          { id: 227, pid: 221, name: '晋源区', code: '140110', lng: '112.47985', lat: '37.72479' },
          { id: 228, pid: 221, name: '清徐县', code: '140121', lng: '112.35888', lat: '37.60758' },
          { id: 229, pid: 221, name: '阳曲县', code: '140122', lng: '112.67861', lat: '38.05989' },
          { id: 230, pid: 221, name: '娄烦县', code: '140123', lng: '111.79473', lat: '38.06689' },
          { id: 231, pid: 221, name: '古交市', code: '140181', lng: '112.16918', lat: '37.90983' },
        ],
      },
      {
        id: 232,
        pid: 220,
        name: '大同市',
        code: '140200',
        lng: '113.295259',
        lat: '40.09031',
        children: [
          { id: 233, pid: 232, name: '城区', code: '140202', lng: '113.298', lat: '40.07566' },
          { id: 234, pid: 232, name: '矿区', code: '140203', lng: '113.1772', lat: '40.03685' },
          { id: 235, pid: 232, name: '南郊区', code: '140211', lng: '113.14947', lat: '40.00539' },
          { id: 236, pid: 232, name: '新荣区', code: '140212', lng: '113.13504', lat: '40.25618' },
          { id: 237, pid: 232, name: '阳高县', code: '140221', lng: '113.75012', lat: '40.36256' },
          { id: 238, pid: 232, name: '天镇县', code: '140222', lng: '114.0931', lat: '40.42299' },
          { id: 239, pid: 232, name: '广灵县', code: '140223', lng: '114.28204', lat: '39.76082' },
          { id: 240, pid: 232, name: '灵丘县', code: '140224', lng: '114.23672', lat: '39.44043' },
          { id: 241, pid: 232, name: '浑源县', code: '140225', lng: '113.69552', lat: '39.69962' },
          { id: 242, pid: 232, name: '左云县', code: '140226', lng: '112.70266', lat: '40.01336' },
          { id: 243, pid: 232, name: '大同县', code: '140227', lng: '113.61212', lat: '40.04012' },
        ],
      },
      {
        id: 244,
        pid: 220,
        name: '阳泉市',
        code: '140300',
        lng: '113.583285',
        lat: '37.861188',
        children: [
          { id: 245, pid: 244, name: '城区', code: '140302', lng: '113.60069', lat: '37.8474' },
          { id: 246, pid: 244, name: '矿区', code: '140303', lng: '113.55677', lat: '37.86895' },
          { id: 247, pid: 244, name: '郊区', code: '140311', lng: '113.58539', lat: '37.94139' },
          { id: 248, pid: 244, name: '平定县', code: '140321', lng: '113.65789', lat: '37.78601' },
          { id: 249, pid: 244, name: '盂县', code: '140322', lng: '113.41235', lat: '38.08579' },
        ],
      },
      {
        id: 250,
        pid: 220,
        name: '长治市',
        code: '140400',
        lng: '113.113556',
        lat: '36.191112',
        children: [
          { id: 251, pid: 250, name: '城区', code: '140402', lng: '113.12308', lat: '36.20351' },
          { id: 252, pid: 250, name: '郊区', code: '140411', lng: '113.12653', lat: '36.19918' },
          { id: 253, pid: 250, name: '长治县', code: '140421', lng: '113.04791', lat: '36.04722' },
          { id: 254, pid: 250, name: '襄垣县', code: '140423', lng: '113.05157', lat: '36.53527' },
          { id: 255, pid: 250, name: '屯留县', code: '140424', lng: '112.89196', lat: '36.31579' },
          { id: 256, pid: 250, name: '平顺县', code: '140425', lng: '113.43603', lat: '36.20005' },
          { id: 257, pid: 250, name: '黎城县', code: '140426', lng: '113.38766', lat: '36.50301' },
          { id: 258, pid: 250, name: '壶关县', code: '140427', lng: '113.207', lat: '36.11301' },
          { id: 259, pid: 250, name: '长子县', code: '140428', lng: '112.87731', lat: '36.12125' },
          { id: 260, pid: 250, name: '武乡县', code: '140429', lng: '112.86343', lat: '36.83687' },
          { id: 261, pid: 250, name: '沁县', code: '140430', lng: '112.69863', lat: '36.75628' },
          { id: 262, pid: 250, name: '沁源县', code: '140431', lng: '112.33758', lat: '36.50008' },
          { id: 263, pid: 250, name: '潞城市', code: '140481', lng: '113.22888', lat: '36.33414' },
        ],
      },
      {
        id: 264,
        pid: 220,
        name: '晋城市',
        code: '140500',
        lng: '112.851274',
        lat: '35.497553',
        children: [
          { id: 265, pid: 264, name: '城区', code: '140502', lng: '112.85319', lat: '35.50175' },
          { id: 266, pid: 264, name: '沁水县', code: '140521', lng: '112.1871', lat: '35.69102' },
          { id: 267, pid: 264, name: '阳城县', code: '140522', lng: '112.41485', lat: '35.48614' },
          { id: 268, pid: 264, name: '陵川县', code: '140524', lng: '113.2806', lat: '35.77532' },
          { id: 269, pid: 264, name: '泽州县', code: '140525', lng: '112.83947', lat: '35.50789' },
          { id: 270, pid: 264, name: '高平市', code: '140581', lng: '112.92288', lat: '35.79705' },
        ],
      },
      {
        id: 271,
        pid: 220,
        name: '朔州市',
        code: '140600',
        lng: '112.433387',
        lat: '39.331261',
        children: [
          { id: 272, pid: 271, name: '朔城区', code: '140602', lng: '112.43189', lat: '39.31982' },
          { id: 273, pid: 271, name: '平鲁区', code: '140603', lng: '112.28833', lat: '39.51155' },
          { id: 274, pid: 271, name: '山阴县', code: '140621', lng: '112.81662', lat: '39.52697' },
          { id: 275, pid: 271, name: '应县', code: '140622', lng: '113.19052', lat: '39.55279' },
          { id: 276, pid: 271, name: '右玉县', code: '140623', lng: '112.46902', lat: '39.99011' },
          { id: 277, pid: 271, name: '怀仁县', code: '140624', lng: '113.10009', lat: '39.82806' },
        ],
      },
      {
        id: 278,
        pid: 220,
        name: '晋中市',
        code: '140700',
        lng: '112.736465',
        lat: '37.696495',
        children: [
          { id: 279, pid: 278, name: '榆次区', code: '140702', lng: '112.70788', lat: '37.6978' },
          { id: 280, pid: 278, name: '榆社县', code: '140721', lng: '112.97558', lat: '37.0721' },
          { id: 281, pid: 278, name: '左权县', code: '140722', lng: '113.37918', lat: '37.08235' },
          { id: 282, pid: 278, name: '和顺县', code: '140723', lng: '113.56988', lat: '37.32963' },
          { id: 283, pid: 278, name: '昔阳县', code: '140724', lng: '113.70517', lat: '37.61863' },
          { id: 284, pid: 278, name: '寿阳县', code: '140725', lng: '113.17495', lat: '37.88899' },
          { id: 285, pid: 278, name: '太谷县', code: '140726', lng: '112.55246', lat: '37.42161' },
          { id: 286, pid: 278, name: '祁县', code: '140727', lng: '112.33358', lat: '37.3579' },
          { id: 287, pid: 278, name: '平遥县', code: '140728', lng: '112.17553', lat: '37.1892' },
          { id: 288, pid: 278, name: '灵石县', code: '140729', lng: '111.7774', lat: '36.84814' },
          { id: 289, pid: 278, name: '介休市', code: '140781', lng: '111.91824', lat: '37.02771' },
        ],
      },
      {
        id: 290,
        pid: 220,
        name: '运城市',
        code: '140800',
        lng: '111.003957',
        lat: '35.022778',
        children: [
          { id: 291, pid: 290, name: '盐湖区', code: '140802', lng: '110.99827', lat: '35.0151' },
          { id: 292, pid: 290, name: '临猗县', code: '140821', lng: '110.77432', lat: '35.14455' },
          { id: 293, pid: 290, name: '万荣县', code: '140822', lng: '110.83657', lat: '35.41556' },
          { id: 294, pid: 290, name: '闻喜县', code: '140823', lng: '111.22265', lat: '35.35553' },
          { id: 295, pid: 290, name: '稷山县', code: '140824', lng: '110.97924', lat: '35.59993' },
          { id: 296, pid: 290, name: '新绛县', code: '140825', lng: '111.22509', lat: '35.61566' },
          { id: 297, pid: 290, name: '绛县', code: '140826', lng: '111.56668', lat: '35.49096' },
          { id: 298, pid: 290, name: '垣曲县', code: '140827', lng: '111.67166', lat: '35.29923' },
          { id: 299, pid: 290, name: '夏县', code: '140828', lng: '111.21966', lat: '35.14121' },
          { id: 300, pid: 290, name: '平陆县', code: '140829', lng: '111.21704', lat: '34.83772' },
          { id: 301, pid: 290, name: '芮城县', code: '140830', lng: '110.69455', lat: '34.69384' },
          { id: 302, pid: 290, name: '永济市', code: '140881', lng: '110.44537', lat: '34.86556' },
          { id: 303, pid: 290, name: '河津市', code: '140882', lng: '110.7116', lat: '35.59478' },
        ],
      },
      {
        id: 304,
        pid: 220,
        name: '忻州市',
        code: '140900',
        lng: '112.733538',
        lat: '38.41769',
        children: [
          { id: 305, pid: 304, name: '忻府区', code: '140902', lng: '112.74603', lat: '38.40414' },
          { id: 306, pid: 304, name: '定襄县', code: '140921', lng: '112.95733', lat: '38.47387' },
          { id: 307, pid: 304, name: '五台县', code: '140922', lng: '113.25256', lat: '38.72774' },
          { id: 308, pid: 304, name: '代县', code: '140923', lng: '112.95913', lat: '39.06717' },
          { id: 309, pid: 304, name: '繁峙县', code: '140924', lng: '113.26303', lat: '39.18886' },
          { id: 310, pid: 304, name: '宁武县', code: '140925', lng: '112.30423', lat: '39.00211' },
          { id: 311, pid: 304, name: '静乐县', code: '140926', lng: '111.94158', lat: '38.3602' },
          { id: 312, pid: 304, name: '神池县', code: '140927', lng: '112.20541', lat: '39.09' },
          { id: 313, pid: 304, name: '五寨县', code: '140928', lng: '111.8489', lat: '38.90757' },
          { id: 314, pid: 304, name: '岢岚县', code: '140929', lng: '111.57388', lat: '38.70452' },
          { id: 315, pid: 304, name: '河曲县', code: '140930', lng: '111.13821', lat: '39.38439' },
          { id: 316, pid: 304, name: '保德县', code: '140931', lng: '111.08656', lat: '39.02248' },
          { id: 317, pid: 304, name: '偏关县', code: '140932', lng: '111.50863', lat: '39.43609' },
          { id: 318, pid: 304, name: '原平市', code: '140981', lng: '112.70584', lat: '38.73181' },
        ],
      },
      {
        id: 319,
        pid: 220,
        name: '临汾市',
        code: '141000',
        lng: '111.517973',
        lat: '36.08415',
        children: [
          { id: 320, pid: 319, name: '尧都区', code: '141002', lng: '111.5787', lat: '36.08298' },
          { id: 321, pid: 319, name: '曲沃县', code: '141021', lng: '111.47525', lat: '35.64119' },
          { id: 322, pid: 319, name: '翼城县', code: '141022', lng: '111.7181', lat: '35.73881' },
          { id: 323, pid: 319, name: '襄汾县', code: '141023', lng: '111.44204', lat: '35.87711' },
          { id: 324, pid: 319, name: '洪洞县', code: '141024', lng: '111.67501', lat: '36.25425' },
          { id: 325, pid: 319, name: '古县', code: '141025', lng: '111.92041', lat: '36.26688' },
          { id: 326, pid: 319, name: '安泽县', code: '141026', lng: '112.24981', lat: '36.14803' },
          { id: 327, pid: 319, name: '浮山县', code: '141027', lng: '111.84744', lat: '35.96854' },
          { id: 328, pid: 319, name: '吉县', code: '141028', lng: '110.68148', lat: '36.09873' },
          { id: 329, pid: 319, name: '乡宁县', code: '141029', lng: '110.84652', lat: '35.97072' },
          { id: 330, pid: 319, name: '大宁县', code: '141030', lng: '110.75216', lat: '36.46624' },
          { id: 331, pid: 319, name: '隰县', code: '141031', lng: '110.93881', lat: '36.69258' },
          { id: 332, pid: 319, name: '永和县', code: '141032', lng: '110.63168', lat: '36.7584' },
          { id: 333, pid: 319, name: '蒲县', code: '141033', lng: '111.09674', lat: '36.41243' },
          { id: 334, pid: 319, name: '汾西县', code: '141034', lng: '111.56811', lat: '36.65063' },
          { id: 335, pid: 319, name: '侯马市', code: '141081', lng: '111.37207', lat: '35.61903' },
          { id: 336, pid: 319, name: '霍州市', code: '141082', lng: '111.755', lat: '36.5638' },
        ],
      },
      {
        id: 337,
        pid: 220,
        name: '吕梁市',
        code: '141100',
        lng: '111.134335',
        lat: '37.524366',
        children: [
          { id: 338, pid: 337, name: '离石区', code: '141102', lng: '111.15059', lat: '37.5177' },
          { id: 339, pid: 337, name: '文水县', code: '141121', lng: '112.02829', lat: '37.43841' },
          { id: 340, pid: 337, name: '交城县', code: '141122', lng: '112.1585', lat: '37.5512' },
          { id: 341, pid: 337, name: '兴县', code: '141123', lng: '111.12692', lat: '38.46321' },
          { id: 342, pid: 337, name: '临县', code: '141124', lng: '110.99282', lat: '37.95271' },
          { id: 343, pid: 337, name: '柳林县', code: '141125', lng: '110.88922', lat: '37.42932' },
          { id: 344, pid: 337, name: '石楼县', code: '141126', lng: '110.8352', lat: '36.99731' },
          { id: 345, pid: 337, name: '岚县', code: '141127', lng: '111.67627', lat: '38.27874' },
          { id: 346, pid: 337, name: '方山县', code: '141128', lng: '111.24011', lat: '37.88979' },
          { id: 347, pid: 337, name: '中阳县', code: '141129', lng: '111.1795', lat: '37.35715' },
          { id: 348, pid: 337, name: '交口县', code: '141130', lng: '111.18103', lat: '36.98213' },
          { id: 349, pid: 337, name: '孝义市', code: '141181', lng: '111.77362', lat: '37.14414' },
          { id: 350, pid: 337, name: '汾阳市', code: '141182', lng: '111.7882', lat: '37.26605' },
        ],
      },
    ],
  },
  {
    id: 351,
    pid: 0,
    name: '内蒙古自治区',
    code: '150000',
    lng: '111.670801',
    lat: '40.818311',
    children: [
      {
        id: 352,
        pid: 351,
        name: '呼和浩特市',
        code: '150100',
        lng: '111.670801',
        lat: '40.818311',
        children: [
          { id: 353, pid: 352, name: '新城区', code: '150102', lng: '111.66554', lat: '40.85828' },
          { id: 354, pid: 352, name: '回民区', code: '150103', lng: '111.62402', lat: '40.80827' },
          { id: 355, pid: 352, name: '玉泉区', code: '150104', lng: '111.67456', lat: '40.75227' },
          { id: 356, pid: 352, name: '赛罕区', code: '150105', lng: '111.70224', lat: '40.79207' },
          { id: 357, pid: 352, name: '土默特左旗', code: '150121', lng: '111.14898', lat: '40.72229' },
          { id: 358, pid: 352, name: '托克托县', code: '150122', lng: '111.19101', lat: '40.27492' },
          { id: 359, pid: 352, name: '和林格尔县', code: '150123', lng: '111.82205', lat: '40.37892' },
          { id: 360, pid: 352, name: '清水河县', code: '150124', lng: '111.68316', lat: '39.9097' },
          { id: 361, pid: 352, name: '武川县', code: '150125', lng: '111.45785', lat: '41.09289' },
        ],
      },
      {
        id: 362,
        pid: 351,
        name: '包头市',
        code: '150200',
        lng: '109.840405',
        lat: '40.658168',
        children: [
          { id: 363, pid: 362, name: '东河区', code: '150202', lng: '110.0462', lat: '40.58237' },
          { id: 364, pid: 362, name: '昆都仑区', code: '150203', lng: '109.83862', lat: '40.64175' },
          { id: 365, pid: 362, name: '青山区', code: '150204', lng: '109.90131', lat: '40.64329' },
          { id: 366, pid: 362, name: '石拐区', code: '150205', lng: '110.27322', lat: '40.67297' },
          { id: 367, pid: 362, name: '白云鄂博矿区', code: '150206', lng: '109.97367', lat: '41.76968' },
          { id: 368, pid: 362, name: '九原区', code: '150207', lng: '109.96496', lat: '40.60554' },
          { id: 369, pid: 362, name: '土默特右旗', code: '150221', lng: '110.52417', lat: '40.5688' },
          { id: 370, pid: 362, name: '固阳县', code: '150222', lng: '110.06372', lat: '41.01851' },
          { id: 371, pid: 362, name: '达尔罕茂明安联合旗', code: '150223', lng: '110.43258', lat: '41.69875' },
        ],
      },
      {
        id: 372,
        pid: 351,
        name: '乌海市',
        code: '150300',
        lng: '106.825563',
        lat: '39.673734',
        children: [
          { id: 373, pid: 372, name: '海勃湾区', code: '150302', lng: '106.8222', lat: '39.66955' },
          { id: 374, pid: 372, name: '海南区', code: '150303', lng: '106.88656', lat: '39.44128' },
          { id: 375, pid: 372, name: '乌达区', code: '150304', lng: '106.72723', lat: '39.505' },
        ],
      },
      {
        id: 376,
        pid: 351,
        name: '赤峰市',
        code: '150400',
        lng: '118.956806',
        lat: '42.275317',
        children: [
          { id: 377, pid: 376, name: '红山区', code: '150402', lng: '118.95755', lat: '42.24312' },
          { id: 378, pid: 376, name: '元宝山区', code: '150403', lng: '119.28921', lat: '42.04005' },
          { id: 379, pid: 376, name: '松山区', code: '150404', lng: '118.9328', lat: '42.28613' },
          { id: 380, pid: 376, name: '阿鲁科尔沁旗', code: '150421', lng: '120.06527', lat: '43.87988' },
          { id: 381, pid: 376, name: '巴林左旗', code: '150422', lng: '119.38012', lat: '43.97031' },
          { id: 382, pid: 376, name: '巴林右旗', code: '150423', lng: '118.66461', lat: '43.53387' },
          { id: 383, pid: 376, name: '林西县', code: '150424', lng: '118.04733', lat: '43.61165' },
          { id: 384, pid: 376, name: '克什克腾旗', code: '150425', lng: '117.54562', lat: '43.26501' },
          { id: 385, pid: 376, name: '翁牛特旗', code: '150426', lng: '119.03042', lat: '42.93147' },
          { id: 386, pid: 376, name: '喀喇沁旗', code: '150428', lng: '118.70144', lat: '41.92917' },
          { id: 387, pid: 376, name: '宁城县', code: '150429', lng: '119.34375', lat: '41.59661' },
          { id: 388, pid: 376, name: '敖汉旗', code: '150430', lng: '119.92163', lat: '42.29071' },
        ],
      },
      {
        id: 389,
        pid: 351,
        name: '通辽市',
        code: '150500',
        lng: '122.263119',
        lat: '43.617429',
        children: [
          { id: 390, pid: 389, name: '科尔沁区', code: '150502', lng: '122.25573', lat: '43.62257' },
          { id: 391, pid: 389, name: '科尔沁左翼中旗', code: '150521', lng: '123.31912', lat: '44.13014' },
          { id: 392, pid: 389, name: '科尔沁左翼后旗', code: '150522', lng: '122.35745', lat: '42.94897' },
          { id: 393, pid: 389, name: '开鲁县', code: '150523', lng: '121.31884', lat: '43.60003' },
          { id: 394, pid: 389, name: '库伦旗', code: '150524', lng: '121.776', lat: '42.72998' },
          { id: 395, pid: 389, name: '奈曼旗', code: '150525', lng: '120.66348', lat: '42.84527' },
          { id: 396, pid: 389, name: '扎鲁特旗', code: '150526', lng: '120.91507', lat: '44.55592' },
          { id: 397, pid: 389, name: '霍林郭勒市', code: '150581', lng: '119.65429', lat: '45.53454' },
        ],
      },
      {
        id: 398,
        pid: 351,
        name: '鄂尔多斯市',
        code: '150600',
        lng: '109.99029',
        lat: '39.817179',
        children: [
          { id: 399, pid: 398, name: '东胜区', code: '150602', lng: '109.96289', lat: '39.82236' },
          { id: 400, pid: 398, name: '达拉特旗', code: '150621', lng: '110.03317', lat: '40.4001' },
          { id: 401, pid: 398, name: '准格尔旗', code: '150622', lng: '111.23645', lat: '39.86783' },
          { id: 402, pid: 398, name: '鄂托克前旗', code: '150623', lng: '107.48403', lat: '38.18396' },
          { id: 403, pid: 398, name: '鄂托克旗', code: '150624', lng: '107.98226', lat: '39.09456' },
          { id: 404, pid: 398, name: '杭锦旗', code: '150625', lng: '108.72934', lat: '39.84023' },
          { id: 405, pid: 398, name: '乌审旗', code: '150626', lng: '108.8461', lat: '38.59092' },
          { id: 406, pid: 398, name: '伊金霍洛旗', code: '150627', lng: '109.74908', lat: '39.57393' },
        ],
      },
      {
        id: 407,
        pid: 351,
        name: '呼伦贝尔市',
        code: '150700',
        lng: '119.758168',
        lat: '49.215333',
        children: [
          { id: 408, pid: 407, name: '海拉尔区', code: '150702', lng: '119.7364', lat: '49.2122' },
          { id: 409, pid: 407, name: '扎赉诺尔区', code: '150703', lng: '117.792702', lat: '49.486943' },
          { id: 410, pid: 407, name: '阿荣旗', code: '150721', lng: '123.45941', lat: '48.12581' },
          { id: 411, pid: 407, name: '莫力达瓦达斡尔族自治旗', code: '150722', lng: '124.51498', lat: '48.48055' },
          { id: 412, pid: 407, name: '鄂伦春自治旗', code: '150723', lng: '123.72604', lat: '50.59777' },
          { id: 413, pid: 407, name: '鄂温克族自治旗', code: '150724', lng: '119.7565', lat: '49.14284' },
          { id: 414, pid: 407, name: '陈巴尔虎旗', code: '150725', lng: '119.42434', lat: '49.32684' },
          { id: 415, pid: 407, name: '新巴尔虎左旗', code: '150726', lng: '118.26989', lat: '48.21842' },
          { id: 416, pid: 407, name: '新巴尔虎右旗', code: '150727', lng: '116.82366', lat: '48.66473' },
          { id: 417, pid: 407, name: '满洲里市', code: '150781', lng: '117.47946', lat: '49.58272' },
          { id: 418, pid: 407, name: '牙克石市', code: '150782', lng: '120.7117', lat: '49.2856' },
          { id: 419, pid: 407, name: '扎兰屯市', code: '150783', lng: '122.73757', lat: '48.01363' },
          { id: 420, pid: 407, name: '额尔古纳市', code: '150784', lng: '120.19094', lat: '50.24249' },
          { id: 421, pid: 407, name: '根河市', code: '150785', lng: '121.52197', lat: '50.77996' },
        ],
      },
      {
        id: 422,
        pid: 351,
        name: '巴彦淖尔市',
        code: '150800',
        lng: '107.416959',
        lat: '40.757402',
        children: [
          { id: 423, pid: 422, name: '临河区', code: '150802', lng: '107.42668', lat: '40.75827' },
          { id: 424, pid: 422, name: '五原县', code: '150821', lng: '108.26916', lat: '41.09631' },
          { id: 425, pid: 422, name: '磴口县', code: '150822', lng: '107.00936', lat: '40.33062' },
          { id: 426, pid: 422, name: '乌拉特前旗', code: '150823', lng: '108.65219', lat: '40.73649' },
          { id: 427, pid: 422, name: '乌拉特中旗', code: '150824', lng: '108.52587', lat: '41.56789' },
          { id: 428, pid: 422, name: '乌拉特后旗', code: '150825', lng: '106.98971', lat: '41.43151' },
          { id: 429, pid: 422, name: '杭锦后旗', code: '150826', lng: '107.15133', lat: '40.88627' },
        ],
      },
      {
        id: 430,
        pid: 351,
        name: '乌兰察布市',
        code: '150900',
        lng: '113.114543',
        lat: '41.034126',
        children: [
          { id: 431, pid: 430, name: '集宁区', code: '150902', lng: '113.11452', lat: '41.0353' },
          { id: 432, pid: 430, name: '卓资县', code: '150921', lng: '112.57757', lat: '40.89414' },
          { id: 433, pid: 430, name: '化德县', code: '150922', lng: '114.01071', lat: '41.90433' },
          { id: 434, pid: 430, name: '商都县', code: '150923', lng: '113.57772', lat: '41.56213' },
          { id: 435, pid: 430, name: '兴和县', code: '150924', lng: '113.83395', lat: '40.87186' },
          { id: 436, pid: 430, name: '凉城县', code: '150925', lng: '112.49569', lat: '40.53346' },
          { id: 437, pid: 430, name: '察哈尔右翼前旗', code: '150926', lng: '113.22131', lat: '40.7788' },
          { id: 438, pid: 430, name: '察哈尔右翼中旗', code: '150927', lng: '112.63537', lat: '41.27742' },
          { id: 439, pid: 430, name: '察哈尔右翼后旗', code: '150928', lng: '113.19216', lat: '41.43554' },
          { id: 440, pid: 430, name: '四子王旗', code: '150929', lng: '111.70654', lat: '41.53312' },
          { id: 441, pid: 430, name: '丰镇市', code: '150981', lng: '113.10983', lat: '40.4369' },
        ],
      },
      {
        id: 442,
        pid: 351,
        name: '兴安盟',
        code: '152200',
        lng: '122.070317',
        lat: '46.076268',
        children: [
          { id: 443, pid: 442, name: '乌兰浩特市', code: '152201', lng: '122.06378', lat: '46.06235' },
          { id: 444, pid: 442, name: '阿尔山市', code: '152202', lng: '119.94317', lat: '47.17716' },
          { id: 445, pid: 442, name: '科尔沁右翼前旗', code: '152221', lng: '121.95269', lat: '46.0795' },
          { id: 446, pid: 442, name: '科尔沁右翼中旗', code: '152222', lng: '121.46807', lat: '45.05605' },
          { id: 447, pid: 442, name: '扎赉特旗', code: '152223', lng: '122.91229', lat: '46.7267' },
          { id: 448, pid: 442, name: '突泉县', code: '152224', lng: '121.59396', lat: '45.38187' },
        ],
      },
      {
        id: 449,
        pid: 351,
        name: '锡林郭勒盟',
        code: '152500',
        lng: '116.090996',
        lat: '43.944018',
        children: [
          { id: 450, pid: 449, name: '二连浩特市', code: '152501', lng: '111.98297', lat: '43.65303' },
          { id: 451, pid: 449, name: '锡林浩特市', code: '152502', lng: '116.08603', lat: '43.93341' },
          { id: 452, pid: 449, name: '阿巴嘎旗', code: '152522', lng: '114.96826', lat: '44.02174' },
          { id: 453, pid: 449, name: '苏尼特左旗', code: '152523', lng: '113.6506', lat: '43.85687' },
          { id: 454, pid: 449, name: '苏尼特右旗', code: '152524', lng: '112.65741', lat: '42.7469' },
          { id: 455, pid: 449, name: '东乌珠穆沁旗', code: '152525', lng: '116.97293', lat: '45.51108' },
          { id: 456, pid: 449, name: '西乌珠穆沁旗', code: '152526', lng: '117.60983', lat: '44.59623' },
          { id: 457, pid: 449, name: '太仆寺旗', code: '152527', lng: '115.28302', lat: '41.87727' },
          { id: 458, pid: 449, name: '镶黄旗', code: '152528', lng: '113.84472', lat: '42.23927' },
          { id: 459, pid: 449, name: '正镶白旗', code: '152529', lng: '115.00067', lat: '42.30712' },
          { id: 460, pid: 449, name: '正蓝旗', code: '152530', lng: '116.00363', lat: '42.25229' },
          { id: 461, pid: 449, name: '多伦县', code: '152531', lng: '116.48565', lat: '42.203' },
        ],
      },
      {
        id: 462,
        pid: 351,
        name: '阿拉善盟',
        code: '152900',
        lng: '105.706422',
        lat: '38.844814',
        children: [
          { id: 463, pid: 462, name: '阿拉善左旗', code: '152921', lng: '105.67532', lat: '38.8293' },
          { id: 464, pid: 462, name: '阿拉善右旗', code: '152922', lng: '101.66705', lat: '39.21533' },
          { id: 465, pid: 462, name: '额济纳旗', code: '152923', lng: '101.06887', lat: '41.96755' },
        ],
      },
    ],
  },
  {
    id: 466,
    pid: 0,
    name: '辽宁省',
    code: '210000',
    lng: '123.429096',
    lat: '41.796767',
    children: [
      {
        id: 467,
        pid: 466,
        name: '沈阳市',
        code: '210100',
        lng: '123.429096',
        lat: '41.796767',
        children: [
          { id: 468, pid: 467, name: '和平区', code: '210102', lng: '123.4204', lat: '41.78997' },
          { id: 469, pid: 467, name: '沈河区', code: '210103', lng: '123.45871', lat: '41.79625' },
          { id: 470, pid: 467, name: '大东区', code: '210104', lng: '123.46997', lat: '41.80539' },
          { id: 471, pid: 467, name: '皇姑区', code: '210105', lng: '123.42527', lat: '41.82035' },
          { id: 472, pid: 467, name: '铁西区', code: '210106', lng: '123.37675', lat: '41.80269' },
          { id: 473, pid: 467, name: '苏家屯区', code: '210111', lng: '123.34405', lat: '41.66475' },
          { id: 474, pid: 467, name: '浑南区', code: '210112', lng: '123.457707', lat: '41.719450' },
          { id: 475, pid: 467, name: '沈北新区', code: '210113', lng: '123.52658', lat: '42.05297' },
          { id: 476, pid: 467, name: '于洪区', code: '210114', lng: '123.30807', lat: '41.794' },
          { id: 477, pid: 467, name: '辽中县', code: '210122', lng: '122.72659', lat: '41.51302' },
          { id: 478, pid: 467, name: '康平县', code: '210123', lng: '123.35446', lat: '42.75081' },
          { id: 479, pid: 467, name: '法库县', code: '210124', lng: '123.41214', lat: '42.50608' },
          { id: 480, pid: 467, name: '新民市', code: '210181', lng: '122.82867', lat: '41.99847' },
        ],
      },
      {
        id: 481,
        pid: 466,
        name: '大连市',
        code: '210200',
        lng: '121.618622',
        lat: '38.91459',
        children: [
          { id: 482, pid: 481, name: '中山区', code: '210202', lng: '121.64465', lat: '38.91859' },
          { id: 483, pid: 481, name: '西岗区', code: '210203', lng: '121.61238', lat: '38.91469' },
          { id: 484, pid: 481, name: '沙河口区', code: '210204', lng: '121.58017', lat: '38.90536' },
          { id: 485, pid: 481, name: '甘井子区', code: '210211', lng: '121.56567', lat: '38.95017' },
          { id: 486, pid: 481, name: '旅顺口区', code: '210212', lng: '121.26202', lat: '38.85125' },
          { id: 487, pid: 481, name: '金州区', code: '210213', lng: '121.71893', lat: '39.1004' },
          { id: 488, pid: 481, name: '长海县', code: '210224', lng: '122.58859', lat: '39.27274' },
          { id: 489, pid: 481, name: '瓦房店市', code: '210281', lng: '121.98104', lat: '39.62843' },
          { id: 490, pid: 481, name: '普兰店市', code: '210282', lng: '121.96316', lat: '39.39465' },
          { id: 491, pid: 481, name: '庄河市', code: '210283', lng: '122.96725', lat: '39.68815' },
        ],
      },
      {
        id: 492,
        pid: 466,
        name: '鞍山市',
        code: '210300',
        lng: '122.995632',
        lat: '41.110626',
        children: [
          { id: 493, pid: 492, name: '铁东区', code: '210302', lng: '122.99085', lat: '41.08975' },
          { id: 494, pid: 492, name: '铁西区', code: '210303', lng: '122.96967', lat: '41.11977' },
          { id: 495, pid: 492, name: '立山区', code: '210304', lng: '123.02948', lat: '41.15008' },
          { id: 496, pid: 492, name: '千山区', code: '210311', lng: '122.96048', lat: '41.07507' },
          { id: 497, pid: 492, name: '台安县', code: '210321', lng: '122.43585', lat: '41.41265' },
          { id: 498, pid: 492, name: '岫岩满族自治县', code: '210323', lng: '123.28875', lat: '40.27996' },
          { id: 499, pid: 492, name: '海城市', code: '210381', lng: '122.68457', lat: '40.88142' },
        ],
      },
      {
        id: 500,
        pid: 466,
        name: '抚顺市',
        code: '210400',
        lng: '123.921109',
        lat: '41.875956',
        children: [
          { id: 501, pid: 500, name: '新抚区', code: '210402', lng: '123.91264', lat: '41.86205' },
          { id: 502, pid: 500, name: '东洲区', code: '210403', lng: '124.03759', lat: '41.8519' },
          { id: 503, pid: 500, name: '望花区', code: '210404', lng: '123.78283', lat: '41.85532' },
          { id: 504, pid: 500, name: '顺城区', code: '210411', lng: '123.94506', lat: '41.88321' },
          { id: 505, pid: 500, name: '抚顺县', code: '210421', lng: '124.17755', lat: '41.71217' },
          { id: 506, pid: 500, name: '新宾满族自治县', code: '210422', lng: '125.04049', lat: '41.73409' },
          { id: 507, pid: 500, name: '清原满族自治县', code: '210423', lng: '124.92807', lat: '42.10221' },
        ],
      },
      {
        id: 508,
        pid: 466,
        name: '本溪市',
        code: '210500',
        lng: '123.770519',
        lat: '41.297909',
        children: [
          { id: 509, pid: 508, name: '平山区', code: '210502', lng: '123.76892', lat: '41.2997' },
          { id: 510, pid: 508, name: '溪湖区', code: '210503', lng: '123.76764', lat: '41.32921' },
          { id: 511, pid: 508, name: '明山区', code: '210504', lng: '123.81746', lat: '41.30827' },
          { id: 512, pid: 508, name: '南芬区', code: '210505', lng: '123.74523', lat: '41.1006' },
          { id: 513, pid: 508, name: '本溪满族自治县', code: '210521', lng: '124.12741', lat: '41.30059' },
          { id: 514, pid: 508, name: '桓仁满族自治县', code: '210522', lng: '125.36062', lat: '41.26798' },
        ],
      },
      {
        id: 515,
        pid: 466,
        name: '丹东市',
        code: '210600',
        lng: '124.383044',
        lat: '40.124296',
        children: [
          { id: 516, pid: 515, name: '元宝区', code: '210602', lng: '124.39575', lat: '40.13651' },
          { id: 517, pid: 515, name: '振兴区', code: '210603', lng: '124.36035', lat: '40.10489' },
          { id: 518, pid: 515, name: '振安区', code: '210604', lng: '124.42816', lat: '40.15826' },
          { id: 519, pid: 515, name: '宽甸满族自治县', code: '210624', lng: '124.78247', lat: '40.73187' },
          { id: 520, pid: 515, name: '东港市', code: '210681', lng: '124.16287', lat: '39.86256' },
          { id: 521, pid: 515, name: '凤城市', code: '210682', lng: '124.06671', lat: '40.45302' },
        ],
      },
      {
        id: 522,
        pid: 466,
        name: '锦州市',
        code: '210700',
        lng: '121.135742',
        lat: '41.119269',
        children: [
          { id: 523, pid: 522, name: '古塔区', code: '210702', lng: '121.12832', lat: '41.11725' },
          { id: 524, pid: 522, name: '凌河区', code: '210703', lng: '121.15089', lat: '41.11496' },
          { id: 525, pid: 522, name: '太和区', code: '210711', lng: '121.10354', lat: '41.10929' },
          { id: 526, pid: 522, name: '黑山县', code: '210726', lng: '122.12081', lat: '41.69417' },
          { id: 527, pid: 522, name: '义县', code: '210727', lng: '121.24035', lat: '41.53458' },
          { id: 528, pid: 522, name: '凌海市', code: '210781', lng: '121.35705', lat: '41.1737' },
          { id: 529, pid: 522, name: '北镇市', code: '210782', lng: '121.79858', lat: '41.59537' },
        ],
      },
      {
        id: 530,
        pid: 466,
        name: '营口市',
        code: '210800',
        lng: '122.235151',
        lat: '40.667432',
        children: [
          { id: 531, pid: 530, name: '站前区', code: '210802', lng: '122.25896', lat: '40.67266' },
          { id: 532, pid: 530, name: '西市区', code: '210803', lng: '122.20641', lat: '40.6664' },
          { id: 533, pid: 530, name: '鲅鱼圈区', code: '210804', lng: '122.13266', lat: '40.26865' },
          { id: 534, pid: 530, name: '老边区', code: '210811', lng: '122.37996', lat: '40.6803' },
          { id: 535, pid: 530, name: '盖州市', code: '210881', lng: '122.35464', lat: '40.40446' },
          { id: 536, pid: 530, name: '大石桥市', code: '210882', lng: '122.50927', lat: '40.64567' },
        ],
      },
      {
        id: 537,
        pid: 466,
        name: '阜新市',
        code: '210900',
        lng: '121.648962',
        lat: '42.011796',
        children: [
          { id: 538, pid: 537, name: '海州区', code: '210902', lng: '121.65626', lat: '42.01336' },
          { id: 539, pid: 537, name: '新邱区', code: '210903', lng: '121.79251', lat: '42.09181' },
          { id: 540, pid: 537, name: '太平区', code: '210904', lng: '121.67865', lat: '42.01065' },
          { id: 541, pid: 537, name: '清河门区', code: '210905', lng: '121.4161', lat: '41.78309' },
          { id: 542, pid: 537, name: '细河区', code: '210911', lng: '121.68013', lat: '42.02533' },
          { id: 543, pid: 537, name: '阜新蒙古族自治县', code: '210921', lng: '121.75787', lat: '42.0651' },
          { id: 544, pid: 537, name: '彰武县', code: '210922', lng: '122.54022', lat: '42.38625' },
        ],
      },
      {
        id: 545,
        pid: 466,
        name: '辽阳市',
        code: '211000',
        lng: '123.18152',
        lat: '41.269402',
        children: [
          { id: 546, pid: 545, name: '白塔区', code: '211002', lng: '123.1747', lat: '41.27025' },
          { id: 547, pid: 545, name: '文圣区', code: '211003', lng: '123.18521', lat: '41.26267' },
          { id: 548, pid: 545, name: '宏伟区', code: '211004', lng: '123.1929', lat: '41.21852' },
          { id: 549, pid: 545, name: '弓长岭区', code: '211005', lng: '123.41963', lat: '41.15181' },
          { id: 550, pid: 545, name: '太子河区', code: '211011', lng: '123.18182', lat: '41.25337' },
          { id: 551, pid: 545, name: '辽阳县', code: '211021', lng: '123.10574', lat: '41.20542' },
          { id: 552, pid: 545, name: '灯塔市', code: '211081', lng: '123.33926', lat: '41.42612' },
        ],
      },
      {
        id: 553,
        pid: 466,
        name: '盘锦市',
        code: '211100',
        lng: '122.06957',
        lat: '41.124484',
        children: [
          { id: 554, pid: 553, name: '双台子区', code: '211102', lng: '122.06011', lat: '41.1906' },
          { id: 555, pid: 553, name: '兴隆台区', code: '211103', lng: '122.07529', lat: '41.12402' },
          { id: 556, pid: 553, name: '大洼县', code: '211121', lng: '122.08239', lat: '41.00244' },
          { id: 557, pid: 553, name: '盘山县', code: '211122', lng: '121.99777', lat: '41.23805' },
        ],
      },
      {
        id: 558,
        pid: 466,
        name: '铁岭市',
        code: '211200',
        lng: '123.844279',
        lat: '42.290585',
        children: [
          { id: 559, pid: 558, name: '银州区', code: '211202', lng: '123.8573', lat: '42.29507' },
          { id: 560, pid: 558, name: '清河区', code: '211204', lng: '124.15911', lat: '42.54679' },
          { id: 561, pid: 558, name: '铁岭县', code: '211221', lng: '123.77325', lat: '42.22498' },
          { id: 562, pid: 558, name: '西丰县', code: '211223', lng: '124.7304', lat: '42.73756' },
          { id: 563, pid: 558, name: '昌图县', code: '211224', lng: '124.11206', lat: '42.78428' },
          { id: 564, pid: 558, name: '调兵山市', code: '211281', lng: '123.56689', lat: '42.4675' },
          { id: 565, pid: 558, name: '开原市', code: '211282', lng: '124.03945', lat: '42.54585' },
        ],
      },
      {
        id: 566,
        pid: 466,
        name: '朝阳市',
        code: '211300',
        lng: '120.451176',
        lat: '41.576758',
        children: [
          { id: 567, pid: 566, name: '双塔区', code: '211302', lng: '120.45385', lat: '41.566' },
          { id: 568, pid: 566, name: '龙城区', code: '211303', lng: '120.43719', lat: '41.59264' },
          { id: 569, pid: 566, name: '朝阳县', code: '211321', lng: '120.17401', lat: '41.4324' },
          { id: 570, pid: 566, name: '建平县', code: '211322', lng: '119.64392', lat: '41.40315' },
          { id: 571, pid: 566, name: '喀喇沁左翼蒙古族自治县', code: '211324', lng: '119.74185', lat: '41.12801' },
          { id: 572, pid: 566, name: '北票市', code: '211381', lng: '120.76977', lat: '41.80196' },
          { id: 573, pid: 566, name: '凌源市', code: '211382', lng: '119.40148', lat: '41.24558' },
        ],
      },
      {
        id: 574,
        pid: 466,
        name: '葫芦岛市',
        code: '211400',
        lng: '120.856394',
        lat: '40.755572',
        children: [
          { id: 575, pid: 574, name: '连山区', code: '211402', lng: '120.86393', lat: '40.75554' },
          { id: 576, pid: 574, name: '龙港区', code: '211403', lng: '120.94866', lat: '40.71919' },
          { id: 577, pid: 574, name: '南票区', code: '211404', lng: '120.74978', lat: '41.10707' },
          { id: 578, pid: 574, name: '绥中县', code: '211421', lng: '120.34451', lat: '40.32552' },
          { id: 579, pid: 574, name: '建昌县', code: '211422', lng: '119.8377', lat: '40.82448' },
          { id: 580, pid: 574, name: '兴城市', code: '211481', lng: '120.72537', lat: '40.61492' },
        ],
      },
      {
        id: 581,
        pid: 466,
        name: '金普新区',
        code: '211500',
        lng: '121.789627',
        lat: '39.055451',
        children: [
          { id: 582, pid: 581, name: '金州新区', code: '211501', lng: '121.784821', lat: '39.052252' },
          { id: 583, pid: 581, name: '普湾新区', code: '211502', lng: '121.812812', lat: '39.330093' },
          { id: 584, pid: 581, name: '保税区', code: '211503', lng: '121.94289', lat: '39.224614' },
        ],
      },
    ],
  },
  {
    id: 585,
    pid: 0,
    name: '吉林省',
    code: '220000',
    lng: '125.3245',
    lat: '43.886841',
    children: [
      {
        id: 586,
        pid: 585,
        name: '长春市',
        code: '220100',
        lng: '125.3245',
        lat: '43.886841',
        children: [
          { id: 587, pid: 586, name: '南关区', code: '220102', lng: '125.35035', lat: '43.86401' },
          { id: 588, pid: 586, name: '宽城区', code: '220103', lng: '125.32635', lat: '43.90182' },
          { id: 589, pid: 586, name: '朝阳区', code: '220104', lng: '125.2883', lat: '43.83339' },
          { id: 590, pid: 586, name: '二道区', code: '220105', lng: '125.37429', lat: '43.86501' },
          { id: 591, pid: 586, name: '绿园区', code: '220106', lng: '125.25582', lat: '43.88045' },
          { id: 592, pid: 586, name: '双阳区', code: '220112', lng: '125.65631', lat: '43.52803' },
          { id: 593, pid: 586, name: '九台区', code: '220113', lng: '125.8395', lat: '44.15163' },
          { id: 594, pid: 586, name: '农安县', code: '220122', lng: '125.18481', lat: '44.43265' },
          { id: 595, pid: 586, name: '榆树市', code: '220182', lng: '126.55688', lat: '44.82523' },
          { id: 596, pid: 586, name: '德惠市', code: '220183', lng: '125.70538', lat: '44.53719' },
        ],
      },
      {
        id: 597,
        pid: 585,
        name: '吉林市',
        code: '220200',
        lng: '126.55302',
        lat: '43.843577',
        children: [
          { id: 598, pid: 597, name: '昌邑区', code: '220202', lng: '126.57424', lat: '43.88183' },
          { id: 599, pid: 597, name: '龙潭区', code: '220203', lng: '126.56213', lat: '43.91054' },
          { id: 600, pid: 597, name: '船营区', code: '220204', lng: '126.54096', lat: '43.83344' },
          { id: 601, pid: 597, name: '丰满区', code: '220211', lng: '126.56237', lat: '43.82236' },
          { id: 602, pid: 597, name: '永吉县', code: '220221', lng: '126.4963', lat: '43.67197' },
          { id: 603, pid: 597, name: '蛟河市', code: '220281', lng: '127.34426', lat: '43.72696' },
          { id: 604, pid: 597, name: '桦甸市', code: '220282', lng: '126.74624', lat: '42.97206' },
          { id: 605, pid: 597, name: '舒兰市', code: '220283', lng: '126.9653', lat: '44.40582' },
          { id: 606, pid: 597, name: '磐石市', code: '220284', lng: '126.0625', lat: '42.94628' },
        ],
      },
      {
        id: 607,
        pid: 585,
        name: '四平市',
        code: '220300',
        lng: '124.370785',
        lat: '43.170344',
        children: [
          { id: 608, pid: 607, name: '铁西区', code: '220302', lng: '124.37369', lat: '43.17456' },
          { id: 609, pid: 607, name: '铁东区', code: '220303', lng: '124.40976', lat: '43.16241' },
          { id: 610, pid: 607, name: '梨树县', code: '220322', lng: '124.33563', lat: '43.30717' },
          { id: 611, pid: 607, name: '伊通满族自治县', code: '220323', lng: '125.30596', lat: '43.34434' },
          { id: 612, pid: 607, name: '公主岭市', code: '220381', lng: '124.82266', lat: '43.50453' },
          { id: 613, pid: 607, name: '双辽市', code: '220382', lng: '123.50106', lat: '43.52099' },
        ],
      },
      {
        id: 614,
        pid: 585,
        name: '辽源市',
        code: '220400',
        lng: '125.145349',
        lat: '42.902692',
        children: [
          { id: 615, pid: 614, name: '龙山区', code: '220402', lng: '125.13641', lat: '42.89714' },
          { id: 616, pid: 614, name: '西安区', code: '220403', lng: '125.14904', lat: '42.927' },
          { id: 617, pid: 614, name: '东丰县', code: '220421', lng: '125.53244', lat: '42.6783' },
          { id: 618, pid: 614, name: '东辽县', code: '220422', lng: '124.98596', lat: '42.92492' },
        ],
      },
      {
        id: 619,
        pid: 585,
        name: '通化市',
        code: '220500',
        lng: '125.936501',
        lat: '41.721177',
        children: [
          { id: 620, pid: 619, name: '东昌区', code: '220502', lng: '125.9551', lat: '41.72849' },
          { id: 621, pid: 619, name: '二道江区', code: '220503', lng: '126.04257', lat: '41.7741' },
          { id: 622, pid: 619, name: '通化县', code: '220521', lng: '125.75936', lat: '41.67928' },
          { id: 623, pid: 619, name: '辉南县', code: '220523', lng: '126.04684', lat: '42.68497' },
          { id: 624, pid: 619, name: '柳河县', code: '220524', lng: '125.74475', lat: '42.28468' },
          { id: 625, pid: 619, name: '梅河口市', code: '220581', lng: '125.71041', lat: '42.53828' },
          { id: 626, pid: 619, name: '集安市', code: '220582', lng: '126.18829', lat: '41.12268' },
        ],
      },
      {
        id: 627,
        pid: 585,
        name: '白山市',
        code: '220600',
        lng: '126.427839',
        lat: '41.942505',
        children: [
          { id: 628, pid: 627, name: '浑江区', code: '220602', lng: '126.422342', lat: '41.945656' },
          { id: 629, pid: 627, name: '江源区', code: '220605', lng: '126.59079', lat: '42.05664' },
          { id: 630, pid: 627, name: '抚松县', code: '220621', lng: '127.2803', lat: '42.34198' },
          { id: 631, pid: 627, name: '靖宇县', code: '220622', lng: '126.81308', lat: '42.38863' },
          { id: 632, pid: 627, name: '长白朝鲜族自治县', code: '220623', lng: '128.20047', lat: '41.41996' },
          { id: 633, pid: 627, name: '临江市', code: '220681', lng: '126.91751', lat: '41.81142' },
        ],
      },
      {
        id: 634,
        pid: 585,
        name: '松原市',
        code: '220700',
        lng: '124.823608',
        lat: '45.118243',
        children: [
          { id: 635, pid: 634, name: '宁江区', code: '220702', lng: '124.81689', lat: '45.17175' },
          { id: 636, pid: 634, name: '前郭尔罗斯蒙古族自治县', code: '220721', lng: '124.82351', lat: '45.11726' },
          { id: 637, pid: 634, name: '长岭县', code: '220722', lng: '123.96725', lat: '44.27581' },
          { id: 638, pid: 634, name: '乾安县', code: '220723', lng: '124.02737', lat: '45.01068' },
          { id: 639, pid: 634, name: '扶余市', code: '220781', lng: '126.042758', lat: '44.986199' },
        ],
      },
      {
        id: 640,
        pid: 585,
        name: '白城市',
        code: '220800',
        lng: '122.841114',
        lat: '45.619026',
        children: [
          { id: 641, pid: 640, name: '洮北区', code: '220802', lng: '122.85104', lat: '45.62167' },
          { id: 642, pid: 640, name: '镇赉县', code: '220821', lng: '123.19924', lat: '45.84779' },
          { id: 643, pid: 640, name: '通榆县', code: '220822', lng: '123.08761', lat: '44.81388' },
          { id: 644, pid: 640, name: '洮南市', code: '220881', lng: '122.78772', lat: '45.33502' },
          { id: 645, pid: 640, name: '大安市', code: '220882', lng: '124.29519', lat: '45.50846' },
        ],
      },
      {
        id: 646,
        pid: 585,
        name: '延边朝鲜族自治州',
        code: '222400',
        lng: '129.513228',
        lat: '42.904823',
        children: [
          { id: 647, pid: 646, name: '延吉市', code: '222401', lng: '129.51357', lat: '42.90682' },
          { id: 648, pid: 646, name: '图们市', code: '222402', lng: '129.84381', lat: '42.96801' },
          { id: 649, pid: 646, name: '敦化市', code: '222403', lng: '128.23242', lat: '43.37304' },
          { id: 650, pid: 646, name: '珲春市', code: '222404', lng: '130.36572', lat: '42.86242' },
          { id: 651, pid: 646, name: '龙井市', code: '222405', lng: '129.42584', lat: '42.76804' },
          { id: 652, pid: 646, name: '和龙市', code: '222406', lng: '129.01077', lat: '42.5464' },
          { id: 653, pid: 646, name: '汪清县', code: '222424', lng: '129.77121', lat: '43.31278' },
          { id: 654, pid: 646, name: '安图县', code: '222426', lng: '128.90625', lat: '43.11533' },
        ],
      },
    ],
  },
  {
    id: 655,
    pid: 0,
    name: '黑龙江省',
    code: '230000',
    lng: '126.642464',
    lat: '45.756967',
    children: [
      {
        id: 656,
        pid: 655,
        name: '哈尔滨市',
        code: '230100',
        lng: '126.642464',
        lat: '45.756967',
        children: [
          { id: 657, pid: 656, name: '道里区', code: '230102', lng: '126.61705', lat: '45.75586' },
          { id: 658, pid: 656, name: '南岗区', code: '230103', lng: '126.66854', lat: '45.75996' },
          { id: 659, pid: 656, name: '道外区', code: '230104', lng: '126.64938', lat: '45.79187' },
          { id: 660, pid: 656, name: '平房区', code: '230108', lng: '126.63729', lat: '45.59777' },
          { id: 661, pid: 656, name: '松北区', code: '230109', lng: '126.56276', lat: '45.80831' },
          { id: 662, pid: 656, name: '香坊区', code: '230110', lng: '126.67968', lat: '45.72383' },
          { id: 663, pid: 656, name: '呼兰区', code: '230111', lng: '126.58792', lat: '45.88895' },
          { id: 664, pid: 656, name: '阿城区', code: '230112', lng: '126.97525', lat: '45.54144' },
          { id: 665, pid: 656, name: '双城区', code: '230113', lng: '126.308784', lat: '45.377942' },
          { id: 666, pid: 656, name: '依兰县', code: '230123', lng: '129.56817', lat: '46.3247' },
          { id: 667, pid: 656, name: '方正县', code: '230124', lng: '128.82952', lat: '45.85162' },
          { id: 668, pid: 656, name: '宾县', code: '230125', lng: '127.48675', lat: '45.75504' },
          { id: 669, pid: 656, name: '巴彦县', code: '230126', lng: '127.40799', lat: '46.08148' },
          { id: 670, pid: 656, name: '木兰县', code: '230127', lng: '128.0448', lat: '45.94944' },
          { id: 671, pid: 656, name: '通河县', code: '230128', lng: '128.74603', lat: '45.99007' },
          { id: 672, pid: 656, name: '延寿县', code: '230129', lng: '128.33419', lat: '45.4554' },
          { id: 673, pid: 656, name: '尚志市', code: '230183', lng: '127.96191', lat: '45.21736' },
          { id: 674, pid: 656, name: '五常市', code: '230184', lng: '127.16751', lat: '44.93184' },
        ],
      },
      {
        id: 675,
        pid: 655,
        name: '齐齐哈尔市',
        code: '230200',
        lng: '123.953486',
        lat: '47.348079',
        children: [
          { id: 676, pid: 675, name: '龙沙区', code: '230202', lng: '123.95752', lat: '47.31776' },
          { id: 677, pid: 675, name: '建华区', code: '230203', lng: '124.0133', lat: '47.36718' },
          { id: 678, pid: 675, name: '铁锋区', code: '230204', lng: '123.97821', lat: '47.34075' },
          { id: 679, pid: 675, name: '昂昂溪区', code: '230205', lng: '123.82229', lat: '47.15513' },
          { id: 680, pid: 675, name: '富拉尔基区', code: '230206', lng: '123.62918', lat: '47.20884' },
          { id: 681, pid: 675, name: '碾子山区', code: '230207', lng: '122.88183', lat: '47.51662' },
          { id: 682, pid: 675, name: '梅里斯达斡尔族区', code: '230208', lng: '123.75274', lat: '47.30946' },
          { id: 683, pid: 675, name: '龙江县', code: '230221', lng: '123.20532', lat: '47.33868' },
          { id: 684, pid: 675, name: '依安县', code: '230223', lng: '125.30896', lat: '47.8931' },
          { id: 685, pid: 675, name: '泰来县', code: '230224', lng: '123.42285', lat: '46.39386' },
          { id: 686, pid: 675, name: '甘南县', code: '230225', lng: '123.50317', lat: '47.92437' },
          { id: 687, pid: 675, name: '富裕县', code: '230227', lng: '124.47457', lat: '47.77431' },
          { id: 688, pid: 675, name: '克山县', code: '230229', lng: '125.87396', lat: '48.03265' },
          { id: 689, pid: 675, name: '克东县', code: '230230', lng: '126.24917', lat: '48.03828' },
          { id: 690, pid: 675, name: '拜泉县', code: '230231', lng: '126.09167', lat: '47.60817' },
          { id: 691, pid: 675, name: '讷河市', code: '230281', lng: '124.87713', lat: '48.48388' },
        ],
      },
      {
        id: 692,
        pid: 655,
        name: '鸡西市',
        code: '230300',
        lng: '130.975966',
        lat: '45.300046',
        children: [
          { id: 693, pid: 692, name: '鸡冠区', code: '230302', lng: '130.98139', lat: '45.30396' },
          { id: 694, pid: 692, name: '恒山区', code: '230303', lng: '130.90493', lat: '45.21071' },
          { id: 695, pid: 692, name: '滴道区', code: '230304', lng: '130.84841', lat: '45.35109' },
          { id: 696, pid: 692, name: '梨树区', code: '230305', lng: '130.69848', lat: '45.09037' },
          { id: 697, pid: 692, name: '城子河区', code: '230306', lng: '131.01132', lat: '45.33689' },
          { id: 698, pid: 692, name: '麻山区', code: '230307', lng: '130.47811', lat: '45.21209' },
          { id: 699, pid: 692, name: '鸡东县', code: '230321', lng: '131.12423', lat: '45.26025' },
          { id: 700, pid: 692, name: '虎林市', code: '230381', lng: '132.93679', lat: '45.76291' },
          { id: 701, pid: 692, name: '密山市', code: '230382', lng: '131.84625', lat: '45.5297' },
        ],
      },
      {
        id: 702,
        pid: 655,
        name: '鹤岗市',
        code: '230400',
        lng: '130.277487',
        lat: '47.332085',
        children: [
          { id: 703, pid: 702, name: '向阳区', code: '230402', lng: '130.2943', lat: '47.34247' },
          { id: 704, pid: 702, name: '工农区', code: '230403', lng: '130.27468', lat: '47.31869' },
          { id: 705, pid: 702, name: '南山区', code: '230404', lng: '130.27676', lat: '47.31404' },
          { id: 706, pid: 702, name: '兴安区', code: '230405', lng: '130.23965', lat: '47.2526' },
          { id: 707, pid: 702, name: '东山区', code: '230406', lng: '130.31706', lat: '47.33853' },
          { id: 708, pid: 702, name: '兴山区', code: '230407', lng: '130.29271', lat: '47.35776' },
          { id: 709, pid: 702, name: '萝北县', code: '230421', lng: '130.83346', lat: '47.57959' },
          { id: 710, pid: 702, name: '绥滨县', code: '230422', lng: '131.86029', lat: '47.2903' },
        ],
      },
      {
        id: 711,
        pid: 655,
        name: '双鸭山市',
        code: '230500',
        lng: '131.157304',
        lat: '46.643442',
        children: [
          { id: 712, pid: 711, name: '尖山区', code: '230502', lng: '131.15841', lat: '46.64635' },
          { id: 713, pid: 711, name: '岭东区', code: '230503', lng: '131.16473', lat: '46.59043' },
          { id: 714, pid: 711, name: '四方台区', code: '230505', lng: '131.33593', lat: '46.59499' },
          { id: 715, pid: 711, name: '宝山区', code: '230506', lng: '131.4016', lat: '46.57718' },
          { id: 716, pid: 711, name: '集贤县', code: '230521', lng: '131.14053', lat: '46.72678' },
          { id: 717, pid: 711, name: '友谊县', code: '230522', lng: '131.80789', lat: '46.76739' },
          { id: 718, pid: 711, name: '宝清县', code: '230523', lng: '132.19695', lat: '46.32716' },
          { id: 719, pid: 711, name: '饶河县', code: '230524', lng: '134.01986', lat: '46.79899' },
        ],
      },
      {
        id: 720,
        pid: 655,
        name: '大庆市',
        code: '230600',
        lng: '125.11272',
        lat: '46.590734',
        children: [
          { id: 721, pid: 720, name: '萨尔图区', code: '230602', lng: '125.08792', lat: '46.59359' },
          { id: 722, pid: 720, name: '龙凤区', code: '230603', lng: '125.11657', lat: '46.53273' },
          { id: 723, pid: 720, name: '让胡路区', code: '230604', lng: '124.87075', lat: '46.6522' },
          { id: 724, pid: 720, name: '红岗区', code: '230605', lng: '124.89248', lat: '46.40128' },
          { id: 725, pid: 720, name: '大同区', code: '230606', lng: '124.81591', lat: '46.03295' },
          { id: 726, pid: 720, name: '肇州县', code: '230621', lng: '125.27059', lat: '45.70414' },
          { id: 727, pid: 720, name: '肇源县', code: '230622', lng: '125.08456', lat: '45.52032' },
          { id: 728, pid: 720, name: '林甸县', code: '230623', lng: '124.87564', lat: '47.18601' },
          { id: 729, pid: 720, name: '杜尔伯特蒙古族自治县', code: '230624', lng: '124.44937', lat: '46.86507' },
        ],
      },
      {
        id: 730,
        pid: 655,
        name: '伊春市',
        code: '230700',
        lng: '128.899396',
        lat: '47.724775',
        children: [
          { id: 731, pid: 730, name: '伊春区', code: '230702', lng: '128.90752', lat: '47.728' },
          { id: 732, pid: 730, name: '南岔区', code: '230703', lng: '129.28362', lat: '47.13897' },
          { id: 733, pid: 730, name: '友好区', code: '230704', lng: '128.84039', lat: '47.85371' },
          { id: 734, pid: 730, name: '西林区', code: '230705', lng: '129.31201', lat: '47.48103' },
          { id: 735, pid: 730, name: '翠峦区', code: '230706', lng: '128.66729', lat: '47.72503' },
          { id: 736, pid: 730, name: '新青区', code: '230707', lng: '129.53653', lat: '48.29067' },
          { id: 737, pid: 730, name: '美溪区', code: '230708', lng: '129.13708', lat: '47.63513' },
          { id: 738, pid: 730, name: '金山屯区', code: '230709', lng: '129.43768', lat: '47.41349' },
          { id: 739, pid: 730, name: '五营区', code: '230710', lng: '129.24545', lat: '48.10791' },
          { id: 740, pid: 730, name: '乌马河区', code: '230711', lng: '128.79672', lat: '47.728' },
          { id: 741, pid: 730, name: '汤旺河区', code: '230712', lng: '129.57226', lat: '48.45182' },
          { id: 742, pid: 730, name: '带岭区', code: '230713', lng: '129.02352', lat: '47.02553' },
          { id: 743, pid: 730, name: '乌伊岭区', code: '230714', lng: '129.43981', lat: '48.59602' },
          { id: 744, pid: 730, name: '红星区', code: '230715', lng: '129.3887', lat: '48.23944' },
          { id: 745, pid: 730, name: '上甘岭区', code: '230716', lng: '129.02447', lat: '47.97522' },
          { id: 746, pid: 730, name: '嘉荫县', code: '230722', lng: '130.39825', lat: '48.8917' },
          { id: 747, pid: 730, name: '铁力市', code: '230781', lng: '128.0317', lat: '46.98571' },
        ],
      },
      {
        id: 748,
        pid: 655,
        name: '佳木斯市',
        code: '230800',
        lng: '130.361634',
        lat: '46.809606',
        children: [
          { id: 749, pid: 748, name: '向阳区', code: '230803', lng: '130.36519', lat: '46.80778' },
          { id: 750, pid: 748, name: '前进区', code: '230804', lng: '130.37497', lat: '46.81401' },
          { id: 751, pid: 748, name: '东风区', code: '230805', lng: '130.40366', lat: '46.82257' },
          { id: 752, pid: 748, name: '郊区', code: '230811', lng: '130.32731', lat: '46.80958' },
          { id: 753, pid: 748, name: '桦南县', code: '230822', lng: '130.55361', lat: '46.23921' },
          { id: 754, pid: 748, name: '桦川县', code: '230826', lng: '130.71893', lat: '47.02297' },
          { id: 755, pid: 748, name: '汤原县', code: '230828', lng: '129.90966', lat: '46.72755' },
          { id: 756, pid: 748, name: '抚远县', code: '230833', lng: '134.29595', lat: '48.36794' },
          { id: 757, pid: 748, name: '同江市', code: '230881', lng: '132.51095', lat: '47.64211' },
          { id: 758, pid: 748, name: '富锦市', code: '230882', lng: '132.03707', lat: '47.25132' },
        ],
      },
      {
        id: 759,
        pid: 655,
        name: '七台河市',
        code: '230900',
        lng: '131.015584',
        lat: '45.771266',
        children: [
          { id: 760, pid: 759, name: '新兴区', code: '230902', lng: '130.93212', lat: '45.81624' },
          { id: 761, pid: 759, name: '桃山区', code: '230903', lng: '131.01786', lat: '45.76782' },
          { id: 762, pid: 759, name: '茄子河区', code: '230904', lng: '131.06807', lat: '45.78519' },
          { id: 763, pid: 759, name: '勃利县', code: '230921', lng: '130.59179', lat: '45.755' },
        ],
      },
      {
        id: 764,
        pid: 655,
        name: '牡丹江市',
        code: '231000',
        lng: '129.618602',
        lat: '44.582962',
        children: [
          { id: 765, pid: 764, name: '东安区', code: '231002', lng: '129.62665', lat: '44.58133' },
          { id: 766, pid: 764, name: '阳明区', code: '231003', lng: '129.63547', lat: '44.59603' },
          { id: 767, pid: 764, name: '爱民区', code: '231004', lng: '129.59077', lat: '44.59648' },
          { id: 768, pid: 764, name: '西安区', code: '231005', lng: '129.61616', lat: '44.57766' },
          { id: 769, pid: 764, name: '东宁县', code: '231024', lng: '131.12793', lat: '44.0661' },
          { id: 770, pid: 764, name: '林口县', code: '231025', lng: '130.28393', lat: '45.27809' },
          { id: 771, pid: 764, name: '绥芬河市', code: '231081', lng: '131.15139', lat: '44.41249' },
          { id: 772, pid: 764, name: '海林市', code: '231083', lng: '129.38156', lat: '44.59' },
          { id: 773, pid: 764, name: '宁安市', code: '231084', lng: '129.48303', lat: '44.34016' },
          { id: 774, pid: 764, name: '穆棱市', code: '231085', lng: '130.52465', lat: '44.919' },
        ],
      },
      {
        id: 775,
        pid: 655,
        name: '黑河市',
        code: '231100',
        lng: '127.499023',
        lat: '50.249585',
        children: [
          { id: 776, pid: 775, name: '爱辉区', code: '231102', lng: '127.50074', lat: '50.25202' },
          { id: 777, pid: 775, name: '嫩江县', code: '231121', lng: '125.22607', lat: '49.17844' },
          { id: 778, pid: 775, name: '逊克县', code: '231123', lng: '128.47882', lat: '49.57983' },
          { id: 779, pid: 775, name: '孙吴县', code: '231124', lng: '127.33599', lat: '49.42539' },
          { id: 780, pid: 775, name: '北安市', code: '231181', lng: '126.48193', lat: '48.23872' },
          { id: 781, pid: 775, name: '五大连池市', code: '231182', lng: '126.20294', lat: '48.51507' },
        ],
      },
      {
        id: 782,
        pid: 655,
        name: '绥化市',
        code: '231200',
        lng: '126.99293',
        lat: '46.637393',
        children: [
          { id: 783, pid: 782, name: '北林区', code: '231202', lng: '126.98564', lat: '46.63735' },
          { id: 784, pid: 782, name: '望奎县', code: '231221', lng: '126.48187', lat: '46.83079' },
          { id: 785, pid: 782, name: '兰西县', code: '231222', lng: '126.28994', lat: '46.2525' },
          { id: 786, pid: 782, name: '青冈县', code: '231223', lng: '126.11325', lat: '46.68534' },
          { id: 787, pid: 782, name: '庆安县', code: '231224', lng: '127.50753', lat: '46.88016' },
          { id: 788, pid: 782, name: '明水县', code: '231225', lng: '125.90594', lat: '47.17327' },
          { id: 789, pid: 782, name: '绥棱县', code: '231226', lng: '127.11584', lat: '47.24267' },
          { id: 790, pid: 782, name: '安达市', code: '231281', lng: '125.34375', lat: '46.4177' },
          { id: 791, pid: 782, name: '肇东市', code: '231282', lng: '125.96243', lat: '46.05131' },
          { id: 792, pid: 782, name: '海伦市', code: '231283', lng: '126.9682', lat: '47.46093' },
        ],
      },
      {
        id: 793,
        pid: 655,
        name: '大兴安岭地区',
        code: '232700',
        lng: '124.711526',
        lat: '52.335262',
        children: [
          { id: 794, pid: 793, name: '加格达奇区', code: '232701', lng: '124.30954', lat: '51.98144' },
          { id: 795, pid: 793, name: '新林区', code: '232702', lng: '124.397983', lat: '51.67341' },
          { id: 796, pid: 793, name: '松岭区', code: '232703', lng: '124.189713', lat: '51.985453' },
          { id: 797, pid: 793, name: '呼中区', code: '232704', lng: '123.60009', lat: '52.03346' },
          { id: 798, pid: 793, name: '呼玛县', code: '232721', lng: '126.66174', lat: '51.73112' },
          { id: 799, pid: 793, name: '塔河县', code: '232722', lng: '124.70999', lat: '52.33431' },
          { id: 800, pid: 793, name: '漠河县', code: '232723', lng: '122.53759', lat: '52.97003' },
        ],
      },
    ],
  },
  {
    id: 801,
    pid: 0,
    name: '上海市',
    code: '310000',
    lng: '121.472644',
    lat: '31.231706',
    children: [
      {
        id: 802,
        pid: 801,
        name: '上海市',
        code: '310100',
        lng: '121.472644',
        lat: '31.231706',
        children: [
          { id: 803, pid: 802, name: '黄浦区', code: '310101', lng: '121.49295', lat: '31.22337' },
          { id: 804, pid: 802, name: '徐汇区', code: '310104', lng: '121.43676', lat: '31.18831' },
          { id: 805, pid: 802, name: '长宁区', code: '310105', lng: '121.42462', lat: '31.22036' },
          { id: 806, pid: 802, name: '静安区', code: '310106', lng: '121.4444', lat: '31.22884' },
          { id: 807, pid: 802, name: '普陀区', code: '310107', lng: '121.39703', lat: '31.24951' },
          { id: 808, pid: 802, name: '闸北区', code: '310108', lng: '121.44636', lat: '31.28075' },
          { id: 809, pid: 802, name: '虹口区', code: '310109', lng: '121.48162', lat: '31.27788' },
          { id: 810, pid: 802, name: '杨浦区', code: '310110', lng: '121.526', lat: '31.2595' },
          { id: 811, pid: 802, name: '闵行区', code: '310112', lng: '121.38162', lat: '31.11246' },
          { id: 812, pid: 802, name: '宝山区', code: '310113', lng: '121.4891', lat: '31.4045' },
          { id: 813, pid: 802, name: '嘉定区', code: '310114', lng: '121.2655', lat: '31.37473' },
          { id: 814, pid: 802, name: '浦东新区', code: '310115', lng: '121.5447', lat: '31.22249' },
          { id: 815, pid: 802, name: '金山区', code: '310116', lng: '121.34164', lat: '30.74163' },
          { id: 816, pid: 802, name: '松江区', code: '310117', lng: '121.22879', lat: '31.03222' },
          { id: 817, pid: 802, name: '青浦区', code: '310118', lng: '121.12417', lat: '31.14974' },
          { id: 818, pid: 802, name: '奉贤区', code: '310120', lng: '121.47412', lat: '30.9179' },
          { id: 819, pid: 802, name: '崇明县', code: '310230', lng: '121.39758', lat: '31.62278' },
        ],
      },
    ],
  },
  {
    id: 820,
    pid: 0,
    name: '江苏省',
    code: '320000',
    lng: '118.767413',
    lat: '32.041544',
    children: [
      {
        id: 821,
        pid: 820,
        name: '南京市',
        code: '320100',
        lng: '118.767413',
        lat: '32.041544',
        children: [
          { id: 822, pid: 821, name: '玄武区', code: '320102', lng: '118.79772', lat: '32.04856' },
          { id: 823, pid: 821, name: '秦淮区', code: '320104', lng: '118.79815', lat: '32.01112' },
          { id: 824, pid: 821, name: '建邺区', code: '320105', lng: '118.76641', lat: '32.03096' },
          { id: 825, pid: 821, name: '鼓楼区', code: '320106', lng: '118.76974', lat: '32.06632' },
          { id: 826, pid: 821, name: '浦口区', code: '320111', lng: '118.62802', lat: '32.05881' },
          { id: 827, pid: 821, name: '栖霞区', code: '320113', lng: '118.88064', lat: '32.11352' },
          { id: 828, pid: 821, name: '雨花台区', code: '320114', lng: '118.7799', lat: '31.99202' },
          { id: 829, pid: 821, name: '江宁区', code: '320115', lng: '118.8399', lat: '31.95263' },
          { id: 830, pid: 821, name: '六合区', code: '320116', lng: '118.8413', lat: '32.34222' },
          { id: 831, pid: 821, name: '溧水区', code: '320117', lng: '119.028732', lat: '31.653061' },
          { id: 832, pid: 821, name: '高淳区', code: '320118', lng: '118.87589', lat: '31.327132' },
        ],
      },
      {
        id: 833,
        pid: 820,
        name: '无锡市',
        code: '320200',
        lng: '120.301663',
        lat: '31.574729',
        children: [
          { id: 834, pid: 833, name: '崇安区', code: '320202', lng: '120.29975', lat: '31.58002' },
          { id: 835, pid: 833, name: '南长区', code: '320203', lng: '120.30873', lat: '31.56359' },
          { id: 836, pid: 833, name: '北塘区', code: '320204', lng: '120.29405', lat: '31.60592' },
          { id: 837, pid: 833, name: '锡山区', code: '320205', lng: '120.35699', lat: '31.5886' },
          { id: 838, pid: 833, name: '惠山区', code: '320206', lng: '120.29849', lat: '31.68088' },
          { id: 839, pid: 833, name: '滨湖区', code: '320211', lng: '120.29461', lat: '31.52162' },
          { id: 840, pid: 833, name: '江阴市', code: '320281', lng: '120.2853', lat: '31.91996' },
          { id: 841, pid: 833, name: '宜兴市', code: '320282', lng: '119.82357', lat: '31.33978' },
        ],
      },
      {
        id: 842,
        pid: 820,
        name: '徐州市',
        code: '320300',
        lng: '117.184811',
        lat: '34.261792',
        children: [
          { id: 843, pid: 842, name: '鼓楼区', code: '320302', lng: '117.18559', lat: '34.28851' },
          { id: 844, pid: 842, name: '云龙区', code: '320303', lng: '117.23053', lat: '34.24895' },
          { id: 845, pid: 842, name: '贾汪区', code: '320305', lng: '117.45346', lat: '34.44264' },
          { id: 846, pid: 842, name: '泉山区', code: '320311', lng: '117.19378', lat: '34.24418' },
          { id: 847, pid: 842, name: '铜山区', code: '320312', lng: '117.183894', lat: '34.19288' },
          { id: 848, pid: 842, name: '丰县', code: '320321', lng: '116.59957', lat: '34.69972' },
          { id: 849, pid: 842, name: '沛县', code: '320322', lng: '116.93743', lat: '34.72163' },
          { id: 850, pid: 842, name: '睢宁县', code: '320324', lng: '117.94104', lat: '33.91269' },
          { id: 851, pid: 842, name: '新沂市', code: '320381', lng: '118.35452', lat: '34.36942' },
          { id: 852, pid: 842, name: '邳州市', code: '320382', lng: '117.95858', lat: '34.33329' },
        ],
      },
      {
        id: 853,
        pid: 820,
        name: '常州市',
        code: '320400',
        lng: '119.946973',
        lat: '31.772752',
        children: [
          { id: 854, pid: 853, name: '天宁区', code: '320402', lng: '119.95132', lat: '31.75211' },
          { id: 855, pid: 853, name: '钟楼区', code: '320404', lng: '119.90178', lat: '31.80221' },
          { id: 856, pid: 853, name: '戚墅堰区', code: '320405', lng: '120.06106', lat: '31.71956' },
          { id: 857, pid: 853, name: '新北区', code: '320411', lng: '119.97131', lat: '31.83046' },
          { id: 858, pid: 853, name: '武进区', code: '320412', lng: '119.94244', lat: '31.70086' },
          { id: 859, pid: 853, name: '溧阳市', code: '320481', lng: '119.4837', lat: '31.41538' },
          { id: 860, pid: 853, name: '金坛市', code: '320482', lng: '119.57757', lat: '31.74043' },
        ],
      },
      {
        id: 861,
        pid: 820,
        name: '苏州市',
        code: '320500',
        lng: '120.619585',
        lat: '31.299379',
        children: [
          { id: 862, pid: 861, name: '虎丘区', code: '320505', lng: '120.57345', lat: '31.2953' },
          { id: 863, pid: 861, name: '吴中区', code: '320506', lng: '120.63211', lat: '31.26226' },
          { id: 864, pid: 861, name: '相城区', code: '320507', lng: '120.64239', lat: '31.36889' },
          { id: 865, pid: 861, name: '姑苏区', code: '320508', lng: '120.619585', lat: '31.299379' },
          { id: 866, pid: 861, name: '吴江区', code: '320509', lng: '120.638317', lat: '31.159815' },
          { id: 867, pid: 861, name: '常熟市', code: '320581', lng: '120.75225', lat: '31.65374' },
          { id: 868, pid: 861, name: '张家港市', code: '320582', lng: '120.55538', lat: '31.87532' },
          { id: 869, pid: 861, name: '昆山市', code: '320583', lng: '120.98074', lat: '31.38464' },
          { id: 870, pid: 861, name: '太仓市', code: '320585', lng: '121.10891', lat: '31.4497' },
        ],
      },
      {
        id: 871,
        pid: 820,
        name: '南通市',
        code: '320600',
        lng: '120.864608',
        lat: '32.016212',
        children: [
          { id: 872, pid: 871, name: '崇川区', code: '320602', lng: '120.8573', lat: '32.0098' },
          { id: 873, pid: 871, name: '港闸区', code: '320611', lng: '120.81778', lat: '32.03163' },
          { id: 874, pid: 871, name: '通州区', code: '320612', lng: '121.07293', lat: '32.0676' },
          { id: 875, pid: 871, name: '海安县', code: '320621', lng: '120.45852', lat: '32.54514' },
          { id: 876, pid: 871, name: '如东县', code: '320623', lng: '121.18942', lat: '32.31439' },
          { id: 877, pid: 871, name: '启东市', code: '320681', lng: '121.65985', lat: '31.81083' },
          { id: 878, pid: 871, name: '如皋市', code: '320682', lng: '120.55969', lat: '32.37597' },
          { id: 879, pid: 871, name: '海门市', code: '320684', lng: '121.16995', lat: '31.89422' },
        ],
      },
      {
        id: 880,
        pid: 820,
        name: '连云港市',
        code: '320700',
        lng: '119.178821',
        lat: '34.600018',
        children: [
          { id: 881, pid: 880, name: '连云区', code: '320703', lng: '119.37304', lat: '34.75293' },
          { id: 882, pid: 880, name: '海州区', code: '320706', lng: '119.13128', lat: '34.56986' },
          { id: 883, pid: 880, name: '赣榆区', code: '320707', lng: '119.128774', lat: '34.839154' },
          { id: 884, pid: 880, name: '东海县', code: '320722', lng: '118.77145', lat: '34.54215' },
          { id: 885, pid: 880, name: '灌云县', code: '320723', lng: '119.23925', lat: '34.28391' },
          { id: 886, pid: 880, name: '灌南县', code: '320724', lng: '119.35632', lat: '34.09' },
        ],
      },
      {
        id: 887,
        pid: 820,
        name: '淮安市',
        code: '320800',
        lng: '119.021265',
        lat: '33.597506',
        children: [
          { id: 888, pid: 887, name: '清河区', code: '320802', lng: '119.00778', lat: '33.59949' },
          { id: 889, pid: 887, name: '淮安区', code: '320803', lng: '119.021265', lat: '33.597506' },
          { id: 890, pid: 887, name: '淮阴区', code: '320804', lng: '119.03485', lat: '33.63171' },
          { id: 891, pid: 887, name: '清浦区', code: '320811', lng: '119.02648', lat: '33.55232' },
          { id: 892, pid: 887, name: '涟水县', code: '320826', lng: '119.26083', lat: '33.78094' },
          { id: 893, pid: 887, name: '洪泽县', code: '320829', lng: '118.87344', lat: '33.29429' },
          { id: 894, pid: 887, name: '盱眙县', code: '320830', lng: '118.54495', lat: '33.01086' },
          { id: 895, pid: 887, name: '金湖县', code: '320831', lng: '119.02307', lat: '33.02219' },
        ],
      },
      {
        id: 896,
        pid: 820,
        name: '盐城市',
        code: '320900',
        lng: '120.139998',
        lat: '33.377631',
        children: [
          { id: 897, pid: 896, name: '亭湖区', code: '320902', lng: '120.16583', lat: '33.37825' },
          { id: 898, pid: 896, name: '盐都区', code: '320903', lng: '120.15441', lat: '33.3373' },
          { id: 899, pid: 896, name: '响水县', code: '320921', lng: '119.56985', lat: '34.20513' },
          { id: 900, pid: 896, name: '滨海县', code: '320922', lng: '119.82058', lat: '33.98972' },
          { id: 901, pid: 896, name: '阜宁县', code: '320923', lng: '119.80175', lat: '33.78228' },
          { id: 902, pid: 896, name: '射阳县', code: '320924', lng: '120.26043', lat: '33.77636' },
          { id: 903, pid: 896, name: '建湖县', code: '320925', lng: '119.79852', lat: '33.47241' },
          { id: 904, pid: 896, name: '东台市', code: '320981', lng: '120.32376', lat: '32.85078' },
          { id: 905, pid: 896, name: '大丰市', code: '320982', lng: '120.46594', lat: '33.19893' },
        ],
      },
      {
        id: 906,
        pid: 820,
        name: '扬州市',
        code: '321000',
        lng: '119.421003',
        lat: '32.393159',
        children: [
          { id: 907, pid: 906, name: '广陵区', code: '321002', lng: '119.43186', lat: '32.39472' },
          { id: 908, pid: 906, name: '邗江区', code: '321003', lng: '119.39816', lat: '32.3765' },
          { id: 909, pid: 906, name: '江都区', code: '321012', lng: '119.567481', lat: '32.426564' },
          { id: 910, pid: 906, name: '宝应县', code: '321023', lng: '119.31213', lat: '33.23549' },
          { id: 911, pid: 906, name: '仪征市', code: '321081', lng: '119.18432', lat: '32.27197' },
          { id: 912, pid: 906, name: '高邮市', code: '321084', lng: '119.45965', lat: '32.78135' },
        ],
      },
      {
        id: 913,
        pid: 820,
        name: '镇江市',
        code: '321100',
        lng: '119.452753',
        lat: '32.204402',
        children: [
          { id: 914, pid: 913, name: '京口区', code: '321102', lng: '119.46947', lat: '32.19809' },
          { id: 915, pid: 913, name: '润州区', code: '321111', lng: '119.41134', lat: '32.19523' },
          { id: 916, pid: 913, name: '丹徒区', code: '321112', lng: '119.43383', lat: '32.13183' },
          { id: 917, pid: 913, name: '丹阳市', code: '321181', lng: '119.57525', lat: '31.99121' },
          { id: 918, pid: 913, name: '扬中市', code: '321182', lng: '119.79718', lat: '32.2363' },
          { id: 919, pid: 913, name: '句容市', code: '321183', lng: '119.16482', lat: '31.95591' },
        ],
      },
      {
        id: 920,
        pid: 820,
        name: '泰州市',
        code: '321200',
        lng: '119.915176',
        lat: '32.484882',
        children: [
          { id: 921, pid: 920, name: '海陵区', code: '321202', lng: '119.91942', lat: '32.49101' },
          { id: 922, pid: 920, name: '高港区', code: '321203', lng: '119.88089', lat: '32.31833' },
          { id: 923, pid: 920, name: '姜堰区', code: '321204', lng: '120.148208', lat: '32.508483' },
          { id: 924, pid: 920, name: '兴化市', code: '321281', lng: '119.85238', lat: '32.90944' },
          { id: 925, pid: 920, name: '靖江市', code: '321282', lng: '120.27291', lat: '32.01595' },
          { id: 926, pid: 920, name: '泰兴市', code: '321283', lng: '120.05194', lat: '32.17187' },
        ],
      },
      {
        id: 927,
        pid: 820,
        name: '宿迁市',
        code: '321300',
        lng: '118.293328',
        lat: '33.945154',
        children: [
          { id: 928, pid: 927, name: '宿城区', code: '321302', lng: '118.29141', lat: '33.94219' },
          { id: 929, pid: 927, name: '宿豫区', code: '321311', lng: '118.32922', lat: '33.94673' },
          { id: 930, pid: 927, name: '沭阳县', code: '321322', lng: '118.76873', lat: '34.11446' },
          { id: 931, pid: 927, name: '泗阳县', code: '321323', lng: '118.7033', lat: '33.72096' },
          { id: 932, pid: 927, name: '泗洪县', code: '321324', lng: '118.21716', lat: '33.45996' },
        ],
      },
    ],
  },
  {
    id: 933,
    pid: 0,
    name: '浙江省',
    code: '330000',
    lng: '120.153576',
    lat: '30.287459',
    children: [
      {
        id: 934,
        pid: 933,
        name: '杭州市',
        code: '330100',
        lng: '120.153576',
        lat: '30.287459',
        children: [
          { id: 935, pid: 934, name: '上城区', code: '330102', lng: '120.16922', lat: '30.24255' },
          { id: 936, pid: 934, name: '下城区', code: '330103', lng: '120.18096', lat: '30.28153' },
          { id: 937, pid: 934, name: '江干区', code: '330104', lng: '120.20517', lat: '30.2572' },
          { id: 938, pid: 934, name: '拱墅区', code: '330105', lng: '120.14209', lat: '30.31968' },
          { id: 939, pid: 934, name: '西湖区', code: '330106', lng: '120.12979', lat: '30.25949' },
          { id: 940, pid: 934, name: '滨江区', code: '330108', lng: '120.21194', lat: '30.20835' },
          { id: 941, pid: 934, name: '萧山区', code: '330109', lng: '120.26452', lat: '30.18505' },
          { id: 942, pid: 934, name: '余杭区', code: '330110', lng: '120.29986', lat: '30.41829' },
          { id: 943, pid: 934, name: '桐庐县', code: '330122', lng: '119.68853', lat: '29.79779' },
          { id: 944, pid: 934, name: '淳安县', code: '330127', lng: '119.04257', lat: '29.60988' },
          { id: 945, pid: 934, name: '建德市', code: '330182', lng: '119.28158', lat: '29.47603' },
          { id: 946, pid: 934, name: '富阳区', code: '330183', lng: '119.96041', lat: '30.04878' },
          { id: 947, pid: 934, name: '临安市', code: '330185', lng: '119.72473', lat: '30.23447' },
        ],
      },
      {
        id: 948,
        pid: 933,
        name: '宁波市',
        code: '330200',
        lng: '121.549792',
        lat: '29.868388',
        children: [
          { id: 949, pid: 948, name: '海曙区', code: '330203', lng: '121.55106', lat: '29.85977' },
          { id: 950, pid: 948, name: '江东区', code: '330204', lng: '121.57028', lat: '29.86701' },
          { id: 951, pid: 948, name: '江北区', code: '330205', lng: '121.55681', lat: '29.88776' },
          { id: 952, pid: 948, name: '北仑区', code: '330206', lng: '121.84408', lat: '29.90069' },
          { id: 953, pid: 948, name: '镇海区', code: '330211', lng: '121.71615', lat: '29.94893' },
          { id: 954, pid: 948, name: '鄞州区', code: '330212', lng: '121.54754', lat: '29.81614' },
          { id: 955, pid: 948, name: '象山县', code: '330225', lng: '121.86917', lat: '29.47758' },
          { id: 956, pid: 948, name: '宁海县', code: '330226', lng: '121.43072', lat: '29.2889' },
          { id: 957, pid: 948, name: '余姚市', code: '330281', lng: '121.15341', lat: '30.03867' },
          { id: 958, pid: 948, name: '慈溪市', code: '330282', lng: '121.26641', lat: '30.16959' },
          { id: 959, pid: 948, name: '奉化市', code: '330283', lng: '121.41003', lat: '29.65537' },
        ],
      },
      {
        id: 960,
        pid: 933,
        name: '温州市',
        code: '330300',
        lng: '120.672111',
        lat: '28.000575',
        children: [
          { id: 961, pid: 960, name: '鹿城区', code: '330302', lng: '120.65505', lat: '28.01489' },
          { id: 962, pid: 960, name: '龙湾区', code: '330303', lng: '120.83053', lat: '27.91284' },
          { id: 963, pid: 960, name: '瓯海区', code: '330304', lng: '120.63751', lat: '28.00714' },
          { id: 964, pid: 960, name: '洞头县', code: '330322', lng: '121.15606', lat: '27.83634' },
          { id: 965, pid: 960, name: '永嘉县', code: '330324', lng: '120.69317', lat: '28.15456' },
          { id: 966, pid: 960, name: '平阳县', code: '330326', lng: '120.56506', lat: '27.66245' },
          { id: 967, pid: 960, name: '苍南县', code: '330327', lng: '120.42608', lat: '27.51739' },
          { id: 968, pid: 960, name: '文成县', code: '330328', lng: '120.09063', lat: '27.78678' },
          { id: 969, pid: 960, name: '泰顺县', code: '330329', lng: '119.7182', lat: '27.55694' },
          { id: 970, pid: 960, name: '瑞安市', code: '330381', lng: '120.65466', lat: '27.78041' },
          { id: 971, pid: 960, name: '乐清市', code: '330382', lng: '120.9617', lat: '28.12404' },
        ],
      },
      {
        id: 972,
        pid: 933,
        name: '嘉兴市',
        code: '330400',
        lng: '120.750865',
        lat: '30.762653',
        children: [
          { id: 973, pid: 972, name: '南湖区', code: '330402', lng: '120.78524', lat: '30.74865' },
          { id: 974, pid: 972, name: '秀洲区', code: '330411', lng: '120.70867', lat: '30.76454' },
          { id: 975, pid: 972, name: '嘉善县', code: '330421', lng: '120.92559', lat: '30.82993' },
          { id: 976, pid: 972, name: '海盐县', code: '330424', lng: '120.9457', lat: '30.52547' },
          { id: 977, pid: 972, name: '海宁市', code: '330481', lng: '120.6813', lat: '30.5097' },
          { id: 978, pid: 972, name: '平湖市', code: '330482', lng: '121.02166', lat: '30.69618' },
          { id: 979, pid: 972, name: '桐乡市', code: '330483', lng: '120.56485', lat: '30.6302' },
        ],
      },
      {
        id: 980,
        pid: 933,
        name: '湖州市',
        code: '330500',
        lng: '120.102398',
        lat: '30.867198',
        children: [
          { id: 981, pid: 980, name: '吴兴区', code: '330502', lng: '120.12548', lat: '30.85752' },
          { id: 982, pid: 980, name: '南浔区', code: '330503', lng: '120.42038', lat: '30.86686' },
          { id: 983, pid: 980, name: '德清县', code: '330521', lng: '119.97836', lat: '30.53369' },
          { id: 984, pid: 980, name: '长兴县', code: '330522', lng: '119.90783', lat: '31.00606' },
          { id: 985, pid: 980, name: '安吉县', code: '330523', lng: '119.68158', lat: '30.63798' },
        ],
      },
      {
        id: 986,
        pid: 933,
        name: '绍兴市',
        code: '330600',
        lng: '120.582112',
        lat: '29.997117',
        children: [
          { id: 987, pid: 986, name: '越城区', code: '330602', lng: '120.5819', lat: '29.98895' },
          { id: 988, pid: 986, name: '柯桥区', code: '330603', lng: '120.492736', lat: '30.08763' },
          { id: 989, pid: 986, name: '上虞区', code: '330604', lng: '120.476075', lat: '30.078038' },
          { id: 990, pid: 986, name: '新昌县', code: '330624', lng: '120.90435', lat: '29.49991' },
          { id: 991, pid: 986, name: '诸暨市', code: '330681', lng: '120.23629', lat: '29.71358' },
          { id: 992, pid: 986, name: '嵊州市', code: '330683', lng: '120.82174', lat: '29.58854' },
        ],
      },
      {
        id: 993,
        pid: 933,
        name: '金华市',
        code: '330700',
        lng: '119.649506',
        lat: '29.089524',
        children: [
          { id: 994, pid: 993, name: '婺城区', code: '330702', lng: '119.57135', lat: '29.09521' },
          { id: 995, pid: 993, name: '金东区', code: '330703', lng: '119.69302', lat: '29.0991' },
          { id: 996, pid: 993, name: '武义县', code: '330723', lng: '119.8164', lat: '28.89331' },
          { id: 997, pid: 993, name: '浦江县', code: '330726', lng: '119.89181', lat: '29.45353' },
          { id: 998, pid: 993, name: '磐安县', code: '330727', lng: '120.45022', lat: '29.05733' },
          { id: 999, pid: 993, name: '兰溪市', code: '330781', lng: '119.45965', lat: '29.20841' },
          { id: 1000, pid: 993, name: '义乌市', code: '330782', lng: '120.0744', lat: '29.30558' },
          { id: 1001, pid: 993, name: '东阳市', code: '330783', lng: '120.24185', lat: '29.28942' },
          { id: 1002, pid: 993, name: '永康市', code: '330784', lng: '120.04727', lat: '28.88844' },
        ],
      },
      {
        id: 1003,
        pid: 933,
        name: '衢州市',
        code: '330800',
        lng: '118.87263',
        lat: '28.941708',
        children: [
          { id: 1004, pid: 1003, name: '柯城区', code: '330802', lng: '118.87109', lat: '28.96858' },
          { id: 1005, pid: 1003, name: '衢江区', code: '330803', lng: '118.9598', lat: '28.97977' },
          { id: 1006, pid: 1003, name: '常山县', code: '330822', lng: '118.51025', lat: '28.90191' },
          { id: 1007, pid: 1003, name: '开化县', code: '330824', lng: '118.41616', lat: '29.13785' },
          { id: 1008, pid: 1003, name: '龙游县', code: '330825', lng: '119.17221', lat: '29.02823' },
          { id: 1009, pid: 1003, name: '江山市', code: '330881', lng: '118.62674', lat: '28.7386' },
        ],
      },
      {
        id: 1010,
        pid: 933,
        name: '舟山市',
        code: '330900',
        lng: '122.106863',
        lat: '30.016028',
        children: [
          { id: 1011, pid: 1010, name: '定海区', code: '330902', lng: '122.10677', lat: '30.01985' },
          { id: 1012, pid: 1010, name: '普陀区', code: '330903', lng: '122.30278', lat: '29.94908' },
          { id: 1013, pid: 1010, name: '岱山县', code: '330921', lng: '122.20486', lat: '30.24385' },
          { id: 1014, pid: 1010, name: '嵊泗县', code: '330922', lng: '122.45129', lat: '30.72678' },
        ],
      },
      {
        id: 1015,
        pid: 933,
        name: '台州市',
        code: '331000',
        lng: '121.428599',
        lat: '28.661378',
        children: [
          { id: 1016, pid: 1015, name: '椒江区', code: '331002', lng: '121.44287', lat: '28.67301' },
          { id: 1017, pid: 1015, name: '黄岩区', code: '331003', lng: '121.25891', lat: '28.65077' },
          { id: 1018, pid: 1015, name: '路桥区', code: '331004', lng: '121.37381', lat: '28.58016' },
          { id: 1019, pid: 1015, name: '玉环县', code: '331021', lng: '121.23242', lat: '28.13637' },
          { id: 1020, pid: 1015, name: '三门县', code: '331022', lng: '121.3937', lat: '29.1051' },
          { id: 1021, pid: 1015, name: '天台县', code: '331023', lng: '121.00848', lat: '29.1429' },
          { id: 1022, pid: 1015, name: '仙居县', code: '331024', lng: '120.72872', lat: '28.84672' },
          { id: 1023, pid: 1015, name: '温岭市', code: '331081', lng: '121.38595', lat: '28.37176' },
          { id: 1024, pid: 1015, name: '临海市', code: '331082', lng: '121.13885', lat: '28.85603' },
        ],
      },
      {
        id: 1025,
        pid: 933,
        name: '丽水市',
        code: '331100',
        lng: '119.921786',
        lat: '28.451993',
        children: [
          { id: 1026, pid: 1025, name: '莲都区', code: '331102', lng: '119.9127', lat: '28.44583' },
          { id: 1027, pid: 1025, name: '青田县', code: '331121', lng: '120.29028', lat: '28.13897' },
          { id: 1028, pid: 1025, name: '缙云县', code: '331122', lng: '120.09036', lat: '28.65944' },
          { id: 1029, pid: 1025, name: '遂昌县', code: '331123', lng: '119.27606', lat: '28.59291' },
          { id: 1030, pid: 1025, name: '松阳县', code: '331124', lng: '119.48199', lat: '28.4494' },
          { id: 1031, pid: 1025, name: '云和县', code: '331125', lng: '119.57287', lat: '28.11643' },
          { id: 1032, pid: 1025, name: '庆元县', code: '331126', lng: '119.06256', lat: '27.61842' },
          { id: 1033, pid: 1025, name: '景宁畲族自治县', code: '331127', lng: '119.63839', lat: '27.97393' },
          { id: 1034, pid: 1025, name: '龙泉市', code: '331181', lng: '119.14163', lat: '28.0743' },
        ],
      },
      {
        id: 1035,
        pid: 933,
        name: '舟山群岛新区',
        code: '331200',
        lng: '122.317657',
        lat: '29.813242',
        children: [
          { id: 1036, pid: 1035, name: '金塘岛', code: '331201', lng: '121.893373', lat: '30.040641' },
          { id: 1037, pid: 1035, name: '六横岛', code: '331202', lng: '122.14265', lat: '29.662938' },
          { id: 1038, pid: 1035, name: '衢山岛', code: '331203', lng: '122.358425', lat: '30.442642' },
          { id: 1039, pid: 1035, name: '舟山本岛西北部', code: '331204', lng: '122.03064', lat: '30.140377' },
          { id: 1040, pid: 1035, name: '岱山岛西南部', code: '331205', lng: '122.180123', lat: '30.277269' },
          { id: 1041, pid: 1035, name: '泗礁岛', code: '331206', lng: '122.45803', lat: '30.725112' },
          { id: 1042, pid: 1035, name: '朱家尖岛', code: '331207', lng: '122.390636', lat: '29.916303' },
          { id: 1043, pid: 1035, name: '洋山岛', code: '331208', lng: '121.995891', lat: '30.094637' },
          { id: 1044, pid: 1035, name: '长涂岛', code: '331209', lng: '122.284681', lat: '30.24888' },
          { id: 1045, pid: 1035, name: '虾峙岛', code: '331210', lng: '122.244686', lat: '29.752941' },
        ],
      },
    ],
  },
  {
    id: 1046,
    pid: 0,
    name: '安徽省',
    code: '340000',
    lng: '117.283042',
    lat: '31.86119',
    children: [
      {
        id: 1047,
        pid: 1046,
        name: '合肥市',
        code: '340100',
        lng: '117.283042',
        lat: '31.86119',
        children: [
          { id: 1048, pid: 1047, name: '瑶海区', code: '340102', lng: '117.30947', lat: '31.85809' },
          { id: 1049, pid: 1047, name: '庐阳区', code: '340103', lng: '117.26452', lat: '31.87874' },
          { id: 1050, pid: 1047, name: '蜀山区', code: '340104', lng: '117.26104', lat: '31.85117' },
          { id: 1051, pid: 1047, name: '包河区', code: '340111', lng: '117.30984', lat: '31.79502' },
          { id: 1052, pid: 1047, name: '长丰县', code: '340121', lng: '117.16549', lat: '32.47959' },
          { id: 1053, pid: 1047, name: '肥东县', code: '340122', lng: '117.47128', lat: '31.88525' },
          { id: 1054, pid: 1047, name: '肥西县', code: '340123', lng: '117.16845', lat: '31.72143' },
          { id: 1055, pid: 1047, name: '庐江县', code: '340124', lng: '117.289844', lat: '31.251488' },
          { id: 1056, pid: 1047, name: '巢湖市', code: '340181', lng: '117.874155', lat: '31.600518' },
        ],
      },
      {
        id: 1057,
        pid: 1046,
        name: '芜湖市',
        code: '340200',
        lng: '118.376451',
        lat: '31.326319',
        children: [
          { id: 1058, pid: 1057, name: '镜湖区', code: '340202', lng: '118.38525', lat: '31.34038' },
          { id: 1059, pid: 1057, name: '弋江区', code: '340203', lng: '118.37265', lat: '31.31178' },
          { id: 1060, pid: 1057, name: '鸠江区', code: '340207', lng: '118.39215', lat: '31.36928' },
          { id: 1061, pid: 1057, name: '三山区', code: '340208', lng: '118.22509', lat: '31.20703' },
          { id: 1062, pid: 1057, name: '芜湖县', code: '340221', lng: '118.57525', lat: '31.13476' },
          { id: 1063, pid: 1057, name: '繁昌县', code: '340222', lng: '118.19982', lat: '31.08319' },
          { id: 1064, pid: 1057, name: '南陵县', code: '340223', lng: '118.33688', lat: '30.91969' },
          { id: 1065, pid: 1057, name: '无为县', code: '340225', lng: '117.911432', lat: '31.303075' },
        ],
      },
      {
        id: 1066,
        pid: 1046,
        name: '蚌埠市',
        code: '340300',
        lng: '117.36237',
        lat: '32.934037',
        children: [
          { id: 1067, pid: 1066, name: '龙子湖区', code: '340302', lng: '117.39379', lat: '32.94301' },
          { id: 1068, pid: 1066, name: '蚌山区', code: '340303', lng: '117.36767', lat: '32.94411' },
          { id: 1069, pid: 1066, name: '禹会区', code: '340304', lng: '117.35315', lat: '32.93336' },
          { id: 1070, pid: 1066, name: '淮上区', code: '340311', lng: '117.35983', lat: '32.96423' },
          { id: 1071, pid: 1066, name: '怀远县', code: '340321', lng: '117.20507', lat: '32.97007' },
          { id: 1072, pid: 1066, name: '五河县', code: '340322', lng: '117.89144', lat: '33.14457' },
          { id: 1073, pid: 1066, name: '固镇县', code: '340323', lng: '117.31558', lat: '33.31803' },
        ],
      },
      {
        id: 1074,
        pid: 1046,
        name: '淮南市',
        code: '340400',
        lng: '117.025449',
        lat: '32.645947',
        children: [
          { id: 1075, pid: 1074, name: '大通区', code: '340402', lng: '117.05255', lat: '32.63265' },
          { id: 1076, pid: 1074, name: '田家庵区', code: '340403', lng: '117.01739', lat: '32.64697' },
          { id: 1077, pid: 1074, name: '谢家集区', code: '340404', lng: '116.86377', lat: '32.59818' },
          { id: 1078, pid: 1074, name: '八公山区', code: '340405', lng: '116.83694', lat: '32.62941' },
          { id: 1079, pid: 1074, name: '潘集区', code: '340406', lng: '116.81622', lat: '32.78287' },
          { id: 1080, pid: 1074, name: '凤台县', code: '340421', lng: '116.71569', lat: '32.70752' },
        ],
      },
      {
        id: 1081,
        pid: 1046,
        name: '马鞍山市',
        code: '340500',
        lng: '118.507906',
        lat: '31.689362',
        children: [
          { id: 1082, pid: 1081, name: '花山区', code: '340503', lng: '118.51231', lat: '31.7001' },
          { id: 1083, pid: 1081, name: '雨山区', code: '340504', lng: '118.49869', lat: '31.68219' },
          { id: 1084, pid: 1081, name: '博望区', code: '340506', lng: '118.844387', lat: '31.561871' },
          { id: 1085, pid: 1081, name: '当涂县', code: '340521', lng: '118.49786', lat: '31.57098' },
          { id: 1086, pid: 1081, name: '含山县', code: '340522', lng: '118.105545', lat: '31.727758' },
          { id: 1087, pid: 1081, name: '和县', code: '340523', lng: '118.351405', lat: '31.741794' },
        ],
      },
      {
        id: 1088,
        pid: 1046,
        name: '淮北市',
        code: '340600',
        lng: '116.794664',
        lat: '33.971707',
        children: [
          { id: 1089, pid: 1088, name: '杜集区', code: '340602', lng: '116.82998', lat: '33.99363' },
          { id: 1090, pid: 1088, name: '相山区', code: '340603', lng: '116.79464', lat: '33.95979' },
          { id: 1091, pid: 1088, name: '烈山区', code: '340604', lng: '116.81448', lat: '33.89355' },
          { id: 1092, pid: 1088, name: '濉溪县', code: '340621', lng: '116.76785', lat: '33.91455' },
        ],
      },
      {
        id: 1093,
        pid: 1046,
        name: '铜陵市',
        code: '340700',
        lng: '117.816576',
        lat: '30.929935',
        children: [
          { id: 1094, pid: 1093, name: '铜官山区', code: '340702', lng: '117.81525', lat: '30.93423' },
          { id: 1095, pid: 1093, name: '狮子山区', code: '340703', lng: '117.89178', lat: '30.92631' },
          { id: 1096, pid: 1093, name: '郊区', code: '340711', lng: '117.80868', lat: '30.91976' },
          { id: 1097, pid: 1093, name: '铜陵县', code: '340721', lng: '117.79113', lat: '30.95365' },
        ],
      },
      {
        id: 1098,
        pid: 1046,
        name: '安庆市',
        code: '340800',
        lng: '117.053571',
        lat: '30.524816',
        children: [
          { id: 1099, pid: 1098, name: '迎江区', code: '340802', lng: '117.0493', lat: '30.50421' },
          { id: 1100, pid: 1098, name: '大观区', code: '340803', lng: '117.03426', lat: '30.51216' },
          { id: 1101, pid: 1098, name: '宜秀区', code: '340811', lng: '117.06127', lat: '30.50783' },
          { id: 1102, pid: 1098, name: '怀宁县', code: '340822', lng: '116.82968', lat: '30.73376' },
          { id: 1103, pid: 1098, name: '枞阳县', code: '340823', lng: '117.22015', lat: '30.69956' },
          { id: 1104, pid: 1098, name: '潜山县', code: '340824', lng: '116.57574', lat: '30.63037' },
          { id: 1105, pid: 1098, name: '太湖县', code: '340825', lng: '116.3088', lat: '30.4541' },
          { id: 1106, pid: 1098, name: '宿松县', code: '340826', lng: '116.12915', lat: '30.1536' },
          { id: 1107, pid: 1098, name: '望江县', code: '340827', lng: '116.68814', lat: '30.12585' },
          { id: 1108, pid: 1098, name: '岳西县', code: '340828', lng: '116.35995', lat: '30.84983' },
          { id: 1109, pid: 1098, name: '桐城市', code: '340881', lng: '116.95071', lat: '31.05216' },
        ],
      },
      {
        id: 1110,
        pid: 1046,
        name: '黄山市',
        code: '341000',
        lng: '118.317325',
        lat: '29.709239',
        children: [
          { id: 1111, pid: 1110, name: '屯溪区', code: '341002', lng: '118.33368', lat: '29.71138' },
          { id: 1112, pid: 1110, name: '黄山区', code: '341003', lng: '118.1416', lat: '30.2729' },
          { id: 1113, pid: 1110, name: '徽州区', code: '341004', lng: '118.33654', lat: '29.82784' },
          { id: 1114, pid: 1110, name: '歙县', code: '341021', lng: '118.43676', lat: '29.86745' },
          { id: 1115, pid: 1110, name: '休宁县', code: '341022', lng: '118.18136', lat: '29.78607' },
          { id: 1116, pid: 1110, name: '黟县', code: '341023', lng: '117.94137', lat: '29.92588' },
          { id: 1117, pid: 1110, name: '祁门县', code: '341024', lng: '117.71847', lat: '29.85723' },
        ],
      },
      {
        id: 1118,
        pid: 1046,
        name: '滁州市',
        code: '341100',
        lng: '118.316264',
        lat: '32.303627',
        children: [
          { id: 1119, pid: 1118, name: '琅琊区', code: '341102', lng: '118.30538', lat: '32.29521' },
          { id: 1120, pid: 1118, name: '南谯区', code: '341103', lng: '118.31222', lat: '32.31861' },
          { id: 1121, pid: 1118, name: '来安县', code: '341122', lng: '118.43438', lat: '32.45176' },
          { id: 1122, pid: 1118, name: '全椒县', code: '341124', lng: '118.27291', lat: '32.08524' },
          { id: 1123, pid: 1118, name: '定远县', code: '341125', lng: '117.68035', lat: '32.52488' },
          { id: 1124, pid: 1118, name: '凤阳县', code: '341126', lng: '117.56454', lat: '32.86507' },
          { id: 1125, pid: 1118, name: '天长市', code: '341181', lng: '118.99868', lat: '32.69124' },
          { id: 1126, pid: 1118, name: '明光市', code: '341182', lng: '117.99093', lat: '32.77819' },
        ],
      },
      {
        id: 1127,
        pid: 1046,
        name: '阜阳市',
        code: '341200',
        lng: '115.819729',
        lat: '32.896969',
        children: [
          { id: 1128, pid: 1127, name: '颍州区', code: '341202', lng: '115.80694', lat: '32.88346' },
          { id: 1129, pid: 1127, name: '颍东区', code: '341203', lng: '115.85659', lat: '32.91296' },
          { id: 1130, pid: 1127, name: '颍泉区', code: '341204', lng: '115.80712', lat: '32.9249' },
          { id: 1131, pid: 1127, name: '临泉县', code: '341221', lng: '115.26232', lat: '33.06758' },
          { id: 1132, pid: 1127, name: '太和县', code: '341222', lng: '115.62191', lat: '33.16025' },
          { id: 1133, pid: 1127, name: '阜南县', code: '341225', lng: '115.58563', lat: '32.63551' },
          { id: 1134, pid: 1127, name: '颍上县', code: '341226', lng: '116.26458', lat: '32.62998' },
          { id: 1135, pid: 1127, name: '界首市', code: '341282', lng: '115.37445', lat: '33.25714' },
        ],
      },
      {
        id: 1136,
        pid: 1046,
        name: '宿州市',
        code: '341300',
        lng: '116.984084',
        lat: '33.633891',
        children: [
          { id: 1137, pid: 1136, name: '埇桥区', code: '341302', lng: '116.97731', lat: '33.64058' },
          { id: 1138, pid: 1136, name: '砀山县', code: '341321', lng: '116.35363', lat: '34.42356' },
          { id: 1139, pid: 1136, name: '萧县', code: '341322', lng: '116.94546', lat: '34.1879' },
          { id: 1140, pid: 1136, name: '灵璧县', code: '341323', lng: '117.55813', lat: '33.54339' },
          { id: 1141, pid: 1136, name: '泗县', code: '341324', lng: '117.91033', lat: '33.48295' },
        ],
      },
      {
        id: 1142,
        pid: 1046,
        name: '六安市',
        code: '341500',
        lng: '116.507676',
        lat: '31.752889',
        children: [
          { id: 1143, pid: 1142, name: '金安区', code: '341502', lng: '116.50912', lat: '31.75573' },
          { id: 1144, pid: 1142, name: '裕安区', code: '341503', lng: '116.47985', lat: '31.73787' },
          { id: 1145, pid: 1142, name: '寿县', code: '341521', lng: '116.78466', lat: '32.57653' },
          { id: 1146, pid: 1142, name: '霍邱县', code: '341522', lng: '116.27795', lat: '32.353' },
          { id: 1147, pid: 1142, name: '舒城县', code: '341523', lng: '116.94491', lat: '31.46413' },
          { id: 1148, pid: 1142, name: '金寨县', code: '341524', lng: '115.93463', lat: '31.7351' },
          { id: 1149, pid: 1142, name: '霍山县', code: '341525', lng: '116.33291', lat: '31.3929' },
        ],
      },
      {
        id: 1150,
        pid: 1046,
        name: '亳州市',
        code: '341600',
        lng: '115.782939',
        lat: '33.869338',
        children: [
          { id: 1151, pid: 1150, name: '谯城区', code: '341602', lng: '115.77941', lat: '33.87532' },
          { id: 1152, pid: 1150, name: '涡阳县', code: '341621', lng: '116.21682', lat: '33.50911' },
          { id: 1153, pid: 1150, name: '蒙城县', code: '341622', lng: '116.5646', lat: '33.26477' },
          { id: 1154, pid: 1150, name: '利辛县', code: '341623', lng: '116.208', lat: '33.14198' },
        ],
      },
      {
        id: 1155,
        pid: 1046,
        name: '池州市',
        code: '341700',
        lng: '117.489157',
        lat: '30.656037',
        children: [
          { id: 1156, pid: 1155, name: '贵池区', code: '341702', lng: '117.48722', lat: '30.65283' },
          { id: 1157, pid: 1155, name: '东至县', code: '341721', lng: '117.02719', lat: '30.0969' },
          { id: 1158, pid: 1155, name: '石台县', code: '341722', lng: '117.48666', lat: '30.21042' },
          { id: 1159, pid: 1155, name: '青阳县', code: '341723', lng: '117.84744', lat: '30.63932' },
        ],
      },
      {
        id: 1160,
        pid: 1046,
        name: '宣城市',
        code: '341800',
        lng: '118.757995',
        lat: '30.945667',
        children: [
          { id: 1161, pid: 1160, name: '宣州区', code: '341802', lng: '118.75462', lat: '30.94439' },
          { id: 1162, pid: 1160, name: '郎溪县', code: '341821', lng: '119.17923', lat: '31.12599' },
          { id: 1163, pid: 1160, name: '广德县', code: '341822', lng: '119.41769', lat: '30.89371' },
          { id: 1164, pid: 1160, name: '泾县', code: '341823', lng: '118.41964', lat: '30.69498' },
          { id: 1165, pid: 1160, name: '绩溪县', code: '341824', lng: '118.59765', lat: '30.07069' },
          { id: 1166, pid: 1160, name: '旌德县', code: '341825', lng: '118.54299', lat: '30.28898' },
          { id: 1167, pid: 1160, name: '宁国市', code: '341881', lng: '118.98349', lat: '30.6238' },
        ],
      },
    ],
  },
  {
    id: 1168,
    pid: 0,
    name: '福建省',
    code: '350000',
    lng: '119.306239',
    lat: '26.075302',
    children: [
      {
        id: 1169,
        pid: 1168,
        name: '福州市',
        code: '350100',
        lng: '119.306239',
        lat: '26.075302',
        children: [
          { id: 1170, pid: 1169, name: '鼓楼区', code: '350102', lng: '119.30384', lat: '26.08225' },
          { id: 1171, pid: 1169, name: '台江区', code: '350103', lng: '119.30899', lat: '26.06204' },
          { id: 1172, pid: 1169, name: '仓山区', code: '350104', lng: '119.31543', lat: '26.04335' },
          { id: 1173, pid: 1169, name: '马尾区', code: '350105', lng: '119.4555', lat: '25.98942' },
          { id: 1174, pid: 1169, name: '晋安区', code: '350111', lng: '119.32828', lat: '26.0818' },
          { id: 1175, pid: 1169, name: '闽侯县', code: '350121', lng: '119.13388', lat: '26.15014' },
          { id: 1176, pid: 1169, name: '连江县', code: '350122', lng: '119.53433', lat: '26.19466' },
          { id: 1177, pid: 1169, name: '罗源县', code: '350123', lng: '119.5509', lat: '26.48752' },
          { id: 1178, pid: 1169, name: '闽清县', code: '350124', lng: '118.8623', lat: '26.21901' },
          { id: 1179, pid: 1169, name: '永泰县', code: '350125', lng: '118.936', lat: '25.86816' },
          { id: 1180, pid: 1169, name: '平潭县', code: '350128', lng: '119.791197', lat: '25.503672' },
          { id: 1181, pid: 1169, name: '福清市', code: '350181', lng: '119.38507', lat: '25.72086' },
          { id: 1182, pid: 1169, name: '长乐市', code: '350182', lng: '119.52313', lat: '25.96276' },
        ],
      },
      {
        id: 1183,
        pid: 1168,
        name: '厦门市',
        code: '350200',
        lng: '118.11022',
        lat: '24.490474',
        children: [
          { id: 1184, pid: 1183, name: '思明区', code: '350203', lng: '118.08233', lat: '24.44543' },
          { id: 1185, pid: 1183, name: '海沧区', code: '350205', lng: '118.03289', lat: '24.48461' },
          { id: 1186, pid: 1183, name: '湖里区', code: '350206', lng: '118.14621', lat: '24.51253' },
          { id: 1187, pid: 1183, name: '集美区', code: '350211', lng: '118.09719', lat: '24.57584' },
          { id: 1188, pid: 1183, name: '同安区', code: '350212', lng: '118.15197', lat: '24.72308' },
          { id: 1189, pid: 1183, name: '翔安区', code: '350213', lng: '118.24783', lat: '24.61863' },
        ],
      },
      {
        id: 1190,
        pid: 1168,
        name: '莆田市',
        code: '350300',
        lng: '119.007558',
        lat: '25.431011',
        children: [
          { id: 1191, pid: 1190, name: '城厢区', code: '350302', lng: '118.99462', lat: '25.41872' },
          { id: 1192, pid: 1190, name: '涵江区', code: '350303', lng: '119.11621', lat: '25.45876' },
          { id: 1193, pid: 1190, name: '荔城区', code: '350304', lng: '119.01339', lat: '25.43369' },
          { id: 1194, pid: 1190, name: '秀屿区', code: '350305', lng: '119.10553', lat: '25.31831' },
          { id: 1195, pid: 1190, name: '仙游县', code: '350322', lng: '118.69177', lat: '25.36214' },
        ],
      },
      {
        id: 1196,
        pid: 1168,
        name: '三明市',
        code: '350400',
        lng: '117.635001',
        lat: '26.265444',
        children: [
          { id: 1197, pid: 1196, name: '梅列区', code: '350402', lng: '117.64585', lat: '26.27171' },
          { id: 1198, pid: 1196, name: '三元区', code: '350403', lng: '117.60788', lat: '26.23372' },
          { id: 1199, pid: 1196, name: '明溪县', code: '350421', lng: '117.20498', lat: '26.35294' },
          { id: 1200, pid: 1196, name: '清流县', code: '350423', lng: '116.8146', lat: '26.17144' },
          { id: 1201, pid: 1196, name: '宁化县', code: '350424', lng: '116.66101', lat: '26.25874' },
          { id: 1202, pid: 1196, name: '大田县', code: '350425', lng: '117.8471', lat: '25.6926' },
          { id: 1203, pid: 1196, name: '尤溪县', code: '350426', lng: '118.19049', lat: '26.17002' },
          { id: 1204, pid: 1196, name: '沙县', code: '350427', lng: '117.79266', lat: '26.39615' },
          { id: 1205, pid: 1196, name: '将乐县', code: '350428', lng: '117.47317', lat: '26.72837' },
          { id: 1206, pid: 1196, name: '泰宁县', code: '350429', lng: '117.17578', lat: '26.9001' },
          { id: 1207, pid: 1196, name: '建宁县', code: '350430', lng: '116.84603', lat: '26.83091' },
          { id: 1208, pid: 1196, name: '永安市', code: '350481', lng: '117.36517', lat: '25.94136' },
        ],
      },
      {
        id: 1209,
        pid: 1168,
        name: '泉州市',
        code: '350500',
        lng: '118.589421',
        lat: '24.908853',
        children: [
          { id: 1210, pid: 1209, name: '鲤城区', code: '350502', lng: '118.56591', lat: '24.88741' },
          { id: 1211, pid: 1209, name: '丰泽区', code: '350503', lng: '118.61328', lat: '24.89119' },
          { id: 1212, pid: 1209, name: '洛江区', code: '350504', lng: '118.67111', lat: '24.93984' },
          { id: 1213, pid: 1209, name: '泉港区', code: '350505', lng: '118.91586', lat: '25.12005' },
          { id: 1214, pid: 1209, name: '惠安县', code: '350521', lng: '118.79687', lat: '25.03059' },
          { id: 1215, pid: 1209, name: '安溪县', code: '350524', lng: '118.18719', lat: '25.05627' },
          { id: 1216, pid: 1209, name: '永春县', code: '350525', lng: '118.29437', lat: '25.32183' },
          { id: 1217, pid: 1209, name: '德化县', code: '350526', lng: '118.24176', lat: '25.49224' },
          { id: 1218, pid: 1209, name: '金门县', code: '350527', lng: '118.32263', lat: '24.42922' },
          { id: 1219, pid: 1209, name: '石狮市', code: '350581', lng: '118.64779', lat: '24.73242' },
          { id: 1220, pid: 1209, name: '晋江市', code: '350582', lng: '118.55194', lat: '24.78141' },
          { id: 1221, pid: 1209, name: '南安市', code: '350583', lng: '118.38589', lat: '24.96055' },
        ],
      },
      {
        id: 1222,
        pid: 1168,
        name: '漳州市',
        code: '350600',
        lng: '117.661801',
        lat: '24.510897',
        children: [
          { id: 1223, pid: 1222, name: '芗城区', code: '350602', lng: '117.65402', lat: '24.51081' },
          { id: 1224, pid: 1222, name: '龙文区', code: '350603', lng: '117.70971', lat: '24.50323' },
          { id: 1225, pid: 1222, name: '云霄县', code: '350622', lng: '117.34051', lat: '23.95534' },
          { id: 1226, pid: 1222, name: '漳浦县', code: '350623', lng: '117.61367', lat: '24.11706' },
          { id: 1227, pid: 1222, name: '诏安县', code: '350624', lng: '117.17501', lat: '23.71148' },
          { id: 1228, pid: 1222, name: '长泰县', code: '350625', lng: '117.75924', lat: '24.62526' },
          { id: 1229, pid: 1222, name: '东山县', code: '350626', lng: '117.42822', lat: '23.70109' },
          { id: 1230, pid: 1222, name: '南靖县', code: '350627', lng: '117.35736', lat: '24.51448' },
          { id: 1231, pid: 1222, name: '平和县', code: '350628', lng: '117.3124', lat: '24.36395' },
          { id: 1232, pid: 1222, name: '华安县', code: '350629', lng: '117.54077', lat: '25.00563' },
          { id: 1233, pid: 1222, name: '龙海市', code: '350681', lng: '117.81802', lat: '24.44655' },
        ],
      },
      {
        id: 1234,
        pid: 1168,
        name: '南平市',
        code: '350700',
        lng: '118.178459',
        lat: '26.635627',
        children: [
          { id: 1235, pid: 1234, name: '延平区', code: '350702', lng: '118.18189', lat: '26.63745' },
          { id: 1236, pid: 1234, name: '建阳区', code: '350703', lng: '118.12267', lat: '27.332067' },
          { id: 1237, pid: 1234, name: '顺昌县', code: '350721', lng: '117.8103', lat: '26.79298' },
          { id: 1238, pid: 1234, name: '浦城县', code: '350722', lng: '118.54007', lat: '27.91888' },
          { id: 1239, pid: 1234, name: '光泽县', code: '350723', lng: '117.33346', lat: '27.54231' },
          { id: 1240, pid: 1234, name: '松溪县', code: '350724', lng: '118.78533', lat: '27.52624' },
          { id: 1241, pid: 1234, name: '政和县', code: '350725', lng: '118.85571', lat: '27.36769' },
          { id: 1242, pid: 1234, name: '邵武市', code: '350781', lng: '117.4924', lat: '27.34033' },
          { id: 1243, pid: 1234, name: '武夷山市', code: '350782', lng: '118.03665', lat: '27.75543' },
          { id: 1244, pid: 1234, name: '建瓯市', code: '350783', lng: '118.29766', lat: '27.02301' },
        ],
      },
      {
        id: 1245,
        pid: 1168,
        name: '龙岩市',
        code: '350800',
        lng: '117.02978',
        lat: '25.091603',
        children: [
          { id: 1246, pid: 1245, name: '新罗区', code: '350802', lng: '117.03693', lat: '25.09834' },
          { id: 1247, pid: 1245, name: '长汀县', code: '350821', lng: '116.35888', lat: '25.82773' },
          { id: 1248, pid: 1245, name: '永定区', code: '350822', lng: '116.73199', lat: '24.72302' },
          { id: 1249, pid: 1245, name: '上杭县', code: '350823', lng: '116.42022', lat: '25.04943' },
          { id: 1250, pid: 1245, name: '武平县', code: '350824', lng: '116.10229', lat: '25.09244' },
          { id: 1251, pid: 1245, name: '连城县', code: '350825', lng: '116.75454', lat: '25.7103' },
          { id: 1252, pid: 1245, name: '漳平市', code: '350881', lng: '117.41992', lat: '25.29109' },
        ],
      },
      {
        id: 1253,
        pid: 1168,
        name: '宁德市',
        code: '350900',
        lng: '119.527082',
        lat: '26.65924',
        children: [
          { id: 1254, pid: 1253, name: '蕉城区', code: '350902', lng: '119.52643', lat: '26.66048' },
          { id: 1255, pid: 1253, name: '霞浦县', code: '350921', lng: '119.99893', lat: '26.88578' },
          { id: 1256, pid: 1253, name: '古田县', code: '350922', lng: '118.74688', lat: '26.57682' },
          { id: 1257, pid: 1253, name: '屏南县', code: '350923', lng: '118.98861', lat: '26.91099' },
          { id: 1258, pid: 1253, name: '寿宁县', code: '350924', lng: '119.5039', lat: '27.45996' },
          { id: 1259, pid: 1253, name: '周宁县', code: '350925', lng: '119.33837', lat: '27.10664' },
          { id: 1260, pid: 1253, name: '柘荣县', code: '350926', lng: '119.89971', lat: '27.23543' },
          { id: 1261, pid: 1253, name: '福安市', code: '350981', lng: '119.6495', lat: '27.08673' },
          { id: 1262, pid: 1253, name: '福鼎市', code: '350982', lng: '120.21664', lat: '27.3243' },
        ],
      },
    ],
  },
  {
    id: 1263,
    pid: 0,
    name: '江西省',
    code: '360000',
    lng: '115.892151',
    lat: '28.676493',
    children: [
      {
        id: 1264,
        pid: 1263,
        name: '南昌市',
        code: '360100',
        lng: '115.892151',
        lat: '28.676493',
        children: [
          { id: 1265, pid: 1264, name: '东湖区', code: '360102', lng: '115.8988', lat: '28.68505' },
          { id: 1266, pid: 1264, name: '西湖区', code: '360103', lng: '115.87728', lat: '28.65688' },
          { id: 1267, pid: 1264, name: '青云谱区', code: '360104', lng: '115.915', lat: '28.63199' },
          { id: 1268, pid: 1264, name: '湾里区', code: '360105', lng: '115.73104', lat: '28.71529' },
          { id: 1269, pid: 1264, name: '青山湖区', code: '360111', lng: '115.9617', lat: '28.68206' },
          { id: 1270, pid: 1264, name: '南昌县', code: '360121', lng: '115.94393', lat: '28.54559' },
          { id: 1271, pid: 1264, name: '新建县', code: '360122', lng: '115.81546', lat: '28.69248' },
          { id: 1272, pid: 1264, name: '安义县', code: '360123', lng: '115.54879', lat: '28.84602' },
          { id: 1273, pid: 1264, name: '进贤县', code: '360124', lng: '116.24087', lat: '28.37679' },
        ],
      },
      {
        id: 1274,
        pid: 1263,
        name: '景德镇市',
        code: '360200',
        lng: '117.214664',
        lat: '29.29256',
        children: [
          { id: 1275, pid: 1274, name: '昌江区', code: '360202', lng: '117.18359', lat: '29.27321' },
          { id: 1276, pid: 1274, name: '珠山区', code: '360203', lng: '117.20233', lat: '29.30127' },
          { id: 1277, pid: 1274, name: '浮梁县', code: '360222', lng: '117.21517', lat: '29.35156' },
          { id: 1278, pid: 1274, name: '乐平市', code: '360281', lng: '117.12887', lat: '28.96295' },
        ],
      },
      {
        id: 1279,
        pid: 1263,
        name: '萍乡市',
        code: '360300',
        lng: '113.852186',
        lat: '27.622946',
        children: [
          { id: 1280, pid: 1279, name: '安源区', code: '360302', lng: '113.89135', lat: '27.61653' },
          { id: 1281, pid: 1279, name: '湘东区', code: '360313', lng: '113.73294', lat: '27.64007' },
          { id: 1282, pid: 1279, name: '莲花县', code: '360321', lng: '113.96142', lat: '27.12866' },
          { id: 1283, pid: 1279, name: '上栗县', code: '360322', lng: '113.79403', lat: '27.87467' },
          { id: 1284, pid: 1279, name: '芦溪县', code: '360323', lng: '114.02951', lat: '27.63063' },
        ],
      },
      {
        id: 1285,
        pid: 1263,
        name: '九江市',
        code: '360400',
        lng: '115.992811',
        lat: '29.712034',
        children: [
          { id: 1286, pid: 1285, name: '庐山区', code: '360402', lng: '115.98904', lat: '29.67177' },
          { id: 1287, pid: 1285, name: '浔阳区', code: '360403', lng: '115.98986', lat: '29.72786' },
          { id: 1288, pid: 1285, name: '九江县', code: '360421', lng: '115.91128', lat: '29.60852' },
          { id: 1289, pid: 1285, name: '武宁县', code: '360423', lng: '115.10061', lat: '29.2584' },
          { id: 1290, pid: 1285, name: '修水县', code: '360424', lng: '114.54684', lat: '29.02539' },
          { id: 1291, pid: 1285, name: '永修县', code: '360425', lng: '115.80911', lat: '29.02093' },
          { id: 1292, pid: 1285, name: '德安县', code: '360426', lng: '115.75601', lat: '29.31341' },
          { id: 1293, pid: 1285, name: '星子县', code: '360427', lng: '116.04492', lat: '29.44608' },
          { id: 1294, pid: 1285, name: '都昌县', code: '360428', lng: '116.20401', lat: '29.27327' },
          { id: 1295, pid: 1285, name: '湖口县', code: '360429', lng: '116.21853', lat: '29.73818' },
          { id: 1296, pid: 1285, name: '彭泽县', code: '360430', lng: '116.55011', lat: '29.89589' },
          { id: 1297, pid: 1285, name: '瑞昌市', code: '360481', lng: '115.66705', lat: '29.67183' },
          { id: 1298, pid: 1285, name: '共青城市', code: '360482', lng: '115.801939', lat: '29.238785' },
        ],
      },
      {
        id: 1299,
        pid: 1263,
        name: '新余市',
        code: '360500',
        lng: '114.930835',
        lat: '27.810834',
        children: [
          { id: 1300, pid: 1299, name: '渝水区', code: '360502', lng: '114.944', lat: '27.80098' },
          { id: 1301, pid: 1299, name: '分宜县', code: '360521', lng: '114.69189', lat: '27.81475' },
        ],
      },
      {
        id: 1302,
        pid: 1263,
        name: '鹰潭市',
        code: '360600',
        lng: '117.033838',
        lat: '28.238638',
        children: [
          { id: 1303, pid: 1302, name: '月湖区', code: '360602', lng: '117.03732', lat: '28.23913' },
          { id: 1304, pid: 1302, name: '余江县', code: '360622', lng: '116.81851', lat: '28.21034' },
          { id: 1305, pid: 1302, name: '贵溪市', code: '360681', lng: '117.24246', lat: '28.2926' },
        ],
      },
      {
        id: 1306,
        pid: 1263,
        name: '赣州市',
        code: '360700',
        lng: '114.940278',
        lat: '25.85097',
        children: [
          { id: 1307, pid: 1306, name: '章贡区', code: '360702', lng: '114.94284', lat: '25.8624' },
          { id: 1308, pid: 1306, name: '南康区', code: '360703', lng: '114.756933', lat: '25.661721' },
          { id: 1309, pid: 1306, name: '赣县', code: '360721', lng: '115.01171', lat: '25.86149' },
          { id: 1310, pid: 1306, name: '信丰县', code: '360722', lng: '114.92279', lat: '25.38612' },
          { id: 1311, pid: 1306, name: '大余县', code: '360723', lng: '114.35757', lat: '25.39561' },
          { id: 1312, pid: 1306, name: '上犹县', code: '360724', lng: '114.54138', lat: '25.79567' },
          { id: 1313, pid: 1306, name: '崇义县', code: '360725', lng: '114.30835', lat: '25.68186' },
          { id: 1314, pid: 1306, name: '安远县', code: '360726', lng: '115.39483', lat: '25.1371' },
          { id: 1315, pid: 1306, name: '龙南县', code: '360727', lng: '114.78994', lat: '24.91086' },
          { id: 1316, pid: 1306, name: '定南县', code: '360728', lng: '115.02713', lat: '24.78395' },
          { id: 1317, pid: 1306, name: '全南县', code: '360729', lng: '114.5292', lat: '24.74324' },
          { id: 1318, pid: 1306, name: '宁都县', code: '360730', lng: '116.01565', lat: '26.47227' },
          { id: 1319, pid: 1306, name: '于都县', code: '360731', lng: '115.41415', lat: '25.95257' },
          { id: 1320, pid: 1306, name: '兴国县', code: '360732', lng: '115.36309', lat: '26.33776' },
          { id: 1321, pid: 1306, name: '会昌县', code: '360733', lng: '115.78555', lat: '25.60068' },
          { id: 1322, pid: 1306, name: '寻乌县', code: '360734', lng: '115.64852', lat: '24.95513' },
          { id: 1323, pid: 1306, name: '石城县', code: '360735', lng: '116.3442', lat: '26.32617' },
          { id: 1324, pid: 1306, name: '瑞金市', code: '360781', lng: '116.02703', lat: '25.88557' },
        ],
      },
      {
        id: 1325,
        pid: 1263,
        name: '吉安市',
        code: '360800',
        lng: '114.986373',
        lat: '27.111699',
        children: [
          { id: 1326, pid: 1325, name: '吉州区', code: '360802', lng: '114.97598', lat: '27.10669' },
          { id: 1327, pid: 1325, name: '青原区', code: '360803', lng: '115.01747', lat: '27.10577' },
          { id: 1328, pid: 1325, name: '吉安县', code: '360821', lng: '114.90695', lat: '27.04048' },
          { id: 1329, pid: 1325, name: '吉水县', code: '360822', lng: '115.1343', lat: '27.21071' },
          { id: 1330, pid: 1325, name: '峡江县', code: '360823', lng: '115.31723', lat: '27.576' },
          { id: 1331, pid: 1325, name: '新干县', code: '360824', lng: '115.39306', lat: '27.74092' },
          { id: 1332, pid: 1325, name: '永丰县', code: '360825', lng: '115.44238', lat: '27.31785' },
          { id: 1333, pid: 1325, name: '泰和县', code: '360826', lng: '114.90789', lat: '26.79113' },
          { id: 1334, pid: 1325, name: '遂川县', code: '360827', lng: '114.51629', lat: '26.32598' },
          { id: 1335, pid: 1325, name: '万安县', code: '360828', lng: '114.78659', lat: '26.45931' },
          { id: 1336, pid: 1325, name: '安福县', code: '360829', lng: '114.61956', lat: '27.39276' },
          { id: 1337, pid: 1325, name: '永新县', code: '360830', lng: '114.24246', lat: '26.94488' },
          { id: 1338, pid: 1325, name: '井冈山市', code: '360881', lng: '114.28949', lat: '26.74804' },
        ],
      },
      {
        id: 1339,
        pid: 1263,
        name: '宜春市',
        code: '360900',
        lng: '114.391136',
        lat: '27.8043',
        children: [
          { id: 1340, pid: 1339, name: '袁州区', code: '360902', lng: '114.38246', lat: '27.79649' },
          { id: 1341, pid: 1339, name: '奉新县', code: '360921', lng: '115.40036', lat: '28.6879' },
          { id: 1342, pid: 1339, name: '万载县', code: '360922', lng: '114.4458', lat: '28.10656' },
          { id: 1343, pid: 1339, name: '上高县', code: '360923', lng: '114.92459', lat: '28.23423' },
          { id: 1344, pid: 1339, name: '宜丰县', code: '360924', lng: '114.7803', lat: '28.38555' },
          { id: 1345, pid: 1339, name: '靖安县', code: '360925', lng: '115.36279', lat: '28.86167' },
          { id: 1346, pid: 1339, name: '铜鼓县', code: '360926', lng: '114.37036', lat: '28.52311' },
          { id: 1347, pid: 1339, name: '丰城市', code: '360981', lng: '115.77114', lat: '28.15918' },
          { id: 1348, pid: 1339, name: '樟树市', code: '360982', lng: '115.5465', lat: '28.05332' },
          { id: 1349, pid: 1339, name: '高安市', code: '360983', lng: '115.3753', lat: '28.4178' },
        ],
      },
      {
        id: 1350,
        pid: 1263,
        name: '抚州市',
        code: '361000',
        lng: '116.358351',
        lat: '27.98385',
        children: [
          { id: 1351, pid: 1350, name: '临川区', code: '361002', lng: '116.35919', lat: '27.97721' },
          { id: 1352, pid: 1350, name: '南城县', code: '361021', lng: '116.64419', lat: '27.55381' },
          { id: 1353, pid: 1350, name: '黎川县', code: '361022', lng: '116.90771', lat: '27.28232' },
          { id: 1354, pid: 1350, name: '南丰县', code: '361023', lng: '116.5256', lat: '27.21842' },
          { id: 1355, pid: 1350, name: '崇仁县', code: '361024', lng: '116.06021', lat: '27.75962' },
          { id: 1356, pid: 1350, name: '乐安县', code: '361025', lng: '115.83108', lat: '27.42812' },
          { id: 1357, pid: 1350, name: '宜黄县', code: '361026', lng: '116.23626', lat: '27.55487' },
          { id: 1358, pid: 1350, name: '金溪县', code: '361027', lng: '116.77392', lat: '27.90753' },
          { id: 1359, pid: 1350, name: '资溪县', code: '361028', lng: '117.06939', lat: '27.70493' },
          { id: 1360, pid: 1350, name: '东乡县', code: '361029', lng: '116.59039', lat: '28.23614' },
          { id: 1361, pid: 1350, name: '广昌县', code: '361030', lng: '116.32547', lat: '26.8341' },
        ],
      },
      {
        id: 1362,
        pid: 1263,
        name: '上饶市',
        code: '361100',
        lng: '117.971185',
        lat: '28.44442',
        children: [
          { id: 1363, pid: 1362, name: '信州区', code: '361102', lng: '117.96682', lat: '28.43121' },
          { id: 1364, pid: 1362, name: '上饶县', code: '361121', lng: '117.90884', lat: '28.44856' },
          { id: 1365, pid: 1362, name: '广丰县', code: '361122', lng: '118.19158', lat: '28.43766' },
          { id: 1366, pid: 1362, name: '玉山县', code: '361123', lng: '118.24462', lat: '28.6818' },
          { id: 1367, pid: 1362, name: '铅山县', code: '361124', lng: '117.70996', lat: '28.31549' },
          { id: 1368, pid: 1362, name: '横峰县', code: '361125', lng: '117.5964', lat: '28.40716' },
          { id: 1369, pid: 1362, name: '弋阳县', code: '361126', lng: '117.45929', lat: '28.37451' },
          { id: 1370, pid: 1362, name: '余干县', code: '361127', lng: '116.69555', lat: '28.70206' },
          { id: 1371, pid: 1362, name: '鄱阳县', code: '361128', lng: '116.69967', lat: '29.0118' },
          { id: 1372, pid: 1362, name: '万年县', code: '361129', lng: '117.06884', lat: '28.69537' },
          { id: 1373, pid: 1362, name: '婺源县', code: '361130', lng: '117.86105', lat: '29.24841' },
          { id: 1374, pid: 1362, name: '德兴市', code: '361181', lng: '117.57919', lat: '28.94736' },
        ],
      },
    ],
  },
  {
    id: 1375,
    pid: 0,
    name: '山东省',
    code: '370000',
    lng: '117.000923',
    lat: '36.675807',
    children: [
      {
        id: 1376,
        pid: 1375,
        name: '济南市',
        code: '370100',
        lng: '117.000923',
        lat: '36.675807',
        children: [
          { id: 1377, pid: 1376, name: '历下区', code: '370102', lng: '117.0768', lat: '36.66661' },
          { id: 1378, pid: 1376, name: '市中区', code: '370103', lng: '116.99741', lat: '36.65101' },
          { id: 1379, pid: 1376, name: '槐荫区', code: '370104', lng: '116.90075', lat: '36.65136' },
          { id: 1380, pid: 1376, name: '天桥区', code: '370105', lng: '116.98749', lat: '36.67801' },
          { id: 1381, pid: 1376, name: '历城区', code: '370112', lng: '117.06509', lat: '36.67995' },
          { id: 1382, pid: 1376, name: '长清区', code: '370113', lng: '116.75192', lat: '36.55352' },
          { id: 1383, pid: 1376, name: '平阴县', code: '370124', lng: '116.45587', lat: '36.28955' },
          { id: 1384, pid: 1376, name: '济阳县', code: '370125', lng: '117.17327', lat: '36.97845' },
          { id: 1385, pid: 1376, name: '商河县', code: '370126', lng: '117.15722', lat: '37.31119' },
          { id: 1386, pid: 1376, name: '章丘市', code: '370181', lng: '117.53677', lat: '36.71392' },
        ],
      },
      {
        id: 1387,
        pid: 1375,
        name: '青岛市',
        code: '370200',
        lng: '120.369557',
        lat: '36.094406',
        children: [
          { id: 1388, pid: 1387, name: '市南区', code: '370202', lng: '120.38773', lat: '36.06671' },
          { id: 1389, pid: 1387, name: '市北区', code: '370203', lng: '120.37469', lat: '36.08734' },
          { id: 1390, pid: 1387, name: '黄岛区', code: '370211', lng: '120.19775', lat: '35.96065' },
          { id: 1391, pid: 1387, name: '崂山区', code: '370212', lng: '120.46923', lat: '36.10717' },
          { id: 1392, pid: 1387, name: '李沧区', code: '370213', lng: '120.43286', lat: '36.14502' },
          { id: 1393, pid: 1387, name: '城阳区', code: '370214', lng: '120.39621', lat: '36.30735' },
          { id: 1394, pid: 1387, name: '胶州市', code: '370281', lng: '120.0335', lat: '36.26442' },
          { id: 1395, pid: 1387, name: '即墨市', code: '370282', lng: '120.44699', lat: '36.38907' },
          { id: 1396, pid: 1387, name: '平度市', code: '370283', lng: '119.95996', lat: '36.78688' },
          { id: 1397, pid: 1387, name: '莱西市', code: '370285', lng: '120.51773', lat: '36.88804' },
          { id: 1398, pid: 1387, name: '西海岸新区', code: '370286', lng: '120.19775', lat: '35.96065' },
        ],
      },
      {
        id: 1399,
        pid: 1375,
        name: '淄博市',
        code: '370300',
        lng: '118.047648',
        lat: '36.814939',
        children: [
          { id: 1400, pid: 1399, name: '淄川区', code: '370302', lng: '117.96655', lat: '36.64339' },
          { id: 1401, pid: 1399, name: '张店区', code: '370303', lng: '118.01788', lat: '36.80676' },
          { id: 1402, pid: 1399, name: '博山区', code: '370304', lng: '117.86166', lat: '36.49469' },
          { id: 1403, pid: 1399, name: '临淄区', code: '370305', lng: '118.30966', lat: '36.8259' },
          { id: 1404, pid: 1399, name: '周村区', code: '370306', lng: '117.86969', lat: '36.80322' },
          { id: 1405, pid: 1399, name: '桓台县', code: '370321', lng: '118.09698', lat: '36.96036' },
          { id: 1406, pid: 1399, name: '高青县', code: '370322', lng: '117.82708', lat: '37.17197' },
          { id: 1407, pid: 1399, name: '沂源县', code: '370323', lng: '118.17105', lat: '36.18536' },
        ],
      },
      {
        id: 1408,
        pid: 1375,
        name: '枣庄市',
        code: '370400',
        lng: '117.557964',
        lat: '34.856424',
        children: [
          { id: 1409, pid: 1408, name: '市中区', code: '370402', lng: '117.55603', lat: '34.86391' },
          { id: 1410, pid: 1408, name: '薛城区', code: '370403', lng: '117.26318', lat: '34.79498' },
          { id: 1411, pid: 1408, name: '峄城区', code: '370404', lng: '117.59057', lat: '34.77225' },
          { id: 1412, pid: 1408, name: '台儿庄区', code: '370405', lng: '117.73452', lat: '34.56363' },
          { id: 1413, pid: 1408, name: '山亭区', code: '370406', lng: '117.4663', lat: '35.09541' },
          { id: 1414, pid: 1408, name: '滕州市', code: '370481', lng: '117.165', lat: '35.10534' },
        ],
      },
      {
        id: 1415,
        pid: 1375,
        name: '东营市',
        code: '370500',
        lng: '118.4963',
        lat: '37.461266',
        children: [
          { id: 1416, pid: 1415, name: '东营区', code: '370502', lng: '118.5816', lat: '37.44875' },
          { id: 1417, pid: 1415, name: '河口区', code: '370503', lng: '118.5249', lat: '37.88541' },
          { id: 1418, pid: 1415, name: '垦利县', code: '370521', lng: '118.54815', lat: '37.58825' },
          { id: 1419, pid: 1415, name: '利津县', code: '370522', lng: '118.25637', lat: '37.49157' },
          { id: 1420, pid: 1415, name: '广饶县', code: '370523', lng: '118.40704', lat: '37.05381' },
        ],
      },
      {
        id: 1421,
        pid: 1375,
        name: '烟台市',
        code: '370600',
        lng: '121.391382',
        lat: '37.539297',
        children: [
          { id: 1422, pid: 1421, name: '芝罘区', code: '370602', lng: '121.40023', lat: '37.54064' },
          { id: 1423, pid: 1421, name: '福山区', code: '370611', lng: '121.26812', lat: '37.49841' },
          { id: 1424, pid: 1421, name: '牟平区', code: '370612', lng: '121.60067', lat: '37.38846' },
          { id: 1425, pid: 1421, name: '莱山区', code: '370613', lng: '121.44512', lat: '37.51165' },
          { id: 1426, pid: 1421, name: '长岛县', code: '370634', lng: '120.738', lat: '37.91754' },
          { id: 1427, pid: 1421, name: '龙口市', code: '370681', lng: '120.50634', lat: '37.64064' },
          { id: 1428, pid: 1421, name: '莱阳市', code: '370682', lng: '120.71066', lat: '36.98012' },
          { id: 1429, pid: 1421, name: '莱州市', code: '370683', lng: '119.94137', lat: '37.17806' },
          { id: 1430, pid: 1421, name: '蓬莱市', code: '370684', lng: '120.75988', lat: '37.81119' },
          { id: 1431, pid: 1421, name: '招远市', code: '370685', lng: '120.40481', lat: '37.36269' },
          { id: 1432, pid: 1421, name: '栖霞市', code: '370686', lng: '120.85025', lat: '37.33571' },
          { id: 1433, pid: 1421, name: '海阳市', code: '370687', lng: '121.15976', lat: '36.77622' },
        ],
      },
      {
        id: 1434,
        pid: 1375,
        name: '潍坊市',
        code: '370700',
        lng: '119.107078',
        lat: '36.70925',
        children: [
          { id: 1435, pid: 1434, name: '潍城区', code: '370702', lng: '119.10582', lat: '36.7139' },
          { id: 1436, pid: 1434, name: '寒亭区', code: '370703', lng: '119.21832', lat: '36.77504' },
          { id: 1437, pid: 1434, name: '坊子区', code: '370704', lng: '119.16476', lat: '36.65218' },
          { id: 1438, pid: 1434, name: '奎文区', code: '370705', lng: '119.12532', lat: '36.70723' },
          { id: 1439, pid: 1434, name: '临朐县', code: '370724', lng: '118.544', lat: '36.51216' },
          { id: 1440, pid: 1434, name: '昌乐县', code: '370725', lng: '118.83017', lat: '36.7078' },
          { id: 1441, pid: 1434, name: '青州市', code: '370781', lng: '118.47915', lat: '36.68505' },
          { id: 1442, pid: 1434, name: '诸城市', code: '370782', lng: '119.40988', lat: '35.99662' },
          { id: 1443, pid: 1434, name: '寿光市', code: '370783', lng: '118.74047', lat: '36.88128' },
          { id: 1444, pid: 1434, name: '安丘市', code: '370784', lng: '119.2189', lat: '36.47847' },
          { id: 1445, pid: 1434, name: '高密市', code: '370785', lng: '119.75701', lat: '36.38397' },
          { id: 1446, pid: 1434, name: '昌邑市', code: '370786', lng: '119.39767', lat: '36.86008' },
        ],
      },
      {
        id: 1447,
        pid: 1375,
        name: '济宁市',
        code: '370800',
        lng: '116.587245',
        lat: '35.415393',
        children: [
          { id: 1448, pid: 1447, name: '任城区', code: '370811', lng: '116.59504', lat: '35.40659' },
          { id: 1449, pid: 1447, name: '兖州区', code: '370812', lng: '116.826546', lat: '35.552305' },
          { id: 1450, pid: 1447, name: '微山县', code: '370826', lng: '117.12875', lat: '34.80712' },
          { id: 1451, pid: 1447, name: '鱼台县', code: '370827', lng: '116.64761', lat: '34.99674' },
          { id: 1452, pid: 1447, name: '金乡县', code: '370828', lng: '116.31146', lat: '35.065' },
          { id: 1453, pid: 1447, name: '嘉祥县', code: '370829', lng: '116.34249', lat: '35.40836' },
          { id: 1454, pid: 1447, name: '汶上县', code: '370830', lng: '116.48742', lat: '35.73295' },
          { id: 1455, pid: 1447, name: '泗水县', code: '370831', lng: '117.27948', lat: '35.66113' },
          { id: 1456, pid: 1447, name: '梁山县', code: '370832', lng: '116.09683', lat: '35.80322' },
          { id: 1457, pid: 1447, name: '曲阜市', code: '370881', lng: '116.98645', lat: '35.58091' },
          { id: 1458, pid: 1447, name: '邹城市', code: '370883', lng: '116.97335', lat: '35.40531' },
        ],
      },
      {
        id: 1459,
        pid: 1375,
        name: '泰安市',
        code: '370900',
        lng: '117.129063',
        lat: '36.194968',
        children: [
          { id: 1460, pid: 1459, name: '泰山区', code: '370902', lng: '117.13446', lat: '36.19411' },
          { id: 1461, pid: 1459, name: '岱岳区', code: '370911', lng: '117.04174', lat: '36.1875' },
          { id: 1462, pid: 1459, name: '宁阳县', code: '370921', lng: '116.80542', lat: '35.7599' },
          { id: 1463, pid: 1459, name: '东平县', code: '370923', lng: '116.47113', lat: '35.93792' },
          { id: 1464, pid: 1459, name: '新泰市', code: '370982', lng: '117.76959', lat: '35.90887' },
          { id: 1465, pid: 1459, name: '肥城市', code: '370983', lng: '116.76815', lat: '36.18247' },
        ],
      },
      {
        id: 1466,
        pid: 1375,
        name: '威海市',
        code: '371000',
        lng: '122.116394',
        lat: '37.509691',
        children: [
          { id: 1467, pid: 1466, name: '环翠区', code: '371002', lng: '122.12344', lat: '37.50199' },
          { id: 1468, pid: 1466, name: '文登区', code: '371003', lng: '122.057139', lat: '37.196211' },
          { id: 1469, pid: 1466, name: '荣成市', code: '371082', lng: '122.48773', lat: '37.1652' },
          { id: 1470, pid: 1466, name: '乳山市', code: '371083', lng: '121.53814', lat: '36.91918' },
        ],
      },
      {
        id: 1471,
        pid: 1375,
        name: '日照市',
        code: '371100',
        lng: '119.461208',
        lat: '35.428588',
        children: [
          { id: 1472, pid: 1471, name: '东港区', code: '371102', lng: '119.46237', lat: '35.42541' },
          { id: 1473, pid: 1471, name: '岚山区', code: '371103', lng: '119.31884', lat: '35.12203' },
          { id: 1474, pid: 1471, name: '五莲县', code: '371121', lng: '119.207', lat: '35.75004' },
          { id: 1475, pid: 1471, name: '莒县', code: '371122', lng: '118.83789', lat: '35.58054' },
        ],
      },
      {
        id: 1476,
        pid: 1375,
        name: '莱芜市',
        code: '371200',
        lng: '117.677736',
        lat: '36.214397',
        children: [
          { id: 1477, pid: 1476, name: '莱城区', code: '371202', lng: '117.65986', lat: '36.2032' },
          { id: 1478, pid: 1476, name: '钢城区', code: '371203', lng: '117.8049', lat: '36.06319' },
        ],
      },
      {
        id: 1479,
        pid: 1375,
        name: '临沂市',
        code: '371300',
        lng: '118.326443',
        lat: '35.065282',
        children: [
          { id: 1480, pid: 1479, name: '兰山区', code: '371302', lng: '118.34817', lat: '35.06872' },
          { id: 1481, pid: 1479, name: '罗庄区', code: '371311', lng: '118.28466', lat: '34.99627' },
          { id: 1482, pid: 1479, name: '河东区', code: '371312', lng: '118.41055', lat: '35.08803' },
          { id: 1483, pid: 1479, name: '沂南县', code: '371321', lng: '118.47061', lat: '35.55131' },
          { id: 1484, pid: 1479, name: '郯城县', code: '371322', lng: '118.36712', lat: '34.61354' },
          { id: 1485, pid: 1479, name: '沂水县', code: '371323', lng: '118.63009', lat: '35.78731' },
          { id: 1486, pid: 1479, name: '兰陵县', code: '371324', lng: '117.856592', lat: '34.738315' },
          { id: 1487, pid: 1479, name: '费县', code: '371325', lng: '117.97836', lat: '35.26562' },
          { id: 1488, pid: 1479, name: '平邑县', code: '371326', lng: '117.63867', lat: '35.50573' },
          { id: 1489, pid: 1479, name: '莒南县', code: '371327', lng: '118.83227', lat: '35.17539' },
          { id: 1490, pid: 1479, name: '蒙阴县', code: '371328', lng: '117.94592', lat: '35.70996' },
          { id: 1491, pid: 1479, name: '临沭县', code: '371329', lng: '118.65267', lat: '34.92091' },
        ],
      },
      {
        id: 1492,
        pid: 1375,
        name: '德州市',
        code: '371400',
        lng: '116.307428',
        lat: '37.453968',
        children: [
          { id: 1493, pid: 1492, name: '德城区', code: '371402', lng: '116.29943', lat: '37.45126' },
          { id: 1494, pid: 1492, name: '陵城区', code: '371403', lng: '116.57601', lat: '37.33571' },
          { id: 1495, pid: 1492, name: '宁津县', code: '371422', lng: '116.79702', lat: '37.65301' },
          { id: 1496, pid: 1492, name: '庆云县', code: '371423', lng: '117.38635', lat: '37.77616' },
          { id: 1497, pid: 1492, name: '临邑县', code: '371424', lng: '116.86547', lat: '37.19053' },
          { id: 1498, pid: 1492, name: '齐河县', code: '371425', lng: '116.75515', lat: '36.79532' },
          { id: 1499, pid: 1492, name: '平原县', code: '371426', lng: '116.43432', lat: '37.16632' },
          { id: 1500, pid: 1492, name: '夏津县', code: '371427', lng: '116.0017', lat: '36.94852' },
          { id: 1501, pid: 1492, name: '武城县', code: '371428', lng: '116.07009', lat: '37.21403' },
          { id: 1502, pid: 1492, name: '乐陵市', code: '371481', lng: '117.23141', lat: '37.73164' },
          { id: 1503, pid: 1492, name: '禹城市', code: '371482', lng: '116.64309', lat: '36.93444' },
        ],
      },
      {
        id: 1504,
        pid: 1375,
        name: '聊城市',
        code: '371500',
        lng: '115.980367',
        lat: '36.456013',
        children: [
          { id: 1505, pid: 1504, name: '东昌府区', code: '371502', lng: '115.97383', lat: '36.44458' },
          { id: 1506, pid: 1504, name: '阳谷县', code: '371521', lng: '115.79126', lat: '36.11444' },
          { id: 1507, pid: 1504, name: '莘县', code: '371522', lng: '115.6697', lat: '36.23423' },
          { id: 1508, pid: 1504, name: '茌平县', code: '371523', lng: '116.25491', lat: '36.57969' },
          { id: 1509, pid: 1504, name: '东阿县', code: '371524', lng: '116.25012', lat: '36.33209' },
          { id: 1510, pid: 1504, name: '冠县', code: '371525', lng: '115.44195', lat: '36.48429' },
          { id: 1511, pid: 1504, name: '高唐县', code: '371526', lng: '116.23172', lat: '36.86535' },
          { id: 1512, pid: 1504, name: '临清市', code: '371581', lng: '115.70629', lat: '36.83945' },
        ],
      },
      {
        id: 1513,
        pid: 1375,
        name: '滨州市',
        code: '371600',
        lng: '118.016974',
        lat: '37.383542',
        children: [
          { id: 1514, pid: 1513, name: '滨城区', code: '371602', lng: '118.02026', lat: '37.38524' },
          { id: 1515, pid: 1513, name: '沾化区', code: '371603', lng: '118.13214', lat: '37.69832' },
          { id: 1516, pid: 1513, name: '惠民县', code: '371621', lng: '117.51113', lat: '37.49013' },
          { id: 1517, pid: 1513, name: '阳信县', code: '371622', lng: '117.58139', lat: '37.64198' },
          { id: 1518, pid: 1513, name: '无棣县', code: '371623', lng: '117.61395', lat: '37.74009' },
          { id: 1519, pid: 1513, name: '博兴县', code: '371625', lng: '118.1336', lat: '37.14316' },
          { id: 1520, pid: 1513, name: '邹平县', code: '371626', lng: '117.74307', lat: '36.86295' },
          { id: 1521, pid: 1513, name: '北海新区', code: '371627', lng: '118.016974', lat: '37.383542' },
        ],
      },
      {
        id: 1522,
        pid: 1375,
        name: '菏泽市',
        code: '371700',
        lng: '115.469381',
        lat: '35.246531',
        children: [
          { id: 1523, pid: 1522, name: '牡丹区', code: '371702', lng: '115.41662', lat: '35.25091' },
          { id: 1524, pid: 1522, name: '曹县', code: '371721', lng: '115.54226', lat: '34.82659' },
          { id: 1525, pid: 1522, name: '单县', code: '371722', lng: '116.08703', lat: '34.79514' },
          { id: 1526, pid: 1522, name: '成武县', code: '371723', lng: '115.8897', lat: '34.95332' },
          { id: 1527, pid: 1522, name: '巨野县', code: '371724', lng: '116.09497', lat: '35.39788' },
          { id: 1528, pid: 1522, name: '郓城县', code: '371725', lng: '115.94439', lat: '35.60044' },
          { id: 1529, pid: 1522, name: '鄄城县', code: '371726', lng: '115.50997', lat: '35.56412' },
          { id: 1530, pid: 1522, name: '定陶县', code: '371727', lng: '115.57287', lat: '35.07118' },
          { id: 1531, pid: 1522, name: '东明县', code: '371728', lng: '115.09079', lat: '35.28906' },
        ],
      },
    ],
  },
  {
    id: 1532,
    pid: 0,
    name: '河南省',
    code: '410000',
    lng: '113.665412',
    lat: '34.757975',
    children: [
      {
        id: 1533,
        pid: 1532,
        name: '郑州市',
        code: '410100',
        lng: '113.665412',
        lat: '34.757975',
        children: [
          { id: 1534, pid: 1533, name: '中原区', code: '410102', lng: '113.61333', lat: '34.74827' },
          { id: 1535, pid: 1533, name: '二七区', code: '410103', lng: '113.63931', lat: '34.72336' },
          { id: 1536, pid: 1533, name: '管城回族区', code: '410104', lng: '113.67734', lat: '34.75383' },
          { id: 1537, pid: 1533, name: '金水区', code: '410105', lng: '113.66057', lat: '34.80028' },
          { id: 1538, pid: 1533, name: '上街区', code: '410106', lng: '113.30897', lat: '34.80276' },
          { id: 1539, pid: 1533, name: '惠济区', code: '410108', lng: '113.61688', lat: '34.86735' },
          { id: 1540, pid: 1533, name: '中牟县', code: '410122', lng: '113.97619', lat: '34.71899' },
          { id: 1541, pid: 1533, name: '巩义市', code: '410181', lng: '113.022', lat: '34.74794' },
          { id: 1542, pid: 1533, name: '荥阳市', code: '410182', lng: '113.38345', lat: '34.78759' },
          { id: 1543, pid: 1533, name: '新密市', code: '410183', lng: '113.3869', lat: '34.53704' },
          { id: 1544, pid: 1533, name: '新郑市', code: '410184', lng: '113.73645', lat: '34.3955' },
          { id: 1545, pid: 1533, name: '登封市', code: '410185', lng: '113.05023', lat: '34.45345' },
          { id: 3749, pid: 1533, name: '航空港区', code: '410173', lng: '113.73645', lat: '34.3955' },
          { id: 3750, pid: 1533, name: '郑东新区', code: '410107', lng: '113.73645', lat: '34.3955' },
          { id: 3751, pid: 1533, name: '高新区', code: '410173', lng: '113.73645', lat: '34.3955' },
          { id: 3752, pid: 1533, name: '经开区', code: '410171', lng: '113.73645', lat: '34.3955' },
          { id: 3753, pid: 1533, name: '自贸区', code: '410172', lng: '113.73645', lat: '34.3955' },
        ],
      },
      {
        id: 1546,
        pid: 1532,
        name: '开封市',
        code: '410200',
        lng: '114.341447',
        lat: '34.797049',
        children: [
          { id: 1547, pid: 1546, name: '龙亭区', code: '410202', lng: '114.35484', lat: '34.79995' },
          { id: 1548, pid: 1546, name: '顺河回族区', code: '410203', lng: '114.36123', lat: '34.79586' },
          { id: 1549, pid: 1546, name: '鼓楼区', code: '410204', lng: '114.35559', lat: '34.79517' },
          { id: 1550, pid: 1546, name: '禹王台区', code: '410205', lng: '114.34787', lat: '34.77693' },
          { id: 1551, pid: 1546, name: '祥符区', code: '410212', lng: '114.43859', lat: '34.75874' },
          { id: 1552, pid: 1546, name: '杞县', code: '410221', lng: '114.7828', lat: '34.55033' },
          { id: 1553, pid: 1546, name: '通许县', code: '410222', lng: '114.46716', lat: '34.47522' },
          { id: 1554, pid: 1546, name: '尉氏县', code: '410223', lng: '114.19284', lat: '34.41223' },
          { id: 1555, pid: 1546, name: '兰考县', code: '410225', lng: '114.81961', lat: '34.8235' },
        ],
      },
      {
        id: 1556,
        pid: 1532,
        name: '洛阳市',
        code: '410300',
        lng: '112.434468',
        lat: '34.663041',
        children: [
          { id: 1557, pid: 1556, name: '老城区', code: '410302', lng: '112.46902', lat: '34.68364' },
          { id: 1558, pid: 1556, name: '西工区', code: '410303', lng: '112.4371', lat: '34.67' },
          { id: 1559, pid: 1556, name: '瀍河回族区', code: '410304', lng: '112.50018', lat: '34.67985' },
          { id: 1560, pid: 1556, name: '涧西区', code: '410305', lng: '112.39588', lat: '34.65823' },
          { id: 1561, pid: 1556, name: '吉利区', code: '410306', lng: '112.58905', lat: '34.90088' },
          { id: 1562, pid: 1556, name: '洛龙区', code: '410311', lng: '112.46412', lat: '34.61866' },
          { id: 1563, pid: 1556, name: '孟津县', code: '410322', lng: '112.44351', lat: '34.826' },
          { id: 1564, pid: 1556, name: '新安县', code: '410323', lng: '112.13238', lat: '34.72814' },
          { id: 1565, pid: 1556, name: '栾川县', code: '410324', lng: '111.61779', lat: '33.78576' },
          { id: 1566, pid: 1556, name: '嵩县', code: '410325', lng: '112.08526', lat: '34.13466' },
          { id: 1567, pid: 1556, name: '汝阳县', code: '410326', lng: '112.47314', lat: '34.15387' },
          { id: 1568, pid: 1556, name: '宜阳县', code: '410327', lng: '112.17907', lat: '34.51523' },
          { id: 1569, pid: 1556, name: '洛宁县', code: '410328', lng: '111.65087', lat: '34.38913' },
          { id: 1570, pid: 1556, name: '伊川县', code: '410329', lng: '112.42947', lat: '34.42205' },
          { id: 1571, pid: 1556, name: '偃师市', code: '410381', lng: '112.7922', lat: '34.7281' },
        ],
      },
      {
        id: 1572,
        pid: 1532,
        name: '平顶山市',
        code: '410400',
        lng: '113.307718',
        lat: '33.735241',
        children: [
          { id: 1573, pid: 1572, name: '新华区', code: '410402', lng: '113.29402', lat: '33.7373' },
          { id: 1574, pid: 1572, name: '卫东区', code: '410403', lng: '113.33511', lat: '33.73472' },
          { id: 1575, pid: 1572, name: '石龙区', code: '410404', lng: '112.89879', lat: '33.89878' },
          { id: 1576, pid: 1572, name: '湛河区', code: '410411', lng: '113.29252', lat: '33.7362' },
          { id: 1577, pid: 1572, name: '宝丰县', code: '410421', lng: '113.05493', lat: '33.86916' },
          { id: 1578, pid: 1572, name: '叶县', code: '410422', lng: '113.35104', lat: '33.62225' },
          { id: 1579, pid: 1572, name: '鲁山县', code: '410423', lng: '112.9057', lat: '33.73879' },
          { id: 1580, pid: 1572, name: '郏县', code: '410425', lng: '113.21588', lat: '33.97072' },
          { id: 1581, pid: 1572, name: '舞钢市', code: '410481', lng: '113.52417', lat: '33.2938' },
          { id: 1582, pid: 1572, name: '汝州市', code: '410482', lng: '112.84301', lat: '34.16135' },
        ],
      },
      {
        id: 1583,
        pid: 1532,
        name: '安阳市',
        code: '410500',
        lng: '114.352482',
        lat: '36.103442',
        children: [
          { id: 1584, pid: 1583, name: '文峰区', code: '410502', lng: '114.35708', lat: '36.09046' },
          { id: 1585, pid: 1583, name: '北关区', code: '410503', lng: '114.35735', lat: '36.11872' },
          { id: 1586, pid: 1583, name: '殷都区', code: '410505', lng: '114.3034', lat: '36.1099' },
          { id: 1587, pid: 1583, name: '龙安区', code: '410506', lng: '114.34814', lat: '36.11904' },
          { id: 1588, pid: 1583, name: '安阳县', code: '410522', lng: '114.36605', lat: '36.06695' },
          { id: 1589, pid: 1583, name: '汤阴县', code: '410523', lng: '114.35839', lat: '35.92152' },
          { id: 1590, pid: 1583, name: '滑县', code: '410526', lng: '114.52066', lat: '35.5807' },
          { id: 1591, pid: 1583, name: '内黄县', code: '410527', lng: '114.90673', lat: '35.95269' },
          { id: 1592, pid: 1583, name: '林州市', code: '410581', lng: '113.81558', lat: '36.07804' },
        ],
      },
      {
        id: 1593,
        pid: 1532,
        name: '鹤壁市',
        code: '410600',
        lng: '114.295444',
        lat: '35.748236',
        children: [
          { id: 1594, pid: 1593, name: '鹤山区', code: '410602', lng: '114.16336', lat: '35.95458' },
          { id: 1595, pid: 1593, name: '山城区', code: '410603', lng: '114.18443', lat: '35.89773' },
          { id: 1596, pid: 1593, name: '淇滨区', code: '410611', lng: '114.29867', lat: '35.74127' },
          { id: 1597, pid: 1593, name: '浚县', code: '410621', lng: '114.54879', lat: '35.67085' },
          { id: 1598, pid: 1593, name: '淇县', code: '410622', lng: '114.1976', lat: '35.60782' },
        ],
      },
      {
        id: 1599,
        pid: 1532,
        name: '新乡市',
        code: '410700',
        lng: '113.883991',
        lat: '35.302616',
        children: [
          { id: 1600, pid: 1599, name: '红旗区', code: '410702', lng: '113.87523', lat: '35.30367' },
          { id: 1601, pid: 1599, name: '卫滨区', code: '410703', lng: '113.86578', lat: '35.30211' },
          { id: 1602, pid: 1599, name: '凤泉区', code: '410704', lng: '113.91507', lat: '35.38399' },
          { id: 1603, pid: 1599, name: '牧野区', code: '410711', lng: '113.9086', lat: '35.3149' },
          { id: 1604, pid: 1599, name: '新乡县', code: '410721', lng: '113.80511', lat: '35.19075' },
          { id: 1605, pid: 1599, name: '获嘉县', code: '410724', lng: '113.66159', lat: '35.26521' },
          { id: 1606, pid: 1599, name: '原阳县', code: '410725', lng: '113.93994', lat: '35.06565' },
          { id: 1607, pid: 1599, name: '延津县', code: '410726', lng: '114.20266', lat: '35.14327' },
          { id: 1608, pid: 1599, name: '封丘县', code: '410727', lng: '114.41915', lat: '35.04166' },
          { id: 1609, pid: 1599, name: '长垣县', code: '410728', lng: '114.66882', lat: '35.20046' },
          { id: 1610, pid: 1599, name: '卫辉市', code: '410781', lng: '114.06454', lat: '35.39843' },
          { id: 1611, pid: 1599, name: '辉县市', code: '410782', lng: '113.8067', lat: '35.46307' },
        ],
      },
      {
        id: 1612,
        pid: 1532,
        name: '焦作市',
        code: '410800',
        lng: '113.238266',
        lat: '35.23904',
        children: [
          { id: 1613, pid: 1612, name: '解放区', code: '410802', lng: '113.22933', lat: '35.24023' },
          { id: 1614, pid: 1612, name: '中站区', code: '410803', lng: '113.18315', lat: '35.23665' },
          { id: 1615, pid: 1612, name: '马村区', code: '410804', lng: '113.3187', lat: '35.26908' },
          { id: 1616, pid: 1612, name: '山阳区', code: '410811', lng: '113.25464', lat: '35.21436' },
          { id: 1617, pid: 1612, name: '修武县', code: '410821', lng: '113.44775', lat: '35.22357' },
          { id: 1618, pid: 1612, name: '博爱县', code: '410822', lng: '113.06698', lat: '35.16943' },
          { id: 1619, pid: 1612, name: '武陟县', code: '410823', lng: '113.39718', lat: '35.09505' },
          { id: 1620, pid: 1612, name: '温县', code: '410825', lng: '113.08065', lat: '34.94022' },
          { id: 1621, pid: 1612, name: '沁阳市', code: '410882', lng: '112.94494', lat: '35.08935' },
          { id: 1622, pid: 1612, name: '孟州市', code: '410883', lng: '112.79138', lat: '34.9071' },
        ],
      },
      {
        id: 1623,
        pid: 1532,
        name: '濮阳市',
        code: '410900',
        lng: '115.041299',
        lat: '35.768234',
        children: [
          { id: 1624, pid: 1623, name: '华龙区', code: '410902', lng: '115.07446', lat: '35.77736' },
          { id: 1625, pid: 1623, name: '清丰县', code: '410922', lng: '115.10415', lat: '35.88507' },
          { id: 1626, pid: 1623, name: '南乐县', code: '410923', lng: '115.20639', lat: '36.07686' },
          { id: 1627, pid: 1623, name: '范县', code: '410926', lng: '115.50405', lat: '35.85178' },
          { id: 1628, pid: 1623, name: '台前县', code: '410927', lng: '115.87158', lat: '35.96923' },
          { id: 1629, pid: 1623, name: '濮阳县', code: '410928', lng: '115.03057', lat: '35.70745' },
        ],
      },
      {
        id: 1630,
        pid: 1532,
        name: '许昌市',
        code: '411000',
        lng: '113.826063',
        lat: '34.022956',
        children: [
          { id: 1631, pid: 1630, name: '魏都区', code: '411002', lng: '113.8227', lat: '34.02544' },
          { id: 1632, pid: 1630, name: '许昌县', code: '411023', lng: '113.84707', lat: '34.00406' },
          { id: 1633, pid: 1630, name: '鄢陵县', code: '411024', lng: '114.18795', lat: '34.10317' },
          { id: 1634, pid: 1630, name: '襄城县', code: '411025', lng: '113.48196', lat: '33.84928' },
          { id: 1635, pid: 1630, name: '禹州市', code: '411081', lng: '113.48803', lat: '34.14054' },
          { id: 1636, pid: 1630, name: '长葛市', code: '411082', lng: '113.77328', lat: '34.21846' },
        ],
      },
      {
        id: 1637,
        pid: 1532,
        name: '漯河市',
        code: '411100',
        lng: '114.026405',
        lat: '33.575855',
        children: [
          { id: 1638, pid: 1637, name: '源汇区', code: '411102', lng: '114.00647', lat: '33.55627' },
          { id: 1639, pid: 1637, name: '郾城区', code: '411103', lng: '114.00694', lat: '33.58723' },
          { id: 1640, pid: 1637, name: '召陵区', code: '411104', lng: '114.09399', lat: '33.58601' },
          { id: 1641, pid: 1637, name: '舞阳县', code: '411121', lng: '113.59848', lat: '33.43243' },
          { id: 1642, pid: 1637, name: '临颍县', code: '411122', lng: '113.93661', lat: '33.81123' },
        ],
      },
      {
        id: 1643,
        pid: 1532,
        name: '三门峡市',
        code: '411200',
        lng: '111.194099',
        lat: '34.777338',
        children: [
          { id: 1644, pid: 1643, name: '湖滨区', code: '411202', lng: '111.20006', lat: '34.77872' },
          { id: 1645, pid: 1643, name: '渑池县', code: '411221', lng: '111.76184', lat: '34.76725' },
          { id: 1646, pid: 1643, name: '陕县', code: '411222', lng: '111.10333', lat: '34.72052' },
          { id: 1647, pid: 1643, name: '卢氏县', code: '411224', lng: '111.04782', lat: '34.05436' },
          { id: 1648, pid: 1643, name: '义马市', code: '411281', lng: '111.87445', lat: '34.74721' },
          { id: 1649, pid: 1643, name: '灵宝市', code: '411282', lng: '110.8945', lat: '34.51682' },
        ],
      },
      {
        id: 1650,
        pid: 1532,
        name: '南阳市',
        code: '411300',
        lng: '112.540918',
        lat: '32.999082',
        children: [
          { id: 1651, pid: 1650, name: '宛城区', code: '411302', lng: '112.53955', lat: '33.00378' },
          { id: 1652, pid: 1650, name: '卧龙区', code: '411303', lng: '112.53479', lat: '32.98615' },
          { id: 1653, pid: 1650, name: '南召县', code: '411321', lng: '112.43194', lat: '33.49098' },
          { id: 1654, pid: 1650, name: '方城县', code: '411322', lng: '113.01269', lat: '33.25453' },
          { id: 1655, pid: 1650, name: '西峡县', code: '411323', lng: '111.48187', lat: '33.29772' },
          { id: 1656, pid: 1650, name: '镇平县', code: '411324', lng: '112.2398', lat: '33.03629' },
          { id: 1657, pid: 1650, name: '内乡县', code: '411325', lng: '111.84957', lat: '33.04671' },
          { id: 1658, pid: 1650, name: '淅川县', code: '411326', lng: '111.48663', lat: '33.13708' },
          { id: 1659, pid: 1650, name: '社旗县', code: '411327', lng: '112.94656', lat: '33.05503' },
          { id: 1660, pid: 1650, name: '唐河县', code: '411328', lng: '112.83609', lat: '32.69453' },
          { id: 1661, pid: 1650, name: '新野县', code: '411329', lng: '112.36151', lat: '32.51698' },
          { id: 1662, pid: 1650, name: '桐柏县', code: '411330', lng: '113.42886', lat: '32.37917' },
          { id: 1663, pid: 1650, name: '邓州市', code: '411381', lng: '112.0896', lat: '32.68577' },
        ],
      },
      {
        id: 1664,
        pid: 1532,
        name: '商丘市',
        code: '411400',
        lng: '115.650497',
        lat: '34.437054',
        children: [
          { id: 1665, pid: 1664, name: '梁园区', code: '411402', lng: '115.64487', lat: '34.44341' },
          { id: 1666, pid: 1664, name: '睢阳区', code: '411403', lng: '115.65338', lat: '34.38804' },
          { id: 1667, pid: 1664, name: '民权县', code: '411421', lng: '115.14621', lat: '34.64931' },
          { id: 1668, pid: 1664, name: '睢县', code: '411422', lng: '115.07168', lat: '34.44539' },
          { id: 1669, pid: 1664, name: '宁陵县', code: '411423', lng: '115.30511', lat: '34.45463' },
          { id: 1670, pid: 1664, name: '柘城县', code: '411424', lng: '115.30538', lat: '34.0911' },
          { id: 1671, pid: 1664, name: '虞城县', code: '411425', lng: '115.86337', lat: '34.40189' },
          { id: 1672, pid: 1664, name: '夏邑县', code: '411426', lng: '116.13348', lat: '34.23242' },
          { id: 1673, pid: 1664, name: '永城市', code: '411481', lng: '116.44943', lat: '33.92911' },
        ],
      },
      {
        id: 1674,
        pid: 1532,
        name: '信阳市',
        code: '411500',
        lng: '114.075031',
        lat: '32.123274',
        children: [
          { id: 1675, pid: 1674, name: '浉河区', code: '411502', lng: '114.05871', lat: '32.1168' },
          { id: 1676, pid: 1674, name: '平桥区', code: '411503', lng: '114.12435', lat: '32.10095' },
          { id: 1677, pid: 1674, name: '罗山县', code: '411521', lng: '114.5314', lat: '32.20277' },
          { id: 1678, pid: 1674, name: '光山县', code: '411522', lng: '114.91873', lat: '32.00992' },
          { id: 1679, pid: 1674, name: '新县', code: '411523', lng: '114.87924', lat: '31.64386' },
          { id: 1680, pid: 1674, name: '商城县', code: '411524', lng: '115.40856', lat: '31.79986' },
          { id: 1681, pid: 1674, name: '固始县', code: '411525', lng: '115.68298', lat: '32.18011' },
          { id: 1682, pid: 1674, name: '潢川县', code: '411526', lng: '115.04696', lat: '32.13763' },
          { id: 1683, pid: 1674, name: '淮滨县', code: '411527', lng: '115.4205', lat: '32.46614' },
          { id: 1684, pid: 1674, name: '息县', code: '411528', lng: '114.7402', lat: '32.34279' },
        ],
      },
      {
        id: 1685,
        pid: 1532,
        name: '周口市',
        code: '411600',
        lng: '114.649653',
        lat: '33.620357',
        children: [
          { id: 1686, pid: 1685, name: '川汇区', code: '411602', lng: '114.64202', lat: '33.6256' },
          { id: 1687, pid: 1685, name: '扶沟县', code: '411621', lng: '114.39477', lat: '34.05999' },
          { id: 1688, pid: 1685, name: '西华县', code: '411622', lng: '114.52279', lat: '33.78548' },
          { id: 1689, pid: 1685, name: '商水县', code: '411623', lng: '114.60604', lat: '33.53912' },
          { id: 1690, pid: 1685, name: '沈丘县', code: '411624', lng: '115.09851', lat: '33.40936' },
          { id: 1691, pid: 1685, name: '郸城县', code: '411625', lng: '115.17715', lat: '33.64485' },
          { id: 1692, pid: 1685, name: '淮阳县', code: '411626', lng: '114.88848', lat: '33.73211' },
          { id: 1693, pid: 1685, name: '太康县', code: '411627', lng: '114.83773', lat: '34.06376' },
          { id: 1694, pid: 1685, name: '鹿邑县', code: '411628', lng: '115.48553', lat: '33.85931' },
          { id: 1695, pid: 1685, name: '项城市', code: '411681', lng: '114.87558', lat: '33.4672' },
        ],
      },
      {
        id: 1696,
        pid: 1532,
        name: '驻马店市',
        code: '411700',
        lng: '114.024736',
        lat: '32.980169',
        children: [
          { id: 1697, pid: 1696, name: '驿城区', code: '411702', lng: '113.99377', lat: '32.97316' },
          { id: 1698, pid: 1696, name: '西平县', code: '411721', lng: '114.02322', lat: '33.3845' },
          { id: 1699, pid: 1696, name: '上蔡县', code: '411722', lng: '114.26825', lat: '33.26825' },
          { id: 1700, pid: 1696, name: '平舆县', code: '411723', lng: '114.63552', lat: '32.95727' },
          { id: 1701, pid: 1696, name: '正阳县', code: '411724', lng: '114.38952', lat: '32.6039' },
          { id: 1702, pid: 1696, name: '确山县', code: '411725', lng: '114.02917', lat: '32.80281' },
          { id: 1703, pid: 1696, name: '泌阳县', code: '411726', lng: '113.32681', lat: '32.71781' },
          { id: 1704, pid: 1696, name: '汝南县', code: '411727', lng: '114.36138', lat: '33.00461' },
          { id: 1705, pid: 1696, name: '遂平县', code: '411728', lng: '114.01297', lat: '33.14571' },
          { id: 1706, pid: 1696, name: '新蔡县', code: '411729', lng: '114.98199', lat: '32.7502' },
        ],
      },
      {
        id: 1707,
        pid: 1532,
        name: '直辖县级',
        code: '419000',
        lng: '113.665412',
        lat: '34.757975',
        children: [{ id: 1708, pid: 1707, name: '济源市', code: '419001', lng: '112.590047', lat: '35.090378' }],
      },
    ],
  },
  {
    id: 1709,
    pid: 0,
    name: '湖北省',
    code: '420000',
    lng: '114.298572',
    lat: '30.584355',
    children: [
      {
        id: 1710,
        pid: 1709,
        name: '武汉市',
        code: '420100',
        lng: '114.298572',
        lat: '30.584355',
        children: [
          { id: 1711, pid: 1710, name: '江岸区', code: '420102', lng: '114.30943', lat: '30.59982' },
          { id: 1712, pid: 1710, name: '江汉区', code: '420103', lng: '114.27093', lat: '30.60146' },
          { id: 1713, pid: 1710, name: '硚口区', code: '420104', lng: '114.26422', lat: '30.56945' },
          { id: 1714, pid: 1710, name: '汉阳区', code: '420105', lng: '114.27478', lat: '30.54915' },
          { id: 1715, pid: 1710, name: '武昌区', code: '420106', lng: '114.31589', lat: '30.55389' },
          { id: 1716, pid: 1710, name: '青山区', code: '420107', lng: '114.39117', lat: '30.63427' },
          { id: 1717, pid: 1710, name: '洪山区', code: '420111', lng: '114.34375', lat: '30.49989' },
          { id: 1718, pid: 1710, name: '东西湖区', code: '420112', lng: '114.13708', lat: '30.61989' },
          { id: 1719, pid: 1710, name: '汉南区', code: '420113', lng: '114.08462', lat: '30.30879' },
          { id: 1720, pid: 1710, name: '蔡甸区', code: '420114', lng: '114.02929', lat: '30.58197' },
          { id: 1721, pid: 1710, name: '江夏区', code: '420115', lng: '114.31301', lat: '30.34653' },
          { id: 1722, pid: 1710, name: '黄陂区', code: '420116', lng: '114.37512', lat: '30.88151' },
          { id: 1723, pid: 1710, name: '新洲区', code: '420117', lng: '114.80136', lat: '30.84145' },
        ],
      },
      {
        id: 1724,
        pid: 1709,
        name: '黄石市',
        code: '420200',
        lng: '115.077048',
        lat: '30.220074',
        children: [
          { id: 1725, pid: 1724, name: '黄石港区', code: '420202', lng: '115.06604', lat: '30.22279' },
          { id: 1726, pid: 1724, name: '西塞山区', code: '420203', lng: '115.11016', lat: '30.20487' },
          { id: 1727, pid: 1724, name: '下陆区', code: '420204', lng: '114.96112', lat: '30.17368' },
          { id: 1728, pid: 1724, name: '铁山区', code: '420205', lng: '114.90109', lat: '30.20678' },
          { id: 1729, pid: 1724, name: '阳新县', code: '420222', lng: '115.21527', lat: '29.83038' },
          { id: 1730, pid: 1724, name: '大冶市', code: '420281', lng: '114.97174', lat: '30.09438' },
        ],
      },
      {
        id: 1731,
        pid: 1709,
        name: '十堰市',
        code: '420300',
        lng: '110.785239',
        lat: '32.647017',
        children: [
          { id: 1732, pid: 1731, name: '茅箭区', code: '420302', lng: '110.81341', lat: '32.59153' },
          { id: 1733, pid: 1731, name: '张湾区', code: '420303', lng: '110.77067', lat: '32.65195' },
          { id: 1734, pid: 1731, name: '郧阳区', code: '420304', lng: '110.81854', lat: '32.83593' },
          { id: 1735, pid: 1731, name: '郧西县', code: '420322', lng: '110.42556', lat: '32.99349' },
          { id: 1736, pid: 1731, name: '竹山县', code: '420323', lng: '110.23071', lat: '32.22536' },
          { id: 1737, pid: 1731, name: '竹溪县', code: '420324', lng: '109.71798', lat: '32.31901' },
          { id: 1738, pid: 1731, name: '房县', code: '420325', lng: '110.74386', lat: '32.05794' },
          { id: 1739, pid: 1731, name: '丹江口市', code: '420381', lng: '111.51525', lat: '32.54085' },
        ],
      },
      {
        id: 1740,
        pid: 1709,
        name: '宜昌市',
        code: '420500',
        lng: '111.290843',
        lat: '30.702636',
        children: [
          { id: 1741, pid: 1740, name: '西陵区', code: '420502', lng: '111.28573', lat: '30.71077' },
          { id: 1742, pid: 1740, name: '伍家岗区', code: '420503', lng: '111.3609', lat: '30.64434' },
          { id: 1743, pid: 1740, name: '点军区', code: '420504', lng: '111.26828', lat: '30.6934' },
          { id: 1744, pid: 1740, name: '猇亭区', code: '420505', lng: '111.44079', lat: '30.52663' },
          { id: 1745, pid: 1740, name: '夷陵区', code: '420506', lng: '111.3262', lat: '30.76881' },
          { id: 1746, pid: 1740, name: '远安县', code: '420525', lng: '111.6416', lat: '31.05989' },
          { id: 1747, pid: 1740, name: '兴山县', code: '420526', lng: '110.74951', lat: '31.34686' },
          { id: 1748, pid: 1740, name: '秭归县', code: '420527', lng: '110.98156', lat: '30.82702' },
          { id: 1749, pid: 1740, name: '长阳土家族自治县', code: '420528', lng: '111.20105', lat: '30.47052' },
          { id: 1750, pid: 1740, name: '五峰土家族自治县', code: '420529', lng: '110.6748', lat: '30.19856' },
          { id: 1751, pid: 1740, name: '宜都市', code: '420581', lng: '111.45025', lat: '30.37807' },
          { id: 1752, pid: 1740, name: '当阳市', code: '420582', lng: '111.78912', lat: '30.8208' },
          { id: 1753, pid: 1740, name: '枝江市', code: '420583', lng: '111.76855', lat: '30.42612' },
        ],
      },
      {
        id: 1754,
        pid: 1709,
        name: '襄阳市',
        code: '420600',
        lng: '112.144146',
        lat: '32.042426',
        children: [
          { id: 1755, pid: 1754, name: '襄城区', code: '420602', lng: '112.13372', lat: '32.01017' },
          { id: 1756, pid: 1754, name: '樊城区', code: '420606', lng: '112.13546', lat: '32.04482' },
          { id: 1757, pid: 1754, name: '襄州区', code: '420607', lng: '112.150327', lat: '32.015088' },
          { id: 1758, pid: 1754, name: '南漳县', code: '420624', lng: '111.84603', lat: '31.77653' },
          { id: 1759, pid: 1754, name: '谷城县', code: '420625', lng: '111.65267', lat: '32.26377' },
          { id: 1760, pid: 1754, name: '保康县', code: '420626', lng: '111.26138', lat: '31.87874' },
          { id: 1761, pid: 1754, name: '老河口市', code: '420682', lng: '111.67117', lat: '32.38476' },
          { id: 1762, pid: 1754, name: '枣阳市', code: '420683', lng: '112.77444', lat: '32.13142' },
          { id: 1763, pid: 1754, name: '宜城市', code: '420684', lng: '112.25772', lat: '31.71972' },
        ],
      },
      {
        id: 1764,
        pid: 1709,
        name: '鄂州市',
        code: '420700',
        lng: '114.890593',
        lat: '30.396536',
        children: [
          { id: 1765, pid: 1764, name: '梁子湖区', code: '420702', lng: '114.68463', lat: '30.10003' },
          { id: 1766, pid: 1764, name: '华容区', code: '420703', lng: '114.73568', lat: '30.53328' },
          { id: 1767, pid: 1764, name: '鄂城区', code: '420704', lng: '114.89158', lat: '30.40024' },
        ],
      },
      {
        id: 1768,
        pid: 1709,
        name: '荆门市',
        code: '420800',
        lng: '112.204251',
        lat: '31.03542',
        children: [
          { id: 1769, pid: 1768, name: '东宝区', code: '420802', lng: '112.20147', lat: '31.05192' },
          { id: 1770, pid: 1768, name: '掇刀区', code: '420804', lng: '112.208', lat: '30.97316' },
          { id: 1771, pid: 1768, name: '京山县', code: '420821', lng: '113.11074', lat: '31.0224' },
          { id: 1772, pid: 1768, name: '沙洋县', code: '420822', lng: '112.58853', lat: '30.70916' },
          { id: 1773, pid: 1768, name: '钟祥市', code: '420881', lng: '112.58932', lat: '31.1678' },
        ],
      },
      {
        id: 1774,
        pid: 1709,
        name: '孝感市',
        code: '420900',
        lng: '113.926655',
        lat: '30.926423',
        children: [
          { id: 1775, pid: 1774, name: '孝南区', code: '420902', lng: '113.91111', lat: '30.9168' },
          { id: 1776, pid: 1774, name: '孝昌县', code: '420921', lng: '113.99795', lat: '31.25799' },
          { id: 1777, pid: 1774, name: '大悟县', code: '420922', lng: '114.12564', lat: '31.56176' },
          { id: 1778, pid: 1774, name: '云梦县', code: '420923', lng: '113.75289', lat: '31.02093' },
          { id: 1779, pid: 1774, name: '应城市', code: '420981', lng: '113.57287', lat: '30.92834' },
          { id: 1780, pid: 1774, name: '安陆市', code: '420982', lng: '113.68557', lat: '31.25693' },
          { id: 1781, pid: 1774, name: '汉川市', code: '420984', lng: '113.83898', lat: '30.66117' },
        ],
      },
      {
        id: 1782,
        pid: 1709,
        name: '荆州市',
        code: '421000',
        lng: '112.23813',
        lat: '30.326857',
        children: [
          { id: 1783, pid: 1782, name: '沙市区', code: '421002', lng: '112.25543', lat: '30.31107' },
          { id: 1784, pid: 1782, name: '荆州区', code: '421003', lng: '112.19006', lat: '30.35264' },
          { id: 1785, pid: 1782, name: '公安县', code: '421022', lng: '112.23242', lat: '30.05902' },
          { id: 1786, pid: 1782, name: '监利县', code: '421023', lng: '112.89462', lat: '29.81494' },
          { id: 1787, pid: 1782, name: '江陵县', code: '421024', lng: '112.42468', lat: '30.04174' },
          { id: 1788, pid: 1782, name: '石首市', code: '421081', lng: '112.42636', lat: '29.72127' },
          { id: 1789, pid: 1782, name: '洪湖市', code: '421083', lng: '113.47598', lat: '29.827' },
          { id: 1790, pid: 1782, name: '松滋市', code: '421087', lng: '111.76739', lat: '30.16965' },
        ],
      },
      {
        id: 1791,
        pid: 1709,
        name: '黄冈市',
        code: '421100',
        lng: '114.879365',
        lat: '30.447711',
        children: [
          { id: 1792, pid: 1791, name: '黄州区', code: '421102', lng: '114.88008', lat: '30.43436' },
          { id: 1793, pid: 1791, name: '团风县', code: '421121', lng: '114.87228', lat: '30.64359' },
          { id: 1794, pid: 1791, name: '红安县', code: '421122', lng: '114.6224', lat: '31.28668' },
          { id: 1795, pid: 1791, name: '罗田县', code: '421123', lng: '115.39971', lat: '30.78255' },
          { id: 1796, pid: 1791, name: '英山县', code: '421124', lng: '115.68142', lat: '30.73516' },
          { id: 1797, pid: 1791, name: '浠水县', code: '421125', lng: '115.26913', lat: '30.45265' },
          { id: 1798, pid: 1791, name: '蕲春县', code: '421126', lng: '115.43615', lat: '30.22613' },
          { id: 1799, pid: 1791, name: '黄梅县', code: '421127', lng: '115.94427', lat: '30.07033' },
          { id: 1800, pid: 1791, name: '麻城市', code: '421181', lng: '115.00988', lat: '31.17228' },
          { id: 1801, pid: 1791, name: '武穴市', code: '421182', lng: '115.55975', lat: '29.84446' },
        ],
      },
      {
        id: 1802,
        pid: 1709,
        name: '咸宁市',
        code: '421200',
        lng: '114.328963',
        lat: '29.832798',
        children: [
          { id: 1803, pid: 1802, name: '咸安区', code: '421202', lng: '114.29872', lat: '29.8529' },
          { id: 1804, pid: 1802, name: '嘉鱼县', code: '421221', lng: '113.93927', lat: '29.97054' },
          { id: 1805, pid: 1802, name: '通城县', code: '421222', lng: '113.81582', lat: '29.24568' },
          { id: 1806, pid: 1802, name: '崇阳县', code: '421223', lng: '114.03982', lat: '29.55564' },
          { id: 1807, pid: 1802, name: '通山县', code: '421224', lng: '114.48239', lat: '29.6063' },
          { id: 1808, pid: 1802, name: '赤壁市', code: '421281', lng: '113.90039', lat: '29.72454' },
        ],
      },
      {
        id: 1809,
        pid: 1709,
        name: '随州市',
        code: '421300',
        lng: '113.37377',
        lat: '31.717497',
        children: [
          { id: 1810, pid: 1809, name: '曾都区', code: '421303', lng: '113.37128', lat: '31.71614' },
          { id: 1811, pid: 1809, name: '随县', code: '421321', lng: '113.82663', lat: '31.6179' },
          { id: 1812, pid: 1809, name: '广水市', code: '421381', lng: '113.82663', lat: '31.6179' },
        ],
      },
      {
        id: 1813,
        pid: 1709,
        name: '恩施土家族苗族自治州',
        code: '422800',
        lng: '109.48699',
        lat: '30.283114',
        children: [
          { id: 1814, pid: 1813, name: '恩施市', code: '422801', lng: '109.47942', lat: '30.29502' },
          { id: 1815, pid: 1813, name: '利川市', code: '422802', lng: '108.93591', lat: '30.29117' },
          { id: 1816, pid: 1813, name: '建始县', code: '422822', lng: '109.72207', lat: '30.60209' },
          { id: 1817, pid: 1813, name: '巴东县', code: '422823', lng: '110.34066', lat: '31.04233' },
          { id: 1818, pid: 1813, name: '宣恩县', code: '422825', lng: '109.49179', lat: '29.98714' },
          { id: 1819, pid: 1813, name: '咸丰县', code: '422826', lng: '109.152', lat: '29.67983' },
          { id: 1820, pid: 1813, name: '来凤县', code: '422827', lng: '109.40716', lat: '29.49373' },
          { id: 1821, pid: 1813, name: '鹤峰县', code: '422828', lng: '110.03091', lat: '29.89072' },
        ],
      },
      {
        id: 1822,
        pid: 1709,
        name: '直辖县级',
        code: '429000',
        lng: '114.298572',
        lat: '30.584355',
        children: [
          { id: 1823, pid: 1822, name: '仙桃市', code: '429004', lng: '113.453974', lat: '30.364953' },
          { id: 1824, pid: 1822, name: '潜江市', code: '429005', lng: '112.896866', lat: '30.421215' },
          { id: 1825, pid: 1822, name: '天门市', code: '429006', lng: '113.165862', lat: '30.653061' },
          { id: 1826, pid: 1822, name: '神农架林区', code: '429021', lng: '110.671525', lat: '31.744449' },
        ],
      },
    ],
  },
  {
    id: 1827,
    pid: 0,
    name: '湖南省',
    code: '430000',
    lng: '112.982279',
    lat: '28.19409',
    children: [
      {
        id: 1828,
        pid: 1827,
        name: '长沙市',
        code: '430100',
        lng: '112.982279',
        lat: '28.19409',
        children: [
          { id: 1829, pid: 1828, name: '芙蓉区', code: '430102', lng: '113.03176', lat: '28.1844' },
          { id: 1830, pid: 1828, name: '天心区', code: '430103', lng: '112.98991', lat: '28.1127' },
          { id: 1831, pid: 1828, name: '岳麓区', code: '430104', lng: '112.93133', lat: '28.2351' },
          { id: 1832, pid: 1828, name: '开福区', code: '430105', lng: '112.98623', lat: '28.25585' },
          { id: 1833, pid: 1828, name: '雨花区', code: '430111', lng: '113.03567', lat: '28.13541' },
          { id: 1834, pid: 1828, name: '望城区', code: '430112', lng: '112.819549', lat: '28.347458' },
          { id: 1835, pid: 1828, name: '长沙县', code: '430121', lng: '113.08071', lat: '28.24595' },
          { id: 1836, pid: 1828, name: '宁乡县', code: '430124', lng: '112.55749', lat: '28.25358' },
          { id: 1837, pid: 1828, name: '浏阳市', code: '430181', lng: '113.64312', lat: '28.16375' },
        ],
      },
      {
        id: 1838,
        pid: 1827,
        name: '株洲市',
        code: '430200',
        lng: '113.151737',
        lat: '27.835806',
        children: [
          { id: 1839, pid: 1838, name: '荷塘区', code: '430202', lng: '113.17315', lat: '27.85569' },
          { id: 1840, pid: 1838, name: '芦淞区', code: '430203', lng: '113.15562', lat: '27.78525' },
          { id: 1841, pid: 1838, name: '石峰区', code: '430204', lng: '113.11776', lat: '27.87552' },
          { id: 1842, pid: 1838, name: '天元区', code: '430211', lng: '113.12335', lat: '27.83103' },
          { id: 1843, pid: 1838, name: '株洲县', code: '430221', lng: '113.14428', lat: '27.69826' },
          { id: 1844, pid: 1838, name: '攸县', code: '430223', lng: '113.34365', lat: '27.00352' },
          { id: 1845, pid: 1838, name: '茶陵县', code: '430224', lng: '113.54364', lat: '26.7915' },
          { id: 1846, pid: 1838, name: '炎陵县', code: '430225', lng: '113.77163', lat: '26.48818' },
          { id: 1847, pid: 1838, name: '醴陵市', code: '430281', lng: '113.49704', lat: '27.64615' },
        ],
      },
      {
        id: 1848,
        pid: 1827,
        name: '湘潭市',
        code: '430300',
        lng: '112.925083',
        lat: '27.846725',
        children: [
          { id: 1849, pid: 1848, name: '雨湖区', code: '430302', lng: '112.90399', lat: '27.86859' },
          { id: 1850, pid: 1848, name: '岳塘区', code: '430304', lng: '112.9606', lat: '27.85784' },
          { id: 1851, pid: 1848, name: '湘潭县', code: '430321', lng: '112.9508', lat: '27.77893' },
          { id: 1852, pid: 1848, name: '湘乡市', code: '430381', lng: '112.53512', lat: '27.73543' },
          { id: 1853, pid: 1848, name: '韶山市', code: '430382', lng: '112.52655', lat: '27.91503' },
        ],
      },
      {
        id: 1854,
        pid: 1827,
        name: '衡阳市',
        code: '430400',
        lng: '112.607693',
        lat: '26.900358',
        children: [
          { id: 1855, pid: 1854, name: '珠晖区', code: '430405', lng: '112.62054', lat: '26.89361' },
          { id: 1856, pid: 1854, name: '雁峰区', code: '430406', lng: '112.61654', lat: '26.88866' },
          { id: 1857, pid: 1854, name: '石鼓区', code: '430407', lng: '112.61069', lat: '26.90232' },
          { id: 1858, pid: 1854, name: '蒸湘区', code: '430408', lng: '112.6033', lat: '26.89651' },
          { id: 1859, pid: 1854, name: '南岳区', code: '430412', lng: '112.7384', lat: '27.23262' },
          { id: 1860, pid: 1854, name: '衡阳县', code: '430421', lng: '112.37088', lat: '26.9706' },
          { id: 1861, pid: 1854, name: '衡南县', code: '430422', lng: '112.67788', lat: '26.73828' },
          { id: 1862, pid: 1854, name: '衡山县', code: '430423', lng: '112.86776', lat: '27.23134' },
          { id: 1863, pid: 1854, name: '衡东县', code: '430424', lng: '112.94833', lat: '27.08093' },
          { id: 1864, pid: 1854, name: '祁东县', code: '430426', lng: '112.09039', lat: '26.79964' },
          { id: 1865, pid: 1854, name: '耒阳市', code: '430481', lng: '112.85998', lat: '26.42132' },
          { id: 1866, pid: 1854, name: '常宁市', code: '430482', lng: '112.4009', lat: '26.40692' },
        ],
      },
      {
        id: 1867,
        pid: 1827,
        name: '邵阳市',
        code: '430500',
        lng: '111.46923',
        lat: '27.237842',
        children: [
          { id: 1868, pid: 1867, name: '双清区', code: '430502', lng: '111.49715', lat: '27.23291' },
          { id: 1869, pid: 1867, name: '大祥区', code: '430503', lng: '111.45412', lat: '27.23332' },
          { id: 1870, pid: 1867, name: '北塔区', code: '430511', lng: '111.45219', lat: '27.24648' },
          { id: 1871, pid: 1867, name: '邵东县', code: '430521', lng: '111.74441', lat: '27.2584' },
          { id: 1872, pid: 1867, name: '新邵县', code: '430522', lng: '111.46066', lat: '27.32169' },
          { id: 1873, pid: 1867, name: '邵阳县', code: '430523', lng: '111.27459', lat: '26.99143' },
          { id: 1874, pid: 1867, name: '隆回县', code: '430524', lng: '111.03216', lat: '27.10937' },
          { id: 1875, pid: 1867, name: '洞口县', code: '430525', lng: '110.57388', lat: '27.05462' },
          { id: 1876, pid: 1867, name: '绥宁县', code: '430527', lng: '110.15576', lat: '26.58636' },
          { id: 1877, pid: 1867, name: '新宁县', code: '430528', lng: '110.85131', lat: '26.42936' },
          { id: 1878, pid: 1867, name: '城步苗族自治县', code: '430529', lng: '110.3222', lat: '26.39048' },
          { id: 1879, pid: 1867, name: '武冈市', code: '430581', lng: '110.63281', lat: '26.72817' },
        ],
      },
      {
        id: 1880,
        pid: 1827,
        name: '岳阳市',
        code: '430600',
        lng: '113.132855',
        lat: '29.37029',
        children: [
          { id: 1881, pid: 1880, name: '岳阳楼区', code: '430602', lng: '113.12942', lat: '29.3719' },
          { id: 1882, pid: 1880, name: '云溪区', code: '430603', lng: '113.27713', lat: '29.47357' },
          { id: 1883, pid: 1880, name: '君山区', code: '430611', lng: '113.00439', lat: '29.45941' },
          { id: 1884, pid: 1880, name: '岳阳县', code: '430621', lng: '113.11987', lat: '29.14314' },
          { id: 1885, pid: 1880, name: '华容县', code: '430623', lng: '112.54089', lat: '29.53019' },
          { id: 1886, pid: 1880, name: '湘阴县', code: '430624', lng: '112.90911', lat: '28.68922' },
          { id: 1887, pid: 1880, name: '平江县', code: '430626', lng: '113.58105', lat: '28.70664' },
          { id: 1888, pid: 1880, name: '汨罗市', code: '430681', lng: '113.06707', lat: '28.80631' },
          { id: 1889, pid: 1880, name: '临湘市', code: '430682', lng: '113.4501', lat: '29.47701' },
        ],
      },
      {
        id: 1890,
        pid: 1827,
        name: '常德市',
        code: '430700',
        lng: '111.691347',
        lat: '29.040225',
        children: [
          { id: 1891, pid: 1890, name: '武陵区', code: '430702', lng: '111.69791', lat: '29.02876' },
          { id: 1892, pid: 1890, name: '鼎城区', code: '430703', lng: '111.68078', lat: '29.01859' },
          { id: 1893, pid: 1890, name: '安乡县', code: '430721', lng: '112.16732', lat: '29.41326' },
          { id: 1894, pid: 1890, name: '汉寿县', code: '430722', lng: '111.96691', lat: '28.90299' },
          { id: 1895, pid: 1890, name: '澧县', code: '430723', lng: '111.75866', lat: '29.63317' },
          { id: 1896, pid: 1890, name: '临澧县', code: '430724', lng: '111.65161', lat: '29.44163' },
          { id: 1897, pid: 1890, name: '桃源县', code: '430725', lng: '111.48892', lat: '28.90474' },
          { id: 1898, pid: 1890, name: '石门县', code: '430726', lng: '111.37966', lat: '29.58424' },
          { id: 1899, pid: 1890, name: '津市市', code: '430781', lng: '111.87756', lat: '29.60563' },
        ],
      },
      {
        id: 1900,
        pid: 1827,
        name: '张家界市',
        code: '430800',
        lng: '110.479921',
        lat: '29.127401',
        children: [
          { id: 1901, pid: 1900, name: '永定区', code: '430802', lng: '110.47464', lat: '29.13387' },
          { id: 1902, pid: 1900, name: '武陵源区', code: '430811', lng: '110.55026', lat: '29.34574' },
          { id: 1903, pid: 1900, name: '慈利县', code: '430821', lng: '111.13946', lat: '29.42989' },
          { id: 1904, pid: 1900, name: '桑植县', code: '430822', lng: '110.16308', lat: '29.39815' },
        ],
      },
      {
        id: 1905,
        pid: 1827,
        name: '益阳市',
        code: '430900',
        lng: '112.355042',
        lat: '28.570066',
        children: [
          { id: 1906, pid: 1905, name: '资阳区', code: '430902', lng: '112.32447', lat: '28.59095' },
          { id: 1907, pid: 1905, name: '赫山区', code: '430903', lng: '112.37265', lat: '28.57425' },
          { id: 1908, pid: 1905, name: '南县', code: '430921', lng: '112.3963', lat: '29.36159' },
          { id: 1909, pid: 1905, name: '桃江县', code: '430922', lng: '112.1557', lat: '28.51814' },
          { id: 1910, pid: 1905, name: '安化县', code: '430923', lng: '111.21298', lat: '28.37424' },
          { id: 1911, pid: 1905, name: '沅江市', code: '430981', lng: '112.35427', lat: '28.84403' },
        ],
      },
      {
        id: 1912,
        pid: 1827,
        name: '郴州市',
        code: '431000',
        lng: '113.032067',
        lat: '25.793589',
        children: [
          { id: 1913, pid: 1912, name: '北湖区', code: '431002', lng: '113.01103', lat: '25.78405' },
          { id: 1914, pid: 1912, name: '苏仙区', code: '431003', lng: '113.04226', lat: '25.80045' },
          { id: 1915, pid: 1912, name: '桂阳县', code: '431021', lng: '112.73364', lat: '25.75406' },
          { id: 1916, pid: 1912, name: '宜章县', code: '431022', lng: '112.95147', lat: '25.39931' },
          { id: 1917, pid: 1912, name: '永兴县', code: '431023', lng: '113.11242', lat: '26.12646' },
          { id: 1918, pid: 1912, name: '嘉禾县', code: '431024', lng: '112.36935', lat: '25.58795' },
          { id: 1919, pid: 1912, name: '临武县', code: '431025', lng: '112.56369', lat: '25.27602' },
          { id: 1920, pid: 1912, name: '汝城县', code: '431026', lng: '113.68582', lat: '25.55204' },
          { id: 1921, pid: 1912, name: '桂东县', code: '431027', lng: '113.9468', lat: '26.07987' },
          { id: 1922, pid: 1912, name: '安仁县', code: '431028', lng: '113.26944', lat: '26.70931' },
          { id: 1923, pid: 1912, name: '资兴市', code: '431081', lng: '113.23724', lat: '25.97668' },
        ],
      },
      {
        id: 1924,
        pid: 1827,
        name: '永州市',
        code: '431100',
        lng: '111.608019',
        lat: '26.434516',
        children: [
          { id: 1925, pid: 1924, name: '零陵区', code: '431102', lng: '111.62103', lat: '26.22109' },
          { id: 1926, pid: 1924, name: '冷水滩区', code: '431103', lng: '111.59214', lat: '26.46107' },
          { id: 1927, pid: 1924, name: '祁阳县', code: '431121', lng: '111.84011', lat: '26.58009' },
          { id: 1928, pid: 1924, name: '东安县', code: '431122', lng: '111.3164', lat: '26.39202' },
          { id: 1929, pid: 1924, name: '双牌县', code: '431123', lng: '111.65927', lat: '25.95988' },
          { id: 1930, pid: 1924, name: '道县', code: '431124', lng: '111.60195', lat: '25.52766' },
          { id: 1931, pid: 1924, name: '江永县', code: '431125', lng: '111.34082', lat: '25.27233' },
          { id: 1932, pid: 1924, name: '宁远县', code: '431126', lng: '111.94625', lat: '25.56913' },
          { id: 1933, pid: 1924, name: '蓝山县', code: '431127', lng: '112.19363', lat: '25.36794' },
          { id: 1934, pid: 1924, name: '新田县', code: '431128', lng: '112.22103', lat: '25.9095' },
          { id: 1935, pid: 1924, name: '江华瑶族自治县', code: '431129', lng: '111.58847', lat: '25.1845' },
        ],
      },
      {
        id: 1936,
        pid: 1827,
        name: '怀化市',
        code: '431200',
        lng: '109.97824',
        lat: '27.550082',
        children: [
          { id: 1937, pid: 1936, name: '鹤城区', code: '431202', lng: '109.96509', lat: '27.54942' },
          { id: 1938, pid: 1936, name: '中方县', code: '431221', lng: '109.94497', lat: '27.43988' },
          { id: 1939, pid: 1936, name: '沅陵县', code: '431222', lng: '110.39633', lat: '28.45548' },
          { id: 1940, pid: 1936, name: '辰溪县', code: '431223', lng: '110.18942', lat: '28.00406' },
          { id: 1941, pid: 1936, name: '溆浦县', code: '431224', lng: '110.59384', lat: '27.90836' },
          { id: 1942, pid: 1936, name: '会同县', code: '431225', lng: '109.73568', lat: '26.88716' },
          { id: 1943, pid: 1936, name: '麻阳苗族自治县', code: '431226', lng: '109.80194', lat: '27.866' },
          { id: 1944, pid: 1936, name: '新晃侗族自治县', code: '431227', lng: '109.17166', lat: '27.35937' },
          { id: 1945, pid: 1936, name: '芷江侗族自治县', code: '431228', lng: '109.6849', lat: '27.44297' },
          { id: 1946, pid: 1936, name: '靖州苗族侗族自治县', code: '431229', lng: '109.69821', lat: '26.57651' },
          { id: 1947, pid: 1936, name: '通道侗族自治县', code: '431230', lng: '109.78515', lat: '26.1571' },
          { id: 1948, pid: 1936, name: '洪江市', code: '431281', lng: '109.83651', lat: '27.20922' },
        ],
      },
      {
        id: 1949,
        pid: 1827,
        name: '娄底市',
        code: '431300',
        lng: '112.008497',
        lat: '27.728136',
        children: [
          { id: 1950, pid: 1949, name: '娄星区', code: '431302', lng: '112.00193', lat: '27.72992' },
          { id: 1951, pid: 1949, name: '双峰县', code: '431321', lng: '112.19921', lat: '27.45418' },
          { id: 1952, pid: 1949, name: '新化县', code: '431322', lng: '111.32739', lat: '27.7266' },
          { id: 1953, pid: 1949, name: '冷水江市', code: '431381', lng: '111.43554', lat: '27.68147' },
          { id: 1954, pid: 1949, name: '涟源市', code: '431382', lng: '111.67233', lat: '27.68831' },
        ],
      },
      {
        id: 1955,
        pid: 1827,
        name: '湘西土家族苗族自治州',
        code: '433100',
        lng: '109.739735',
        lat: '28.314296',
        children: [
          { id: 1956, pid: 1955, name: '吉首市', code: '433101', lng: '109.69799', lat: '28.26247' },
          { id: 1957, pid: 1955, name: '泸溪县', code: '433122', lng: '110.21682', lat: '28.2205' },
          { id: 1958, pid: 1955, name: '凤凰县', code: '433123', lng: '109.60156', lat: '27.94822' },
          { id: 1959, pid: 1955, name: '花垣县', code: '433124', lng: '109.48217', lat: '28.5721' },
          { id: 1960, pid: 1955, name: '保靖县', code: '433125', lng: '109.66049', lat: '28.69997' },
          { id: 1961, pid: 1955, name: '古丈县', code: '433126', lng: '109.94812', lat: '28.61944' },
          { id: 1962, pid: 1955, name: '永顺县', code: '433127', lng: '109.85266', lat: '29.00103' },
          { id: 1963, pid: 1955, name: '龙山县', code: '433130', lng: '109.4432', lat: '29.45693' },
        ],
      },
    ],
  },
  {
    id: 1964,
    pid: 0,
    name: '广东省',
    code: '440000',
    lng: '113.280637',
    lat: '23.125178',
    children: [
      {
        id: 1965,
        pid: 1964,
        name: '广州市',
        code: '440100',
        lng: '113.280637',
        lat: '23.125178',
        children: [
          { id: 1966, pid: 1965, name: '荔湾区', code: '440103', lng: '113.2442', lat: '23.12592' },
          { id: 1967, pid: 1965, name: '越秀区', code: '440104', lng: '113.26683', lat: '23.12897' },
          { id: 1968, pid: 1965, name: '海珠区', code: '440105', lng: '113.26197', lat: '23.10379' },
          { id: 1969, pid: 1965, name: '天河区', code: '440106', lng: '113.36112', lat: '23.12467' },
          { id: 1970, pid: 1965, name: '白云区', code: '440111', lng: '113.27307', lat: '23.15787' },
          { id: 1971, pid: 1965, name: '黄埔区', code: '440112', lng: '113.45895', lat: '23.10642' },
          { id: 1972, pid: 1965, name: '番禺区', code: '440113', lng: '113.38397', lat: '22.93599' },
          { id: 1973, pid: 1965, name: '花都区', code: '440114', lng: '113.22033', lat: '23.40358' },
          { id: 1974, pid: 1965, name: '南沙区', code: '440115', lng: '113.60845', lat: '22.77144' },
          { id: 1975, pid: 1965, name: '从化区', code: '440117', lng: '113.587386', lat: '23.545283' },
          { id: 1976, pid: 1965, name: '增城区', code: '440118', lng: '113.829579', lat: '23.290497' },
        ],
      },
      {
        id: 1977,
        pid: 1964,
        name: '韶关市',
        code: '440200',
        lng: '113.591544',
        lat: '24.801322',
        children: [
          { id: 1978, pid: 1977, name: '武江区', code: '440203', lng: '113.58767', lat: '24.79264' },
          { id: 1979, pid: 1977, name: '浈江区', code: '440204', lng: '113.61109', lat: '24.80438' },
          { id: 1980, pid: 1977, name: '曲江区', code: '440205', lng: '113.60165', lat: '24.67915' },
          { id: 1981, pid: 1977, name: '始兴县', code: '440222', lng: '114.06799', lat: '24.94759' },
          { id: 1982, pid: 1977, name: '仁化县', code: '440224', lng: '113.74737', lat: '25.08742' },
          { id: 1983, pid: 1977, name: '翁源县', code: '440229', lng: '114.13385', lat: '24.3495' },
          { id: 1984, pid: 1977, name: '乳源瑶族自治县', code: '440232', lng: '113.27734', lat: '24.77803' },
          { id: 1985, pid: 1977, name: '新丰县', code: '440233', lng: '114.20788', lat: '24.05924' },
          { id: 1986, pid: 1977, name: '乐昌市', code: '440281', lng: '113.35653', lat: '25.12799' },
          { id: 1987, pid: 1977, name: '南雄市', code: '440282', lng: '114.30966', lat: '25.11706' },
        ],
      },
      {
        id: 1988,
        pid: 1964,
        name: '深圳市',
        code: '440300',
        lng: '114.085947',
        lat: '22.547',
        children: [
          { id: 1989, pid: 1988, name: '罗湖区', code: '440303', lng: '114.13116', lat: '22.54836' },
          { id: 1990, pid: 1988, name: '福田区', code: '440304', lng: '114.05571', lat: '22.52245' },
          { id: 1991, pid: 1988, name: '南山区', code: '440305', lng: '113.93029', lat: '22.53291' },
          { id: 1992, pid: 1988, name: '宝安区', code: '440306', lng: '113.88311', lat: '22.55371' },
          { id: 1993, pid: 1988, name: '龙岗区', code: '440307', lng: '114.24771', lat: '22.71986' },
          { id: 1994, pid: 1988, name: '盐田区', code: '440308', lng: '114.23733', lat: '22.5578' },
          { id: 1995, pid: 1988, name: '光明新区', code: '440309', lng: '113.896026', lat: '22.777292' },
          { id: 1996, pid: 1988, name: '坪山新区', code: '440310', lng: '114.34637', lat: '22.690529' },
          { id: 1997, pid: 1988, name: '大鹏新区', code: '440311', lng: '114.479901', lat: '22.587862' },
          { id: 1998, pid: 1988, name: '龙华新区', code: '440312', lng: '114.036585', lat: '22.68695' },
        ],
      },
      {
        id: 1999,
        pid: 1964,
        name: '珠海市',
        code: '440400',
        lng: '113.552724',
        lat: '22.255899',
        children: [
          { id: 2000, pid: 1999, name: '香洲区', code: '440402', lng: '113.5435', lat: '22.26654' },
          { id: 2001, pid: 1999, name: '斗门区', code: '440403', lng: '113.29644', lat: '22.20898' },
          { id: 2002, pid: 1999, name: '金湾区', code: '440404', lng: '113.36361', lat: '22.14691' },
        ],
      },
      {
        id: 2003,
        pid: 1964,
        name: '汕头市',
        code: '440500',
        lng: '116.708463',
        lat: '23.37102',
        children: [
          { id: 2004, pid: 2003, name: '龙湖区', code: '440507', lng: '116.71641', lat: '23.37166' },
          { id: 2005, pid: 2003, name: '金平区', code: '440511', lng: '116.70364', lat: '23.36637' },
          { id: 2006, pid: 2003, name: '濠江区', code: '440512', lng: '116.72659', lat: '23.28588' },
          { id: 2007, pid: 2003, name: '潮阳区', code: '440513', lng: '116.6015', lat: '23.26485' },
          { id: 2008, pid: 2003, name: '潮南区', code: '440514', lng: '116.43188', lat: '23.25' },
          { id: 2009, pid: 2003, name: '澄海区', code: '440515', lng: '116.75589', lat: '23.46728' },
          { id: 2010, pid: 2003, name: '南澳县', code: '440523', lng: '117.01889', lat: '23.4223' },
        ],
      },
      {
        id: 2011,
        pid: 1964,
        name: '佛山市',
        code: '440600',
        lng: '113.122717',
        lat: '23.028762',
        children: [
          { id: 2012, pid: 2011, name: '禅城区', code: '440604', lng: '113.1228', lat: '23.00842' },
          { id: 2013, pid: 2011, name: '南海区', code: '440605', lng: '113.14299', lat: '23.02877' },
          { id: 2014, pid: 2011, name: '顺德区', code: '440606', lng: '113.29394', lat: '22.80452' },
          { id: 2015, pid: 2011, name: '三水区', code: '440607', lng: '112.89703', lat: '23.15564' },
          { id: 2016, pid: 2011, name: '高明区', code: '440608', lng: '112.89254', lat: '22.90022' },
        ],
      },
      {
        id: 2017,
        pid: 1964,
        name: '江门市',
        code: '440700',
        lng: '113.094942',
        lat: '22.590431',
        children: [
          { id: 2018, pid: 2017, name: '蓬江区', code: '440703', lng: '113.07849', lat: '22.59515' },
          { id: 2019, pid: 2017, name: '江海区', code: '440704', lng: '113.11099', lat: '22.56024' },
          { id: 2020, pid: 2017, name: '新会区', code: '440705', lng: '113.03225', lat: '22.45876' },
          { id: 2021, pid: 2017, name: '台山市', code: '440781', lng: '112.79382', lat: '22.2515' },
          { id: 2022, pid: 2017, name: '开平市', code: '440783', lng: '112.69842', lat: '22.37622' },
          { id: 2023, pid: 2017, name: '鹤山市', code: '440784', lng: '112.96429', lat: '22.76523' },
          { id: 2024, pid: 2017, name: '恩平市', code: '440785', lng: '112.30496', lat: '22.18288' },
        ],
      },
      {
        id: 2025,
        pid: 1964,
        name: '湛江市',
        code: '440800',
        lng: '110.405529',
        lat: '21.195338',
        children: [
          { id: 2026, pid: 2025, name: '赤坎区', code: '440802', lng: '110.36592', lat: '21.26606' },
          { id: 2027, pid: 2025, name: '霞山区', code: '440803', lng: '110.39822', lat: '21.19181' },
          { id: 2028, pid: 2025, name: '坡头区', code: '440804', lng: '110.45533', lat: '21.24472' },
          { id: 2029, pid: 2025, name: '麻章区', code: '440811', lng: '110.3342', lat: '21.26333' },
          { id: 2030, pid: 2025, name: '遂溪县', code: '440823', lng: '110.25003', lat: '21.37721' },
          { id: 2031, pid: 2025, name: '徐闻县', code: '440825', lng: '110.17379', lat: '20.32812' },
          { id: 2032, pid: 2025, name: '廉江市', code: '440881', lng: '110.28442', lat: '21.60917' },
          { id: 2033, pid: 2025, name: '雷州市', code: '440882', lng: '110.10092', lat: '20.91428' },
          { id: 2034, pid: 2025, name: '吴川市', code: '440883', lng: '110.77703', lat: '21.44584' },
        ],
      },
      {
        id: 2035,
        pid: 1964,
        name: '茂名市',
        code: '440900',
        lng: '110.919229',
        lat: '21.659751',
        children: [
          { id: 2036, pid: 2035, name: '茂南区', code: '440902', lng: '110.9187', lat: '21.64103' },
          { id: 2037, pid: 2035, name: '电白区', code: '440904', lng: '111.007264', lat: '21.507219' },
          { id: 2038, pid: 2035, name: '高州市', code: '440981', lng: '110.85519', lat: '21.92057' },
          { id: 2039, pid: 2035, name: '化州市', code: '440982', lng: '110.63949', lat: '21.66394' },
          { id: 2040, pid: 2035, name: '信宜市', code: '440983', lng: '110.94647', lat: '22.35351' },
        ],
      },
      {
        id: 2041,
        pid: 1964,
        name: '肇庆市',
        code: '441200',
        lng: '112.472529',
        lat: '23.051546',
        children: [
          { id: 2042, pid: 2041, name: '端州区', code: '441202', lng: '112.48495', lat: '23.0519' },
          { id: 2043, pid: 2041, name: '鼎湖区', code: '441203', lng: '112.56643', lat: '23.15846' },
          { id: 2044, pid: 2041, name: '广宁县', code: '441223', lng: '112.44064', lat: '23.6346' },
          { id: 2045, pid: 2041, name: '怀集县', code: '441224', lng: '112.18396', lat: '23.90918' },
          { id: 2046, pid: 2041, name: '封开县', code: '441225', lng: '111.50332', lat: '23.43571' },
          { id: 2047, pid: 2041, name: '德庆县', code: '441226', lng: '111.78555', lat: '23.14371' },
          { id: 2048, pid: 2041, name: '高要市', code: '441283', lng: '112.45834', lat: '23.02577' },
          { id: 2049, pid: 2041, name: '四会市', code: '441284', lng: '112.73416', lat: '23.32686' },
        ],
      },
      {
        id: 2050,
        pid: 1964,
        name: '惠州市',
        code: '441300',
        lng: '114.412599',
        lat: '23.079404',
        children: [
          { id: 2051, pid: 2050, name: '惠城区', code: '441302', lng: '114.3828', lat: '23.08377' },
          { id: 2052, pid: 2050, name: '惠阳区', code: '441303', lng: '114.45639', lat: '22.78845' },
          { id: 2053, pid: 2050, name: '博罗县', code: '441322', lng: '114.28964', lat: '23.17307' },
          { id: 2054, pid: 2050, name: '惠东县', code: '441323', lng: '114.72009', lat: '22.98484' },
          { id: 2055, pid: 2050, name: '龙门县', code: '441324', lng: '114.25479', lat: '23.72758' },
        ],
      },
      {
        id: 2056,
        pid: 1964,
        name: '梅州市',
        code: '441400',
        lng: '116.117582',
        lat: '24.299112',
        children: [
          { id: 2057, pid: 2056, name: '梅江区', code: '441402', lng: '116.11663', lat: '24.31062' },
          { id: 2058, pid: 2056, name: '梅县区', code: '441403', lng: '116.097753', lat: '24.286739' },
          { id: 2059, pid: 2056, name: '大埔县', code: '441422', lng: '116.69662', lat: '24.35325' },
          { id: 2060, pid: 2056, name: '丰顺县', code: '441423', lng: '116.18219', lat: '23.74094' },
          { id: 2061, pid: 2056, name: '五华县', code: '441424', lng: '115.77893', lat: '23.92417' },
          { id: 2062, pid: 2056, name: '平远县', code: '441426', lng: '115.89556', lat: '24.57116' },
          { id: 2063, pid: 2056, name: '蕉岭县', code: '441427', lng: '116.17089', lat: '24.65732' },
          { id: 2064, pid: 2056, name: '兴宁市', code: '441481', lng: '115.73141', lat: '24.14001' },
        ],
      },
      {
        id: 2065,
        pid: 1964,
        name: '汕尾市',
        code: '441500',
        lng: '115.364238',
        lat: '22.774485',
        children: [
          { id: 2066, pid: 2065, name: '城区', code: '441502', lng: '115.36503', lat: '22.7789' },
          { id: 2067, pid: 2065, name: '海丰县', code: '441521', lng: '115.32336', lat: '22.96653' },
          { id: 2068, pid: 2065, name: '陆河县', code: '441523', lng: '115.65597', lat: '23.30365' },
          { id: 2069, pid: 2065, name: '陆丰市', code: '441581', lng: '115.64813', lat: '22.94335' },
        ],
      },
      {
        id: 2070,
        pid: 1964,
        name: '河源市',
        code: '441600',
        lng: '114.697802',
        lat: '23.746266',
        children: [
          { id: 2071, pid: 2070, name: '源城区', code: '441602', lng: '114.70242', lat: '23.7341' },
          { id: 2072, pid: 2070, name: '紫金县', code: '441621', lng: '115.18365', lat: '23.63867' },
          { id: 2073, pid: 2070, name: '龙川县', code: '441622', lng: '115.26025', lat: '24.10142' },
          { id: 2074, pid: 2070, name: '连平县', code: '441623', lng: '114.49026', lat: '24.37156' },
          { id: 2075, pid: 2070, name: '和平县', code: '441624', lng: '114.93841', lat: '24.44319' },
          { id: 2076, pid: 2070, name: '东源县', code: '441625', lng: '114.74633', lat: '23.78835' },
        ],
      },
      {
        id: 2077,
        pid: 1964,
        name: '阳江市',
        code: '441700',
        lng: '111.975107',
        lat: '21.859222',
        children: [
          { id: 2078, pid: 2077, name: '江城区', code: '441702', lng: '111.95488', lat: '21.86193' },
          { id: 2079, pid: 2077, name: '阳东区', code: '441704', lng: '112.01467', lat: '21.87398' },
          { id: 2080, pid: 2077, name: '阳西县', code: '441721', lng: '111.61785', lat: '21.75234' },
          { id: 2081, pid: 2077, name: '阳春市', code: '441781', lng: '111.78854', lat: '22.17232' },
        ],
      },
      {
        id: 2082,
        pid: 1964,
        name: '清远市',
        code: '441800',
        lng: '113.036779',
        lat: '23.704188',
        children: [
          { id: 2083, pid: 2082, name: '清城区', code: '441802', lng: '113.06265', lat: '23.69784' },
          { id: 2084, pid: 2082, name: '清新区', code: '441803', lng: '113.015203', lat: '23.736949' },
          { id: 2085, pid: 2082, name: '佛冈县', code: '441821', lng: '113.53286', lat: '23.87231' },
          { id: 2086, pid: 2082, name: '阳山县', code: '441823', lng: '112.64129', lat: '24.46516' },
          { id: 2087, pid: 2082, name: '连山壮族瑶族自治县', code: '441825', lng: '112.0802', lat: '24.56807' },
          { id: 2088, pid: 2082, name: '连南瑶族自治县', code: '441826', lng: '112.28842', lat: '24.71726' },
          { id: 2089, pid: 2082, name: '英德市', code: '441881', lng: '113.415', lat: '24.18571' },
          { id: 2090, pid: 2082, name: '连州市', code: '441882', lng: '112.38153', lat: '24.77913' },
        ],
      },
      {
        id: 2091,
        pid: 1964,
        name: '东莞市',
        code: '441900',
        lng: '113.760234',
        lat: '23.048884',
        children: [
          { id: 2092, pid: 2091, name: '莞城区', code: '441901', lng: '113.751043', lat: '23.053412' },
          { id: 2093, pid: 2091, name: '南城区', code: '441902', lng: '113.752125', lat: '23.02018' },
          { id: 2094, pid: 2091, name: '万江区', code: '441904', lng: '113.739053', lat: '23.043842' },
          { id: 2095, pid: 2091, name: '石碣镇', code: '441905', lng: '113.80217', lat: '23.09899' },
          { id: 2096, pid: 2091, name: '石龙镇', code: '441906', lng: '113.876381', lat: '23.107444' },
          { id: 2097, pid: 2091, name: '茶山镇', code: '441907', lng: '113.883526', lat: '23.062375' },
          { id: 2098, pid: 2091, name: '石排镇', code: '441908', lng: '113.919859', lat: '23.0863' },
          { id: 2099, pid: 2091, name: '企石镇', code: '441909', lng: '114.013233', lat: '23.066044' },
          { id: 2100, pid: 2091, name: '横沥镇', code: '441910', lng: '113.957436', lat: '23.025732' },
          { id: 2101, pid: 2091, name: '桥头镇', code: '441911', lng: '114.01385', lat: '22.939727' },
          { id: 2102, pid: 2091, name: '谢岗镇', code: '441912', lng: '114.141396', lat: '22.959664' },
          { id: 2103, pid: 2091, name: '东坑镇', code: '441913', lng: '113.939835', lat: '22.992804' },
          { id: 2104, pid: 2091, name: '常平镇', code: '441914', lng: '114.029627', lat: '23.016116' },
          { id: 2105, pid: 2091, name: '寮步镇', code: '441915', lng: '113.884745', lat: '22.991738' },
          { id: 2106, pid: 2091, name: '大朗镇', code: '441916', lng: '113.9271', lat: '22.965748' },
          { id: 2107, pid: 2091, name: '麻涌镇', code: '441917', lng: '113.546177', lat: '23.045315' },
          { id: 2108, pid: 2091, name: '中堂镇', code: '441918', lng: '113.654422', lat: '23.090164' },
          { id: 2109, pid: 2091, name: '高埗镇', code: '441919', lng: '113.735917', lat: '23.068415' },
          { id: 2110, pid: 2091, name: '樟木头镇', code: '441920', lng: '114.066298', lat: '22.956682' },
          { id: 2111, pid: 2091, name: '大岭山镇', code: '441921', lng: '113.782955', lat: '22.885366' },
          { id: 2112, pid: 2091, name: '望牛墩镇', code: '441922', lng: '113.658847', lat: '23.055018' },
          { id: 2113, pid: 2091, name: '黄江镇', code: '441923', lng: '113.992635', lat: '22.877536' },
          { id: 2114, pid: 2091, name: '洪梅镇', code: '441924', lng: '113.613081', lat: '22.992675' },
          { id: 2115, pid: 2091, name: '清溪镇', code: '441925', lng: '114.155796', lat: '22.844456' },
          { id: 2116, pid: 2091, name: '沙田镇', code: '441926', lng: '113.760234', lat: '23.048884' },
          { id: 2117, pid: 2091, name: '道滘镇', code: '441927', lng: '113.760234', lat: '23.048884' },
          { id: 2118, pid: 2091, name: '塘厦镇', code: '441928', lng: '114.10765', lat: '22.822862' },
          { id: 2119, pid: 2091, name: '虎门镇', code: '441929', lng: '113.71118', lat: '22.82615' },
          { id: 2120, pid: 2091, name: '厚街镇', code: '441930', lng: '113.67301', lat: '22.940815' },
          { id: 2121, pid: 2091, name: '凤岗镇', code: '441931', lng: '114.141194', lat: '22.744598' },
          { id: 2122, pid: 2091, name: '长安镇', code: '441932', lng: '113.803939', lat: '22.816644' },
        ],
      },
      {
        id: 2123,
        pid: 1964,
        name: '中山市',
        code: '442000',
        lng: '113.382391',
        lat: '22.521113',
        children: [
          { id: 2124, pid: 2123, name: '石岐区', code: '442001', lng: '113.378835', lat: '22.52522' },
          { id: 2125, pid: 2123, name: '南区', code: '442004', lng: '113.355896', lat: '22.486568' },
          { id: 2126, pid: 2123, name: '五桂山区', code: '442005', lng: '113.41079', lat: '22.51968' },
          { id: 2127, pid: 2123, name: '火炬开发区', code: '442006', lng: '113.480523', lat: '22.566082' },
          { id: 2128, pid: 2123, name: '黄圃镇', code: '442007', lng: '113.342359', lat: '22.715116' },
          { id: 2129, pid: 2123, name: '南头镇', code: '442008', lng: '113.296358', lat: '22.713907' },
          { id: 2130, pid: 2123, name: '东凤镇', code: '442009', lng: '113.26114', lat: '22.68775' },
          { id: 2131, pid: 2123, name: '阜沙镇', code: '442010', lng: '113.353024', lat: '22.666364' },
          { id: 2132, pid: 2123, name: '小榄镇', code: '442011', lng: '113.244235', lat: '22.666951' },
          { id: 2133, pid: 2123, name: '东升镇', code: '442012', lng: '113.296298', lat: '22.614003' },
          { id: 2134, pid: 2123, name: '古镇镇', code: '442013', lng: '113.179745', lat: '22.611019' },
          { id: 2135, pid: 2123, name: '横栏镇', code: '442014', lng: '113.265845', lat: '22.523202' },
          { id: 2136, pid: 2123, name: '三角镇', code: '442015', lng: '113.423624', lat: '22.677033' },
          { id: 2137, pid: 2123, name: '民众镇', code: '442016', lng: '113.486025', lat: '22.623468' },
          { id: 2138, pid: 2123, name: '南朗镇', code: '442017', lng: '113.533939', lat: '22.492378' },
          { id: 2139, pid: 2123, name: '港口镇', code: '442018', lng: '113.382391', lat: '22.521113' },
          { id: 2140, pid: 2123, name: '大涌镇', code: '442019', lng: '113.291708', lat: '22.467712' },
          { id: 2141, pid: 2123, name: '沙溪镇', code: '442020', lng: '113.328369', lat: '22.526325' },
          { id: 2142, pid: 2123, name: '三乡镇', code: '442021', lng: '113.4334', lat: '22.352494' },
          { id: 2143, pid: 2123, name: '板芙镇', code: '442022', lng: '113.320346', lat: '22.415674' },
          { id: 2144, pid: 2123, name: '神湾镇', code: '442023', lng: '113.359387', lat: '22.312476' },
          { id: 2145, pid: 2123, name: '坦洲镇', code: '442024', lng: '113.485677', lat: '22.261269' },
        ],
      },
      {
        id: 2146,
        pid: 1964,
        name: '潮州市',
        code: '445100',
        lng: '116.632301',
        lat: '23.661701',
        children: [
          { id: 2147, pid: 2146, name: '湘桥区', code: '445102', lng: '116.62805', lat: '23.67451' },
          { id: 2148, pid: 2146, name: '潮安区', code: '445103', lng: '116.592895', lat: '23.643656' },
          { id: 2149, pid: 2146, name: '饶平县', code: '445122', lng: '117.00692', lat: '23.66994' },
        ],
      },
      {
        id: 2150,
        pid: 1964,
        name: '揭阳市',
        code: '445200',
        lng: '116.355733',
        lat: '23.543778',
        children: [
          { id: 2151, pid: 2150, name: '榕城区', code: '445202', lng: '116.3671', lat: '23.52508' },
          { id: 2152, pid: 2150, name: '揭东区', code: '445203', lng: '116.412947', lat: '23.569887' },
          { id: 2153, pid: 2150, name: '揭西县', code: '445222', lng: '115.83883', lat: '23.42714' },
          { id: 2154, pid: 2150, name: '惠来县', code: '445224', lng: '116.29599', lat: '23.03289' },
          { id: 2155, pid: 2150, name: '普宁市', code: '445281', lng: '116.16564', lat: '23.29732' },
        ],
      },
      {
        id: 2156,
        pid: 1964,
        name: '云浮市',
        code: '445300',
        lng: '112.044439',
        lat: '22.929801',
        children: [
          { id: 2157, pid: 2156, name: '云城区', code: '445302', lng: '112.03908', lat: '22.92996' },
          { id: 2158, pid: 2156, name: '云安区', code: '445303', lng: '112.00936', lat: '23.07779' },
          { id: 2159, pid: 2156, name: '新兴县', code: '445321', lng: '112.23019', lat: '22.69734' },
          { id: 2160, pid: 2156, name: '郁南县', code: '445322', lng: '111.53387', lat: '23.23307' },
          { id: 2161, pid: 2156, name: '罗定市', code: '445381', lng: '111.56979', lat: '22.76967' },
        ],
      },
    ],
  },
  {
    id: 2162,
    pid: 0,
    name: '广西壮族自治区',
    code: '450000',
    lng: '108.320004',
    lat: '22.82402',
    children: [
      {
        id: 2163,
        pid: 2162,
        name: '南宁市',
        code: '450100',
        lng: '108.320004',
        lat: '22.82402',
        children: [
          { id: 2164, pid: 2163, name: '兴宁区', code: '450102', lng: '108.36694', lat: '22.85355' },
          { id: 2165, pid: 2163, name: '青秀区', code: '450103', lng: '108.49545', lat: '22.78511' },
          { id: 2166, pid: 2163, name: '江南区', code: '450105', lng: '108.27325', lat: '22.78127' },
          { id: 2167, pid: 2163, name: '西乡塘区', code: '450107', lng: '108.31347', lat: '22.83386' },
          { id: 2168, pid: 2163, name: '良庆区', code: '450108', lng: '108.41284', lat: '22.74914' },
          { id: 2169, pid: 2163, name: '邕宁区', code: '450109', lng: '108.48684', lat: '22.75628' },
          { id: 2170, pid: 2163, name: '武鸣县', code: '450122', lng: '108.27719', lat: '23.15643' },
          { id: 2171, pid: 2163, name: '隆安县', code: '450123', lng: '107.69192', lat: '23.17336' },
          { id: 2172, pid: 2163, name: '马山县', code: '450124', lng: '108.17697', lat: '23.70931' },
          { id: 2173, pid: 2163, name: '上林县', code: '450125', lng: '108.60522', lat: '23.432' },
          { id: 2174, pid: 2163, name: '宾阳县', code: '450126', lng: '108.81185', lat: '23.2196' },
          { id: 2175, pid: 2163, name: '横县', code: '450127', lng: '109.26608', lat: '22.68448' },
          { id: 2176, pid: 2163, name: '埌东新区', code: '450128', lng: '108.419094', lat: '22.812976' },
        ],
      },
      {
        id: 2177,
        pid: 2162,
        name: '柳州市',
        code: '450200',
        lng: '109.411703',
        lat: '24.314617',
        children: [
          { id: 2178, pid: 2177, name: '城中区', code: '450202', lng: '109.41082', lat: '24.31543' },
          { id: 2179, pid: 2177, name: '鱼峰区', code: '450203', lng: '109.4533', lat: '24.31868' },
          { id: 2180, pid: 2177, name: '柳南区', code: '450204', lng: '109.38548', lat: '24.33599' },
          { id: 2181, pid: 2177, name: '柳北区', code: '450205', lng: '109.40202', lat: '24.36267' },
          { id: 2182, pid: 2177, name: '柳江县', code: '450221', lng: '109.33273', lat: '24.25596' },
          { id: 2183, pid: 2177, name: '柳城县', code: '450222', lng: '109.23877', lat: '24.64951' },
          { id: 2184, pid: 2177, name: '鹿寨县', code: '450223', lng: '109.75177', lat: '24.47306' },
          { id: 2185, pid: 2177, name: '融安县', code: '450224', lng: '109.39761', lat: '25.22465' },
          { id: 2186, pid: 2177, name: '融水苗族自治县', code: '450225', lng: '109.25634', lat: '25.06628' },
          { id: 2187, pid: 2177, name: '三江侗族自治县', code: '450226', lng: '109.60446', lat: '25.78428' },
          { id: 2188, pid: 2177, name: '柳东新区', code: '450227', lng: '109.437053', lat: '24.329204' },
        ],
      },
      {
        id: 2189,
        pid: 2162,
        name: '桂林市',
        code: '450300',
        lng: '110.299121',
        lat: '25.274215',
        children: [
          { id: 2190, pid: 2189, name: '秀峰区', code: '450302', lng: '110.28915', lat: '25.28249' },
          { id: 2191, pid: 2189, name: '叠彩区', code: '450303', lng: '110.30195', lat: '25.31381' },
          { id: 2192, pid: 2189, name: '象山区', code: '450304', lng: '110.28108', lat: '25.26168' },
          { id: 2193, pid: 2189, name: '七星区', code: '450305', lng: '110.31793', lat: '25.2525' },
          { id: 2194, pid: 2189, name: '雁山区', code: '450311', lng: '110.30911', lat: '25.06038' },
          { id: 2195, pid: 2189, name: '临桂区', code: '450312', lng: '110.205487', lat: '25.246257' },
          { id: 2196, pid: 2189, name: '阳朔县', code: '450321', lng: '110.49475', lat: '24.77579' },
          { id: 2197, pid: 2189, name: '灵川县', code: '450323', lng: '110.32949', lat: '25.41292' },
          { id: 2198, pid: 2189, name: '全州县', code: '450324', lng: '111.07211', lat: '25.92799' },
          { id: 2199, pid: 2189, name: '兴安县', code: '450325', lng: '110.67144', lat: '25.61167' },
          { id: 2200, pid: 2189, name: '永福县', code: '450326', lng: '109.98333', lat: '24.98004' },
          { id: 2201, pid: 2189, name: '灌阳县', code: '450327', lng: '111.15954', lat: '25.48803' },
          { id: 2202, pid: 2189, name: '龙胜各族自治县', code: '450328', lng: '110.01226', lat: '25.79614' },
          { id: 2203, pid: 2189, name: '资源县', code: '450329', lng: '110.65255', lat: '26.04237' },
          { id: 2204, pid: 2189, name: '平乐县', code: '450330', lng: '110.64175', lat: '24.63242' },
          { id: 2205, pid: 2189, name: '荔浦县', code: '450331', lng: '110.3971', lat: '24.49589' },
          { id: 2206, pid: 2189, name: '恭城瑶族自治县', code: '450332', lng: '110.83035', lat: '24.83286' },
        ],
      },
      {
        id: 2207,
        pid: 2162,
        name: '梧州市',
        code: '450400',
        lng: '111.316229',
        lat: '23.472309',
        children: [
          { id: 2208, pid: 2207, name: '万秀区', code: '450403', lng: '111.32052', lat: '23.47298' },
          { id: 2209, pid: 2207, name: '长洲区', code: '450405', lng: '111.27494', lat: '23.48573' },
          { id: 2210, pid: 2207, name: '龙圩区', code: '450406', lng: '111.316229', lat: '23.472309' },
          { id: 2211, pid: 2207, name: '苍梧县', code: '450421', lng: '111.24533', lat: '23.42049' },
          { id: 2212, pid: 2207, name: '藤县', code: '450422', lng: '110.91418', lat: '23.37605' },
          { id: 2213, pid: 2207, name: '蒙山县', code: '450423', lng: '110.52221', lat: '24.20168' },
          { id: 2214, pid: 2207, name: '岑溪市', code: '450481', lng: '110.99594', lat: '22.9191' },
        ],
      },
      {
        id: 2215,
        pid: 2162,
        name: '北海市',
        code: '450500',
        lng: '109.119254',
        lat: '21.473343',
        children: [
          { id: 2216, pid: 2215, name: '海城区', code: '450502', lng: '109.11744', lat: '21.47501' },
          { id: 2217, pid: 2215, name: '银海区', code: '450503', lng: '109.13029', lat: '21.4783' },
          { id: 2218, pid: 2215, name: '铁山港区', code: '450512', lng: '109.45578', lat: '21.59661' },
          { id: 2219, pid: 2215, name: '合浦县', code: '450521', lng: '109.20068', lat: '21.66601' },
        ],
      },
      {
        id: 2220,
        pid: 2162,
        name: '防城港市',
        code: '450600',
        lng: '108.345478',
        lat: '21.614631',
        children: [
          { id: 2221, pid: 2220, name: '港口区', code: '450602', lng: '108.38022', lat: '21.64342' },
          { id: 2222, pid: 2220, name: '防城区', code: '450603', lng: '108.35726', lat: '21.76464' },
          { id: 2223, pid: 2220, name: '上思县', code: '450621', lng: '107.9823', lat: '22.14957' },
          { id: 2224, pid: 2220, name: '东兴市', code: '450681', lng: '107.97204', lat: '21.54713' },
        ],
      },
      {
        id: 2225,
        pid: 2162,
        name: '钦州市',
        code: '450700',
        lng: '108.624175',
        lat: '21.967127',
        children: [
          { id: 2226, pid: 2225, name: '钦南区', code: '450702', lng: '108.61775', lat: '21.95137' },
          { id: 2227, pid: 2225, name: '钦北区', code: '450703', lng: '108.63037', lat: '21.95127' },
          { id: 2228, pid: 2225, name: '灵山县', code: '450721', lng: '109.29153', lat: '22.4165' },
          { id: 2229, pid: 2225, name: '浦北县', code: '450722', lng: '109.55572', lat: '22.26888' },
        ],
      },
      {
        id: 2230,
        pid: 2162,
        name: '贵港市',
        code: '450800',
        lng: '109.602146',
        lat: '23.0936',
        children: [
          { id: 2231, pid: 2230, name: '港北区', code: '450802', lng: '109.57224', lat: '23.11153' },
          { id: 2232, pid: 2230, name: '港南区', code: '450803', lng: '109.60617', lat: '23.07226' },
          { id: 2233, pid: 2230, name: '覃塘区', code: '450804', lng: '109.44293', lat: '23.12677' },
          { id: 2234, pid: 2230, name: '平南县', code: '450821', lng: '110.39062', lat: '23.54201' },
          { id: 2235, pid: 2230, name: '桂平市', code: '450881', lng: '110.08105', lat: '23.39339' },
        ],
      },
      {
        id: 2236,
        pid: 2162,
        name: '玉林市',
        code: '450900',
        lng: '110.154393',
        lat: '22.63136',
        children: [
          { id: 2237, pid: 2236, name: '玉州区', code: '450902', lng: '110.15114', lat: '22.6281' },
          { id: 2238, pid: 2236, name: '福绵区', code: '450903', lng: '110.064816', lat: '22.583057' },
          { id: 2239, pid: 2236, name: '玉东新区', code: '450904', lng: '110.154393', lat: '22.63136' },
          { id: 2240, pid: 2236, name: '容县', code: '450921', lng: '110.55593', lat: '22.85701' },
          { id: 2241, pid: 2236, name: '陆川县', code: '450922', lng: '110.26413', lat: '22.32454' },
          { id: 2242, pid: 2236, name: '博白县', code: '450923', lng: '109.97744', lat: '22.27286' },
          { id: 2243, pid: 2236, name: '兴业县', code: '450924', lng: '109.87612', lat: '22.74237' },
          { id: 2244, pid: 2236, name: '北流市', code: '450981', lng: '110.35302', lat: '22.70817' },
        ],
      },
      {
        id: 2245,
        pid: 2162,
        name: '百色市',
        code: '451000',
        lng: '106.616285',
        lat: '23.897742',
        children: [
          { id: 2246, pid: 2245, name: '右江区', code: '451002', lng: '106.61764', lat: '23.9009' },
          { id: 2247, pid: 2245, name: '田阳县', code: '451021', lng: '106.91558', lat: '23.73535' },
          { id: 2248, pid: 2245, name: '田东县', code: '451022', lng: '107.12432', lat: '23.60003' },
          { id: 2249, pid: 2245, name: '平果县', code: '451023', lng: '107.59045', lat: '23.32969' },
          { id: 2250, pid: 2245, name: '德保县', code: '451024', lng: '106.61917', lat: '23.32515' },
          { id: 2251, pid: 2245, name: '靖西县', code: '451025', lng: '106.41766', lat: '23.13425' },
          { id: 2252, pid: 2245, name: '那坡县', code: '451026', lng: '105.84191', lat: '23.40649' },
          { id: 2253, pid: 2245, name: '凌云县', code: '451027', lng: '106.56155', lat: '24.34747' },
          { id: 2254, pid: 2245, name: '乐业县', code: '451028', lng: '106.56124', lat: '24.78295' },
          { id: 2255, pid: 2245, name: '田林县', code: '451029', lng: '106.22882', lat: '24.29207' },
          { id: 2256, pid: 2245, name: '西林县', code: '451030', lng: '105.09722', lat: '24.48966' },
          { id: 2257, pid: 2245, name: '隆林各族自治县', code: '451031', lng: '105.34295', lat: '24.77036' },
        ],
      },
      {
        id: 2258,
        pid: 2162,
        name: '贺州市',
        code: '451100',
        lng: '111.552056',
        lat: '24.414141',
        children: [
          { id: 2259, pid: 2258, name: '八步区', code: '451102', lng: '111.55225', lat: '24.41179' },
          { id: 2260, pid: 2258, name: '昭平县', code: '451121', lng: '110.81082', lat: '24.1701' },
          { id: 2261, pid: 2258, name: '钟山县', code: '451122', lng: '111.30459', lat: '24.52482' },
          { id: 2262, pid: 2258, name: '富川瑶族自治县', code: '451123', lng: '111.27767', lat: '24.81431' },
          { id: 2263, pid: 2258, name: '平桂管理区', code: '451124', lng: '111.485651', lat: '24.458041' },
        ],
      },
      {
        id: 2264,
        pid: 2162,
        name: '河池市',
        code: '451200',
        lng: '108.062105',
        lat: '24.695899',
        children: [
          { id: 2265, pid: 2264, name: '金城江区', code: '451202', lng: '108.03727', lat: '24.6897' },
          { id: 2266, pid: 2264, name: '南丹县', code: '451221', lng: '107.54562', lat: '24.9776' },
          { id: 2267, pid: 2264, name: '天峨县', code: '451222', lng: '107.17205', lat: '24.99593' },
          { id: 2268, pid: 2264, name: '凤山县', code: '451223', lng: '107.04892', lat: '24.54215' },
          { id: 2269, pid: 2264, name: '东兰县', code: '451224', lng: '107.37527', lat: '24.51053' },
          { id: 2270, pid: 2264, name: '罗城仫佬族自治县', code: '451225', lng: '108.90777', lat: '24.77923' },
          { id: 2271, pid: 2264, name: '环江毛南族自治县', code: '451226', lng: '108.26055', lat: '24.82916' },
          { id: 2272, pid: 2264, name: '巴马瑶族自治县', code: '451227', lng: '107.25308', lat: '24.14135' },
          { id: 2273, pid: 2264, name: '都安瑶族自治县', code: '451228', lng: '108.10116', lat: '23.93245' },
          { id: 2274, pid: 2264, name: '大化瑶族自治县', code: '451229', lng: '107.9985', lat: '23.74487' },
          { id: 2275, pid: 2264, name: '宜州市', code: '451281', lng: '108.65304', lat: '24.49391' },
        ],
      },
      {
        id: 2276,
        pid: 2162,
        name: '来宾市',
        code: '451300',
        lng: '109.229772',
        lat: '23.733766',
        children: [
          { id: 2277, pid: 2276, name: '兴宾区', code: '451302', lng: '109.23471', lat: '23.72731' },
          { id: 2278, pid: 2276, name: '忻城县', code: '451321', lng: '108.66357', lat: '24.06862' },
          { id: 2279, pid: 2276, name: '象州县', code: '451322', lng: '109.6994', lat: '23.97355' },
          { id: 2280, pid: 2276, name: '武宣县', code: '451323', lng: '109.66284', lat: '23.59474' },
          { id: 2281, pid: 2276, name: '金秀瑶族自治县', code: '451324', lng: '110.19079', lat: '24.12929' },
          { id: 2282, pid: 2276, name: '合山市', code: '451381', lng: '108.88586', lat: '23.80619' },
        ],
      },
      {
        id: 2283,
        pid: 2162,
        name: '崇左市',
        code: '451400',
        lng: '107.353926',
        lat: '22.404108',
        children: [
          { id: 2284, pid: 2283, name: '江州区', code: '451402', lng: '107.34747', lat: '22.41135' },
          { id: 2285, pid: 2283, name: '扶绥县', code: '451421', lng: '107.90405', lat: '22.63413' },
          { id: 2286, pid: 2283, name: '宁明县', code: '451422', lng: '107.07299', lat: '22.13655' },
          { id: 2287, pid: 2283, name: '龙州县', code: '451423', lng: '106.85415', lat: '22.33937' },
          { id: 2288, pid: 2283, name: '大新县', code: '451424', lng: '107.19821', lat: '22.83412' },
          { id: 2289, pid: 2283, name: '天等县', code: '451425', lng: '107.13998', lat: '23.077' },
          { id: 2290, pid: 2283, name: '凭祥市', code: '451481', lng: '106.75534', lat: '22.10573' },
        ],
      },
    ],
  },
  {
    id: 2291,
    pid: 0,
    name: '海南省',
    code: '460000',
    lng: '110.33119',
    lat: '20.031971',
    children: [
      {
        id: 2292,
        pid: 2291,
        name: '海口市',
        code: '460100',
        lng: '110.33119',
        lat: '20.031971',
        children: [
          { id: 2293, pid: 2292, name: '秀英区', code: '460105', lng: '110.29345', lat: '20.00752' },
          { id: 2294, pid: 2292, name: '龙华区', code: '460106', lng: '110.30194', lat: '20.02866' },
          { id: 2295, pid: 2292, name: '琼山区', code: '460107', lng: '110.35418', lat: '20.00321' },
          { id: 2296, pid: 2292, name: '美兰区', code: '460108', lng: '110.36908', lat: '20.02864' },
        ],
      },
      {
        id: 2297,
        pid: 2291,
        name: '三亚市',
        code: '460200',
        lng: '109.508268',
        lat: '18.247872',
        children: [
          { id: 2298, pid: 2297, name: '海棠区', code: '460202', lng: '109.508268', lat: '18.247872' },
          { id: 2299, pid: 2297, name: '吉阳区', code: '460203', lng: '109.508268', lat: '18.247872' },
          { id: 2300, pid: 2297, name: '天涯区', code: '460204', lng: '109.508268', lat: '18.247872' },
          { id: 2301, pid: 2297, name: '崖州区', code: '460205', lng: '109.508268', lat: '18.247872' },
        ],
      },
      {
        id: 2302,
        pid: 2291,
        name: '三沙市',
        code: '460300',
        lng: '112.34882',
        lat: '16.831039',
        children: [
          { id: 2303, pid: 2302, name: '西沙群岛', code: '460321', lng: '112.025528', lat: '16.331342' },
          { id: 2304, pid: 2302, name: '南沙群岛', code: '460322', lng: '116.749998', lat: '11.471888' },
          { id: 2305, pid: 2302, name: '中沙群岛', code: '460323', lng: '117.740071', lat: '15.112856' },
        ],
      },
      {
        id: 2306,
        pid: 2291,
        name: '直辖县级',
        code: '469000',
        lng: '109.503479',
        lat: '18.739906',
        children: [
          { id: 2307, pid: 2306, name: '五指山市', code: '469001', lng: '109.516662', lat: '18.776921' },
          { id: 2308, pid: 2306, name: '琼海市', code: '469002', lng: '110.466785', lat: '19.246011' },
          { id: 2309, pid: 2306, name: '儋州市', code: '469003', lng: '109.576782', lat: '19.517486' },
          { id: 2310, pid: 2306, name: '文昌市', code: '469005', lng: '110.753975', lat: '19.612986' },
          { id: 2311, pid: 2306, name: '万宁市', code: '469006', lng: '110.388793', lat: '18.796216' },
          { id: 2312, pid: 2306, name: '东方市', code: '469007', lng: '108.653789', lat: '19.10198' },
          { id: 2313, pid: 2306, name: '定安县', code: '469021', lng: '110.323959', lat: '19.699211' },
          { id: 2314, pid: 2306, name: '屯昌县', code: '469022', lng: '110.102773', lat: '19.362916' },
          { id: 2315, pid: 2306, name: '澄迈县', code: '469023', lng: '110.007147', lat: '19.737095' },
          { id: 2316, pid: 2306, name: '临高县', code: '469024', lng: '109.687697', lat: '19.908293' },
          { id: 2317, pid: 2306, name: '白沙黎族自治县', code: '469025', lng: '109.452606', lat: '19.224584' },
          { id: 2318, pid: 2306, name: '昌江黎族自治县', code: '469026', lng: '109.053351', lat: '19.260968' },
          { id: 2319, pid: 2306, name: '乐东黎族自治县', code: '469027', lng: '109.175444', lat: '18.74758' },
          { id: 2320, pid: 2306, name: '陵水黎族自治县', code: '469028', lng: '110.037218', lat: '18.505006' },
          { id: 2321, pid: 2306, name: '保亭黎族苗族自治县', code: '469029', lng: '109.70245', lat: '18.636371' },
          { id: 2322, pid: 2306, name: '琼中黎族苗族自治县', code: '469030', lng: '109.839996', lat: '19.03557' },
        ],
      },
    ],
  },
  {
    id: 2323,
    pid: 0,
    name: '重庆市',
    code: '500000',
    lng: '106.504962',
    lat: '29.533155',
    children: [
      {
        id: 2324,
        pid: 2323,
        name: '重庆市',
        code: '500100',
        lng: '106.504962',
        lat: '29.533155',
        children: [
          { id: 2325, pid: 2324, name: '万州区', code: '500101', lng: '108.40869', lat: '30.80788' },
          { id: 2326, pid: 2324, name: '涪陵区', code: '500102', lng: '107.39007', lat: '29.70292' },
          { id: 2327, pid: 2324, name: '渝中区', code: '500103', lng: '106.56901', lat: '29.55279' },
          { id: 2328, pid: 2324, name: '大渡口区', code: '500104', lng: '106.48262', lat: '29.48447' },
          { id: 2329, pid: 2324, name: '江北区', code: '500105', lng: '106.57434', lat: '29.60658' },
          { id: 2330, pid: 2324, name: '沙坪坝区', code: '500106', lng: '106.45752', lat: '29.54113' },
          { id: 2331, pid: 2324, name: '九龙坡区', code: '500107', lng: '106.51107', lat: '29.50197' },
          { id: 2332, pid: 2324, name: '南岸区', code: '500108', lng: '106.56347', lat: '29.52311' },
          { id: 2333, pid: 2324, name: '北碚区', code: '500109', lng: '106.39614', lat: '29.80574' },
          { id: 2334, pid: 2324, name: '綦江区', code: '500110', lng: '106.926779', lat: '28.960656' },
          { id: 2335, pid: 2324, name: '大足区', code: '500111', lng: '105.768121', lat: '29.484025' },
          { id: 2336, pid: 2324, name: '渝北区', code: '500112', lng: '106.6307', lat: '29.7182' },
          { id: 2337, pid: 2324, name: '巴南区', code: '500113', lng: '106.52365', lat: '29.38311' },
          { id: 2338, pid: 2324, name: '黔江区', code: '500114', lng: '108.7709', lat: '29.5332' },
          { id: 2339, pid: 2324, name: '长寿区', code: '500115', lng: '107.08166', lat: '29.85359' },
          { id: 2340, pid: 2324, name: '江津区', code: '500116', lng: '106.25912', lat: '29.29008' },
          { id: 2341, pid: 2324, name: '合川区', code: '500117', lng: '106.27633', lat: '29.97227' },
          { id: 2342, pid: 2324, name: '永川区', code: '500118', lng: '105.927', lat: '29.35593' },
          { id: 2343, pid: 2324, name: '南川区', code: '500119', lng: '107.09936', lat: '29.15751' },
          { id: 2344, pid: 2324, name: '璧山区', code: '500120', lng: '106.231126', lat: '29.593581' },
          { id: 2345, pid: 2324, name: '铜梁区', code: '500151', lng: '106.054948', lat: '29.839944' },
          { id: 2346, pid: 2324, name: '潼南县', code: '500223', lng: '105.84005', lat: '30.1912' },
          { id: 2347, pid: 2324, name: '荣昌县', code: '500226', lng: '105.59442', lat: '29.40488' },
          { id: 2348, pid: 2324, name: '梁平县', code: '500228', lng: '107.79998', lat: '30.67545' },
          { id: 2349, pid: 2324, name: '城口县', code: '500229', lng: '108.66513', lat: '31.94801' },
          { id: 2350, pid: 2324, name: '丰都县', code: '500230', lng: '107.73098', lat: '29.86348' },
          { id: 2351, pid: 2324, name: '垫江县', code: '500231', lng: '107.35446', lat: '30.33359' },
          { id: 2352, pid: 2324, name: '武隆县', code: '500232', lng: '107.7601', lat: '29.32548' },
          { id: 2353, pid: 2324, name: '忠县', code: '500233', lng: '108.03689', lat: '30.28898' },
          { id: 2354, pid: 2324, name: '开县', code: '500234', lng: '108.39306', lat: '31.16095' },
          { id: 2355, pid: 2324, name: '云阳县', code: '500235', lng: '108.69726', lat: '30.93062' },
          { id: 2356, pid: 2324, name: '奉节县', code: '500236', lng: '109.46478', lat: '31.01825' },
          { id: 2357, pid: 2324, name: '巫山县', code: '500237', lng: '109.87814', lat: '31.07458' },
          { id: 2358, pid: 2324, name: '巫溪县', code: '500238', lng: '109.63128', lat: '31.39756' },
          { id: 2359, pid: 2324, name: '石柱土家族自治县', code: '500240', lng: '108.11389', lat: '30.00054' },
          { id: 2360, pid: 2324, name: '秀山土家族苗族自治县', code: '500241', lng: '108.98861', lat: '28.45062' },
          { id: 2361, pid: 2324, name: '酉阳土家族苗族自治县', code: '500242', lng: '108.77212', lat: '28.8446' },
          { id: 2362, pid: 2324, name: '彭水苗族土家族自治县', code: '500243', lng: '108.16638', lat: '29.29516' },
        ],
      },
      {
        id: 2363,
        pid: 2323,
        name: '两江新区',
        code: '500300',
        lng: '106.463344',
        lat: '29.729153',
        children: [
          { id: 2364, pid: 2363, name: '北部新区', code: '500301', lng: '106.488841', lat: '29.667062' },
          { id: 2365, pid: 2363, name: '保税港区', code: '500302', lng: '106.638184', lat: '29.716311' },
          { id: 2366, pid: 2363, name: '工业园区', code: '500303', lng: '106.626434', lat: '29.55554' },
        ],
      },
    ],
  },
  {
    id: 2367,
    pid: 0,
    name: '四川省',
    code: '510000',
    lng: '104.065735',
    lat: '30.659462',
    children: [
      {
        id: 2368,
        pid: 2367,
        name: '成都市',
        code: '510100',
        lng: '104.065735',
        lat: '30.659462',
        children: [
          { id: 2369, pid: 2368, name: '锦江区', code: '510104', lng: '104.08347', lat: '30.65614' },
          { id: 2370, pid: 2368, name: '青羊区', code: '510105', lng: '104.06151', lat: '30.67387' },
          { id: 2371, pid: 2368, name: '金牛区', code: '510106', lng: '104.05114', lat: '30.69126' },
          { id: 2372, pid: 2368, name: '武侯区', code: '510107', lng: '104.04303', lat: '30.64235' },
          { id: 2373, pid: 2368, name: '成华区', code: '510108', lng: '104.10193', lat: '30.65993' },
          { id: 2374, pid: 2368, name: '龙泉驿区', code: '510112', lng: '104.27462', lat: '30.55658' },
          { id: 2375, pid: 2368, name: '青白江区', code: '510113', lng: '104.251', lat: '30.87841' },
          { id: 2376, pid: 2368, name: '新都区', code: '510114', lng: '104.15921', lat: '30.82314' },
          { id: 2377, pid: 2368, name: '温江区', code: '510115', lng: '103.84881', lat: '30.68444' },
          { id: 2378, pid: 2368, name: '金堂县', code: '510121', lng: '104.41195', lat: '30.86195' },
          { id: 2379, pid: 2368, name: '双流县', code: '510122', lng: '103.92373', lat: '30.57444' },
          { id: 2380, pid: 2368, name: '郫县', code: '510124', lng: '103.88717', lat: '30.81054' },
          { id: 2381, pid: 2368, name: '大邑县', code: '510129', lng: '103.52075', lat: '30.58738' },
          { id: 2382, pid: 2368, name: '蒲江县', code: '510131', lng: '103.50616', lat: '30.19667' },
          { id: 2383, pid: 2368, name: '新津县', code: '510132', lng: '103.8114', lat: '30.40983' },
          { id: 2384, pid: 2368, name: '都江堰市', code: '510181', lng: '103.61941', lat: '30.99825' },
          { id: 2385, pid: 2368, name: '彭州市', code: '510182', lng: '103.958', lat: '30.99011' },
          { id: 2386, pid: 2368, name: '邛崃市', code: '510183', lng: '103.46283', lat: '30.41489' },
          { id: 2387, pid: 2368, name: '崇州市', code: '510184', lng: '103.67285', lat: '30.63014' },
        ],
      },
      {
        id: 2388,
        pid: 2367,
        name: '自贡市',
        code: '510300',
        lng: '104.773447',
        lat: '29.352765',
        children: [
          { id: 2389, pid: 2388, name: '自流井区', code: '510302', lng: '104.77719', lat: '29.33745' },
          { id: 2390, pid: 2388, name: '贡井区', code: '510303', lng: '104.71536', lat: '29.34576' },
          { id: 2391, pid: 2388, name: '大安区', code: '510304', lng: '104.77383', lat: '29.36364' },
          { id: 2392, pid: 2388, name: '沿滩区', code: '510311', lng: '104.88012', lat: '29.26611' },
          { id: 2393, pid: 2388, name: '荣县', code: '510321', lng: '104.4176', lat: '29.44445' },
          { id: 2394, pid: 2388, name: '富顺县', code: '510322', lng: '104.97491', lat: '29.18123' },
        ],
      },
      {
        id: 2395,
        pid: 2367,
        name: '攀枝花市',
        code: '510400',
        lng: '101.716007',
        lat: '26.580446',
        children: [
          { id: 2396, pid: 2395, name: '东区', code: '510402', lng: '101.7052', lat: '26.54677' },
          { id: 2397, pid: 2395, name: '西区', code: '510403', lng: '101.63058', lat: '26.59753' },
          { id: 2398, pid: 2395, name: '仁和区', code: '510411', lng: '101.73812', lat: '26.49841' },
          { id: 2399, pid: 2395, name: '米易县', code: '510421', lng: '102.11132', lat: '26.88718' },
          { id: 2400, pid: 2395, name: '盐边县', code: '510422', lng: '101.85446', lat: '26.68847' },
        ],
      },
      {
        id: 2401,
        pid: 2367,
        name: '泸州市',
        code: '510500',
        lng: '105.443348',
        lat: '28.889138',
        children: [
          { id: 2402, pid: 2401, name: '江阳区', code: '510502', lng: '105.45336', lat: '28.88934' },
          { id: 2403, pid: 2401, name: '纳溪区', code: '510503', lng: '105.37255', lat: '28.77343' },
          { id: 2404, pid: 2401, name: '龙马潭区', code: '510504', lng: '105.43774', lat: '28.91308' },
          { id: 2405, pid: 2401, name: '泸县', code: '510521', lng: '105.38192', lat: '29.15041' },
          { id: 2406, pid: 2401, name: '合江县', code: '510522', lng: '105.8352', lat: '28.81005' },
          { id: 2407, pid: 2401, name: '叙永县', code: '510524', lng: '105.44473', lat: '28.15586' },
          { id: 2408, pid: 2401, name: '古蔺县', code: '510525', lng: '105.81347', lat: '28.03867' },
        ],
      },
      {
        id: 2409,
        pid: 2367,
        name: '德阳市',
        code: '510600',
        lng: '104.398651',
        lat: '31.127991',
        children: [
          { id: 2410, pid: 2409, name: '旌阳区', code: '510603', lng: '104.39367', lat: '31.13906' },
          { id: 2411, pid: 2409, name: '中江县', code: '510623', lng: '104.67861', lat: '31.03297' },
          { id: 2412, pid: 2409, name: '罗江县', code: '510626', lng: '104.51025', lat: '31.31665' },
          { id: 2413, pid: 2409, name: '广汉市', code: '510681', lng: '104.28234', lat: '30.97686' },
          { id: 2414, pid: 2409, name: '什邡市', code: '510682', lng: '104.16754', lat: '31.1264' },
          { id: 2415, pid: 2409, name: '绵竹市', code: '510683', lng: '104.22076', lat: '31.33772' },
        ],
      },
      {
        id: 2416,
        pid: 2367,
        name: '绵阳市',
        code: '510700',
        lng: '104.741722',
        lat: '31.46402',
        children: [
          { id: 2417, pid: 2416, name: '涪城区', code: '510703', lng: '104.75719', lat: '31.45522' },
          { id: 2418, pid: 2416, name: '游仙区', code: '510704', lng: '104.77092', lat: '31.46574' },
          { id: 2419, pid: 2416, name: '三台县', code: '510722', lng: '105.09079', lat: '31.09179' },
          { id: 2420, pid: 2416, name: '盐亭县', code: '510723', lng: '105.3898', lat: '31.22176' },
          { id: 2421, pid: 2416, name: '安县', code: '510724', lng: '104.56738', lat: '31.53487' },
          { id: 2422, pid: 2416, name: '梓潼县', code: '510725', lng: '105.16183', lat: '31.6359' },
          { id: 2423, pid: 2416, name: '北川羌族自治县', code: '510726', lng: '104.46408', lat: '31.83286' },
          { id: 2424, pid: 2416, name: '平武县', code: '510727', lng: '104.52862', lat: '32.40791' },
          { id: 2425, pid: 2416, name: '江油市', code: '510781', lng: '104.74539', lat: '31.77775' },
        ],
      },
      {
        id: 2426,
        pid: 2367,
        name: '广元市',
        code: '510800',
        lng: '105.829757',
        lat: '32.433668',
        children: [
          { id: 2427, pid: 2426, name: '利州区', code: '510802', lng: '105.826194', lat: '32.432276' },
          { id: 2428, pid: 2426, name: '昭化区', code: '510811', lng: '105.640491', lat: '32.386518' },
          { id: 2429, pid: 2426, name: '朝天区', code: '510812', lng: '105.89273', lat: '32.64398' },
          { id: 2430, pid: 2426, name: '旺苍县', code: '510821', lng: '106.29022', lat: '32.22845' },
          { id: 2431, pid: 2426, name: '青川县', code: '510822', lng: '105.2391', lat: '32.58563' },
          { id: 2432, pid: 2426, name: '剑阁县', code: '510823', lng: '105.5252', lat: '32.28845' },
          { id: 2433, pid: 2426, name: '苍溪县', code: '510824', lng: '105.936', lat: '31.73209' },
        ],
      },
      {
        id: 2434,
        pid: 2367,
        name: '遂宁市',
        code: '510900',
        lng: '105.571331',
        lat: '30.513311',
        children: [
          { id: 2435, pid: 2434, name: '船山区', code: '510903', lng: '105.5809', lat: '30.49991' },
          { id: 2436, pid: 2434, name: '安居区', code: '510904', lng: '105.46402', lat: '30.35778' },
          { id: 2437, pid: 2434, name: '蓬溪县', code: '510921', lng: '105.70752', lat: '30.75775' },
          { id: 2438, pid: 2434, name: '射洪县', code: '510922', lng: '105.38922', lat: '30.87203' },
          { id: 2439, pid: 2434, name: '大英县', code: '510923', lng: '105.24346', lat: '30.59434' },
        ],
      },
      {
        id: 2440,
        pid: 2367,
        name: '内江市',
        code: '511000',
        lng: '105.066138',
        lat: '29.58708',
        children: [
          { id: 2441, pid: 2440, name: '市中区', code: '511002', lng: '105.0679', lat: '29.58709' },
          { id: 2442, pid: 2440, name: '东兴区', code: '511011', lng: '105.07554', lat: '29.59278' },
          { id: 2443, pid: 2440, name: '威远县', code: '511024', lng: '104.66955', lat: '29.52823' },
          { id: 2444, pid: 2440, name: '资中县', code: '511025', lng: '104.85205', lat: '29.76409' },
          { id: 2445, pid: 2440, name: '隆昌县', code: '511028', lng: '105.28738', lat: '29.33937' },
        ],
      },
      {
        id: 2446,
        pid: 2367,
        name: '乐山市',
        code: '511100',
        lng: '103.761263',
        lat: '29.582024',
        children: [
          { id: 2447, pid: 2446, name: '市中区', code: '511102', lng: '103.76159', lat: '29.55543' },
          { id: 2448, pid: 2446, name: '沙湾区', code: '511111', lng: '103.54873', lat: '29.41194' },
          { id: 2449, pid: 2446, name: '五通桥区', code: '511112', lng: '103.82345', lat: '29.40344' },
          { id: 2450, pid: 2446, name: '金口河区', code: '511113', lng: '103.07858', lat: '29.24578' },
          { id: 2451, pid: 2446, name: '犍为县', code: '511123', lng: '103.94989', lat: '29.20973' },
          { id: 2452, pid: 2446, name: '井研县', code: '511124', lng: '104.07019', lat: '29.65228' },
          { id: 2453, pid: 2446, name: '夹江县', code: '511126', lng: '103.57199', lat: '29.73868' },
          { id: 2454, pid: 2446, name: '沐川县', code: '511129', lng: '103.90353', lat: '28.95646' },
          { id: 2455, pid: 2446, name: '峨边彝族自治县', code: '511132', lng: '103.26339', lat: '29.23004' },
          { id: 2456, pid: 2446, name: '马边彝族自治县', code: '511133', lng: '103.54617', lat: '28.83593' },
          { id: 2457, pid: 2446, name: '峨眉山市', code: '511181', lng: '103.4844', lat: '29.60117' },
        ],
      },
      {
        id: 2458,
        pid: 2367,
        name: '南充市',
        code: '511300',
        lng: '106.082974',
        lat: '30.795281',
        children: [
          { id: 2459, pid: 2458, name: '顺庆区', code: '511302', lng: '106.09216', lat: '30.79642' },
          { id: 2460, pid: 2458, name: '高坪区', code: '511303', lng: '106.11894', lat: '30.78162' },
          { id: 2461, pid: 2458, name: '嘉陵区', code: '511304', lng: '106.07141', lat: '30.75848' },
          { id: 2462, pid: 2458, name: '南部县', code: '511321', lng: '106.06738', lat: '31.35451' },
          { id: 2463, pid: 2458, name: '营山县', code: '511322', lng: '106.56637', lat: '31.07747' },
          { id: 2464, pid: 2458, name: '蓬安县', code: '511323', lng: '106.41262', lat: '31.02964' },
          { id: 2465, pid: 2458, name: '仪陇县', code: '511324', lng: '106.29974', lat: '31.27628' },
          { id: 2466, pid: 2458, name: '西充县', code: '511325', lng: '105.89996', lat: '30.9969' },
          { id: 2467, pid: 2458, name: '阆中市', code: '511381', lng: '106.00494', lat: '31.55832' },
        ],
      },
      {
        id: 2468,
        pid: 2367,
        name: '眉山市',
        code: '511400',
        lng: '103.831788',
        lat: '30.048318',
        children: [
          { id: 2469, pid: 2468, name: '东坡区', code: '511402', lng: '103.832', lat: '30.04219' },
          { id: 2470, pid: 2468, name: '彭山区', code: '511403', lng: '103.87268', lat: '30.19283' },
          { id: 2471, pid: 2468, name: '仁寿县', code: '511421', lng: '104.13412', lat: '29.99599' },
          { id: 2472, pid: 2468, name: '洪雅县', code: '511423', lng: '103.37313', lat: '29.90661' },
          { id: 2473, pid: 2468, name: '丹棱县', code: '511424', lng: '103.51339', lat: '30.01562' },
          { id: 2474, pid: 2468, name: '青神县', code: '511425', lng: '103.84771', lat: '29.83235' },
        ],
      },
      {
        id: 2475,
        pid: 2367,
        name: '宜宾市',
        code: '511500',
        lng: '104.630825',
        lat: '28.760189',
        children: [
          { id: 2476, pid: 2475, name: '翠屏区', code: '511502', lng: '104.61978', lat: '28.76566' },
          { id: 2477, pid: 2475, name: '南溪区', code: '511503', lng: '104.981133', lat: '28.839806' },
          { id: 2478, pid: 2475, name: '宜宾县', code: '511521', lng: '104.53314', lat: '28.68996' },
          { id: 2479, pid: 2475, name: '江安县', code: '511523', lng: '105.06683', lat: '28.72385' },
          { id: 2480, pid: 2475, name: '长宁县', code: '511524', lng: '104.9252', lat: '28.57777' },
          { id: 2481, pid: 2475, name: '高县', code: '511525', lng: '104.51754', lat: '28.43619' },
          { id: 2482, pid: 2475, name: '珙县', code: '511526', lng: '104.71398', lat: '28.44512' },
          { id: 2483, pid: 2475, name: '筠连县', code: '511527', lng: '104.51217', lat: '28.16495' },
          { id: 2484, pid: 2475, name: '兴文县', code: '511528', lng: '105.23675', lat: '28.3044' },
          { id: 2485, pid: 2475, name: '屏山县', code: '511529', lng: '104.16293', lat: '28.64369' },
        ],
      },
      {
        id: 2486,
        pid: 2367,
        name: '广安市',
        code: '511600',
        lng: '106.633369',
        lat: '30.456398',
        children: [
          { id: 2487, pid: 2486, name: '广安区', code: '511602', lng: '106.64163', lat: '30.47389' },
          { id: 2488, pid: 2486, name: '前锋区', code: '511603', lng: '106.893537', lat: '30.494572' },
          { id: 2489, pid: 2486, name: '岳池县', code: '511621', lng: '106.44079', lat: '30.53918' },
          { id: 2490, pid: 2486, name: '武胜县', code: '511622', lng: '106.29592', lat: '30.34932' },
          { id: 2491, pid: 2486, name: '邻水县', code: '511623', lng: '106.92968', lat: '30.33449' },
          { id: 2492, pid: 2486, name: '华蓥市', code: '511681', lng: '106.78466', lat: '30.39007' },
        ],
      },
      {
        id: 2493,
        pid: 2367,
        name: '达州市',
        code: '511700',
        lng: '107.502262',
        lat: '31.209484',
        children: [
          { id: 2494, pid: 2493, name: '通川区', code: '511702', lng: '107.50456', lat: '31.21469' },
          { id: 2495, pid: 2493, name: '达川区', code: '511703', lng: '107.502262', lat: '31.209484' },
          { id: 2496, pid: 2493, name: '宣汉县', code: '511722', lng: '107.72775', lat: '31.35516' },
          { id: 2497, pid: 2493, name: '开江县', code: '511723', lng: '107.86889', lat: '31.0841' },
          { id: 2498, pid: 2493, name: '大竹县', code: '511724', lng: '107.20855', lat: '30.74147' },
          { id: 2499, pid: 2493, name: '渠县', code: '511725', lng: '106.97381', lat: '30.8376' },
          { id: 2500, pid: 2493, name: '万源市', code: '511781', lng: '108.03598', lat: '32.08091' },
        ],
      },
      {
        id: 2501,
        pid: 2367,
        name: '雅安市',
        code: '511800',
        lng: '103.001033',
        lat: '29.987722',
        children: [
          { id: 2502, pid: 2501, name: '雨城区', code: '511802', lng: '103.03305', lat: '30.00531' },
          { id: 2503, pid: 2501, name: '名山区', code: '511803', lng: '103.112214', lat: '30.084718' },
          { id: 2504, pid: 2501, name: '荥经县', code: '511822', lng: '102.84652', lat: '29.79402' },
          { id: 2505, pid: 2501, name: '汉源县', code: '511823', lng: '102.6784', lat: '29.35168' },
          { id: 2506, pid: 2501, name: '石棉县', code: '511824', lng: '102.35943', lat: '29.22796' },
          { id: 2507, pid: 2501, name: '天全县', code: '511825', lng: '102.75906', lat: '30.06754' },
          { id: 2508, pid: 2501, name: '芦山县', code: '511826', lng: '102.92791', lat: '30.14369' },
          { id: 2509, pid: 2501, name: '宝兴县', code: '511827', lng: '102.81555', lat: '30.36836' },
        ],
      },
      {
        id: 2510,
        pid: 2367,
        name: '巴中市',
        code: '511900',
        lng: '106.753669',
        lat: '31.858809',
        children: [
          { id: 2511, pid: 2510, name: '巴州区', code: '511902', lng: '106.76889', lat: '31.85125' },
          { id: 2512, pid: 2510, name: '恩阳区', code: '511903', lng: '106.753669', lat: '31.858809' },
          { id: 2513, pid: 2510, name: '通江县', code: '511921', lng: '107.24398', lat: '31.91294' },
          { id: 2514, pid: 2510, name: '南江县', code: '511922', lng: '106.84164', lat: '32.35335' },
          { id: 2515, pid: 2510, name: '平昌县', code: '511923', lng: '107.10424', lat: '31.5594' },
        ],
      },
      {
        id: 2516,
        pid: 2367,
        name: '资阳市',
        code: '512000',
        lng: '104.641917',
        lat: '30.122211',
        children: [
          { id: 2517, pid: 2516, name: '雁江区', code: '512002', lng: '104.65216', lat: '30.11525' },
          { id: 2518, pid: 2516, name: '安岳县', code: '512021', lng: '105.3363', lat: '30.09786' },
          { id: 2519, pid: 2516, name: '乐至县', code: '512022', lng: '105.03207', lat: '30.27227' },
          { id: 2520, pid: 2516, name: '简阳市', code: '512081', lng: '104.54864', lat: '30.3904' },
        ],
      },
      {
        id: 2521,
        pid: 2367,
        name: '阿坝藏族羌族自治州',
        code: '513200',
        lng: '102.221374',
        lat: '31.899792',
        children: [
          { id: 2522, pid: 2521, name: '汶川县', code: '513221', lng: '103.59079', lat: '31.47326' },
          { id: 2523, pid: 2521, name: '理县', code: '513222', lng: '103.17175', lat: '31.43603' },
          { id: 2524, pid: 2521, name: '茂县', code: '513223', lng: '103.85372', lat: '31.682' },
          { id: 2525, pid: 2521, name: '松潘县', code: '513224', lng: '103.59924', lat: '32.63871' },
          { id: 2526, pid: 2521, name: '九寨沟县', code: '513225', lng: '104.23672', lat: '33.26318' },
          { id: 2527, pid: 2521, name: '金川县', code: '513226', lng: '102.06555', lat: '31.47623' },
          { id: 2528, pid: 2521, name: '小金县', code: '513227', lng: '102.36499', lat: '30.99934' },
          { id: 2529, pid: 2521, name: '黑水县', code: '513228', lng: '102.99176', lat: '32.06184' },
          { id: 2530, pid: 2521, name: '马尔康县', code: '513229', lng: '102.20625', lat: '31.90584' },
          { id: 2531, pid: 2521, name: '壤塘县', code: '513230', lng: '100.9783', lat: '32.26578' },
          { id: 2532, pid: 2521, name: '阿坝县', code: '513231', lng: '101.70632', lat: '32.90301' },
          { id: 2533, pid: 2521, name: '若尔盖县', code: '513232', lng: '102.9598', lat: '33.57432' },
          { id: 2534, pid: 2521, name: '红原县', code: '513233', lng: '102.54525', lat: '32.78989' },
        ],
      },
      {
        id: 2535,
        pid: 2367,
        name: '甘孜藏族自治州',
        code: '513300',
        lng: '101.963815',
        lat: '30.050663',
        children: [
          { id: 2536, pid: 2535, name: '康定县', code: '513321', lng: '101.96487', lat: '30.05532' },
          { id: 2537, pid: 2535, name: '泸定县', code: '513322', lng: '102.23507', lat: '29.91475' },
          { id: 2538, pid: 2535, name: '丹巴县', code: '513323', lng: '101.88424', lat: '30.87656' },
          { id: 2539, pid: 2535, name: '九龙县', code: '513324', lng: '101.50848', lat: '29.00091' },
          { id: 2540, pid: 2535, name: '雅江县', code: '513325', lng: '101.01492', lat: '30.03281' },
          { id: 2541, pid: 2535, name: '道孚县', code: '513326', lng: '101.12554', lat: '30.98046' },
          { id: 2542, pid: 2535, name: '炉霍县', code: '513327', lng: '100.67681', lat: '31.3917' },
          { id: 2543, pid: 2535, name: '甘孜县', code: '513328', lng: '99.99307', lat: '31.62672' },
          { id: 2544, pid: 2535, name: '新龙县', code: '513329', lng: '100.3125', lat: '30.94067' },
          { id: 2545, pid: 2535, name: '德格县', code: '513330', lng: '98.58078', lat: '31.80615' },
          { id: 2546, pid: 2535, name: '白玉县', code: '513331', lng: '98.82568', lat: '31.20902' },
          { id: 2547, pid: 2535, name: '石渠县', code: '513332', lng: '98.10156', lat: '32.97884' },
          { id: 2548, pid: 2535, name: '色达县', code: '513333', lng: '100.33224', lat: '32.26839' },
          { id: 2549, pid: 2535, name: '理塘县', code: '513334', lng: '100.27005', lat: '29.99674' },
          { id: 2550, pid: 2535, name: '巴塘县', code: '513335', lng: '99.10409', lat: '30.00423' },
          { id: 2551, pid: 2535, name: '乡城县', code: '513336', lng: '99.79943', lat: '28.93554' },
          { id: 2552, pid: 2535, name: '稻城县', code: '513337', lng: '100.29809', lat: '29.0379' },
          { id: 2553, pid: 2535, name: '得荣县', code: '513338', lng: '99.28628', lat: '28.71297' },
        ],
      },
      {
        id: 2554,
        pid: 2367,
        name: '凉山彝族自治州',
        code: '513400',
        lng: '102.258746',
        lat: '27.886762',
        children: [
          { id: 2555, pid: 2554, name: '西昌市', code: '513401', lng: '102.26413', lat: '27.89524' },
          { id: 2556, pid: 2554, name: '木里藏族自治县', code: '513422', lng: '101.2796', lat: '27.92875' },
          { id: 2557, pid: 2554, name: '盐源县', code: '513423', lng: '101.5097', lat: '27.42177' },
          { id: 2558, pid: 2554, name: '德昌县', code: '513424', lng: '102.18017', lat: '27.40482' },
          { id: 2559, pid: 2554, name: '会理县', code: '513425', lng: '102.24539', lat: '26.65627' },
          { id: 2560, pid: 2554, name: '会东县', code: '513426', lng: '102.57815', lat: '26.63429' },
          { id: 2561, pid: 2554, name: '宁南县', code: '513427', lng: '102.76116', lat: '27.06567' },
          { id: 2562, pid: 2554, name: '普格县', code: '513428', lng: '102.54055', lat: '27.37485' },
          { id: 2563, pid: 2554, name: '布拖县', code: '513429', lng: '102.81234', lat: '27.7079' },
          { id: 2564, pid: 2554, name: '金阳县', code: '513430', lng: '103.24774', lat: '27.69698' },
          { id: 2565, pid: 2554, name: '昭觉县', code: '513431', lng: '102.84661', lat: '28.01155' },
          { id: 2566, pid: 2554, name: '喜德县', code: '513432', lng: '102.41336', lat: '28.30739' },
          { id: 2567, pid: 2554, name: '冕宁县', code: '513433', lng: '102.17108', lat: '28.55161' },
          { id: 2568, pid: 2554, name: '越西县', code: '513434', lng: '102.5079', lat: '28.64133' },
          { id: 2569, pid: 2554, name: '甘洛县', code: '513435', lng: '102.77154', lat: '28.96624' },
          { id: 2570, pid: 2554, name: '美姑县', code: '513436', lng: '103.13116', lat: '28.32596' },
          { id: 2571, pid: 2554, name: '雷波县', code: '513437', lng: '103.57287', lat: '28.26407' },
        ],
      },
    ],
  },
  {
    id: 2572,
    pid: 0,
    name: '贵州省',
    code: '520000',
    lng: '106.713478',
    lat: '26.578343',
    children: [
      {
        id: 2573,
        pid: 2572,
        name: '贵阳市',
        code: '520100',
        lng: '106.713478',
        lat: '26.578343',
        children: [
          { id: 2574, pid: 2573, name: '南明区', code: '520102', lng: '106.7145', lat: '26.56819' },
          { id: 2575, pid: 2573, name: '云岩区', code: '520103', lng: '106.72485', lat: '26.60484' },
          { id: 2576, pid: 2573, name: '花溪区', code: '520111', lng: '106.67688', lat: '26.43343' },
          { id: 2577, pid: 2573, name: '乌当区', code: '520112', lng: '106.7521', lat: '26.6302' },
          { id: 2578, pid: 2573, name: '白云区', code: '520113', lng: '106.63088', lat: '26.68284' },
          { id: 2579, pid: 2573, name: '观山湖区', code: '520115', lng: '106.625442', lat: '26.618209' },
          { id: 2580, pid: 2573, name: '开阳县', code: '520121', lng: '106.9692', lat: '27.05533' },
          { id: 2581, pid: 2573, name: '息烽县', code: '520122', lng: '106.738', lat: '27.09346' },
          { id: 2582, pid: 2573, name: '修文县', code: '520123', lng: '106.59487', lat: '26.83783' },
          { id: 2583, pid: 2573, name: '清镇市', code: '520181', lng: '106.46862', lat: '26.55261' },
        ],
      },
      {
        id: 2584,
        pid: 2572,
        name: '六盘水市',
        code: '520200',
        lng: '104.846743',
        lat: '26.584643',
        children: [
          { id: 2585, pid: 2584, name: '钟山区', code: '520201', lng: '104.87848', lat: '26.57699' },
          { id: 2586, pid: 2584, name: '六枝特区', code: '520203', lng: '105.48062', lat: '26.20117' },
          { id: 2587, pid: 2584, name: '水城县', code: '520221', lng: '104.95764', lat: '26.54785' },
          { id: 2588, pid: 2584, name: '盘县', code: '520222', lng: '104.47061', lat: '25.7136' },
        ],
      },
      {
        id: 2589,
        pid: 2572,
        name: '遵义市',
        code: '520300',
        lng: '106.937265',
        lat: '27.706626',
        children: [
          { id: 2590, pid: 2589, name: '红花岗区', code: '520302', lng: '106.89404', lat: '27.64471' },
          { id: 2591, pid: 2589, name: '汇川区', code: '520303', lng: '106.9393', lat: '27.70625' },
          { id: 2592, pid: 2589, name: '遵义县', code: '520321', lng: '106.83331', lat: '27.53772' },
          { id: 2593, pid: 2589, name: '桐梓县', code: '520322', lng: '106.82568', lat: '28.13806' },
          { id: 2594, pid: 2589, name: '绥阳县', code: '520323', lng: '107.19064', lat: '27.94702' },
          { id: 2595, pid: 2589, name: '正安县', code: '520324', lng: '107.44357', lat: '28.5512' },
          { id: 2596, pid: 2589, name: '道真仡佬族苗族自治县', code: '520325', lng: '107.61152', lat: '28.864' },
          { id: 2597, pid: 2589, name: '务川仡佬族苗族自治县', code: '520326', lng: '107.88935', lat: '28.52227' },
          { id: 2598, pid: 2589, name: '凤冈县', code: '520327', lng: '107.71682', lat: '27.95461' },
          { id: 2599, pid: 2589, name: '湄潭县', code: '520328', lng: '107.48779', lat: '27.76676' },
          { id: 2600, pid: 2589, name: '余庆县', code: '520329', lng: '107.88821', lat: '27.22532' },
          { id: 2601, pid: 2589, name: '习水县', code: '520330', lng: '106.21267', lat: '28.31976' },
          { id: 2602, pid: 2589, name: '赤水市', code: '520381', lng: '105.69845', lat: '28.58921' },
          { id: 2603, pid: 2589, name: '仁怀市', code: '520382', lng: '106.40152', lat: '27.79231' },
        ],
      },
      {
        id: 2604,
        pid: 2572,
        name: '安顺市',
        code: '520400',
        lng: '105.932188',
        lat: '26.245544',
        children: [
          { id: 2605, pid: 2604, name: '西秀区', code: '520402', lng: '105.96585', lat: '26.24491' },
          { id: 2606, pid: 2604, name: '平坝区', code: '520421', lng: '106.25683', lat: '26.40543' },
          { id: 2607, pid: 2604, name: '普定县', code: '520422', lng: '105.74285', lat: '26.30141' },
          { id: 2608, pid: 2604, name: '镇宁布依族苗族自治县', code: '520423', lng: '105.76513', lat: '26.05533' },
          { id: 2609, pid: 2604, name: '关岭布依族苗族自治县', code: '520424', lng: '105.61883', lat: '25.94248' },
          { id: 2610, pid: 2604, name: '紫云苗族布依族自治县', code: '520425', lng: '106.08364', lat: '25.75258' },
        ],
      },
      {
        id: 2611,
        pid: 2572,
        name: '毕节市',
        code: '520500',
        lng: '105.28501',
        lat: '27.301693',
        children: [
          { id: 2612, pid: 2611, name: '七星关区', code: '520502', lng: '104.9497', lat: '27.153556' },
          { id: 2613, pid: 2611, name: '大方县', code: '520521', lng: '105.609254', lat: '27.143521' },
          { id: 2614, pid: 2611, name: '黔西县', code: '520522', lng: '106.038299', lat: '27.024923' },
          { id: 2615, pid: 2611, name: '金沙县', code: '520523', lng: '106.222103', lat: '27.459693' },
          { id: 2616, pid: 2611, name: '织金县', code: '520524', lng: '105.768997', lat: '26.668497' },
          { id: 2617, pid: 2611, name: '纳雍县', code: '520525', lng: '105.375322', lat: '26.769875' },
          { id: 2618, pid: 2611, name: '威宁彝族回族苗族自治县', code: '520526', lng: '104.286523', lat: '26.859099' },
          { id: 2619, pid: 2611, name: '赫章县', code: '520527', lng: '104.726438', lat: '27.119243' },
        ],
      },
      {
        id: 2620,
        pid: 2572,
        name: '铜仁市',
        code: '520600',
        lng: '109.191555',
        lat: '27.718346',
        children: [
          { id: 2621, pid: 2620, name: '碧江区', code: '520602', lng: '109.191555', lat: '27.718346' },
          { id: 2622, pid: 2620, name: '万山区', code: '520603', lng: '109.21199', lat: '27.51903' },
          { id: 2623, pid: 2620, name: '江口县', code: '520621', lng: '108.848427', lat: '27.691904' },
          { id: 2624, pid: 2620, name: '玉屏侗族自治县', code: '520622', lng: '108.917882', lat: '27.238024' },
          { id: 2625, pid: 2620, name: '石阡县', code: '520623', lng: '108.229854', lat: '27.519386' },
          { id: 2626, pid: 2620, name: '思南县', code: '520624', lng: '108.255827', lat: '27.941331' },
          { id: 2627, pid: 2620, name: '印江土家族苗族自治县', code: '520625', lng: '108.405517', lat: '27.997976' },
          { id: 2628, pid: 2620, name: '德江县', code: '520626', lng: '108.117317', lat: '28.26094' },
          { id: 2629, pid: 2620, name: '沿河土家族自治县', code: '520627', lng: '108.495746', lat: '28.560487' },
          { id: 2630, pid: 2620, name: '松桃苗族自治县', code: '520628', lng: '109.202627', lat: '28.165419' },
        ],
      },
      {
        id: 2631,
        pid: 2572,
        name: '黔西南布依族苗族自治州',
        code: '522300',
        lng: '104.897971',
        lat: '25.08812',
        children: [
          { id: 2632, pid: 2631, name: '兴义市 ', code: '522301', lng: '104.89548', lat: '25.09205' },
          { id: 2633, pid: 2631, name: '兴仁县', code: '522322', lng: '105.18652', lat: '25.43282' },
          { id: 2634, pid: 2631, name: '普安县', code: '522323', lng: '104.95529', lat: '25.78603' },
          { id: 2635, pid: 2631, name: '晴隆县', code: '522324', lng: '105.2192', lat: '25.83522' },
          { id: 2636, pid: 2631, name: '贞丰县', code: '522325', lng: '105.65454', lat: '25.38464' },
          { id: 2637, pid: 2631, name: '望谟县', code: '522326', lng: '106.09957', lat: '25.17822' },
          { id: 2638, pid: 2631, name: '册亨县', code: '522327', lng: '105.8124', lat: '24.98376' },
          { id: 2639, pid: 2631, name: '安龙县', code: '522328', lng: '105.44268', lat: '25.09818' },
        ],
      },
      {
        id: 2640,
        pid: 2572,
        name: '黔东南苗族侗族自治州',
        code: '522600',
        lng: '107.977488',
        lat: '26.583352',
        children: [
          { id: 2641, pid: 2640, name: '凯里市', code: '522601', lng: '107.98132', lat: '26.56689' },
          { id: 2642, pid: 2640, name: '黄平县', code: '522622', lng: '107.90179', lat: '26.89573' },
          { id: 2643, pid: 2640, name: '施秉县', code: '522623', lng: '108.12597', lat: '27.03495' },
          { id: 2644, pid: 2640, name: '三穗县', code: '522624', lng: '108.67132', lat: '26.94765' },
          { id: 2645, pid: 2640, name: '镇远县', code: '522625', lng: '108.42721', lat: '27.04933' },
          { id: 2646, pid: 2640, name: '岑巩县', code: '522626', lng: '108.81884', lat: '27.17539' },
          { id: 2647, pid: 2640, name: '天柱县', code: '522627', lng: '109.20718', lat: '26.90781' },
          { id: 2648, pid: 2640, name: '锦屏县', code: '522628', lng: '109.19982', lat: '26.67635' },
          { id: 2649, pid: 2640, name: '剑河县', code: '522629', lng: '108.5913', lat: '26.6525' },
          { id: 2650, pid: 2640, name: '台江县', code: '522630', lng: '108.31814', lat: '26.66916' },
          { id: 2651, pid: 2640, name: '黎平县', code: '522631', lng: '109.13607', lat: '26.23114' },
          { id: 2652, pid: 2640, name: '榕江县', code: '522632', lng: '108.52072', lat: '25.92421' },
          { id: 2653, pid: 2640, name: '从江县', code: '522633', lng: '108.90527', lat: '25.75415' },
          { id: 2654, pid: 2640, name: '雷山县', code: '522634', lng: '108.07745', lat: '26.38385' },
          { id: 2655, pid: 2640, name: '麻江县', code: '522635', lng: '107.59155', lat: '26.49235' },
          { id: 2656, pid: 2640, name: '丹寨县', code: '522636', lng: '107.79718', lat: '26.19816' },
        ],
      },
      {
        id: 2657,
        pid: 2572,
        name: '黔南布依族苗族自治州',
        code: '522700',
        lng: '107.517156',
        lat: '26.258219',
        children: [
          { id: 2658, pid: 2657, name: '都匀市', code: '522701', lng: '107.51872', lat: '26.2594' },
          { id: 2659, pid: 2657, name: '福泉市', code: '522702', lng: '107.51715', lat: '26.67989' },
          { id: 2660, pid: 2657, name: '荔波县', code: '522722', lng: '107.88592', lat: '25.4139' },
          { id: 2661, pid: 2657, name: '贵定县', code: '522723', lng: '107.23654', lat: '26.57812' },
          { id: 2662, pid: 2657, name: '瓮安县', code: '522725', lng: '107.4757', lat: '27.06813' },
          { id: 2663, pid: 2657, name: '独山县', code: '522726', lng: '107.54101', lat: '25.8245' },
          { id: 2664, pid: 2657, name: '平塘县', code: '522727', lng: '107.32428', lat: '25.83294' },
          { id: 2665, pid: 2657, name: '罗甸县', code: '522728', lng: '106.75186', lat: '25.42586' },
          { id: 2666, pid: 2657, name: '长顺县', code: '522729', lng: '106.45217', lat: '26.02299' },
          { id: 2667, pid: 2657, name: '龙里县', code: '522730', lng: '106.97662', lat: '26.45076' },
          { id: 2668, pid: 2657, name: '惠水县', code: '522731', lng: '106.65911', lat: '26.13389' },
          { id: 2669, pid: 2657, name: '三都水族自治县', code: '522732', lng: '107.87464', lat: '25.98562' },
        ],
      },
    ],
  },
  {
    id: 2670,
    pid: 0,
    name: '云南省',
    code: '530000',
    lng: '102.712251',
    lat: '25.040609',
    children: [
      {
        id: 2671,
        pid: 2670,
        name: '昆明市',
        code: '530100',
        lng: '102.712251',
        lat: '25.040609',
        children: [
          { id: 2672, pid: 2671, name: '五华区', code: '530102', lng: '102.70786', lat: '25.03521' },
          { id: 2673, pid: 2671, name: '盘龙区', code: '530103', lng: '102.71994', lat: '25.04053' },
          { id: 2674, pid: 2671, name: '官渡区', code: '530111', lng: '102.74362', lat: '25.01497' },
          { id: 2675, pid: 2671, name: '西山区', code: '530112', lng: '102.66464', lat: '25.03796' },
          { id: 2676, pid: 2671, name: '东川区', code: '530113', lng: '103.18832', lat: '26.083' },
          { id: 2677, pid: 2671, name: '呈贡区', code: '530114', lng: '102.801382', lat: '24.889275' },
          { id: 2678, pid: 2671, name: '晋宁县', code: '530122', lng: '102.59393', lat: '24.6665' },
          { id: 2679, pid: 2671, name: '富民县', code: '530124', lng: '102.4985', lat: '25.22119' },
          { id: 2680, pid: 2671, name: '宜良县', code: '530125', lng: '103.14117', lat: '24.91705' },
          { id: 2681, pid: 2671, name: '石林彝族自治县', code: '530126', lng: '103.27148', lat: '24.75897' },
          { id: 2682, pid: 2671, name: '嵩明县', code: '530127', lng: '103.03729', lat: '25.33986' },
          { id: 2683, pid: 2671, name: '禄劝彝族苗族自治县', code: '530128', lng: '102.4671', lat: '25.55387' },
          { id: 2684, pid: 2671, name: '寻甸回族彝族自治县 ', code: '530129', lng: '103.2557', lat: '25.55961' },
          { id: 2685, pid: 2671, name: '安宁市', code: '530181', lng: '102.46972', lat: '24.91652' },
        ],
      },
      {
        id: 2686,
        pid: 2670,
        name: '曲靖市',
        code: '530300',
        lng: '103.797851',
        lat: '25.501557',
        children: [
          { id: 2687, pid: 2686, name: '麒麟区', code: '530302', lng: '103.80504', lat: '25.49515' },
          { id: 2688, pid: 2686, name: '马龙县', code: '530321', lng: '103.57873', lat: '25.42521' },
          { id: 2689, pid: 2686, name: '陆良县', code: '530322', lng: '103.6665', lat: '25.02335' },
          { id: 2690, pid: 2686, name: '师宗县', code: '530323', lng: '103.99084', lat: '24.82822' },
          { id: 2691, pid: 2686, name: '罗平县', code: '530324', lng: '104.30859', lat: '24.88444' },
          { id: 2692, pid: 2686, name: '富源县', code: '530325', lng: '104.25387', lat: '25.66587' },
          { id: 2693, pid: 2686, name: '会泽县', code: '530326', lng: '103.30017', lat: '26.41076' },
          { id: 2694, pid: 2686, name: '沾益县', code: '530328', lng: '103.82135', lat: '25.60715' },
          { id: 2695, pid: 2686, name: '宣威市', code: '530381', lng: '104.10409', lat: '26.2173' },
        ],
      },
      {
        id: 2696,
        pid: 2670,
        name: '玉溪市',
        code: '530400',
        lng: '102.543907',
        lat: '24.350461',
        children: [
          { id: 2697, pid: 2696, name: '红塔区', code: '530402', lng: '102.5449', lat: '24.35411' },
          { id: 2698, pid: 2696, name: '江川县', code: '530421', lng: '102.75412', lat: '24.28863' },
          { id: 2699, pid: 2696, name: '澄江县', code: '530422', lng: '102.90817', lat: '24.67376' },
          { id: 2700, pid: 2696, name: '通海县', code: '530423', lng: '102.76641', lat: '24.11362' },
          { id: 2701, pid: 2696, name: '华宁县', code: '530424', lng: '102.92831', lat: '24.1926' },
          { id: 2702, pid: 2696, name: '易门县', code: '530425', lng: '102.16354', lat: '24.67122' },
          { id: 2703, pid: 2696, name: '峨山彝族自治县', code: '530426', lng: '102.40576', lat: '24.16904' },
          { id: 2704, pid: 2696, name: '新平彝族傣族自治县', code: '530427', lng: '101.98895', lat: '24.06886' },
          { id: 2705, pid: 2696, name: '元江哈尼族彝族傣族自治县', code: '530428', lng: '101.99812', lat: '23.59655' },
        ],
      },
      {
        id: 2706,
        pid: 2670,
        name: '保山市',
        code: '530500',
        lng: '99.167133',
        lat: '25.111802',
        children: [
          { id: 2707, pid: 2706, name: '隆阳区', code: '530502', lng: '99.16334', lat: '25.11163' },
          { id: 2708, pid: 2706, name: '施甸县', code: '530521', lng: '99.18768', lat: '24.72418' },
          { id: 2709, pid: 2706, name: '腾冲县', code: '530522', lng: '98.49414', lat: '25.02539' },
          { id: 2710, pid: 2706, name: '龙陵县', code: '530523', lng: '98.69024', lat: '24.58746' },
          { id: 2711, pid: 2706, name: '昌宁县', code: '530524', lng: '99.6036', lat: '24.82763' },
        ],
      },
      {
        id: 2712,
        pid: 2670,
        name: '昭通市',
        code: '530600',
        lng: '103.717216',
        lat: '27.336999',
        children: [
          { id: 2713, pid: 2712, name: '昭阳区', code: '530602', lng: '103.70654', lat: '27.31998' },
          { id: 2714, pid: 2712, name: '鲁甸县', code: '530621', lng: '103.54721', lat: '27.19238' },
          { id: 2715, pid: 2712, name: '巧家县', code: '530622', lng: '102.92416', lat: '26.91237' },
          { id: 2716, pid: 2712, name: '盐津县', code: '530623', lng: '104.23461', lat: '28.10856' },
          { id: 2717, pid: 2712, name: '大关县', code: '530624', lng: '103.89254', lat: '27.7488' },
          { id: 2718, pid: 2712, name: '永善县', code: '530625', lng: '103.63504', lat: '28.2279' },
          { id: 2719, pid: 2712, name: '绥江县', code: '530626', lng: '103.94937', lat: '28.59661' },
          { id: 2720, pid: 2712, name: '镇雄县', code: '530627', lng: '104.87258', lat: '27.43981' },
          { id: 2721, pid: 2712, name: '彝良县', code: '530628', lng: '104.04983', lat: '27.62809' },
          { id: 2722, pid: 2712, name: '威信县', code: '530629', lng: '105.04754', lat: '27.84065' },
          { id: 2723, pid: 2712, name: '水富县', code: '530630', lng: '104.4158', lat: '28.62986' },
        ],
      },
      {
        id: 2724,
        pid: 2670,
        name: '丽江市',
        code: '530700',
        lng: '100.233026',
        lat: '26.872108',
        children: [
          { id: 2725, pid: 2724, name: '古城区', code: '530702', lng: '100.2257', lat: '26.87697' },
          { id: 2726, pid: 2724, name: '玉龙纳西族自治县', code: '530721', lng: '100.2369', lat: '26.82149' },
          { id: 2727, pid: 2724, name: '永胜县', code: '530722', lng: '100.74667', lat: '26.68591' },
          { id: 2728, pid: 2724, name: '华坪县', code: '530723', lng: '101.26562', lat: '26.62967' },
          { id: 2729, pid: 2724, name: '宁蒗彝族自治县', code: '530724', lng: '100.8507', lat: '27.28179' },
        ],
      },
      {
        id: 2730,
        pid: 2670,
        name: '普洱市',
        code: '530800',
        lng: '100.972344',
        lat: '22.777321',
        children: [
          { id: 2731, pid: 2730, name: '思茅区', code: '530802', lng: '100.97716', lat: '22.78691' },
          { id: 2732, pid: 2730, name: '宁洱哈尼族彝族自治县', code: '530821', lng: '101.04653', lat: '23.06341' },
          { id: 2733, pid: 2730, name: '墨江哈尼族自治县', code: '530822', lng: '101.69171', lat: '23.43214' },
          { id: 2734, pid: 2730, name: '景东彝族自治县', code: '530823', lng: '100.83599', lat: '24.44791' },
          { id: 2735, pid: 2730, name: '景谷傣族彝族自治县', code: '530824', lng: '100.70251', lat: '23.49705' },
          {
            id: 2736,
            pid: 2730,
            name: '镇沅彝族哈尼族拉祜族自治县',
            code: '530825',
            lng: '101.10675',
            lat: '24.00557',
          },
          { id: 2737, pid: 2730, name: '江城哈尼族彝族自治县', code: '530826', lng: '101.85788', lat: '22.58424' },
          { id: 2738, pid: 2730, name: '孟连傣族拉祜族佤族自治县', code: '530827', lng: '99.58424', lat: '22.32922' },
          { id: 2739, pid: 2730, name: '澜沧拉祜族自治县', code: '530828', lng: '99.93591', lat: '22.55474' },
          { id: 2740, pid: 2730, name: '西盟佤族自治县', code: '530829', lng: '99.59869', lat: '22.64774' },
        ],
      },
      {
        id: 2741,
        pid: 2670,
        name: '临沧市',
        code: '530900',
        lng: '100.08697',
        lat: '23.886567',
        children: [
          { id: 2742, pid: 2741, name: '临翔区', code: '530902', lng: '100.08242', lat: '23.89497' },
          { id: 2743, pid: 2741, name: '凤庆县', code: '530921', lng: '99.92837', lat: '24.58034' },
          { id: 2744, pid: 2741, name: '云县', code: '530922', lng: '100.12808', lat: '24.44675' },
          { id: 2745, pid: 2741, name: '永德县', code: '530923', lng: '99.25326', lat: '24.0276' },
          { id: 2746, pid: 2741, name: '镇康县', code: '530924', lng: '98.8255', lat: '23.76241' },
          {
            id: 2747,
            pid: 2741,
            name: '双江拉祜族佤族布朗族傣族自治县',
            code: '530925',
            lng: '99.82769',
            lat: '23.47349',
          },
          { id: 2748, pid: 2741, name: '耿马傣族佤族自治县', code: '530926', lng: '99.39785', lat: '23.53776' },
          { id: 2749, pid: 2741, name: '沧源佤族自治县', code: '530927', lng: '99.24545', lat: '23.14821' },
        ],
      },
      {
        id: 2750,
        pid: 2670,
        name: '楚雄彝族自治州',
        code: '532300',
        lng: '101.546046',
        lat: '25.041988',
        children: [
          { id: 2751, pid: 2750, name: '楚雄市', code: '532301', lng: '101.54615', lat: '25.0329' },
          { id: 2752, pid: 2750, name: '双柏县', code: '532322', lng: '101.64205', lat: '24.68882' },
          { id: 2753, pid: 2750, name: '牟定县', code: '532323', lng: '101.54', lat: '25.31551' },
          { id: 2754, pid: 2750, name: '南华县', code: '532324', lng: '101.27313', lat: '25.19293' },
          { id: 2755, pid: 2750, name: '姚安县', code: '532325', lng: '101.24279', lat: '25.50467' },
          { id: 2756, pid: 2750, name: '大姚县', code: '532326', lng: '101.32397', lat: '25.72218' },
          { id: 2757, pid: 2750, name: '永仁县', code: '532327', lng: '101.6716', lat: '26.05794' },
          { id: 2758, pid: 2750, name: '元谋县', code: '532328', lng: '101.87728', lat: '25.70438' },
          { id: 2759, pid: 2750, name: '武定县', code: '532329', lng: '102.4038', lat: '25.5295' },
          { id: 2760, pid: 2750, name: '禄丰县', code: '532331', lng: '102.07797', lat: '25.14815' },
        ],
      },
      {
        id: 2761,
        pid: 2670,
        name: '红河哈尼族彝族自治州',
        code: '532500',
        lng: '103.384182',
        lat: '23.366775',
        children: [
          { id: 2762, pid: 2761, name: '个旧市', code: '532501', lng: '103.15966', lat: '23.35894' },
          { id: 2763, pid: 2761, name: '开远市', code: '532502', lng: '103.26986', lat: '23.71012' },
          { id: 2764, pid: 2761, name: '蒙自市', code: '532503', lng: '103.385005', lat: '23.366843' },
          { id: 2765, pid: 2761, name: '弥勒市', code: '532504', lng: '103.436988', lat: '24.40837' },
          { id: 2766, pid: 2761, name: '屏边苗族自治县', code: '532523', lng: '103.68554', lat: '22.98425' },
          { id: 2767, pid: 2761, name: '建水县', code: '532524', lng: '102.82656', lat: '23.63472' },
          { id: 2768, pid: 2761, name: '石屏县', code: '532525', lng: '102.49408', lat: '23.71441' },
          { id: 2769, pid: 2761, name: '泸西县', code: '532527', lng: '103.76373', lat: '24.52854' },
          { id: 2770, pid: 2761, name: '元阳县', code: '532528', lng: '102.83261', lat: '23.22281' },
          { id: 2771, pid: 2761, name: '红河县', code: '532529', lng: '102.42059', lat: '23.36767' },
          { id: 2772, pid: 2761, name: '金平苗族瑶族傣族自治县', code: '532530', lng: '103.22651', lat: '22.77959' },
          { id: 2773, pid: 2761, name: '绿春县', code: '532531', lng: '102.39672', lat: '22.99371' },
          { id: 2774, pid: 2761, name: '河口瑶族自治县', code: '532532', lng: '103.93936', lat: '22.52929' },
        ],
      },
      {
        id: 2775,
        pid: 2670,
        name: '文山壮族苗族自治州',
        code: '532600',
        lng: '104.24401',
        lat: '23.36951',
        children: [
          { id: 2776, pid: 2775, name: '文山市', code: '532601', lng: '104.244277', lat: '23.369216' },
          { id: 2777, pid: 2775, name: '砚山县', code: '532622', lng: '104.33306', lat: '23.60723' },
          { id: 2778, pid: 2775, name: '西畴县', code: '532623', lng: '104.67419', lat: '23.43941' },
          { id: 2779, pid: 2775, name: '麻栗坡县', code: '532624', lng: '104.70132', lat: '23.12028' },
          { id: 2780, pid: 2775, name: '马关县', code: '532625', lng: '104.39514', lat: '23.01293' },
          { id: 2781, pid: 2775, name: '丘北县', code: '532626', lng: '104.19256', lat: '24.03957' },
          { id: 2782, pid: 2775, name: '广南县', code: '532627', lng: '105.05511', lat: '24.0464' },
          { id: 2783, pid: 2775, name: '富宁县', code: '532628', lng: '105.63085', lat: '23.62536' },
        ],
      },
      {
        id: 2784,
        pid: 2670,
        name: '西双版纳傣族自治州',
        code: '532800',
        lng: '100.797941',
        lat: '22.001724',
        children: [
          { id: 2785, pid: 2784, name: '景洪市', code: '532801', lng: '100.79977', lat: '22.01071' },
          { id: 2786, pid: 2784, name: '勐海县', code: '532822', lng: '100.44931', lat: '21.96175' },
          { id: 2787, pid: 2784, name: '勐腊县', code: '532823', lng: '101.56488', lat: '21.48162' },
        ],
      },
      {
        id: 2788,
        pid: 2670,
        name: '大理白族自治州',
        code: '532900',
        lng: '100.240037',
        lat: '25.592765',
        children: [
          { id: 2789, pid: 2788, name: '大理市', code: '532901', lng: '100.22998', lat: '25.59157' },
          { id: 2790, pid: 2788, name: '漾濞彝族自治县', code: '532922', lng: '99.95474', lat: '25.6652' },
          { id: 2791, pid: 2788, name: '祥云县', code: '532923', lng: '100.55761', lat: '25.47342' },
          { id: 2792, pid: 2788, name: '宾川县', code: '532924', lng: '100.57666', lat: '25.83144' },
          { id: 2793, pid: 2788, name: '弥渡县', code: '532925', lng: '100.49075', lat: '25.34179' },
          { id: 2794, pid: 2788, name: '南涧彝族自治县', code: '532926', lng: '100.50964', lat: '25.04349' },
          { id: 2795, pid: 2788, name: '巍山彝族回族自治县', code: '532927', lng: '100.30612', lat: '25.23197' },
          { id: 2796, pid: 2788, name: '永平县', code: '532928', lng: '99.54095', lat: '25.46451' },
          { id: 2797, pid: 2788, name: '云龙县', code: '532929', lng: '99.37255', lat: '25.88505' },
          { id: 2798, pid: 2788, name: '洱源县', code: '532930', lng: '99.94903', lat: '26.10829' },
          { id: 2799, pid: 2788, name: '剑川县', code: '532931', lng: '99.90545', lat: '26.53688' },
          { id: 2800, pid: 2788, name: '鹤庆县', code: '532932', lng: '100.17697', lat: '26.55798' },
        ],
      },
      {
        id: 2801,
        pid: 2670,
        name: '德宏傣族景颇族自治州',
        code: '533100',
        lng: '98.578363',
        lat: '24.436694',
        children: [
          { id: 2802, pid: 2801, name: '瑞丽市', code: '533102', lng: '97.85183', lat: '24.01277' },
          { id: 2803, pid: 2801, name: '芒市', code: '533103', lng: '98.588641', lat: '24.433735' },
          { id: 2804, pid: 2801, name: '梁河县', code: '533122', lng: '98.29705', lat: '24.80658' },
          { id: 2805, pid: 2801, name: '盈江县', code: '533123', lng: '97.93179', lat: '24.70579' },
          { id: 2806, pid: 2801, name: '陇川县', code: '533124', lng: '97.79199', lat: '24.18302' },
        ],
      },
      {
        id: 2807,
        pid: 2670,
        name: '怒江傈僳族自治州',
        code: '533300',
        lng: '98.854304',
        lat: '25.850949',
        children: [
          { id: 2808, pid: 2807, name: '泸水县', code: '533321', lng: '98.85534', lat: '25.83772' },
          { id: 2809, pid: 2807, name: '福贡县', code: '533323', lng: '98.86969', lat: '26.90366' },
          { id: 2810, pid: 2807, name: '贡山独龙族怒族自治县', code: '533324', lng: '98.66583', lat: '27.74088' },
          { id: 2811, pid: 2807, name: '兰坪白族普米族自治县', code: '533325', lng: '99.41891', lat: '26.45251' },
        ],
      },
      {
        id: 2812,
        pid: 2670,
        name: '迪庆藏族自治州',
        code: '533400',
        lng: '99.706463',
        lat: '27.826853',
        children: [
          { id: 2813, pid: 2812, name: '香格里拉市', code: '533421', lng: '99.70601', lat: '27.82308' },
          { id: 2814, pid: 2812, name: '德钦县', code: '533422', lng: '98.91082', lat: '28.4863' },
          { id: 2815, pid: 2812, name: '维西傈僳族自治县', code: '533423', lng: '99.28402', lat: '27.1793' },
        ],
      },
    ],
  },
  {
    id: 2816,
    pid: 0,
    name: '西藏自治区',
    code: '540000',
    lng: '91.132212',
    lat: '29.660361',
    children: [
      {
        id: 2817,
        pid: 2816,
        name: '拉萨市',
        code: '540100',
        lng: '91.132212',
        lat: '29.660361',
        children: [
          { id: 2818, pid: 2817, name: '城关区', code: '540102', lng: '91.13859', lat: '29.65312' },
          { id: 2819, pid: 2817, name: '林周县', code: '540121', lng: '91.2586', lat: '29.89445' },
          { id: 2820, pid: 2817, name: '当雄县', code: '540122', lng: '91.10076', lat: '30.48309' },
          { id: 2821, pid: 2817, name: '尼木县', code: '540123', lng: '90.16378', lat: '29.43353' },
          { id: 2822, pid: 2817, name: '曲水县', code: '540124', lng: '90.73187', lat: '29.35636' },
          { id: 2823, pid: 2817, name: '堆龙德庆县', code: '540125', lng: '91.00033', lat: '29.65002' },
          { id: 2824, pid: 2817, name: '达孜县', code: '540126', lng: '91.35757', lat: '29.6722' },
          { id: 2825, pid: 2817, name: '墨竹工卡县', code: '540127', lng: '91.72814', lat: '29.83614' },
        ],
      },
      {
        id: 2826,
        pid: 2816,
        name: '日喀则市',
        code: '540200',
        lng: '88.884874',
        lat: '29.263792',
        children: [
          { id: 2827, pid: 2826, name: '桑珠孜区', code: '540202', lng: '88.880367', lat: '29.269565' },
          { id: 2828, pid: 2826, name: '南木林县', code: '540221', lng: '89.09686', lat: '29.68206' },
          { id: 2829, pid: 2826, name: '江孜县', code: '540222', lng: '89.60263', lat: '28.91744' },
          { id: 2830, pid: 2826, name: '定日县', code: '540223', lng: '87.12176', lat: '28.66129' },
          { id: 2831, pid: 2826, name: '萨迦县', code: '540224', lng: '88.02191', lat: '28.90299' },
          { id: 2832, pid: 2826, name: '拉孜县', code: '540225', lng: '87.63412', lat: '29.085' },
          { id: 2833, pid: 2826, name: '昂仁县', code: '540226', lng: '87.23858', lat: '29.29496' },
          { id: 2834, pid: 2826, name: '谢通门县', code: '540227', lng: '88.26242', lat: '29.43337' },
          { id: 2835, pid: 2826, name: '白朗县', code: '540228', lng: '89.26205', lat: '29.10553' },
          { id: 2836, pid: 2826, name: '仁布县', code: '540229', lng: '89.84228', lat: '29.2301' },
          { id: 2837, pid: 2826, name: '康马县', code: '540230', lng: '89.68527', lat: '28.5567' },
          { id: 2838, pid: 2826, name: '定结县', code: '540231', lng: '87.77255', lat: '28.36403' },
          { id: 2839, pid: 2826, name: '仲巴县', code: '540232', lng: '84.02951', lat: '29.76595' },
          { id: 2840, pid: 2826, name: '亚东县', code: '540233', lng: '88.90802', lat: '27.4839' },
          { id: 2841, pid: 2826, name: '吉隆县', code: '540234', lng: '85.29846', lat: '28.85382' },
          { id: 2842, pid: 2826, name: '聂拉木县', code: '540235', lng: '85.97998', lat: '28.15645' },
          { id: 2843, pid: 2826, name: '萨嘎县', code: '540236', lng: '85.23413', lat: '29.32936' },
          { id: 2844, pid: 2826, name: '岗巴县', code: '540237', lng: '88.52069', lat: '28.27504' },
        ],
      },
      {
        id: 2845,
        pid: 2816,
        name: '昌都市',
        code: '540300',
        lng: '97.178452',
        lat: '31.136875',
        children: [
          { id: 2846, pid: 2845, name: '卡若区', code: '540302', lng: '97.18043', lat: '31.1385' },
          { id: 2847, pid: 2845, name: '江达县', code: '540321', lng: '98.21865', lat: '31.50343' },
          { id: 2848, pid: 2845, name: '贡觉县', code: '540322', lng: '98.27163', lat: '30.85941' },
          { id: 2849, pid: 2845, name: '类乌齐县', code: '540323', lng: '96.60015', lat: '31.21207' },
          { id: 2850, pid: 2845, name: '丁青县', code: '540324', lng: '95.59362', lat: '31.41621' },
          { id: 2851, pid: 2845, name: '察雅县', code: '540325', lng: '97.56521', lat: '30.65336' },
          { id: 2852, pid: 2845, name: '八宿县', code: '540326', lng: '96.9176', lat: '30.05346' },
          { id: 2853, pid: 2845, name: '左贡县', code: '540327', lng: '97.84429', lat: '29.67108' },
          { id: 2854, pid: 2845, name: '芒康县', code: '540328', lng: '98.59378', lat: '29.67946' },
          { id: 2855, pid: 2845, name: '洛隆县', code: '540329', lng: '95.82644', lat: '30.74049' },
          { id: 2856, pid: 2845, name: '边坝县', code: '540330', lng: '94.70687', lat: '30.93434' },
        ],
      },
      {
        id: 2857,
        pid: 2816,
        name: '山南地区',
        code: '542200',
        lng: '91.766529',
        lat: '29.236023',
        children: [
          { id: 2858, pid: 2857, name: '乃东县', code: '542221', lng: '91.76153', lat: '29.2249' },
          { id: 2859, pid: 2857, name: '扎囊县', code: '542222', lng: '91.33288', lat: '29.2399' },
          { id: 2860, pid: 2857, name: '贡嘎县', code: '542223', lng: '90.98867', lat: '29.29408' },
          { id: 2861, pid: 2857, name: '桑日县', code: '542224', lng: '92.02005', lat: '29.26643' },
          { id: 2862, pid: 2857, name: '琼结县', code: '542225', lng: '91.68093', lat: '29.02632' },
          { id: 2863, pid: 2857, name: '曲松县', code: '542226', lng: '92.20263', lat: '29.06412' },
          { id: 2864, pid: 2857, name: '措美县', code: '542227', lng: '91.43237', lat: '28.43794' },
          { id: 2865, pid: 2857, name: '洛扎县', code: '542228', lng: '90.86035', lat: '28.3872' },
          { id: 2866, pid: 2857, name: '加查县', code: '542229', lng: '92.57702', lat: '29.13973' },
          { id: 2867, pid: 2857, name: '隆子县', code: '542231', lng: '92.46148', lat: '28.40797' },
          { id: 2868, pid: 2857, name: '错那县', code: '542232', lng: '91.95752', lat: '27.99224' },
          { id: 2869, pid: 2857, name: '浪卡子县', code: '542233', lng: '90.40002', lat: '28.96948' },
        ],
      },
      {
        id: 2870,
        pid: 2816,
        name: '那曲地区',
        code: '542400',
        lng: '92.060214',
        lat: '31.476004',
        children: [
          { id: 2871, pid: 2870, name: '那曲县', code: '542421', lng: '92.0535', lat: '31.46964' },
          { id: 2872, pid: 2870, name: '嘉黎县', code: '542422', lng: '93.24987', lat: '30.64233' },
          { id: 2873, pid: 2870, name: '比如县', code: '542423', lng: '93.68685', lat: '31.4779' },
          { id: 2874, pid: 2870, name: '聂荣县', code: '542424', lng: '92.29574', lat: '32.11193' },
          { id: 2875, pid: 2870, name: '安多县', code: '542425', lng: '91.6795', lat: '32.26125' },
          { id: 2876, pid: 2870, name: '申扎县', code: '542426', lng: '88.70776', lat: '30.92995' },
          { id: 2877, pid: 2870, name: '索县', code: '542427', lng: '93.78295', lat: '31.88427' },
          { id: 2878, pid: 2870, name: '班戈县', code: '542428', lng: '90.01907', lat: '31.36149' },
          { id: 2879, pid: 2870, name: '巴青县', code: '542429', lng: '94.05316', lat: '31.91833' },
          { id: 2880, pid: 2870, name: '尼玛县', code: '542430', lng: '87.25256', lat: '31.79654' },
          { id: 2881, pid: 2870, name: '双湖县', code: '542431', lng: '88.837776', lat: '33.189032' },
        ],
      },
      {
        id: 2882,
        pid: 2816,
        name: '阿里地区',
        code: '542500',
        lng: '80.105498',
        lat: '32.503187',
        children: [
          { id: 2883, pid: 2882, name: '普兰县', code: '542521', lng: '81.177', lat: '30.30002' },
          { id: 2884, pid: 2882, name: '札达县', code: '542522', lng: '79.80255', lat: '31.48345' },
          { id: 2885, pid: 2882, name: '噶尔县', code: '542523', lng: '80.09579', lat: '32.50024' },
          { id: 2886, pid: 2882, name: '日土县', code: '542524', lng: '79.7131', lat: '33.38741' },
          { id: 2887, pid: 2882, name: '革吉县', code: '542525', lng: '81.151', lat: '32.3964' },
          { id: 2888, pid: 2882, name: '改则县', code: '542526', lng: '84.06295', lat: '32.30446' },
          { id: 2889, pid: 2882, name: '措勤县', code: '542527', lng: '85.16616', lat: '31.02095' },
        ],
      },
      {
        id: 2890,
        pid: 2816,
        name: '林芝地区',
        code: '542600',
        lng: '94.362348',
        lat: '29.654693',
        children: [
          { id: 2891, pid: 2890, name: '林芝县', code: '542621', lng: '94.48391', lat: '29.57562' },
          { id: 2892, pid: 2890, name: '工布江达县', code: '542622', lng: '93.2452', lat: '29.88576' },
          { id: 2893, pid: 2890, name: '米林县', code: '542623', lng: '94.21316', lat: '29.21535' },
          { id: 2894, pid: 2890, name: '墨脱县', code: '542624', lng: '95.3316', lat: '29.32698' },
          { id: 2895, pid: 2890, name: '波密县', code: '542625', lng: '95.77096', lat: '29.85907' },
          { id: 2896, pid: 2890, name: '察隅县', code: '542626', lng: '97.46679', lat: '28.6618' },
          { id: 2897, pid: 2890, name: '朗县', code: '542627', lng: '93.0754', lat: '29.04549' },
        ],
      },
    ],
  },
  {
    id: 2898,
    pid: 0,
    name: '陕西省',
    code: '610000',
    lng: '108.948024',
    lat: '34.263161',
    children: [
      {
        id: 2899,
        pid: 2898,
        name: '西安市',
        code: '610100',
        lng: '108.948024',
        lat: '34.263161',
        children: [
          { id: 2900, pid: 2899, name: '新城区', code: '610102', lng: '108.9608', lat: '34.26641' },
          { id: 2901, pid: 2899, name: '碑林区', code: '610103', lng: '108.93426', lat: '34.2304' },
          { id: 2902, pid: 2899, name: '莲湖区', code: '610104', lng: '108.9401', lat: '34.26709' },
          { id: 2903, pid: 2899, name: '灞桥区', code: '610111', lng: '109.06451', lat: '34.27264' },
          { id: 2904, pid: 2899, name: '未央区', code: '610112', lng: '108.94683', lat: '34.29296' },
          { id: 2905, pid: 2899, name: '雁塔区', code: '610113', lng: '108.94866', lat: '34.22245' },
          { id: 2906, pid: 2899, name: '阎良区', code: '610114', lng: '109.22616', lat: '34.66221' },
          { id: 2907, pid: 2899, name: '临潼区', code: '610115', lng: '109.21417', lat: '34.36665' },
          { id: 2908, pid: 2899, name: '长安区', code: '610116', lng: '108.94586', lat: '34.15559' },
          { id: 2909, pid: 2899, name: '蓝田县', code: '610122', lng: '109.32339', lat: '34.15128' },
          { id: 2910, pid: 2899, name: '周至县', code: '610124', lng: '108.22207', lat: '34.16337' },
          { id: 2911, pid: 2899, name: '户县', code: '610125', lng: '108.60513', lat: '34.10856' },
          { id: 2912, pid: 2899, name: '高陵区', code: '610126', lng: '109.08816', lat: '34.53483' },
        ],
      },
      {
        id: 2913,
        pid: 2898,
        name: '铜川市',
        code: '610200',
        lng: '108.963122',
        lat: '34.90892',
        children: [
          { id: 2914, pid: 2913, name: '王益区', code: '610202', lng: '109.07564', lat: '35.06896' },
          { id: 2915, pid: 2913, name: '印台区', code: '610203', lng: '109.10208', lat: '35.1169' },
          { id: 2916, pid: 2913, name: '耀州区', code: '610204', lng: '108.98556', lat: '34.91308' },
          { id: 2917, pid: 2913, name: '宜君县', code: '610222', lng: '109.11813', lat: '35.40108' },
        ],
      },
      {
        id: 2918,
        pid: 2898,
        name: '宝鸡市',
        code: '610300',
        lng: '107.14487',
        lat: '34.369315',
        children: [
          { id: 2919, pid: 2918, name: '渭滨区', code: '610302', lng: '107.14991', lat: '34.37116' },
          { id: 2920, pid: 2918, name: '金台区', code: '610303', lng: '107.14691', lat: '34.37612' },
          { id: 2921, pid: 2918, name: '陈仓区', code: '610304', lng: '107.38742', lat: '34.35451' },
          { id: 2922, pid: 2918, name: '凤翔县', code: '610322', lng: '107.39645', lat: '34.52321' },
          { id: 2923, pid: 2918, name: '岐山县', code: '610323', lng: '107.62173', lat: '34.44378' },
          { id: 2924, pid: 2918, name: '扶风县', code: '610324', lng: '107.90017', lat: '34.37524' },
          { id: 2925, pid: 2918, name: '眉县', code: '610326', lng: '107.75079', lat: '34.27569' },
          { id: 2926, pid: 2918, name: '陇县', code: '610327', lng: '106.85946', lat: '34.89404' },
          { id: 2927, pid: 2918, name: '千阳县', code: '610328', lng: '107.13043', lat: '34.64219' },
          { id: 2928, pid: 2918, name: '麟游县', code: '610329', lng: '107.79623', lat: '34.67844' },
          { id: 2929, pid: 2918, name: '凤县', code: '610330', lng: '106.52356', lat: '33.91172' },
          { id: 2930, pid: 2918, name: '太白县', code: '610331', lng: '107.31646', lat: '34.06207' },
        ],
      },
      {
        id: 2931,
        pid: 2898,
        name: '咸阳市',
        code: '610400',
        lng: '108.705117',
        lat: '34.333439',
        children: [
          { id: 2932, pid: 2931, name: '秦都区', code: '610402', lng: '108.71493', lat: '34.33804' },
          { id: 2933, pid: 2931, name: '杨陵区', code: '610403', lng: '108.083481', lat: '34.270434' },
          { id: 2934, pid: 2931, name: '渭城区', code: '610404', lng: '108.72227', lat: '34.33198' },
          { id: 2935, pid: 2931, name: '三原县', code: '610422', lng: '108.93194', lat: '34.61556' },
          { id: 2936, pid: 2931, name: '泾阳县', code: '610423', lng: '108.84259', lat: '34.52705' },
          { id: 2937, pid: 2931, name: '乾县', code: '610424', lng: '108.24231', lat: '34.52946' },
          { id: 2938, pid: 2931, name: '礼泉县', code: '610425', lng: '108.4263', lat: '34.48455' },
          { id: 2939, pid: 2931, name: '永寿县', code: '610426', lng: '108.14474', lat: '34.69081' },
          { id: 2940, pid: 2931, name: '彬县', code: '610427', lng: '108.08468', lat: '35.0342' },
          { id: 2941, pid: 2931, name: '长武县', code: '610428', lng: '107.7951', lat: '35.2067' },
          { id: 2942, pid: 2931, name: '旬邑县', code: '610429', lng: '108.3341', lat: '35.11338' },
          { id: 2943, pid: 2931, name: '淳化县', code: '610430', lng: '108.58026', lat: '34.79886' },
          { id: 2944, pid: 2931, name: '武功县', code: '610431', lng: '108.20434', lat: '34.26003' },
          { id: 2945, pid: 2931, name: '兴平市', code: '610481', lng: '108.49057', lat: '34.29785' },
        ],
      },
      {
        id: 2946,
        pid: 2898,
        name: '渭南市',
        code: '610500',
        lng: '109.502882',
        lat: '34.499381',
        children: [
          { id: 2947, pid: 2946, name: '临渭区', code: '610502', lng: '109.49296', lat: '34.49822' },
          { id: 2948, pid: 2946, name: '华县', code: '610521', lng: '109.77185', lat: '34.51255' },
          { id: 2949, pid: 2946, name: '潼关县', code: '610522', lng: '110.24362', lat: '34.54284' },
          { id: 2950, pid: 2946, name: '大荔县', code: '610523', lng: '109.94216', lat: '34.79565' },
          { id: 2951, pid: 2946, name: '合阳县', code: '610524', lng: '110.14862', lat: '35.23805' },
          { id: 2952, pid: 2946, name: '澄城县', code: '610525', lng: '109.93444', lat: '35.18396' },
          { id: 2953, pid: 2946, name: '蒲城县', code: '610526', lng: '109.5903', lat: '34.9568' },
          { id: 2954, pid: 2946, name: '白水县', code: '610527', lng: '109.59286', lat: '35.17863' },
          { id: 2955, pid: 2946, name: '富平县', code: '610528', lng: '109.1802', lat: '34.75109' },
          { id: 2956, pid: 2946, name: '韩城市', code: '610581', lng: '110.44238', lat: '35.47926' },
          { id: 2957, pid: 2946, name: '华阴市', code: '610582', lng: '110.08752', lat: '34.56608' },
        ],
      },
      {
        id: 2958,
        pid: 2898,
        name: '延安市',
        code: '610600',
        lng: '109.49081',
        lat: '36.596537',
        children: [
          { id: 2959, pid: 2958, name: '宝塔区', code: '610602', lng: '109.49336', lat: '36.59154' },
          { id: 2960, pid: 2958, name: '延长县', code: '610621', lng: '110.01083', lat: '36.57904' },
          { id: 2961, pid: 2958, name: '延川县', code: '610622', lng: '110.19415', lat: '36.87817' },
          { id: 2962, pid: 2958, name: '子长县', code: '610623', lng: '109.67532', lat: '37.14253' },
          { id: 2963, pid: 2958, name: '安塞县', code: '610624', lng: '109.32708', lat: '36.86507' },
          { id: 2964, pid: 2958, name: '志丹县', code: '610625', lng: '108.76815', lat: '36.82177' },
          { id: 2965, pid: 2958, name: '吴起县', code: '610626', lng: '108.17611', lat: '36.92785' },
          { id: 2966, pid: 2958, name: '甘泉县', code: '610627', lng: '109.35012', lat: '36.27754' },
          { id: 2967, pid: 2958, name: '富县', code: '610628', lng: '109.37927', lat: '35.98803' },
          { id: 2968, pid: 2958, name: '洛川县', code: '610629', lng: '109.43286', lat: '35.76076' },
          { id: 2969, pid: 2958, name: '宜川县', code: '610630', lng: '110.17196', lat: '36.04732' },
          { id: 2970, pid: 2958, name: '黄龙县', code: '610631', lng: '109.84259', lat: '35.58349' },
          { id: 2971, pid: 2958, name: '黄陵县', code: '610632', lng: '109.26333', lat: '35.58357' },
        ],
      },
      {
        id: 2972,
        pid: 2898,
        name: '汉中市',
        code: '610700',
        lng: '107.028621',
        lat: '33.077668',
        children: [
          { id: 2973, pid: 2972, name: '汉台区', code: '610702', lng: '107.03187', lat: '33.06774' },
          { id: 2974, pid: 2972, name: '南郑县', code: '610721', lng: '106.94024', lat: '33.00299' },
          { id: 2975, pid: 2972, name: '城固县', code: '610722', lng: '107.33367', lat: '33.15661' },
          { id: 2976, pid: 2972, name: '洋县', code: '610723', lng: '107.54672', lat: '33.22102' },
          { id: 2977, pid: 2972, name: '西乡县', code: '610724', lng: '107.76867', lat: '32.98411' },
          { id: 2978, pid: 2972, name: '勉县', code: '610725', lng: '106.67584', lat: '33.15273' },
          { id: 2979, pid: 2972, name: '宁强县', code: '610726', lng: '106.25958', lat: '32.82881' },
          { id: 2980, pid: 2972, name: '略阳县', code: '610727', lng: '106.15399', lat: '33.33009' },
          { id: 2981, pid: 2972, name: '镇巴县', code: '610728', lng: '107.89648', lat: '32.53487' },
          { id: 2982, pid: 2972, name: '留坝县', code: '610729', lng: '106.92233', lat: '33.61606' },
          { id: 2983, pid: 2972, name: '佛坪县', code: '610730', lng: '107.98974', lat: '33.52496' },
        ],
      },
      {
        id: 2984,
        pid: 2898,
        name: '榆林市',
        code: '610800',
        lng: '109.741193',
        lat: '38.290162',
        children: [
          { id: 2985, pid: 2984, name: '榆阳区', code: '610802', lng: '109.73473', lat: '38.27843' },
          { id: 2986, pid: 2984, name: '神木县', code: '610821', lng: '110.4989', lat: '38.84234' },
          { id: 2987, pid: 2984, name: '府谷县', code: '610822', lng: '111.06723', lat: '39.02805' },
          { id: 2988, pid: 2984, name: '横山县', code: '610823', lng: '109.29568', lat: '37.958' },
          { id: 2989, pid: 2984, name: '靖边县', code: '610824', lng: '108.79412', lat: '37.59938' },
          { id: 2990, pid: 2984, name: '定边县', code: '610825', lng: '107.59793', lat: '37.59037' },
          { id: 2991, pid: 2984, name: '绥德县', code: '610826', lng: '110.26126', lat: '37.49778' },
          { id: 2992, pid: 2984, name: '米脂县', code: '610827', lng: '110.18417', lat: '37.75529' },
          { id: 2993, pid: 2984, name: '佳县', code: '610828', lng: '110.49362', lat: '38.02248' },
          { id: 2994, pid: 2984, name: '吴堡县', code: '610829', lng: '110.74533', lat: '37.45709' },
          { id: 2995, pid: 2984, name: '清涧县', code: '610830', lng: '110.12173', lat: '37.08854' },
          { id: 2996, pid: 2984, name: '子洲县', code: '610831', lng: '110.03488', lat: '37.61238' },
        ],
      },
      {
        id: 2997,
        pid: 2898,
        name: '安康市',
        code: '610900',
        lng: '109.029273',
        lat: '32.6903',
        children: [
          { id: 2998, pid: 2997, name: '汉滨区', code: '610902', lng: '109.02683', lat: '32.69517' },
          { id: 2999, pid: 2997, name: '汉阴县', code: '610921', lng: '108.51098', lat: '32.89129' },
          { id: 3000, pid: 2997, name: '石泉县', code: '610922', lng: '108.24755', lat: '33.03971' },
          { id: 3001, pid: 2997, name: '宁陕县', code: '610923', lng: '108.31515', lat: '33.31726' },
          { id: 3002, pid: 2997, name: '紫阳县', code: '610924', lng: '108.5368', lat: '32.52115' },
          { id: 3003, pid: 2997, name: '岚皋县', code: '610925', lng: '108.90289', lat: '32.30794' },
          { id: 3004, pid: 2997, name: '平利县', code: '610926', lng: '109.35775', lat: '32.39111' },
          { id: 3005, pid: 2997, name: '镇坪县', code: '610927', lng: '109.52456', lat: '31.8833' },
          { id: 3006, pid: 2997, name: '旬阳县', code: '610928', lng: '109.3619', lat: '32.83207' },
          { id: 3007, pid: 2997, name: '白河县', code: '610929', lng: '110.11315', lat: '32.80955' },
        ],
      },
      {
        id: 3008,
        pid: 2898,
        name: '商洛市',
        code: '611000',
        lng: '109.939776',
        lat: '33.868319',
        children: [
          { id: 3009, pid: 3008, name: '商州区', code: '611002', lng: '109.94126', lat: '33.8627' },
          { id: 3010, pid: 3008, name: '洛南县', code: '611021', lng: '110.14645', lat: '34.08994' },
          { id: 3011, pid: 3008, name: '丹凤县', code: '611022', lng: '110.33486', lat: '33.69468' },
          { id: 3012, pid: 3008, name: '商南县', code: '611023', lng: '110.88375', lat: '33.52581' },
          { id: 3013, pid: 3008, name: '山阳县', code: '611024', lng: '109.88784', lat: '33.52931' },
          { id: 3014, pid: 3008, name: '镇安县', code: '611025', lng: '109.15374', lat: '33.42366' },
          { id: 3015, pid: 3008, name: '柞水县', code: '611026', lng: '109.11105', lat: '33.6831' },
        ],
      },
      {
        id: 3016,
        pid: 2898,
        name: '西咸新区',
        code: '611100',
        lng: '108.810654',
        lat: '34.307144',
        children: [
          { id: 3017, pid: 3016, name: '空港新城', code: '611101', lng: '108.760529', lat: '34.440894' },
          { id: 3018, pid: 3016, name: '沣东新城', code: '611102', lng: '108.82988', lat: '34.267431' },
          { id: 3019, pid: 3016, name: '秦汉新城', code: '611103', lng: '108.83812', lat: '34.386513' },
          { id: 3020, pid: 3016, name: '沣西新城', code: '611104', lng: '108.71215', lat: '34.190453' },
          { id: 3021, pid: 3016, name: '泾河新城', code: '611105', lng: '109.049603', lat: '34.460587' },
        ],
      },
    ],
  },
  {
    id: 3022,
    pid: 0,
    name: '甘肃省',
    code: '620000',
    lng: '103.823557',
    lat: '36.058039',
    children: [
      {
        id: 3023,
        pid: 3022,
        name: '兰州市',
        code: '620100',
        lng: '103.823557',
        lat: '36.058039',
        children: [
          { id: 3024, pid: 3023, name: '城关区', code: '620102', lng: '103.8252', lat: '36.05725' },
          { id: 3025, pid: 3023, name: '七里河区', code: '620103', lng: '103.78564', lat: '36.06585' },
          { id: 3026, pid: 3023, name: '西固区', code: '620104', lng: '103.62811', lat: '36.08858' },
          { id: 3027, pid: 3023, name: '安宁区', code: '620105', lng: '103.7189', lat: '36.10384' },
          { id: 3028, pid: 3023, name: '红古区', code: '620111', lng: '102.85955', lat: '36.34537' },
          { id: 3029, pid: 3023, name: '永登县', code: '620121', lng: '103.26055', lat: '36.73522' },
          { id: 3030, pid: 3023, name: '皋兰县', code: '620122', lng: '103.94506', lat: '36.33215' },
          { id: 3031, pid: 3023, name: '榆中县', code: '620123', lng: '104.1145', lat: '35.84415' },
        ],
      },
      {
        id: 3032,
        pid: 3022,
        name: '嘉峪关市',
        code: '620200',
        lng: '98.277304',
        lat: '39.786529',
        children: [
          { id: 3033, pid: 3032, name: '雄关区', code: '620201', lng: '98.277398', lat: '39.77925' },
          { id: 3034, pid: 3032, name: '长城区', code: '620202', lng: '98.273523', lat: '39.787431' },
          { id: 3035, pid: 3032, name: '镜铁区', code: '620203', lng: '98.277304', lat: '39.786529' },
        ],
      },
      {
        id: 3036,
        pid: 3022,
        name: '金昌市',
        code: '620300',
        lng: '102.187888',
        lat: '38.514238',
        children: [
          { id: 3037, pid: 3036, name: '金川区', code: '620302', lng: '102.19376', lat: '38.52101' },
          { id: 3038, pid: 3036, name: '永昌县', code: '620321', lng: '101.97222', lat: '38.24711' },
        ],
      },
      {
        id: 3039,
        pid: 3022,
        name: '白银市',
        code: '620400',
        lng: '104.173606',
        lat: '36.54568',
        children: [
          { id: 3040, pid: 3039, name: '白银区', code: '620402', lng: '104.17355', lat: '36.54411' },
          { id: 3041, pid: 3039, name: '平川区', code: '620403', lng: '104.82498', lat: '36.7277' },
          { id: 3042, pid: 3039, name: '靖远县', code: '620421', lng: '104.68325', lat: '36.56602' },
          { id: 3043, pid: 3039, name: '会宁县', code: '620422', lng: '105.05297', lat: '35.69626' },
          { id: 3044, pid: 3039, name: '景泰县', code: '620423', lng: '104.06295', lat: '37.18359' },
        ],
      },
      {
        id: 3045,
        pid: 3022,
        name: '天水市',
        code: '620500',
        lng: '105.724998',
        lat: '34.578529',
        children: [
          { id: 3046, pid: 3045, name: '秦州区', code: '620502', lng: '105.72421', lat: '34.58089' },
          { id: 3047, pid: 3045, name: '麦积区', code: '620503', lng: '105.89013', lat: '34.57069' },
          { id: 3048, pid: 3045, name: '清水县', code: '620521', lng: '106.13671', lat: '34.75032' },
          { id: 3049, pid: 3045, name: '秦安县', code: '620522', lng: '105.66955', lat: '34.85894' },
          { id: 3050, pid: 3045, name: '甘谷县', code: '620523', lng: '105.33291', lat: '34.73665' },
          { id: 3051, pid: 3045, name: '武山县', code: '620524', lng: '104.88382', lat: '34.72123' },
          { id: 3052, pid: 3045, name: '张家川回族自治县', code: '620525', lng: '106.21582', lat: '34.99582' },
        ],
      },
      {
        id: 3053,
        pid: 3022,
        name: '武威市',
        code: '620600',
        lng: '102.634697',
        lat: '37.929996',
        children: [
          { id: 3054, pid: 3053, name: '凉州区', code: '620602', lng: '102.64203', lat: '37.92832' },
          { id: 3055, pid: 3053, name: '民勤县', code: '620621', lng: '103.09011', lat: '38.62487' },
          { id: 3056, pid: 3053, name: '古浪县', code: '620622', lng: '102.89154', lat: '37.46508' },
          { id: 3057, pid: 3053, name: '天祝藏族自治县', code: '620623', lng: '103.1361', lat: '36.97715' },
        ],
      },
      {
        id: 3058,
        pid: 3022,
        name: '张掖市',
        code: '620700',
        lng: '100.455472',
        lat: '38.932897',
        children: [
          { id: 3059, pid: 3058, name: '甘州区', code: '620702', lng: '100.4527', lat: '38.92947' },
          { id: 3060, pid: 3058, name: '肃南裕固族自治县', code: '620721', lng: '99.61407', lat: '38.83776' },
          { id: 3061, pid: 3058, name: '民乐县', code: '620722', lng: '100.81091', lat: '38.43479' },
          { id: 3062, pid: 3058, name: '临泽县', code: '620723', lng: '100.16445', lat: '39.15252' },
          { id: 3063, pid: 3058, name: '高台县', code: '620724', lng: '99.81918', lat: '39.37829' },
          { id: 3064, pid: 3058, name: '山丹县', code: '620725', lng: '101.09359', lat: '38.78468' },
        ],
      },
      {
        id: 3065,
        pid: 3022,
        name: '平凉市',
        code: '620800',
        lng: '106.684691',
        lat: '35.54279',
        children: [
          { id: 3066, pid: 3065, name: '崆峒区', code: '620802', lng: '106.67483', lat: '35.54262' },
          { id: 3067, pid: 3065, name: '泾川县', code: '620821', lng: '107.36581', lat: '35.33223' },
          { id: 3068, pid: 3065, name: '灵台县', code: '620822', lng: '107.6174', lat: '35.06768' },
          { id: 3069, pid: 3065, name: '崇信县', code: '620823', lng: '107.03738', lat: '35.30344' },
          { id: 3070, pid: 3065, name: '华亭县', code: '620824', lng: '106.65463', lat: '35.2183' },
          { id: 3071, pid: 3065, name: '庄浪县', code: '620825', lng: '106.03662', lat: '35.20235' },
          { id: 3072, pid: 3065, name: '静宁县', code: '620826', lng: '105.72723', lat: '35.51991' },
        ],
      },
      {
        id: 3073,
        pid: 3022,
        name: '酒泉市',
        code: '620900',
        lng: '98.510795',
        lat: '39.744023',
        children: [
          { id: 3074, pid: 3073, name: '肃州区', code: '620902', lng: '98.50775', lat: '39.74506' },
          { id: 3075, pid: 3073, name: '金塔县', code: '620921', lng: '98.90002', lat: '39.97733' },
          { id: 3076, pid: 3073, name: '瓜州县', code: '620922', lng: '95.78271', lat: '40.51548' },
          { id: 3077, pid: 3073, name: '肃北蒙古族自治县', code: '620923', lng: '94.87649', lat: '39.51214' },
          { id: 3078, pid: 3073, name: '阿克塞哈萨克族自治县', code: '620924', lng: '94.34097', lat: '39.63435' },
          { id: 3079, pid: 3073, name: '玉门市', code: '620981', lng: '97.04538', lat: '40.29172' },
          { id: 3080, pid: 3073, name: '敦煌市', code: '620982', lng: '94.66159', lat: '40.14211' },
        ],
      },
      {
        id: 3081,
        pid: 3022,
        name: '庆阳市',
        code: '621000',
        lng: '107.638372',
        lat: '35.734218',
        children: [
          { id: 3082, pid: 3081, name: '西峰区', code: '621002', lng: '107.65107', lat: '35.73065' },
          { id: 3083, pid: 3081, name: '庆城县', code: '621021', lng: '107.88272', lat: '36.01507' },
          { id: 3084, pid: 3081, name: '环县', code: '621022', lng: '107.30835', lat: '36.56846' },
          { id: 3085, pid: 3081, name: '华池县', code: '621023', lng: '107.9891', lat: '36.46108' },
          { id: 3086, pid: 3081, name: '合水县', code: '621024', lng: '108.02032', lat: '35.81911' },
          { id: 3087, pid: 3081, name: '正宁县', code: '621025', lng: '108.36007', lat: '35.49174' },
          { id: 3088, pid: 3081, name: '宁县', code: '621026', lng: '107.92517', lat: '35.50164' },
          { id: 3089, pid: 3081, name: '镇原县', code: '621027', lng: '107.199', lat: '35.67712' },
        ],
      },
      {
        id: 3090,
        pid: 3022,
        name: '定西市',
        code: '621100',
        lng: '104.626294',
        lat: '35.579578',
        children: [
          { id: 3091, pid: 3090, name: '安定区', code: '621102', lng: '104.6106', lat: '35.58066' },
          { id: 3092, pid: 3090, name: '通渭县', code: '621121', lng: '105.24224', lat: '35.21101' },
          { id: 3093, pid: 3090, name: '陇西县', code: '621122', lng: '104.63446', lat: '35.00238' },
          { id: 3094, pid: 3090, name: '渭源县', code: '621123', lng: '104.21435', lat: '35.13649' },
          { id: 3095, pid: 3090, name: '临洮县', code: '621124', lng: '103.86196', lat: '35.3751' },
          { id: 3096, pid: 3090, name: '漳县', code: '621125', lng: '104.46704', lat: '34.84977' },
          { id: 3097, pid: 3090, name: '岷县', code: '621126', lng: '104.03772', lat: '34.43444' },
        ],
      },
      {
        id: 3098,
        pid: 3022,
        name: '陇南市',
        code: '621200',
        lng: '104.929379',
        lat: '33.388598',
        children: [
          { id: 3099, pid: 3098, name: '武都区', code: '621202', lng: '104.92652', lat: '33.39239' },
          { id: 3100, pid: 3098, name: '成县', code: '621221', lng: '105.72586', lat: '33.73925' },
          { id: 3101, pid: 3098, name: '文县', code: '621222', lng: '104.68362', lat: '32.94337' },
          { id: 3102, pid: 3098, name: '宕昌县', code: '621223', lng: '104.39349', lat: '34.04732' },
          { id: 3103, pid: 3098, name: '康县', code: '621224', lng: '105.60711', lat: '33.32912' },
          { id: 3104, pid: 3098, name: '西和县', code: '621225', lng: '105.30099', lat: '34.01432' },
          { id: 3105, pid: 3098, name: '礼县', code: '621226', lng: '105.17785', lat: '34.18935' },
          { id: 3106, pid: 3098, name: '徽县', code: '621227', lng: '106.08529', lat: '33.76898' },
          { id: 3107, pid: 3098, name: '两当县', code: '621228', lng: '106.30484', lat: '33.9096' },
        ],
      },
      {
        id: 3108,
        pid: 3022,
        name: '临夏回族自治州',
        code: '622900',
        lng: '103.212006',
        lat: '35.599446',
        children: [
          { id: 3109, pid: 3108, name: '临夏市', code: '622901', lng: '103.21', lat: '35.59916' },
          { id: 3110, pid: 3108, name: '临夏县', code: '622921', lng: '102.9938', lat: '35.49519' },
          { id: 3111, pid: 3108, name: '康乐县', code: '622922', lng: '103.71093', lat: '35.37219' },
          { id: 3112, pid: 3108, name: '永靖县', code: '622923', lng: '103.32043', lat: '35.93835' },
          { id: 3113, pid: 3108, name: '广河县', code: '622924', lng: '103.56933', lat: '35.48097' },
          { id: 3114, pid: 3108, name: '和政县', code: '622925', lng: '103.34936', lat: '35.42592' },
          { id: 3115, pid: 3108, name: '东乡族自治县', code: '622926', lng: '103.39477', lat: '35.66471' },
          {
            id: 3116,
            pid: 3108,
            name: '积石山保安族东乡族撒拉族自治县',
            code: '622927',
            lng: '102.87374',
            lat: '35.7182',
          },
        ],
      },
      {
        id: 3117,
        pid: 3022,
        name: '甘南藏族自治州',
        code: '623000',
        lng: '102.911008',
        lat: '34.986354',
        children: [
          { id: 3118, pid: 3117, name: '合作市', code: '623001', lng: '102.91082', lat: '35.00016' },
          { id: 3119, pid: 3117, name: '临潭县', code: '623021', lng: '103.35287', lat: '34.69515' },
          { id: 3120, pid: 3117, name: '卓尼县', code: '623022', lng: '103.50811', lat: '34.58919' },
          { id: 3121, pid: 3117, name: '舟曲县', code: '623023', lng: '104.37155', lat: '33.78468' },
          { id: 3122, pid: 3117, name: '迭部县', code: '623024', lng: '103.22274', lat: '34.05623' },
          { id: 3123, pid: 3117, name: '玛曲县', code: '623025', lng: '102.0754', lat: '33.997' },
          { id: 3124, pid: 3117, name: '碌曲县', code: '623026', lng: '102.49176', lat: '34.58872' },
          { id: 3125, pid: 3117, name: '夏河县', code: '623027', lng: '102.52215', lat: '35.20487' },
        ],
      },
    ],
  },
  {
    id: 3126,
    pid: 0,
    name: '青海省',
    code: '630000',
    lng: '101.778916',
    lat: '36.623178',
    children: [
      {
        id: 3127,
        pid: 3126,
        name: '西宁市',
        code: '630100',
        lng: '101.778916',
        lat: '36.623178',
        children: [
          { id: 3128, pid: 3127, name: '城东区', code: '630102', lng: '101.80373', lat: '36.59969' },
          { id: 3129, pid: 3127, name: '城中区', code: '630103', lng: '101.78394', lat: '36.62279' },
          { id: 3130, pid: 3127, name: '城西区', code: '630104', lng: '101.76588', lat: '36.62828' },
          { id: 3131, pid: 3127, name: '城北区', code: '630105', lng: '101.7662', lat: '36.65014' },
          { id: 3132, pid: 3127, name: '大通回族土族自治县', code: '630121', lng: '101.70236', lat: '36.93489' },
          { id: 3133, pid: 3127, name: '湟中县', code: '630122', lng: '101.57159', lat: '36.50083' },
          { id: 3134, pid: 3127, name: '湟源县', code: '630123', lng: '101.25643', lat: '36.68243' },
        ],
      },
      {
        id: 3135,
        pid: 3126,
        name: '海东市',
        code: '630200',
        lng: '102.10327',
        lat: '36.502916',
        children: [
          { id: 3136, pid: 3135, name: '乐都区', code: '630202', lng: '102.402431', lat: '36.480291' },
          { id: 3137, pid: 3135, name: '平安县', code: '630221', lng: '102.104295', lat: '36.502714' },
          { id: 3138, pid: 3135, name: '民和回族土族自治县', code: '630222', lng: '102.804209', lat: '36.329451' },
          { id: 3139, pid: 3135, name: '互助土族自治县', code: '630223', lng: '101.956734', lat: '36.83994' },
          { id: 3140, pid: 3135, name: '化隆回族自治县', code: '630224', lng: '102.262329', lat: '36.098322' },
          { id: 3141, pid: 3135, name: '循化撒拉族自治县', code: '630225', lng: '102.486534', lat: '35.847247' },
        ],
      },
      {
        id: 3142,
        pid: 3126,
        name: '海北藏族自治州',
        code: '632200',
        lng: '100.901059',
        lat: '36.959435',
        children: [
          { id: 3143, pid: 3142, name: '门源回族自治县', code: '632221', lng: '101.62228', lat: '37.37611' },
          { id: 3144, pid: 3142, name: '祁连县', code: '632222', lng: '100.24618', lat: '38.17901' },
          { id: 3145, pid: 3142, name: '海晏县', code: '632223', lng: '100.9927', lat: '36.89902' },
          { id: 3146, pid: 3142, name: '刚察县', code: '632224', lng: '100.14675', lat: '37.32161' },
        ],
      },
      {
        id: 3147,
        pid: 3126,
        name: '黄南藏族自治州',
        code: '632300',
        lng: '102.019988',
        lat: '35.517744',
        children: [
          { id: 3148, pid: 3147, name: '同仁县', code: '632321', lng: '102.0184', lat: '35.51603' },
          { id: 3149, pid: 3147, name: '尖扎县', code: '632322', lng: '102.03411', lat: '35.93947' },
          { id: 3150, pid: 3147, name: '泽库县', code: '632323', lng: '101.46444', lat: '35.03519' },
          { id: 3151, pid: 3147, name: '河南蒙古族自治县', code: '632324', lng: '101.60864', lat: '34.73476' },
        ],
      },
      {
        id: 3152,
        pid: 3126,
        name: '海南藏族自治州',
        code: '632500',
        lng: '100.619542',
        lat: '36.280353',
        children: [
          { id: 3153, pid: 3152, name: '共和县', code: '632521', lng: '100.62003', lat: '36.2841' },
          { id: 3154, pid: 3152, name: '同德县', code: '632522', lng: '100.57159', lat: '35.25488' },
          { id: 3155, pid: 3152, name: '贵德县', code: '632523', lng: '101.432', lat: '36.044' },
          { id: 3156, pid: 3152, name: '兴海县', code: '632524', lng: '99.98846', lat: '35.59031' },
          { id: 3157, pid: 3152, name: '贵南县', code: '632525', lng: '100.74716', lat: '35.58667' },
        ],
      },
      {
        id: 3158,
        pid: 3126,
        name: '果洛藏族自治州',
        code: '632600',
        lng: '100.242143',
        lat: '34.4736',
        children: [
          { id: 3159, pid: 3158, name: '玛沁县', code: '632621', lng: '100.23901', lat: '34.47746' },
          { id: 3160, pid: 3158, name: '班玛县', code: '632622', lng: '100.73745', lat: '32.93253' },
          { id: 3161, pid: 3158, name: '甘德县', code: '632623', lng: '99.90246', lat: '33.96838' },
          { id: 3162, pid: 3158, name: '达日县', code: '632624', lng: '99.65179', lat: '33.75193' },
          { id: 3163, pid: 3158, name: '久治县', code: '632625', lng: '101.48342', lat: '33.42989' },
          { id: 3164, pid: 3158, name: '玛多县', code: '632626', lng: '98.20996', lat: '34.91567' },
        ],
      },
      {
        id: 3165,
        pid: 3126,
        name: '玉树藏族自治州',
        code: '632700',
        lng: '97.008522',
        lat: '33.004049',
        children: [
          { id: 3166, pid: 3165, name: '玉树市', code: '632701', lng: '97.008762', lat: '33.00393' },
          { id: 3167, pid: 3165, name: '杂多县', code: '632722', lng: '95.29864', lat: '32.89318' },
          { id: 3168, pid: 3165, name: '称多县', code: '632723', lng: '97.10788', lat: '33.36899' },
          { id: 3169, pid: 3165, name: '治多县', code: '632724', lng: '95.61572', lat: '33.8528' },
          { id: 3170, pid: 3165, name: '囊谦县', code: '632725', lng: '96.47753', lat: '32.20359' },
          { id: 3171, pid: 3165, name: '曲麻莱县', code: '632726', lng: '95.79757', lat: '34.12609' },
        ],
      },
      {
        id: 3172,
        pid: 3126,
        name: '海西蒙古族藏族自治州',
        code: '632800',
        lng: '97.370785',
        lat: '37.374663',
        children: [
          { id: 3173, pid: 3172, name: '格尔木市', code: '632801', lng: '94.90329', lat: '36.40236' },
          { id: 3174, pid: 3172, name: '德令哈市', code: '632802', lng: '97.36084', lat: '37.36946' },
          { id: 3175, pid: 3172, name: '乌兰县', code: '632821', lng: '98.48196', lat: '36.93471' },
          { id: 3176, pid: 3172, name: '都兰县', code: '632822', lng: '98.09228', lat: '36.30135' },
          { id: 3177, pid: 3172, name: '天峻县', code: '632823', lng: '99.02453', lat: '37.30326' },
        ],
      },
    ],
  },
  {
    id: 3178,
    pid: 0,
    name: '宁夏回族自治区',
    code: '640000',
    lng: '106.278179',
    lat: '38.46637',
    children: [
      {
        id: 3179,
        pid: 3178,
        name: '银川市',
        code: '640100',
        lng: '106.278179',
        lat: '38.46637',
        children: [
          { id: 3180, pid: 3179, name: '兴庆区', code: '640104', lng: '106.28872', lat: '38.47392' },
          { id: 3181, pid: 3179, name: '西夏区', code: '640105', lng: '106.15023', lat: '38.49137' },
          { id: 3182, pid: 3179, name: '金凤区', code: '640106', lng: '106.24261', lat: '38.47294' },
          { id: 3183, pid: 3179, name: '永宁县', code: '640121', lng: '106.2517', lat: '38.27559' },
          { id: 3184, pid: 3179, name: '贺兰县', code: '640122', lng: '106.34982', lat: '38.5544' },
          { id: 3185, pid: 3179, name: '灵武市', code: '640181', lng: '106.33999', lat: '38.10266' },
        ],
      },
      {
        id: 3186,
        pid: 3178,
        name: '石嘴山市',
        code: '640200',
        lng: '106.376173',
        lat: '39.01333',
        children: [
          { id: 3187, pid: 3186, name: '大武口区', code: '640202', lng: '106.37717', lat: '39.01226' },
          { id: 3188, pid: 3186, name: '惠农区', code: '640205', lng: '106.71145', lat: '39.13193' },
          { id: 3189, pid: 3186, name: '平罗县', code: '640221', lng: '106.54538', lat: '38.90429' },
        ],
      },
      {
        id: 3190,
        pid: 3178,
        name: '吴忠市',
        code: '640300',
        lng: '106.199409',
        lat: '37.986165',
        children: [
          { id: 3191, pid: 3190, name: '利通区', code: '640302', lng: '106.20311', lat: '37.98512' },
          { id: 3192, pid: 3190, name: '红寺堡区', code: '640303', lng: '106.19822', lat: '37.99747' },
          { id: 3193, pid: 3190, name: '盐池县', code: '640323', lng: '107.40707', lat: '37.7833' },
          { id: 3194, pid: 3190, name: '同心县', code: '640324', lng: '105.91418', lat: '36.98116' },
          { id: 3195, pid: 3190, name: '青铜峡市', code: '640381', lng: '106.07489', lat: '38.02004' },
        ],
      },
      {
        id: 3196,
        pid: 3178,
        name: '固原市',
        code: '640400',
        lng: '106.285241',
        lat: '36.004561',
        children: [
          { id: 3197, pid: 3196, name: '原州区', code: '640402', lng: '106.28778', lat: '36.00374' },
          { id: 3198, pid: 3196, name: '西吉县', code: '640422', lng: '105.73107', lat: '35.96616' },
          { id: 3199, pid: 3196, name: '隆德县', code: '640423', lng: '106.12426', lat: '35.61718' },
          { id: 3200, pid: 3196, name: '泾源县', code: '640424', lng: '106.33902', lat: '35.49072' },
          { id: 3201, pid: 3196, name: '彭阳县', code: '640425', lng: '106.64462', lat: '35.85076' },
        ],
      },
      {
        id: 3202,
        pid: 3178,
        name: '中卫市',
        code: '640500',
        lng: '105.189568',
        lat: '37.514951',
        children: [
          { id: 3203, pid: 3202, name: '沙坡头区', code: '640502', lng: '105.18962', lat: '37.51044' },
          { id: 3204, pid: 3202, name: '中宁县', code: '640521', lng: '105.68515', lat: '37.49149' },
          { id: 3205, pid: 3202, name: '海原县', code: '640522', lng: '105.64712', lat: '36.56498' },
        ],
      },
    ],
  },
  {
    id: 3206,
    pid: 0,
    name: '新疆维吾尔自治区',
    code: '650000',
    lng: '87.617733',
    lat: '43.792818',
    children: [
      {
        id: 3207,
        pid: 3206,
        name: '乌鲁木齐市',
        code: '650100',
        lng: '87.617733',
        lat: '43.792818',
        children: [
          { id: 3208, pid: 3207, name: '天山区', code: '650102', lng: '87.63167', lat: '43.79439' },
          { id: 3209, pid: 3207, name: '沙依巴克区', code: '650103', lng: '87.59788', lat: '43.80118' },
          { id: 3210, pid: 3207, name: '新市区', code: '650104', lng: '87.57406', lat: '43.84348' },
          { id: 3211, pid: 3207, name: '水磨沟区', code: '650105', lng: '87.64249', lat: '43.83247' },
          { id: 3212, pid: 3207, name: '头屯河区', code: '650106', lng: '87.29138', lat: '43.85487' },
          { id: 3213, pid: 3207, name: '达坂城区', code: '650107', lng: '88.30697', lat: '43.35797' },
          { id: 3214, pid: 3207, name: '米东区', code: '650109', lng: '87.68583', lat: '43.94739' },
          { id: 3215, pid: 3207, name: '乌鲁木齐县', code: '650121', lng: '87.40939', lat: '43.47125' },
        ],
      },
      {
        id: 3216,
        pid: 3206,
        name: '克拉玛依市',
        code: '650200',
        lng: '84.873946',
        lat: '45.595886',
        children: [
          { id: 3217, pid: 3216, name: '独山子区', code: '650202', lng: '84.88671', lat: '44.32867' },
          { id: 3218, pid: 3216, name: '克拉玛依区', code: '650203', lng: '84.86225', lat: '45.59089' },
          { id: 3219, pid: 3216, name: '白碱滩区', code: '650204', lng: '85.13244', lat: '45.68768' },
          { id: 3220, pid: 3216, name: '乌尔禾区', code: '650205', lng: '85.69143', lat: '46.09006' },
        ],
      },
      {
        id: 3221,
        pid: 3206,
        name: '吐鲁番地区',
        code: '652100',
        lng: '89.184078',
        lat: '42.947613',
        children: [
          { id: 3222, pid: 3221, name: '吐鲁番市', code: '652101', lng: '89.18579', lat: '42.93505' },
          { id: 3223, pid: 3221, name: '鄯善县', code: '652122', lng: '90.21402', lat: '42.8635' },
          { id: 3224, pid: 3221, name: '托克逊县', code: '652123', lng: '88.65823', lat: '42.79231' },
        ],
      },
      {
        id: 3225,
        pid: 3206,
        name: '哈密地区',
        code: '652200',
        lng: '93.51316',
        lat: '42.833248',
        children: [
          { id: 3226, pid: 3225, name: '哈密市', code: '652201', lng: '93.51452', lat: '42.82699' },
          { id: 3227, pid: 3225, name: '巴里坤哈萨克自治县', code: '652222', lng: '93.01236', lat: '43.59993' },
          { id: 3228, pid: 3225, name: '伊吾县', code: '652223', lng: '94.69403', lat: '43.2537' },
        ],
      },
      {
        id: 3229,
        pid: 3206,
        name: '昌吉回族自治州',
        code: '652300',
        lng: '87.304012',
        lat: '44.014577',
        children: [
          { id: 3230, pid: 3229, name: '昌吉市', code: '652301', lng: '87.30249', lat: '44.01267' },
          { id: 3231, pid: 3229, name: '阜康市', code: '652302', lng: '87.98529', lat: '44.1584' },
          { id: 3232, pid: 3229, name: '呼图壁县', code: '652323', lng: '86.89892', lat: '44.18977' },
          { id: 3233, pid: 3229, name: '玛纳斯县', code: '652324', lng: '86.2145', lat: '44.30438' },
          { id: 3234, pid: 3229, name: '奇台县', code: '652325', lng: '89.5932', lat: '44.02221' },
          { id: 3235, pid: 3229, name: '吉木萨尔县', code: '652327', lng: '89.18078', lat: '44.00048' },
          { id: 3236, pid: 3229, name: '木垒哈萨克自治县', code: '652328', lng: '90.28897', lat: '43.83508' },
        ],
      },
      {
        id: 3237,
        pid: 3206,
        name: '博尔塔拉蒙古自治州',
        code: '652700',
        lng: '82.074778',
        lat: '44.903258',
        children: [
          { id: 3238, pid: 3237, name: '博乐市', code: '652701', lng: '82.0713', lat: '44.90052' },
          { id: 3239, pid: 3237, name: '阿拉山口市', code: '652702', lng: '82.567721', lat: '45.170616' },
          { id: 3240, pid: 3237, name: '精河县', code: '652722', lng: '82.89419', lat: '44.60774' },
          { id: 3241, pid: 3237, name: '温泉县', code: '652723', lng: '81.03134', lat: '44.97373' },
        ],
      },
      {
        id: 3242,
        pid: 3206,
        name: '巴音郭楞蒙古自治州',
        code: '652800',
        lng: '86.150969',
        lat: '41.768552',
        children: [
          { id: 3243, pid: 3242, name: '库尔勒市', code: '652801', lng: '86.15528', lat: '41.76602' },
          { id: 3244, pid: 3242, name: '轮台县', code: '652822', lng: '84.26101', lat: '41.77642' },
          { id: 3245, pid: 3242, name: '尉犁县', code: '652823', lng: '86.25903', lat: '41.33632' },
          { id: 3246, pid: 3242, name: '若羌县', code: '652824', lng: '88.16812', lat: '39.0179' },
          { id: 3247, pid: 3242, name: '且末县', code: '652825', lng: '85.52975', lat: '38.14534' },
          { id: 3248, pid: 3242, name: '焉耆回族自治县', code: '652826', lng: '86.5744', lat: '42.059' },
          { id: 3249, pid: 3242, name: '和静县', code: '652827', lng: '86.39611', lat: '42.31838' },
          { id: 3250, pid: 3242, name: '和硕县', code: '652828', lng: '86.86392', lat: '42.26814' },
          { id: 3251, pid: 3242, name: '博湖县', code: '652829', lng: '86.63333', lat: '41.98014' },
        ],
      },
      {
        id: 3252,
        pid: 3206,
        name: '阿克苏地区',
        code: '652900',
        lng: '80.265068',
        lat: '41.170712',
        children: [
          { id: 3253, pid: 3252, name: '阿克苏市', code: '652901', lng: '80.26338', lat: '41.16754' },
          { id: 3254, pid: 3252, name: '温宿县', code: '652922', lng: '80.24173', lat: '41.27679' },
          { id: 3255, pid: 3252, name: '库车县', code: '652923', lng: '82.96209', lat: '41.71793' },
          { id: 3256, pid: 3252, name: '沙雅县', code: '652924', lng: '82.78131', lat: '41.22497' },
          { id: 3257, pid: 3252, name: '新和县', code: '652925', lng: '82.61053', lat: '41.54964' },
          { id: 3258, pid: 3252, name: '拜城县', code: '652926', lng: '81.87564', lat: '41.79801' },
          { id: 3259, pid: 3252, name: '乌什县', code: '652927', lng: '79.22937', lat: '41.21569' },
          { id: 3260, pid: 3252, name: '阿瓦提县', code: '652928', lng: '80.38336', lat: '40.63926' },
          { id: 3261, pid: 3252, name: '柯坪县', code: '652929', lng: '79.04751', lat: '40.50585' },
        ],
      },
      {
        id: 3262,
        pid: 3206,
        name: '克孜勒苏柯尔克孜自治州',
        code: '653000',
        lng: '76.172825',
        lat: '39.713431',
        children: [
          { id: 3263, pid: 3262, name: '阿图什市', code: '653001', lng: '76.16827', lat: '39.71615' },
          { id: 3264, pid: 3262, name: '阿克陶县', code: '653022', lng: '75.94692', lat: '39.14892' },
          { id: 3265, pid: 3262, name: '阿合奇县', code: '653023', lng: '78.44848', lat: '40.93947' },
          { id: 3266, pid: 3262, name: '乌恰县', code: '653024', lng: '75.25839', lat: '39.71984' },
        ],
      },
      {
        id: 3267,
        pid: 3206,
        name: '喀什地区',
        code: '653100',
        lng: '75.989138',
        lat: '39.467664',
        children: [
          { id: 3268, pid: 3267, name: '喀什市', code: '653101', lng: '75.99379', lat: '39.46768' },
          { id: 3269, pid: 3267, name: '疏附县', code: '653121', lng: '75.86029', lat: '39.37534' },
          { id: 3270, pid: 3267, name: '疏勒县', code: '653122', lng: '76.05398', lat: '39.40625' },
          { id: 3271, pid: 3267, name: '英吉沙县', code: '653123', lng: '76.17565', lat: '38.92968' },
          { id: 3272, pid: 3267, name: '泽普县', code: '653124', lng: '77.27145', lat: '38.18935' },
          { id: 3273, pid: 3267, name: '莎车县', code: '653125', lng: '77.24316', lat: '38.41601' },
          { id: 3274, pid: 3267, name: '叶城县', code: '653126', lng: '77.41659', lat: '37.88324' },
          { id: 3275, pid: 3267, name: '麦盖提县', code: '653127', lng: '77.64224', lat: '38.89662' },
          { id: 3276, pid: 3267, name: '岳普湖县', code: '653128', lng: '76.77233', lat: '39.23561' },
          { id: 3277, pid: 3267, name: '伽师县', code: '653129', lng: '76.72372', lat: '39.48801' },
          { id: 3278, pid: 3267, name: '巴楚县', code: '653130', lng: '78.54888', lat: '39.7855' },
          { id: 3279, pid: 3267, name: '塔什库尔干塔吉克自治县', code: '653131', lng: '75.23196', lat: '37.77893' },
        ],
      },
      {
        id: 3280,
        pid: 3206,
        name: '和田地区',
        code: '653200',
        lng: '79.92533',
        lat: '37.110687',
        children: [
          { id: 3281, pid: 3280, name: '和田市', code: '653201', lng: '79.91353', lat: '37.11214' },
          { id: 3282, pid: 3280, name: '和田县', code: '653221', lng: '79.82874', lat: '37.08922' },
          { id: 3283, pid: 3280, name: '墨玉县', code: '653222', lng: '79.74035', lat: '37.27248' },
          { id: 3284, pid: 3280, name: '皮山县', code: '653223', lng: '78.28125', lat: '37.62007' },
          { id: 3285, pid: 3280, name: '洛浦县', code: '653224', lng: '80.18536', lat: '37.07364' },
          { id: 3286, pid: 3280, name: '策勒县', code: '653225', lng: '80.80999', lat: '36.99843' },
          { id: 3287, pid: 3280, name: '于田县', code: '653226', lng: '81.66717', lat: '36.854' },
          { id: 3288, pid: 3280, name: '民丰县', code: '653227', lng: '82.68444', lat: '37.06577' },
        ],
      },
      {
        id: 3289,
        pid: 3206,
        name: '伊犁哈萨克自治州',
        code: '654000',
        lng: '81.317946',
        lat: '43.92186',
        children: [
          { id: 3290, pid: 3289, name: '伊宁市', code: '654002', lng: '81.32932', lat: '43.91294' },
          { id: 3291, pid: 3289, name: '奎屯市', code: '654003', lng: '84.90228', lat: '44.425' },
          { id: 3292, pid: 3289, name: '霍尔果斯市', code: '654004', lng: '80.418189', lat: '44.205778' },
          { id: 3293, pid: 3289, name: '伊宁县', code: '654021', lng: '81.52764', lat: '43.97863' },
          { id: 3294, pid: 3289, name: '察布查尔锡伯自治县', code: '654022', lng: '81.14956', lat: '43.84023' },
          { id: 3295, pid: 3289, name: '霍城县', code: '654023', lng: '80.87826', lat: '44.0533' },
          { id: 3296, pid: 3289, name: '巩留县', code: '654024', lng: '82.22851', lat: '43.48429' },
          { id: 3297, pid: 3289, name: '新源县', code: '654025', lng: '83.26095', lat: '43.4284' },
          { id: 3298, pid: 3289, name: '昭苏县', code: '654026', lng: '81.1307', lat: '43.15828' },
          { id: 3299, pid: 3289, name: '特克斯县', code: '654027', lng: '81.84005', lat: '43.21938' },
          { id: 3300, pid: 3289, name: '尼勒克县', code: '654028', lng: '82.51184', lat: '43.79901' },
        ],
      },
      {
        id: 3301,
        pid: 3206,
        name: '塔城地区',
        code: '654200',
        lng: '82.985732',
        lat: '46.746301',
        children: [
          { id: 3302, pid: 3301, name: '塔城市', code: '654201', lng: '82.97892', lat: '46.74852' },
          { id: 3303, pid: 3301, name: '乌苏市', code: '654202', lng: '84.68258', lat: '44.43729' },
          { id: 3304, pid: 3301, name: '额敏县', code: '654221', lng: '83.62872', lat: '46.5284' },
          { id: 3305, pid: 3301, name: '沙湾县', code: '654223', lng: '85.61932', lat: '44.33144' },
          { id: 3306, pid: 3301, name: '托里县', code: '654224', lng: '83.60592', lat: '45.93623' },
          { id: 3307, pid: 3301, name: '裕民县', code: '654225', lng: '82.99002', lat: '46.20377' },
          { id: 3308, pid: 3301, name: '和布克赛尔蒙古自治县', code: '654226', lng: '85.72662', lat: '46.79362' },
        ],
      },
      {
        id: 3309,
        pid: 3206,
        name: '阿勒泰地区',
        code: '654300',
        lng: '88.13963',
        lat: '47.848393',
        children: [
          { id: 3310, pid: 3309, name: '阿勒泰市', code: '654301', lng: '88.13913', lat: '47.8317' },
          { id: 3311, pid: 3309, name: '布尔津县', code: '654321', lng: '86.85751', lat: '47.70062' },
          { id: 3312, pid: 3309, name: '富蕴县', code: '654322', lng: '89.52679', lat: '46.99444' },
          { id: 3313, pid: 3309, name: '福海县', code: '654323', lng: '87.49508', lat: '47.11065' },
          { id: 3314, pid: 3309, name: '哈巴河县', code: '654324', lng: '86.42092', lat: '48.06046' },
          { id: 3315, pid: 3309, name: '青河县', code: '654325', lng: '90.38305', lat: '46.67382' },
          { id: 3316, pid: 3309, name: '吉木乃县', code: '654326', lng: '85.87814', lat: '47.43359' },
        ],
      },
      {
        id: 3317,
        pid: 3206,
        name: '直辖县级',
        code: '659000',
        lng: '91.132212',
        lat: '29.660361',
        children: [
          { id: 3318, pid: 3317, name: '石河子市', code: '659001', lng: '86.041075', lat: '44.305886' },
          { id: 3319, pid: 3317, name: '阿拉尔市', code: '659002', lng: '81.285884', lat: '40.541914' },
          { id: 3320, pid: 3317, name: '图木舒克市', code: '659003', lng: '79.077978', lat: '39.867316' },
          { id: 3321, pid: 3317, name: '五家渠市', code: '659004', lng: '87.526884', lat: '44.167401' },
          { id: 3322, pid: 3317, name: '北屯市', code: '659005', lng: '87.808456', lat: '47.362308' },
          { id: 3323, pid: 3317, name: '铁门关市', code: '659006', lng: '86.194687', lat: '41.811007' },
          { id: 3324, pid: 3317, name: '双河市', code: '659007', lng: '91.132212', lat: '29.660361' },
        ],
      },
    ],
  },
  {
    id: 3325,
    pid: 0,
    name: '台湾',
    code: '710000',
    lng: '121.509062',
    lat: '25.044332',
    children: [
      {
        id: 3326,
        pid: 3325,
        name: '台北市',
        code: '710100',
        lng: '121.565170',
        lat: '25.037798',
        children: [
          { id: 3327, pid: 3326, name: '松山区', code: '710101', lng: '121.577206', lat: '25.049698' },
          { id: 3328, pid: 3326, name: '信义区', code: '710102', lng: '121.751381', lat: '25.129407' },
          { id: 3329, pid: 3326, name: '大安区', code: '710103', lng: '121.534648', lat: '25.026406' },
          { id: 3330, pid: 3326, name: '中山区', code: '710104', lng: '121.533468', lat: '25.064361' },
          { id: 3331, pid: 3326, name: '中正区', code: '710105', lng: '121.518267', lat: '25.032361' },
          { id: 3332, pid: 3326, name: '大同区', code: '710106', lng: '121.515514', lat: '25.065986' },
          { id: 3333, pid: 3326, name: '万华区', code: '710107', lng: '121.499332', lat: '25.031933' },
          { id: 3334, pid: 3326, name: '文山区', code: '710108', lng: '121.570458', lat: '24.989786' },
          { id: 3335, pid: 3326, name: '南港区', code: '710109', lng: '121.606858', lat: '25.054656' },
          { id: 3336, pid: 3326, name: '内湖区', code: '710110', lng: '121.588998', lat: '25.069664' },
          { id: 3337, pid: 3326, name: '士林区', code: '710111', lng: '121.519874', lat: '25.092822' },
          { id: 3338, pid: 3326, name: '北投区', code: '710112', lng: '121.501379', lat: '25.132419' },
        ],
      },
      {
        id: 3339,
        pid: 3325,
        name: '高雄市',
        code: '710200',
        lng: '120.311922',
        lat: '22.620856',
        children: [
          { id: 3340, pid: 3339, name: '盐埕区', code: '710201', lng: '120.286795', lat: '22.624666' },
          { id: 3341, pid: 3339, name: '鼓山区', code: '710202', lng: '120.281154', lat: '22.636797' },
          { id: 3342, pid: 3339, name: '左营区', code: '710203', lng: '120.294958', lat: '22.690124' },
          { id: 3343, pid: 3339, name: '楠梓区', code: '710204', lng: '120.326314', lat: '22.728401' },
          { id: 3344, pid: 3339, name: '三民区', code: '710205', lng: '120.299622', lat: '22.647695' },
          { id: 3345, pid: 3339, name: '新兴区', code: '710206', lng: '120.309535', lat: '22.631147' },
          { id: 3346, pid: 3339, name: '前金区', code: '710207', lng: '120.294159', lat: '22.627421' },
          { id: 3347, pid: 3339, name: '苓雅区', code: '710208', lng: '120.312347', lat: '22.621770' },
          { id: 3348, pid: 3339, name: '前镇区', code: '710209', lng: '120.318583', lat: '22.586425' },
          { id: 3349, pid: 3339, name: '旗津区', code: '710210', lng: '120.284429', lat: '22.590565' },
          { id: 3350, pid: 3339, name: '小港区', code: '710211', lng: '120.337970', lat: '22.565354' },
          { id: 3351, pid: 3339, name: '凤山区', code: '710212', lng: '120.356892', lat: '22.626945' },
          { id: 3352, pid: 3339, name: '林园区', code: '710213', lng: '120.395977', lat: '22.501490' },
          { id: 3353, pid: 3339, name: '大寮区', code: '710214', lng: '120.395422', lat: '22.605386' },
          { id: 3354, pid: 3339, name: '大树区', code: '710215', lng: '120.433095', lat: '22.693394' },
          { id: 3355, pid: 3339, name: '大社区', code: '710216', lng: '120.346635', lat: '22.729966' },
          { id: 3356, pid: 3339, name: '仁武区', code: '710217', lng: '120.347779', lat: '22.701901' },
          { id: 3357, pid: 3339, name: '鸟松区', code: '710218', lng: '120.364402', lat: '22.659340' },
          { id: 3358, pid: 3339, name: '冈山区', code: '710219', lng: '120.295820', lat: '22.796762' },
          { id: 3359, pid: 3339, name: '桥头区', code: '710220', lng: '120.305741', lat: '22.757501' },
          { id: 3360, pid: 3339, name: '燕巢区', code: '710221', lng: '120.361956', lat: '22.793370' },
          { id: 3361, pid: 3339, name: '田寮区', code: '710222', lng: '120.359636', lat: '22.869307' },
          { id: 3362, pid: 3339, name: '阿莲区', code: '710223', lng: '120.327036', lat: '22.883703' },
          { id: 3363, pid: 3339, name: '路竹区', code: '710224', lng: '120.261828', lat: '22.856851' },
          { id: 3364, pid: 3339, name: '湖内区', code: '710225', lng: '120.211530', lat: '22.908188' },
          { id: 3365, pid: 3339, name: '茄萣区', code: '710226', lng: '120.182815', lat: '22.906556' },
          { id: 3366, pid: 3339, name: '永安区', code: '710227', lng: '120.225308', lat: '22.818580' },
          { id: 3367, pid: 3339, name: '弥陀区', code: '710228', lng: '120.247344', lat: '22.782879' },
          { id: 3368, pid: 3339, name: '梓官区', code: '710229', lng: '120.267322', lat: '22.760475' },
          { id: 3369, pid: 3339, name: '旗山区', code: '710230', lng: '120.483550', lat: '22.888491' },
          { id: 3370, pid: 3339, name: '美浓区', code: '710231', lng: '120.541530', lat: '22.897880' },
          { id: 3371, pid: 3339, name: '六龟区', code: '710232', lng: '120.633418', lat: '22.997914' },
          { id: 3372, pid: 3339, name: '甲仙区', code: '710233', lng: '120.591185', lat: '23.084688' },
          { id: 3373, pid: 3339, name: '杉林区', code: '710234', lng: '120.538980', lat: '22.970712' },
          { id: 3374, pid: 3339, name: '内门区', code: '710235', lng: '120.462351', lat: '22.943437' },
          { id: 3375, pid: 3339, name: '茂林区', code: '710236', lng: '120.663217', lat: '22.886248' },
          { id: 3376, pid: 3339, name: '桃源区', code: '710237', lng: '120.760049', lat: '23.159137' },
          { id: 3377, pid: 3339, name: '那玛夏区', code: '710238', lng: '120.692799', lat: '23.216964' },
        ],
      },
      {
        id: 3378,
        pid: 3325,
        name: '基隆市',
        code: '710300',
        lng: '121.746248',
        lat: '25.130741',
        children: [
          { id: 3379, pid: 3378, name: '中正区', code: '710301', lng: '121.518267', lat: '25.032361' },
          { id: 3380, pid: 3378, name: '七堵区', code: '710302', lng: '121.713032', lat: '25.095739' },
          { id: 3381, pid: 3378, name: '暖暖区', code: '710303', lng: '121.736102', lat: '25.099777' },
          { id: 3382, pid: 3378, name: '仁爱区', code: '710304', lng: '121.740940', lat: '25.127526' },
          { id: 3383, pid: 3378, name: '中山区', code: '710305', lng: '121.739132', lat: '25.133991' },
          { id: 3384, pid: 3378, name: '安乐区', code: '710306', lng: '121.723203', lat: '25.120910' },
          { id: 3385, pid: 3378, name: '信义区', code: '710307', lng: '121.751381', lat: '25.129407' },
        ],
      },
      {
        id: 3386,
        pid: 3325,
        name: '台中市',
        code: '710400',
        lng: '120.679040',
        lat: '24.138620',
        children: [
          { id: 3387, pid: 3386, name: '中区', code: '710401', lng: '120.679510', lat: '24.143830' },
          { id: 3388, pid: 3386, name: '东区', code: '710402', lng: '120.704', lat: '24.13662' },
          { id: 3389, pid: 3386, name: '南区', code: '710403', lng: '120.188648', lat: '22.960944' },
          { id: 3390, pid: 3386, name: '西区', code: '710404', lng: '120.67104', lat: '24.14138' },
          { id: 3391, pid: 3386, name: '北区', code: '710405', lng: '120.682410', lat: '24.166040' },
          { id: 3392, pid: 3386, name: '西屯区', code: '710406', lng: '120.639820', lat: '24.181340' },
          { id: 3393, pid: 3386, name: '南屯区', code: '710407', lng: '120.643080', lat: '24.138270' },
          { id: 3394, pid: 3386, name: '北屯区', code: '710408', lng: '120.686250', lat: '24.182220' },
          { id: 3395, pid: 3386, name: '丰原区', code: '710409', lng: '120.718460', lat: '24.242190' },
          { id: 3396, pid: 3386, name: '东势区', code: '710410', lng: '120.827770', lat: '24.258610' },
          { id: 3397, pid: 3386, name: '大甲区', code: '710411', lng: '120.622390', lat: '24.348920' },
          { id: 3398, pid: 3386, name: '清水区', code: '710412', lng: '120.559780', lat: '24.268650' },
          { id: 3399, pid: 3386, name: '沙鹿区', code: '710413', lng: '120.565700', lat: '24.233480' },
          { id: 3400, pid: 3386, name: '梧栖区', code: '710414', lng: '120.531520', lat: '24.254960' },
          { id: 3401, pid: 3386, name: '后里区', code: '710415', lng: '120.710710', lat: '24.304910' },
          { id: 3402, pid: 3386, name: '神冈区', code: '710416', lng: '120.661550', lat: '24.257770' },
          { id: 3403, pid: 3386, name: '潭子区', code: '710417', lng: '120.705160', lat: '24.209530' },
          { id: 3404, pid: 3386, name: '大雅区', code: '710418', lng: '120.647780', lat: '24.229230' },
          { id: 3405, pid: 3386, name: '新社区', code: '710419', lng: '120.809500', lat: '24.234140' },
          { id: 3406, pid: 3386, name: '石冈区', code: '710420', lng: '120.780410', lat: '24.274980' },
          { id: 3407, pid: 3386, name: '外埔区', code: '710421', lng: '120.654370', lat: '24.332010' },
          { id: 3408, pid: 3386, name: '大安区', code: '710422', lng: '120.58652', lat: '24.34607' },
          { id: 3409, pid: 3386, name: '乌日区', code: '710423', lng: '120.623810', lat: '24.104500' },
          { id: 3410, pid: 3386, name: '大肚区', code: '710424', lng: '120.540960', lat: '24.153660' },
          { id: 3411, pid: 3386, name: '龙井区', code: '710425', lng: '120.545940', lat: '24.192710' },
          { id: 3412, pid: 3386, name: '雾峰区', code: '710426', lng: '120.700200', lat: '24.061520' },
          { id: 3413, pid: 3386, name: '太平区', code: '710427', lng: '120.718523', lat: '24.126472' },
          { id: 3414, pid: 3386, name: '大里区', code: '710428', lng: '120.677860', lat: '24.099390' },
          { id: 3415, pid: 3386, name: '和平区', code: '710429', lng: '120.88349', lat: '24.17477' },
        ],
      },
      {
        id: 3416,
        pid: 3325,
        name: '台南市',
        code: '710500',
        lng: '120.279363',
        lat: '23.172478',
        children: [
          { id: 3417, pid: 3416, name: '东区', code: '710501', lng: '120.224198', lat: '22.980072' },
          { id: 3418, pid: 3416, name: '南区', code: '710502', lng: '120.188648', lat: '22.960944' },
          { id: 3419, pid: 3416, name: '北区', code: '710504', lng: '120.682410', lat: '24.166040' },
          { id: 3420, pid: 3416, name: '安南区', code: '710506', lng: '120.184617', lat: '23.047230' },
          { id: 3421, pid: 3416, name: '安平区', code: '710507', lng: '120.166810', lat: '23.000763' },
          { id: 3422, pid: 3416, name: '中西区', code: '710508', lng: '120.205957', lat: '22.992152' },
          { id: 3423, pid: 3416, name: '新营区', code: '710509', lng: '120.316698', lat: '23.310274' },
          { id: 3424, pid: 3416, name: '盐水区', code: '710510', lng: '120.266398', lat: '23.319828' },
          { id: 3425, pid: 3416, name: '白河区', code: '710511', lng: '120.415810', lat: '23.351221' },
          { id: 3426, pid: 3416, name: '柳营区', code: '710512', lng: '120.311286', lat: '23.278133' },
          { id: 3427, pid: 3416, name: '后壁区', code: '710513', lng: '120.362726', lat: '23.366721' },
          { id: 3428, pid: 3416, name: '东山区', code: '710514', lng: '120.403984', lat: '23.326092' },
          { id: 3429, pid: 3416, name: '麻豆区', code: '710515', lng: '120.248179', lat: '23.181680' },
          { id: 3430, pid: 3416, name: '下营区', code: '710516', lng: '120.264484', lat: '23.235413' },
          { id: 3431, pid: 3416, name: '六甲区', code: '710517', lng: '120.347600', lat: '23.231931' },
          { id: 3432, pid: 3416, name: '官田区', code: '710518', lng: '120.314374', lat: '23.194652' },
          { id: 3433, pid: 3416, name: '大内区', code: '710519', lng: '120.348853', lat: '23.119460' },
          { id: 3434, pid: 3416, name: '佳里区', code: '710520', lng: '120.177211', lat: '23.165121' },
          { id: 3435, pid: 3416, name: '学甲区', code: '710521', lng: '120.180255', lat: '23.232348' },
          { id: 3436, pid: 3416, name: '西港区', code: '710522', lng: '120.203618', lat: '23.123057' },
          { id: 3437, pid: 3416, name: '七股区', code: '710523', lng: '120.140003', lat: '23.140545' },
          { id: 3438, pid: 3416, name: '将军区', code: '710524', lng: '120.156871', lat: '23.199543' },
          { id: 3439, pid: 3416, name: '北门区', code: '710525', lng: '120.125821', lat: '23.267148' },
          { id: 3440, pid: 3416, name: '新化区', code: '710526', lng: '120.310807', lat: '23.038533' },
          { id: 3441, pid: 3416, name: '善化区', code: '710527', lng: '120.296895', lat: '23.132261' },
          { id: 3442, pid: 3416, name: '新市区', code: '710528', lng: '120.295138', lat: '23.07897' },
          { id: 3443, pid: 3416, name: '安定区', code: '710529', lng: '120.237083', lat: '23.121498' },
          { id: 3444, pid: 3416, name: '山上区', code: '710530', lng: '120.352908', lat: '23.103223' },
          { id: 3445, pid: 3416, name: '玉井区', code: '710531', lng: '120.460110', lat: '23.123859' },
          { id: 3446, pid: 3416, name: '楠西区', code: '710532', lng: '120.485396', lat: '23.173454' },
          { id: 3447, pid: 3416, name: '南化区', code: '710533', lng: '120.477116', lat: '23.042614' },
          { id: 3448, pid: 3416, name: '左镇区', code: '710534', lng: '120.407309', lat: '23.057955' },
          { id: 3449, pid: 3416, name: '仁德区', code: '710535', lng: '120.251520', lat: '22.972212' },
          { id: 3450, pid: 3416, name: '归仁区', code: '710536', lng: '120.293791', lat: '22.967081' },
          { id: 3451, pid: 3416, name: '关庙区', code: '710537', lng: '120.327689', lat: '22.962949' },
          { id: 3452, pid: 3416, name: '龙崎区', code: '710538', lng: '120.360824', lat: '22.965681' },
          { id: 3453, pid: 3416, name: '永康区', code: '710539', lng: '120.257069', lat: '23.026061' },
        ],
      },
      {
        id: 3454,
        pid: 3325,
        name: '新竹市',
        code: '710600',
        lng: '120.968798',
        lat: '24.806738',
        children: [
          { id: 3455, pid: 3454, name: '东区', code: '710601', lng: '120.970239', lat: '24.801337' },
          { id: 3456, pid: 3454, name: '北区', code: '710602', lng: '120.682410', lat: '24.166040' },
          { id: 3457, pid: 3454, name: '香山区', code: '710603', lng: '120.956679', lat: '24.768933' },
        ],
      },
      {
        id: 3458,
        pid: 3325,
        name: '嘉义市',
        code: '710700',
        lng: '120.452538',
        lat: '23.481568',
        children: [
          { id: 3459, pid: 3458, name: '东区', code: '710701', lng: '120.458009', lat: '23.486213' },
          { id: 3460, pid: 3458, name: '西区', code: '710702', lng: '120.437493', lat: '23.473029' },
        ],
      },
      {
        id: 3461,
        pid: 3325,
        name: '新北市',
        code: '710800',
        lng: '121.465746',
        lat: '25.012366',
        children: [
          { id: 3462, pid: 3461, name: '板桥区', code: '710801', lng: '121.459084', lat: '25.009578' },
          { id: 3463, pid: 3461, name: '三重区', code: '710802', lng: '121.488102', lat: '25.061486' },
          { id: 3464, pid: 3461, name: '中和区', code: '710803', lng: '121.498980', lat: '24.999397' },
          { id: 3465, pid: 3461, name: '永和区', code: '710804', lng: '121.513660', lat: '25.007802' },
          { id: 3466, pid: 3461, name: '新庄区', code: '710805', lng: '121.450413', lat: '25.035947' },
          { id: 3467, pid: 3461, name: '新店区', code: '710806', lng: '121.541750', lat: '24.967558' },
          { id: 3468, pid: 3461, name: '树林区', code: '710807', lng: '121.420533', lat: '24.990706' },
          { id: 3469, pid: 3461, name: '莺歌区', code: '710808', lng: '121.354573', lat: '24.955413' },
          { id: 3470, pid: 3461, name: '三峡区', code: '710809', lng: '121.368905', lat: '24.934339' },
          { id: 3471, pid: 3461, name: '淡水区', code: '710810', lng: '121.440915', lat: '25.169452' },
          { id: 3472, pid: 3461, name: '汐止区', code: '710811', lng: '121.629470', lat: '25.062999' },
          { id: 3473, pid: 3461, name: '瑞芳区', code: '710812', lng: '121.810061', lat: '25.108895' },
          { id: 3474, pid: 3461, name: '土城区', code: '710813', lng: '121.443348', lat: '24.972201' },
          { id: 3475, pid: 3461, name: '芦洲区', code: '710814', lng: '121.473700', lat: '25.084923' },
          { id: 3476, pid: 3461, name: '五股区', code: '710815', lng: '121.438156', lat: '25.082743' },
          { id: 3477, pid: 3461, name: '泰山区', code: '710816', lng: '121.430811', lat: '25.058864' },
          { id: 3478, pid: 3461, name: '林口区', code: '710817', lng: '121.391602', lat: '25.077531' },
          { id: 3479, pid: 3461, name: '深坑区', code: '710818', lng: '121.615670', lat: '25.002329' },
          { id: 3480, pid: 3461, name: '石碇区', code: '710819', lng: '121.658567', lat: '24.991679' },
          { id: 3481, pid: 3461, name: '坪林区', code: '710820', lng: '121.711185', lat: '24.937388' },
          { id: 3482, pid: 3461, name: '三芝区', code: '710821', lng: '121.500866', lat: '25.258047' },
          { id: 3483, pid: 3461, name: '石门区', code: '710822', lng: '121.568491', lat: '25.290412' },
          { id: 3484, pid: 3461, name: '八里区', code: '710823', lng: '121.398227', lat: '25.146680' },
          { id: 3485, pid: 3461, name: '平溪区', code: '710824', lng: '121.738255', lat: '25.025725' },
          { id: 3486, pid: 3461, name: '双溪区', code: '710825', lng: '121.865676', lat: '25.033409' },
          { id: 3487, pid: 3461, name: '贡寮区', code: '710826', lng: '121.908185', lat: '25.022388' },
          { id: 3488, pid: 3461, name: '金山区', code: '710827', lng: '121.636427', lat: '25.221883' },
          { id: 3489, pid: 3461, name: '万里区', code: '710828', lng: '121.688687', lat: '25.181234' },
          { id: 3490, pid: 3461, name: '乌来区', code: '710829', lng: '121.550531', lat: '24.865296' },
        ],
      },
      {
        id: 3491,
        pid: 3325,
        name: '宜兰县',
        code: '712200',
        lng: '121.500000',
        lat: '24.600000',
        children: [
          { id: 3492, pid: 3491, name: '宜兰市', code: '712201', lng: '121.753476', lat: '24.751682' },
          { id: 3493, pid: 3491, name: '罗东镇', code: '712221', lng: '121.766919', lat: '24.677033' },
          { id: 3494, pid: 3491, name: '苏澳镇', code: '712222', lng: '121.842656', lat: '24.594622' },
          { id: 3495, pid: 3491, name: '头城镇', code: '712223', lng: '121.823307', lat: '24.859217' },
          { id: 3496, pid: 3491, name: '礁溪乡', code: '712224', lng: '121.766680', lat: '24.822345' },
          { id: 3497, pid: 3491, name: '壮围乡', code: '712225', lng: '121.781619', lat: '24.744949' },
          { id: 3498, pid: 3491, name: '员山乡', code: '712226', lng: '121.721733', lat: '24.741771' },
          { id: 3499, pid: 3491, name: '冬山乡', code: '712227', lng: '121.792280', lat: '24.634514' },
          { id: 3500, pid: 3491, name: '五结乡', code: '712228', lng: '121.798297', lat: '24.684640' },
          { id: 3501, pid: 3491, name: '三星乡', code: '712229', lng: '121.003418', lat: '23.775291' },
          { id: 3502, pid: 3491, name: '大同乡', code: '712230', lng: '121.605557', lat: '24.675997' },
          { id: 3503, pid: 3491, name: '南澳乡', code: '712231', lng: '121.799810', lat: '24.465393' },
        ],
      },
      {
        id: 3504,
        pid: 3325,
        name: '桃园县',
        code: '712300',
        lng: '121.083000',
        lat: '25.000000',
        children: [
          { id: 3505, pid: 3504, name: '桃园市', code: '712301', lng: '121.301337', lat: '24.993777' },
          { id: 3506, pid: 3504, name: '中坜市', code: '712302', lng: '121.224926', lat: '24.965353' },
          { id: 3507, pid: 3504, name: '平镇市', code: '712303', lng: '121.218359', lat: '24.945752' },
          { id: 3508, pid: 3504, name: '八德市', code: '712304', lng: '121.284655', lat: '24.928651' },
          { id: 3509, pid: 3504, name: '杨梅市', code: '712305', lng: '121.145873', lat: '24.907575' },
          { id: 3510, pid: 3504, name: '芦竹市', code: '712306', lng: '121.292064', lat: '25.045392' },
          { id: 3511, pid: 3504, name: '大溪镇', code: '712321', lng: '121.286962', lat: '24.880584' },
          { id: 3512, pid: 3504, name: '大园乡', code: '712324', lng: '121.196292', lat: '25.064471' },
          { id: 3513, pid: 3504, name: '龟山乡', code: '712325', lng: '121.337767', lat: '24.992517' },
          { id: 3514, pid: 3504, name: '龙潭乡', code: '712327', lng: '121.216392', lat: '24.863851' },
          { id: 3515, pid: 3504, name: '新屋乡', code: '712329', lng: '121.105801', lat: '24.972203' },
          { id: 3516, pid: 3504, name: '观音乡', code: '712330', lng: '121.077519', lat: '25.033303' },
          { id: 3517, pid: 3504, name: '复兴乡', code: '712331', lng: '121.352613', lat: '24.820908' },
        ],
      },
      {
        id: 3518,
        pid: 3325,
        name: '新竹县',
        code: '712400',
        lng: '121.160000',
        lat: '24.600000',
        children: [
          { id: 3519, pid: 3518, name: '竹北市', code: '712401', lng: '121.004317', lat: '24.839652' },
          { id: 3520, pid: 3518, name: '竹东镇', code: '712421', lng: '121.086418', lat: '24.733601' },
          { id: 3521, pid: 3518, name: '新埔镇', code: '712422', lng: '121.072804', lat: '24.824820' },
          { id: 3522, pid: 3518, name: '关西镇', code: '712423', lng: '121.177301', lat: '24.788842' },
          { id: 3523, pid: 3518, name: '湖口乡', code: '712424', lng: '121.043691', lat: '24.903943' },
          { id: 3524, pid: 3518, name: '新丰乡', code: '712425', lng: '120.983006', lat: '24.899600' },
          { id: 3525, pid: 3518, name: '芎林乡', code: '712426', lng: '121.076924', lat: '24.774436' },
          { id: 3526, pid: 3518, name: '横山乡', code: '712427', lng: '121.116244', lat: '24.720807' },
          { id: 3527, pid: 3518, name: '北埔乡', code: '712428', lng: '121.053156', lat: '24.697126' },
          { id: 3528, pid: 3518, name: '宝山乡', code: '712429', lng: '120.985752', lat: '24.760975' },
          { id: 3529, pid: 3518, name: '峨眉乡', code: '712430', lng: '121.015291', lat: '24.686127' },
          { id: 3530, pid: 3518, name: '尖石乡', code: '712431', lng: '121.197802', lat: '24.704360' },
          { id: 3531, pid: 3518, name: '五峰乡', code: '712432', lng: '121.003418', lat: '23.775291' },
        ],
      },
      {
        id: 3532,
        pid: 3325,
        name: '苗栗县',
        code: '712500',
        lng: '120.750000',
        lat: '24.500000',
        children: [
          { id: 3533, pid: 3532, name: '苗栗市', code: '712501', lng: '120.818869', lat: '24.561472' },
          { id: 3534, pid: 3532, name: '苑里镇', code: '712521', lng: '120.648907', lat: '24.441750' },
          { id: 3535, pid: 3532, name: '通霄镇', code: '712522', lng: '120.676700', lat: '24.489087' },
          { id: 3536, pid: 3532, name: '竹南镇', code: '712523', lng: '120.872641', lat: '24.685513' },
          { id: 3537, pid: 3532, name: '头份镇', code: '712524', lng: '120.895188', lat: '24.687993' },
          { id: 3538, pid: 3532, name: '后龙镇', code: '712525', lng: '120.786480', lat: '24.612617' },
          { id: 3539, pid: 3532, name: '卓兰镇', code: '712526', lng: '120.823441', lat: '24.309509' },
          { id: 3540, pid: 3532, name: '大湖乡', code: '712527', lng: '120.863641', lat: '24.422547' },
          { id: 3541, pid: 3532, name: '公馆乡', code: '712528', lng: '120.822983', lat: '24.499108' },
          { id: 3542, pid: 3532, name: '铜锣乡', code: '712529', lng: '121.003418', lat: '23.775291' },
          { id: 3543, pid: 3532, name: '南庄乡', code: '712530', lng: '120.994957', lat: '24.596835' },
          { id: 3544, pid: 3532, name: '头屋乡', code: '712531', lng: '120.846616', lat: '24.574249' },
          { id: 3545, pid: 3532, name: '三义乡', code: '712532', lng: '120.742340', lat: '24.350270' },
          { id: 3546, pid: 3532, name: '西湖乡', code: '712533', lng: '121.003418', lat: '23.775291' },
          { id: 3547, pid: 3532, name: '造桥乡', code: '712534', lng: '120.862399', lat: '24.637537' },
          { id: 3548, pid: 3532, name: '三湾乡', code: '712535', lng: '120.951484', lat: '24.651051' },
          { id: 3549, pid: 3532, name: '狮潭乡', code: '712536', lng: '120.918024', lat: '24.540004' },
          { id: 3550, pid: 3532, name: '泰安乡', code: '712537', lng: '120.904441', lat: '24.442600' },
        ],
      },
      {
        id: 3551,
        pid: 3325,
        name: '彰化县',
        code: '712700',
        lng: '120.416000',
        lat: '24.000000',
        children: [
          { id: 3552, pid: 3551, name: '彰化市', code: '712701', lng: '120.542294', lat: '24.080911' },
          { id: 3553, pid: 3551, name: '鹿港镇', code: '712721', lng: '120.435392', lat: '24.056937' },
          { id: 3554, pid: 3551, name: '和美镇', code: '712722', lng: '120.500265', lat: '24.110904' },
          { id: 3555, pid: 3551, name: '线西乡', code: '712723', lng: '120.465921', lat: '24.128653' },
          { id: 3556, pid: 3551, name: '伸港乡', code: '712724', lng: '120.484224', lat: '24.146081' },
          { id: 3557, pid: 3551, name: '福兴乡', code: '712725', lng: '120.443682', lat: '24.047883' },
          { id: 3558, pid: 3551, name: '秀水乡', code: '712726', lng: '120.502658', lat: '24.035267' },
          { id: 3559, pid: 3551, name: '花坛乡', code: '712727', lng: '120.538403', lat: '24.029399' },
          { id: 3560, pid: 3551, name: '芬园乡', code: '712728', lng: '120.629024', lat: '24.013658' },
          { id: 3561, pid: 3551, name: '员林镇', code: '712729', lng: '120.574625', lat: '23.958999' },
          { id: 3562, pid: 3551, name: '溪湖镇', code: '712730', lng: '120.479144', lat: '23.962315' },
          { id: 3563, pid: 3551, name: '田中镇', code: '712731', lng: '120.580629', lat: '23.861718' },
          { id: 3564, pid: 3551, name: '大村乡', code: '712732', lng: '120.540713', lat: '23.993726' },
          { id: 3565, pid: 3551, name: '埔盐乡', code: '712733', lng: '120.464044', lat: '24.000346' },
          { id: 3566, pid: 3551, name: '埔心乡', code: '712734', lng: '120.543568', lat: '23.953019' },
          { id: 3567, pid: 3551, name: '永靖乡', code: '712735', lng: '120.547775', lat: '23.924703' },
          { id: 3568, pid: 3551, name: '社头乡', code: '712736', lng: '120.582681', lat: '23.896686' },
          { id: 3569, pid: 3551, name: '二水乡', code: '712737', lng: '120.618788', lat: '23.806995' },
          { id: 3570, pid: 3551, name: '北斗镇', code: '712738', lng: '120.520449', lat: '23.870911' },
          { id: 3571, pid: 3551, name: '二林镇', code: '712739', lng: '120.374468', lat: '23.899751' },
          { id: 3572, pid: 3551, name: '田尾乡', code: '712740', lng: '120.524717', lat: '23.890735' },
          { id: 3573, pid: 3551, name: '埤头乡', code: '712741', lng: '120.462599', lat: '23.891324' },
          { id: 3574, pid: 3551, name: '芳苑乡', code: '712742', lng: '120.320329', lat: '23.924222' },
          { id: 3575, pid: 3551, name: '大城乡', code: '712743', lng: '120.320934', lat: '23.852382' },
          { id: 3576, pid: 3551, name: '竹塘乡', code: '712744', lng: '120.427499', lat: '23.860112' },
          { id: 3577, pid: 3551, name: '溪州乡', code: '712745', lng: '120.498706', lat: '23.851229' },
        ],
      },
      {
        id: 3578,
        pid: 3325,
        name: '南投县',
        code: '712800',
        lng: '120.830000',
        lat: '23.830000',
        children: [
          { id: 3579, pid: 3578, name: '南投市', code: '712801', lng: '120.683706', lat: '23.909956' },
          { id: 3580, pid: 3578, name: '埔里镇', code: '712821', lng: '120.964648', lat: '23.964789' },
          { id: 3581, pid: 3578, name: '草屯镇', code: '712822', lng: '120.680343', lat: '23.973947' },
          { id: 3582, pid: 3578, name: '竹山镇', code: '712823', lng: '120.672007', lat: '23.757655' },
          { id: 3583, pid: 3578, name: '集集镇', code: '712824', lng: '120.783673', lat: '23.829013' },
          { id: 3584, pid: 3578, name: '名间乡', code: '712825', lng: '120.702797', lat: '23.838427' },
          { id: 3585, pid: 3578, name: '鹿谷乡', code: '712826', lng: '120.752796', lat: '23.744471' },
          { id: 3586, pid: 3578, name: '中寮乡', code: '712827', lng: '120.766654', lat: '23.878935' },
          { id: 3587, pid: 3578, name: '鱼池乡', code: '712828', lng: '120.936060', lat: '23.896356' },
          { id: 3588, pid: 3578, name: '国姓乡', code: '712829', lng: '120.858541', lat: '24.042298' },
          { id: 3589, pid: 3578, name: '水里乡', code: '712830', lng: '120.855912', lat: '23.812086' },
          { id: 3590, pid: 3578, name: '信义乡', code: '712831', lng: '120.855257', lat: '23.699922' },
          { id: 3591, pid: 3578, name: '仁爱乡', code: '712832', lng: '121.133543', lat: '24.024429' },
        ],
      },
      {
        id: 3592,
        pid: 3325,
        name: '云林县',
        code: '712900',
        lng: '120.250000',
        lat: '23.750000',
        children: [
          { id: 3593, pid: 3592, name: '斗六市', code: '712901', lng: '120.527360', lat: '23.697651' },
          { id: 3594, pid: 3592, name: '斗南镇', code: '712921', lng: '120.479075', lat: '23.679731' },
          { id: 3595, pid: 3592, name: '虎尾镇', code: '712922', lng: '120.445339', lat: '23.708182' },
          { id: 3596, pid: 3592, name: '西螺镇', code: '712923', lng: '120.466010', lat: '23.797984' },
          { id: 3597, pid: 3592, name: '土库镇', code: '712924', lng: '120.392572', lat: '23.677822' },
          { id: 3598, pid: 3592, name: '北港镇', code: '712925', lng: '120.302393', lat: '23.575525' },
          { id: 3599, pid: 3592, name: '古坑乡', code: '712926', lng: '120.562043', lat: '23.642568' },
          { id: 3600, pid: 3592, name: '大埤乡', code: '712927', lng: '120.430516', lat: '23.645908' },
          { id: 3601, pid: 3592, name: '莿桐乡', code: '712928', lng: '120.502374', lat: '23.760784' },
          { id: 3602, pid: 3592, name: '林内乡', code: '712929', lng: '120.611365', lat: '23.758712' },
          { id: 3603, pid: 3592, name: '二仑乡', code: '712930', lng: '120.415077', lat: '23.771273' },
          { id: 3604, pid: 3592, name: '仑背乡', code: '712931', lng: '120.353895', lat: '23.758840' },
          { id: 3605, pid: 3592, name: '麦寮乡', code: '712932', lng: '120.252043', lat: '23.753841' },
          { id: 3606, pid: 3592, name: '东势乡', code: '712933', lng: '120.252672', lat: '23.674679' },
          { id: 3607, pid: 3592, name: '褒忠乡', code: '712934', lng: '120.310488', lat: '23.694245' },
          { id: 3608, pid: 3592, name: '台西乡', code: '712935', lng: '120.196141', lat: '23.702819' },
          { id: 3609, pid: 3592, name: '元长乡', code: '712936', lng: '120.315124', lat: '23.649458' },
          { id: 3610, pid: 3592, name: '四湖乡', code: '712937', lng: '120.225741', lat: '23.637740' },
          { id: 3611, pid: 3592, name: '口湖乡', code: '712938', lng: '120.185370', lat: '23.582406' },
          { id: 3612, pid: 3592, name: '水林乡', code: '712939', lng: '120.245948', lat: '23.572634' },
        ],
      },
      {
        id: 3613,
        pid: 3325,
        name: '嘉义县',
        code: '713000',
        lng: '120.300000',
        lat: '23.500000',
        children: [
          { id: 3614, pid: 3613, name: '太保市', code: '713001', lng: '120.332876', lat: '23.459647' },
          { id: 3615, pid: 3613, name: '朴子市', code: '713002', lng: '120.247014', lat: '23.464961' },
          { id: 3616, pid: 3613, name: '布袋镇', code: '713023', lng: '120.166936', lat: '23.377979' },
          { id: 3617, pid: 3613, name: '大林镇', code: '713024', lng: '120.471336', lat: '23.603815' },
          { id: 3618, pid: 3613, name: '民雄乡', code: '713025', lng: '120.428577', lat: '23.551456' },
          { id: 3619, pid: 3613, name: '溪口乡', code: '713026', lng: '120.393822', lat: '23.602223' },
          { id: 3620, pid: 3613, name: '新港乡', code: '713027', lng: '120.347647', lat: '23.551806' },
          { id: 3621, pid: 3613, name: '六脚乡', code: '713028', lng: '120.291083', lat: '23.493942' },
          { id: 3622, pid: 3613, name: '东石乡', code: '713029', lng: '120.153822', lat: '23.459235' },
          { id: 3623, pid: 3613, name: '义竹乡', code: '713030', lng: '120.243423', lat: '23.336277' },
          { id: 3624, pid: 3613, name: '鹿草乡', code: '713031', lng: '120.308370', lat: '23.410784' },
          { id: 3625, pid: 3613, name: '水上乡', code: '713032', lng: '120.397936', lat: '23.428104' },
          { id: 3626, pid: 3613, name: '中埔乡', code: '713033', lng: '120.522948', lat: '23.425148' },
          { id: 3627, pid: 3613, name: '竹崎乡', code: '713034', lng: '120.551466', lat: '23.523184' },
          { id: 3628, pid: 3613, name: '梅山乡', code: '713035', lng: '120.557192', lat: '23.584915' },
          { id: 3629, pid: 3613, name: '番路乡', code: '713036', lng: '120.555043', lat: '23.465222' },
          { id: 3630, pid: 3613, name: '大埔乡', code: '713037', lng: '120.593795', lat: '23.296715' },
          { id: 3631, pid: 3613, name: '阿里山乡', code: '713038', lng: '120.732520', lat: '23.467950' },
        ],
      },
      {
        id: 3632,
        pid: 3325,
        name: '屏东县',
        code: '713300',
        lng: '120.487928',
        lat: '22.682802',
        children: [
          { id: 3633, pid: 3632, name: '屏东市', code: '713301', lng: '120.488465', lat: '22.669723' },
          { id: 3634, pid: 3632, name: '潮州镇', code: '713321', lng: '120.542854', lat: '22.550536' },
          { id: 3635, pid: 3632, name: '东港镇', code: '713322', lng: '120.454489', lat: '22.466626' },
          { id: 3636, pid: 3632, name: '恒春镇', code: '713323', lng: '120.745451', lat: '22.002373' },
          { id: 3637, pid: 3632, name: '万丹乡', code: '713324', lng: '120.484533', lat: '22.589839' },
          { id: 3638, pid: 3632, name: '长治乡', code: '713325', lng: '120.527614', lat: '22.677062' },
          { id: 3639, pid: 3632, name: '麟洛乡', code: '713326', lng: '120.527283', lat: '22.650604' },
          { id: 3640, pid: 3632, name: '九如乡', code: '713327', lng: '120.490142', lat: '22.739778' },
          { id: 3641, pid: 3632, name: '里港乡', code: '713328', lng: '120.494490', lat: '22.779220' },
          { id: 3642, pid: 3632, name: '盐埔乡', code: '713329', lng: '120.572849', lat: '22.754783' },
          { id: 3643, pid: 3632, name: '高树乡', code: '713330', lng: '120.600214', lat: '22.826789' },
          { id: 3644, pid: 3632, name: '万峦乡', code: '713331', lng: '120.566477', lat: '22.571965' },
          { id: 3645, pid: 3632, name: '内埔乡', code: '713332', lng: '120.566865', lat: '22.611967' },
          { id: 3646, pid: 3632, name: '竹田乡', code: '713333', lng: '120.544038', lat: '22.584678' },
          { id: 3647, pid: 3632, name: '新埤乡', code: '713334', lng: '120.549546', lat: '22.469976' },
          { id: 3648, pid: 3632, name: '枋寮乡', code: '713335', lng: '120.593438', lat: '22.365560' },
          { id: 3649, pid: 3632, name: '新园乡', code: '713336', lng: '120.461739', lat: '22.543952' },
          { id: 3650, pid: 3632, name: '崁顶乡', code: '713337', lng: '120.514571', lat: '22.514795' },
          { id: 3651, pid: 3632, name: '林边乡', code: '713338', lng: '120.515091', lat: '22.434015' },
          { id: 3652, pid: 3632, name: '南州乡', code: '713339', lng: '120.509808', lat: '22.490192' },
          { id: 3653, pid: 3632, name: '佳冬乡', code: '713340', lng: '120.551544', lat: '22.417653' },
          { id: 3654, pid: 3632, name: '琉球乡', code: '713341', lng: '120.369020', lat: '22.342366' },
          { id: 3655, pid: 3632, name: '车城乡', code: '713342', lng: '120.710979', lat: '22.072077' },
          { id: 3656, pid: 3632, name: '满州乡', code: '713343', lng: '120.838843', lat: '22.020853' },
          { id: 3657, pid: 3632, name: '枋山乡', code: '713344', lng: '120.656356', lat: '22.260338' },
          { id: 3658, pid: 3632, name: '三地门乡', code: '713345', lng: '120.654486', lat: '22.713877' },
          { id: 3659, pid: 3632, name: '雾台乡', code: '713346', lng: '120.732318', lat: '22.744877' },
          { id: 3660, pid: 3632, name: '玛家乡', code: '713347', lng: '120.644130', lat: '22.706718' },
          { id: 3661, pid: 3632, name: '泰武乡', code: '713348', lng: '120.632856', lat: '22.591819' },
          { id: 3662, pid: 3632, name: '来义乡', code: '713349', lng: '120.633601', lat: '22.525866' },
          { id: 3663, pid: 3632, name: '春日乡', code: '713350', lng: '120.628793', lat: '22.370672' },
          { id: 3664, pid: 3632, name: '狮子乡', code: '713351', lng: '120.704617', lat: '22.201917' },
          { id: 3665, pid: 3632, name: '牡丹乡', code: '713352', lng: '120.770108', lat: '22.125687' },
        ],
      },
      {
        id: 3666,
        pid: 3325,
        name: '台东县',
        code: '713400',
        lng: '120.916000',
        lat: '23.000000',
        children: [
          { id: 3667, pid: 3666, name: '台东市', code: '713401', lng: '121.145654', lat: '22.756045' },
          { id: 3668, pid: 3666, name: '成功镇', code: '713421', lng: '121.379571', lat: '23.100223' },
          { id: 3669, pid: 3666, name: '关山镇', code: '713422', lng: '121.163134', lat: '23.047450' },
          { id: 3670, pid: 3666, name: '卑南乡', code: '713423', lng: '121.083503', lat: '22.786039' },
          { id: 3671, pid: 3666, name: '鹿野乡', code: '713424', lng: '121.135982', lat: '22.913951' },
          { id: 3672, pid: 3666, name: '池上乡', code: '713425', lng: '121.215139', lat: '23.122393' },
          { id: 3673, pid: 3666, name: '东河乡', code: '713426', lng: '121.300334', lat: '22.969934' },
          { id: 3674, pid: 3666, name: '长滨乡', code: '713427', lng: '121.451522', lat: '23.315041' },
          { id: 3675, pid: 3666, name: '太麻里乡', code: '713428', lng: '121.007394', lat: '22.615383' },
          { id: 3676, pid: 3666, name: '大武乡', code: '713429', lng: '120.889938', lat: '22.339919' },
          { id: 3677, pid: 3666, name: '绿岛乡', code: '713430', lng: '121.492596', lat: '22.661676' },
          { id: 3678, pid: 3666, name: '海端乡', code: '713431', lng: '121.172008', lat: '23.101074' },
          { id: 3679, pid: 3666, name: '延平乡', code: '713432', lng: '121.084499', lat: '22.902358' },
          { id: 3680, pid: 3666, name: '金峰乡', code: '713433', lng: '120.971292', lat: '22.595511' },
          { id: 3681, pid: 3666, name: '达仁乡', code: '713434', lng: '120.884131', lat: '22.294869' },
          { id: 3682, pid: 3666, name: '兰屿乡', code: '713435', lng: '121.532473', lat: '22.056736' },
        ],
      },
      {
        id: 3683,
        pid: 3325,
        name: '花莲县',
        code: '713500',
        lng: '121.300000',
        lat: '23.830000',
        children: [
          { id: 3684, pid: 3683, name: '花莲市', code: '713501', lng: '121.606810', lat: '23.982074' },
          { id: 3685, pid: 3683, name: '凤林镇', code: '713521', lng: '121.451687', lat: '23.744648' },
          { id: 3686, pid: 3683, name: '玉里镇', code: '713522', lng: '121.316445', lat: '23.336509' },
          { id: 3687, pid: 3683, name: '新城乡', code: '713523', lng: '121.640512', lat: '24.128133' },
          { id: 3688, pid: 3683, name: '吉安乡', code: '713524', lng: '121.568005', lat: '23.961635' },
          { id: 3689, pid: 3683, name: '寿丰乡', code: '713525', lng: '121.508955', lat: '23.870680' },
          { id: 3690, pid: 3683, name: '光复乡', code: '713526', lng: '121.423496', lat: '23.669084' },
          { id: 3691, pid: 3683, name: '丰滨乡', code: '713527', lng: '121.518639', lat: '23.597080' },
          { id: 3692, pid: 3683, name: '瑞穗乡', code: '713528', lng: '121.375992', lat: '23.496817' },
          { id: 3693, pid: 3683, name: '富里乡', code: '713529', lng: '121.250124', lat: '23.179984' },
          { id: 3694, pid: 3683, name: '秀林乡', code: '713530', lng: '121.620381', lat: '24.116642' },
          { id: 3695, pid: 3683, name: '万荣乡', code: '713531', lng: '121.407493', lat: '23.715346' },
          { id: 3696, pid: 3683, name: '卓溪乡', code: '713532', lng: '121.303422', lat: '23.346369' },
        ],
      },
      {
        id: 3697,
        pid: 3325,
        name: '澎湖县',
        code: '713600',
        lng: '119.566417',
        lat: '23.569733',
        children: [
          { id: 3698, pid: 3697, name: '马公市', code: '713601', lng: '119.566499', lat: '23.565845' },
          { id: 3699, pid: 3697, name: '湖西乡', code: '713621', lng: '119.659666', lat: '23.583358' },
          { id: 3700, pid: 3697, name: '白沙乡', code: '713622', lng: '119.597919', lat: '23.666060' },
          { id: 3701, pid: 3697, name: '西屿乡', code: '713623', lng: '119.506974', lat: '23.600836' },
          { id: 3702, pid: 3697, name: '望安乡', code: '713624', lng: '119.500538', lat: '23.357531' },
          { id: 3703, pid: 3697, name: '七美乡', code: '713625', lng: '119.423929', lat: '23.206018' },
        ],
      },
      {
        id: 3704,
        pid: 3325,
        name: '金门县',
        code: '713700',
        lng: '118.317089',
        lat: '24.432706',
        children: [
          { id: 3705, pid: 3704, name: '金城镇', code: '713701', lng: '118.316667', lat: '24.416667' },
          { id: 3706, pid: 3704, name: '金湖镇', code: '713702', lng: '118.419743', lat: '24.438633' },
          { id: 3707, pid: 3704, name: '金沙镇', code: '713703', lng: '118.427993', lat: '24.481109' },
          { id: 3708, pid: 3704, name: '金宁乡', code: '713704', lng: '118.334506', lat: '24.45672' },
          { id: 3709, pid: 3704, name: '烈屿乡', code: '713705', lng: '118.247255', lat: '24.433102' },
          { id: 3710, pid: 3704, name: '乌丘乡', code: '713706', lng: '118.319578', lat: '24.435038' },
        ],
      },
      {
        id: 3711,
        pid: 3325,
        name: '连江县',
        code: '713800',
        lng: '119.539704',
        lat: '26.197364',
        children: [
          { id: 3712, pid: 3711, name: '南竿乡', code: '713801', lng: '119.944267', lat: '26.144035' },
          { id: 3713, pid: 3711, name: '北竿乡', code: '713802', lng: '120.000572', lat: '26.221983' },
          { id: 3714, pid: 3711, name: '莒光乡', code: '713803', lng: '119.940405', lat: '25.976256' },
          { id: 3715, pid: 3711, name: '东引乡', code: '713804', lng: '120.493955', lat: '26.366164' },
        ],
      },
    ],
  },
  {
    id: 3716,
    pid: 0,
    name: '香港',
    code: '810000',
    lng: '114.173355',
    lat: '22.320048',
    children: [
      {
        id: 3717,
        pid: 3716,
        name: '香港岛',
        code: '810100',
        lng: '114.177314',
        lat: '22.266416',
        children: [
          { id: 3718, pid: 3717, name: '中西区', code: '810101', lng: '114.154374', lat: '22.281981' },
          { id: 3719, pid: 3717, name: '湾仔区', code: '810102', lng: '114.182915', lat: '22.276389' },
          { id: 3720, pid: 3717, name: '东区', code: '810103', lng: '114.255993', lat: '22.262755' },
          { id: 3721, pid: 3717, name: '南区', code: '810104', lng: '114.174134', lat: '22.24676' },
        ],
      },
      {
        id: 3722,
        pid: 3716,
        name: '九龙',
        code: '810200',
        lng: '114.17495',
        lat: '22.327115',
        children: [
          { id: 3723, pid: 3722, name: '油尖旺区', code: '810201', lng: '114.173332', lat: '22.311704' },
          { id: 3724, pid: 3722, name: '深水埗区', code: '810202', lng: '114.16721', lat: '22.328171' },
          { id: 3725, pid: 3722, name: '九龙城区', code: '810203', lng: '114.195053', lat: '22.32673' },
          { id: 3726, pid: 3722, name: '黄大仙区', code: '810204', lng: '114.19924', lat: '22.336313' },
          { id: 3727, pid: 3722, name: '观塘区', code: '810205', lng: '114.231268', lat: '22.30943' },
        ],
      },
      {
        id: 3728,
        pid: 3716,
        name: '新界',
        code: '810300',
        lng: '114.202408',
        lat: '22.341766',
        children: [
          { id: 3729, pid: 3728, name: '荃湾区', code: '810301', lng: '114.122952', lat: '22.370973' },
          { id: 3730, pid: 3728, name: '屯门区', code: '810302', lng: '113.977416', lat: '22.391047' },
          { id: 3731, pid: 3728, name: '元朗区', code: '810303', lng: '114.039796', lat: '22.443342' },
          { id: 3732, pid: 3728, name: '北区', code: '810304', lng: '114.148959', lat: '22.494086' },
          { id: 3733, pid: 3728, name: '大埔区', code: '810305', lng: '114.171743', lat: '22.445653' },
          { id: 3734, pid: 3728, name: '西贡区', code: '810306', lng: '114.27854', lat: '22.37944' },
          { id: 3735, pid: 3728, name: '沙田区', code: '810307', lng: '114.191941', lat: '22.379294' },
          { id: 3736, pid: 3728, name: '葵青区', code: '810308', lng: '114.13932', lat: '22.363877' },
          { id: 3737, pid: 3728, name: '离岛区', code: '810309', lng: '113.945842', lat: '22.281508' },
        ],
      },
    ],
  },
  {
    id: 3738,
    pid: 0,
    name: '澳门',
    code: '820000',
    lng: '113.54909',
    lat: '22.198951',
    children: [
      {
        id: 3739,
        pid: 3738,
        name: '澳门半岛',
        code: '820100',
        lng: '113.549134',
        lat: '22.198751',
        children: [
          { id: 3740, pid: 3739, name: '花地玛堂区', code: '820101', lng: '113.552284', lat: '22.208067' },
          { id: 3741, pid: 3739, name: '圣安多尼堂区', code: '820102', lng: '113.564301', lat: '22.12381' },
          { id: 3742, pid: 3739, name: '大堂区', code: '820103', lng: '113.552971', lat: '22.188359' },
          { id: 3743, pid: 3739, name: '望德堂区', code: '820104', lng: '113.550568', lat: '22.194081' },
          { id: 3744, pid: 3739, name: '风顺堂区', code: '820105', lng: '113.541928', lat: '22.187368' },
        ],
      },
      {
        id: 3745,
        pid: 3738,
        name: '氹仔岛',
        code: '820200',
        lng: '113.577669',
        lat: '22.156838',
        children: [{ id: 3746, pid: 3745, name: '嘉模堂区', code: '820201', lng: '113.565303', lat: '22.149029' }],
      },
      {
        id: 3747,
        pid: 3738,
        name: '路环岛',
        code: '820300',
        lng: '113.564857',
        lat: '22.116226',
        children: [{ id: 3748, pid: 3747, name: '圣方济各堂区', code: '820301', lng: '113.559954', lat: '22.123486' }],
      },
    ],
  },
]
export var provinceForm = {
  template: `<a-cascader
ref="cascader"
v-model="provinceValue"
@change="handleChange"
:options="chinaArea"
:placeholder="placeholder"
:disabled="disabled"
:size="size"
v-bind="isShowSearch(showSearch)"
:field-names="fieldNames"
:allowClear="allowClear"
:expandTrigger="expandTrigger"
:changeOnSelect="changeOnSelect"
></a-cascader>`,
  name: 'province-form',
  props: {
      placeholder: {
          type: String,
          default: '请选择',
      },
      disabled: {
          type: Boolean,
          default: false,
      },
      showSearch: {
        type: Boolean,
        default: true,
      },
      allowClear: {
          type: Boolean,
          default: true,
      },
      expandTrigger: {
          type: String,
          default: 'click',
      },
      size: {
        type: String,
        default: 'default',
      },
      changeOnSelect: {
          type: Boolean,
          default: false,
      },
      fieldNames: {
          type: Object,
          default: () => ({ label: 'name', value: 'code', children: 'children' }),
      },
      value: {
          type: [String, Number],
          default: '',
      },
  },
  data() {
      return {
        chinaArea: china_area,
        provinceValue: [],
      }
  },
  watch: {
      value: {
          handler(val) {
            this.provinceValue = val ? (val + '').split(',') : []
          },
          immediate: true,
      },
  },
  computed: {
  },
  methods: {
      handleChange(value) {
          const that = this
          this.$nextTick(() => {
              const addressId = value.join(',')
              that.$emit('input', addressId)
              that.$emit('change', addressId)
          })
      },
      isShowSearch(showSearch) {
          return showSearch ? { 'show-search': { filter: this.filter } } : {}
      },
      filter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
      },
  },
  mounted() {
  },
}
